import jq from 'jquery';
import { cookieBase, cookieDomain, notifyServer, userJobs, cdnUrls, flnBillingBaseUrl, facebookAppId, recaptchaPublicKey, languageCode, enterprise, sslBaseUrl } from 'server-data/flconfigs';
import { oneLine, oneLineTrim } from 'common-tags';
import _ from 'underscore';
import SockJS from 'sockjs';
import 'bootstrap';
import 'css/flux/modules/Modal.less';
import angular from 'angular';
import ngRoute from 'angular-route';
import ThreepioLib from 'gitlab:translations/threepio-browser@v1.2.21';
import 'npm:angular-component@0.0.8';
import ngResource from 'angular-resource';
import md5Provider from 'npm:angular-md5@0.1.10';
import Raven from 'github:getsentry/sentry-javascript@2.3.0';
import ThreepioLib$1 from 'gitlab:translations/threepio-browser@v1.2.20';
import 'npm:angular-easyfb@1.6.0';
import ngMessages from 'angular-messages';
import 'css/flux/modules/ModalLoginSignup.less';
import ngSanitize from 'angular-sanitize';
import Modernizr from 'modernizr';
import 'jquery-fileupload';
import 'jquery-fileupload-fp';
import 'jquery-fileupload-ui';
import 'jquery-validate';
import 'mailcheck';
import 'css/flux/legacy/quickhire-modal.less';
import 'css/flux/layout/milestone-modal.less';
import 'css/flux/modules/ModalPaymentVerification.less';
import 'jquery-ba-outside-events';
import 'jquery-slimscroll';
import GoogleMapsLoader from 'google-maps';
import { freeSearchOnLoad, category_job_map, is_admin, countries, exams, total_freelancers, cur_page, continents, seoURL, mapped_jobs, categoriesBundle, sponsoredUpsellSkillIds, selected_users_info, online_status_code, offline_status_code, currencyId } from 'server-data/directory-legacy';
import 'jquery-star-rating';
import 'jquery-star-rating/index.css';

var _taggedTemplateLiteral = (function (strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
});

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || value !== value && other !== other;
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used by `_.defaults` to customize its `_.assignIn` use.
 *
 * @private
 * @param {*} objValue The destination value.
 * @param {*} srcValue The source value.
 * @param {string} key The key of the property to assign.
 * @param {Object} object The parent object of `objValue`.
 * @returns {*} Returns the value to assign.
 */
function assignInDefaults(objValue, srcValue, key, object) {
  if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) {
    return srcValue;
  }
  return objValue;
}

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$1.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
    object[key] = value;
  }
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);
    case 1:
      return func.call(thisArg, args[0]);
    case 2:
      return func.call(thisArg, args[0], args[1]);
    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? func.length - 1 : start, 0);
  return function () {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function (object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a
 * [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792) that affects
 * Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */
var getLength = baseProperty('length');

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto$2.toString;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8 which returns 'object' for typed array and weak map constructors,
  // and PhantomJS 1.9 which returns 'function' for `NodeList` instances.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length,
 *  else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(getLength(value)) && !isFunction(value);
}

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1 = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER$1 : length;
  return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function (object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Built-in value references. */
var Reflect = root.Reflect;

/**
 * Converts `iterator` to an array.
 *
 * @private
 * @param {Object} iterator The iterator to convert.
 * @returns {Array} Returns the converted array.
 */
function iteratorToArray(iterator) {
  var data,
      result = [];

  while (!(data = iterator.next()).done) {
    result.push(data.value);
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Built-in value references. */
var enumerate = Reflect ? Reflect.enumerate : undefined,
    propertyIsEnumerable = objectProto$3.propertyIsEnumerable;

/**
 * The base implementation of `_.keysIn` which doesn't skip the constructor
 * property of prototypes or treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  object = object == null ? object : Object(object);

  var result = [];
  for (var key in object) {
    result.push(key);
  }
  return result;
}

// Fallback for IE < 9 with es6-shim.
if (enumerate && !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf')) {
  baseKeysIn = function baseKeysIn(object) {
    return iteratorToArray(enumerate(object));
  };
}

var baseKeysIn$1 = baseKeysIn;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$4.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$1 = objectProto$4.toString;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$4.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 incorrectly makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty$2.call(value, 'callee') && (!propertyIsEnumerable$1.call(value, 'callee') || objectToString$1.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/** `Object#toString` result references. */
var stringTag = '[object String]';

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$2 = objectProto$5.toString;

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' || !isArray(value) && isObjectLike(value) && objectToString$2.call(value) == stringTag;
}

/**
 * Creates an array of index keys for `object` values of arrays,
 * `arguments` objects, and strings, otherwise `null` is returned.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array|null} Returns index keys, else `null`.
 */
function indexKeys(object) {
  var length = object ? object.length : undefined;
  if (isLength(length) && (isArray(object) || isString(object) || isArguments(object))) {
    return baseTimes(length, String);
  }
  return null;
}

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = typeof Ctor == 'function' && Ctor.prototype || objectProto$6;

  return value === proto;
}

/** Used for built-in method references. */
var objectProto$7 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$7.hasOwnProperty;

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  var index = -1,
      isProto = isPrototype(object),
      props = baseKeysIn$1(object),
      propsLength = props.length,
      indexes = indexKeys(object),
      skipIndexes = !!indexes,
      result = indexes || [],
      length = result.length;

  while (++index < propsLength) {
    var key = props[index];
    if (!(skipIndexes && (key == 'length' || isIndex(key, length))) && !(key == 'constructor' && (isProto || !hasOwnProperty$3.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * This method is like `_.assignIn` except that it accepts `customizer`
 * which is invoked to produce the assigned values. If `customizer` returns
 * `undefined`, assignment is handled by the method instead. The `customizer`
 * is invoked with five arguments: (objValue, srcValue, key, object, source).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias extendWith
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} [customizer] The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @see _.assignWith
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   return _.isUndefined(objValue) ? srcValue : objValue;
 * }
 *
 * var defaults = _.partialRight(_.assignInWith, customizer);
 *
 * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */
var assignInWith = createAssigner(function (object, source, srcIndex, customizer) {
  copyObject(source, keysIn(source), object, customizer);
});

/** `Object#toString` result references. */
var errorTag = '[object Error]';

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$3 = objectProto$8.toString;

/**
 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
 * `SyntaxError`, `TypeError`, or `URIError` object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an error object,
 *  else `false`.
 * @example
 *
 * _.isError(new Error);
 * // => true
 *
 * _.isError(Error);
 * // => false
 */
function isError(value) {
  if (!isObjectLike(value)) {
    return false;
  }
  return objectToString$3.call(value) == errorTag || typeof value.message == 'string' && typeof value.name == 'string';
}

/**
 * Attempts to invoke `func`, returning either the result or the caught error
 * object. Any additional arguments are provided to `func` when it's invoked.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {Function} func The function to attempt.
 * @param {...*} [args] The arguments to invoke `func` with.
 * @returns {*} Returns the `func` result or error object.
 * @example
 *
 * // Avoid throwing errors for invalid selectors.
 * var elements = _.attempt(function(selector) {
 *   return document.querySelectorAll(selector);
 * }, '>_>');
 *
 * if (_.isError(elements)) {
 *   elements = [];
 * }
 */
var attempt = baseRest(function (func, args) {
  try {
    return apply(func, undefined, args);
  } catch (e) {
    return isError(e) ? e : new Error(e);
  }
});

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function (key) {
    return object[key];
  });
}

/** Used to escape characters for inclusion in compiled string literals. */
var stringEscapes = {
  '\\': '\\',
  "'": "'",
  '\n': 'n',
  '\r': 'r',
  '\u2028': 'u2028',
  '\u2029': 'u2029'
};

/**
 * Used by `_.template` to escape characters for inclusion in compiled string literals.
 *
 * @private
 * @param {string} chr The matched character to escape.
 * @returns {string} Returns the escaped character.
 */
function escapeStringChar(chr) {
  return '\\' + stringEscapes[chr];
}

/**
 * Creates a function that invokes `func` with its first argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetPrototype = Object.getPrototypeOf;

/**
 * Gets the `[[Prototype]]` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {null|Object} Returns the `[[Prototype]]`.
 */
var getPrototype = overArg(nativeGetPrototype, Object);

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$9.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  // Avoid a bug in IE 10-11 where objects with a [[Prototype]] of `null`,
  // that are composed entirely of index properties, return `false` for
  // `hasOwnProperty` checks of them.
  return object != null && (hasOwnProperty$4.call(object, key) || typeof object == 'object' && key in object && getPrototype(object) === null);
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = Object.keys;

/**
 * The base implementation of `_.keys` which doesn't skip the constructor
 * property of prototypes or treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
var baseKeys = overArg(nativeKeys, Object);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  var isProto = isPrototype(object);
  if (!(isProto || isArrayLike(object))) {
    return baseKeys(object);
  }
  var indexes = indexKeys(object),
      skipIndexes = !!indexes,
      result = indexes || [],
      length = result.length;

  for (var key in object) {
    if (baseHas(object, key) && !(skipIndexes && (key == 'length' || isIndex(key, length))) && !(isProto && key == 'constructor')) {
      result.push(key);
    }
  }
  return result;
}

/** Used to match template delimiters. */
var reInterpolate = /<%=([\s\S]+?)%>/g;

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function (key) {
    return object == null ? undefined : object[key];
  };
}

/** Used to map characters to HTML entities. */
var htmlEscapes = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '`': '&#96;'
};

/**
 * Used by `_.escape` to convert characters to HTML entities.
 *
 * @private
 * @param {string} chr The matched character to escape.
 * @returns {string} Returns the escaped character.
 */
var escapeHtmlChar = basePropertyOf(htmlEscapes);

/** Built-in value references. */
var Symbol = root.Symbol;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used for built-in method references. */
var objectProto$10 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$4 = objectProto$10.toString;

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' || isObjectLike(value) && objectToString$4.call(value) == symbolTag;
}

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/** Used to match HTML entities and HTML characters. */
var reUnescapedHtml = /[&<>"'`]/g,
    reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

/**
 * Converts the characters "&", "<", ">", '"', "'", and "\`" in `string` to
 * their corresponding HTML entities.
 *
 * **Note:** No other characters are escaped. To escape additional
 * characters use a third-party library like [_he_](https://mths.be/he).
 *
 * Though the ">" character is escaped for symmetry, characters like
 * ">" and "/" don't need escaping in HTML and have no special meaning
 * unless they're part of a tag or unquoted attribute value. See
 * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
 * (under "semi-related fun fact") for more details.
 *
 * Backticks are escaped because in IE < 9, they can break out of
 * attribute values or HTML comments. See [#59](https://html5sec.org/#59),
 * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
 * [#133](https://html5sec.org/#133) of the
 * [HTML5 Security Cheatsheet](https://html5sec.org/) for more details.
 *
 * When working with HTML you should always
 * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
 * XSS vectors.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escape('fred, barney, & pebbles');
 * // => 'fred, barney, &amp; pebbles'
 */
function escape$1(string) {
    string = toString(string);
    return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
}

/** Used to match template delimiters. */
var reEscape = /<%-([\s\S]+?)%>/g;

/** Used to match template delimiters. */
var reEvaluate = /<%([\s\S]+?)%>/g;

/**
 * By default, the template delimiters used by lodash are like those in
 * embedded Ruby (ERB). Change the following template settings to use
 * alternative delimiters.
 *
 * @static
 * @memberOf _
 * @type {Object}
 */
var templateSettings = {

  /**
   * Used to detect `data` property values to be HTML-escaped.
   *
   * @memberOf _.templateSettings
   * @type {RegExp}
   */
  'escape': reEscape,

  /**
   * Used to detect code to be evaluated.
   *
   * @memberOf _.templateSettings
   * @type {RegExp}
   */
  'evaluate': reEvaluate,

  /**
   * Used to detect `data` property values to inject.
   *
   * @memberOf _.templateSettings
   * @type {RegExp}
   */
  'interpolate': reInterpolate,

  /**
   * Used to reference the data object in the template text.
   *
   * @memberOf _.templateSettings
   * @type {string}
   */
  'variable': '',

  /**
   * Used to import variables into the compiled template.
   *
   * @memberOf _.templateSettings
   * @type {Object}
   */
  'imports': {

    /**
     * A reference to the `lodash` function.
     *
     * @memberOf _.templateSettings.imports
     * @type {Function}
     */
    '_': { 'escape': escape$1 }
  }
};

/** Used to match empty string literals in compiled template source. */
var reEmptyStringLeading = /\b__p \+= '';/g,
    reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
    reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

/**
 * Used to match
 * [ES template delimiters](http://ecma-international.org/ecma-262/6.0/#sec-template-literal-lexical-components).
 */
var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

/** Used to ensure capturing order of template delimiters. */
var reNoMatch = /($^)/;

/** Used to match unescaped characters in compiled string literals. */
var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

/**
 * Creates a compiled template function that can interpolate data properties
 * in "interpolate" delimiters, HTML-escape interpolated data properties in
 * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
 * properties may be accessed as free variables in the template. If a setting
 * object is given, it takes precedence over `_.templateSettings` values.
 *
 * **Note:** In the development build `_.template` utilizes
 * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
 * for easier debugging.
 *
 * For more information on precompiling templates see
 * [lodash's custom builds documentation](https://lodash.com/custom-builds).
 *
 * For more information on Chrome extension sandboxes see
 * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category String
 * @param {string} [string=''] The template string.
 * @param {Object} [options={}] The options object.
 * @param {RegExp} [options.escape=_.templateSettings.escape]
 *  The HTML "escape" delimiter.
 * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
 *  The "evaluate" delimiter.
 * @param {Object} [options.imports=_.templateSettings.imports]
 *  An object to import into the template as free variables.
 * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
 *  The "interpolate" delimiter.
 * @param {string} [options.sourceURL='templateSources[n]']
 *  The sourceURL of the compiled template.
 * @param {string} [options.variable='obj']
 *  The data object variable name.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the compiled template function.
 * @example
 *
 * // Use the "interpolate" delimiter to create a compiled template.
 * var compiled = _.template('hello <%= user %>!');
 * compiled({ 'user': 'fred' });
 * // => 'hello fred!'
 *
 * // Use the HTML "escape" delimiter to escape data property values.
 * var compiled = _.template('<b><%- value %></b>');
 * compiled({ 'value': '<script>' });
 * // => '<b>&lt;script&gt;</b>'
 *
 * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
 * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
 * compiled({ 'users': ['fred', 'barney'] });
 * // => '<li>fred</li><li>barney</li>'
 *
 * // Use the internal `print` function in "evaluate" delimiters.
 * var compiled = _.template('<% print("hello " + user); %>!');
 * compiled({ 'user': 'barney' });
 * // => 'hello barney!'
 *
 * // Use the ES delimiter as an alternative to the default "interpolate" delimiter.
 * var compiled = _.template('hello ${ user }!');
 * compiled({ 'user': 'pebbles' });
 * // => 'hello pebbles!'
 *
 * // Use backslashes to treat delimiters as plain text.
 * var compiled = _.template('<%= "\\<%- value %\\>" %>');
 * compiled({ 'value': 'ignored' });
 * // => '<%- value %>'
 *
 * // Use the `imports` option to import `jQuery` as `jq`.
 * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
 * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
 * compiled({ 'users': ['fred', 'barney'] });
 * // => '<li>fred</li><li>barney</li>'
 *
 * // Use the `sourceURL` option to specify a custom sourceURL for the template.
 * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
 * compiled(data);
 * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
 *
 * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
 * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
 * compiled.source;
 * // => function(data) {
 * //   var __t, __p = '';
 * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
 * //   return __p;
 * // }
 *
 * // Use custom template delimiters.
 * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
 * var compiled = _.template('hello {{ user }}!');
 * compiled({ 'user': 'mustache' });
 * // => 'hello mustache!'
 *
 * // Use the `source` property to inline compiled templates for meaningful
 * // line numbers in error messages and stack traces.
 * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
 *   var JST = {\
 *     "main": ' + _.template(mainText).source + '\
 *   };\
 * ');
 */
function template(string, options, guard) {
  // Based on John Resig's `tmpl` implementation
  // (http://ejohn.org/blog/javascript-micro-templating/)
  // and Laura Doktorova's doT.js (https://github.com/olado/doT).
  var settings = templateSettings.imports._.templateSettings || templateSettings;

  if (guard && isIterateeCall(string, options, guard)) {
    options = undefined;
  }
  string = toString(string);
  options = assignInWith({}, options, settings, assignInDefaults);

  var imports = assignInWith({}, options.imports, settings.imports, assignInDefaults),
      importsKeys = keys(imports),
      importsValues = baseValues(imports, importsKeys);

  var isEscaping,
      isEvaluating,
      index = 0,
      interpolate = options.interpolate || reNoMatch,
      source = "__p += '";

  // Compile the regexp to match each delimiter.
  var reDelimiters = RegExp((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');

  // Use a sourceURL for easier debugging.
  var sourceURL = 'sourceURL' in options ? '//# sourceURL=' + options.sourceURL + '\n' : '';

  string.replace(reDelimiters, function (match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
    interpolateValue || (interpolateValue = esTemplateValue);

    // Escape characters that can't be included in string literals.
    source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

    // Replace delimiters with snippets.
    if (escapeValue) {
      isEscaping = true;
      source += "' +\n__e(" + escapeValue + ") +\n'";
    }
    if (evaluateValue) {
      isEvaluating = true;
      source += "';\n" + evaluateValue + ";\n__p += '";
    }
    if (interpolateValue) {
      source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
    }
    index = offset + match.length;

    // The JS engine embedded in Adobe products needs `match` returned in
    // order to produce the correct `offset` value.
    return match;
  });

  source += "';\n";

  // If `variable` is not specified wrap a with-statement around the generated
  // code to add the data object to the top of the scope chain.
  var variable = options.variable;
  if (!variable) {
    source = 'with (obj) {\n' + source + '\n}\n';
  }
  // Cleanup code by stripping empty strings.
  source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');

  // Frame code as the function body.
  source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ', __j = Array.prototype.join;\n' + "function print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';

  var result = attempt(function () {
    return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
  });

  // Provide the compiled function's source by its `toString` method or
  // the `source` property as a convenience for inlining compiled templates.
  result.source = source;
  if (isError(result)) {
    throw result;
  }
  return result;
}

/** `Object#toString` result references. */
var numberTag = '[object Number]';

/** Used for built-in method references. */
var objectProto$11 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$5 = objectProto$11.toString;

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' || isObjectLike(value) && objectToString$5.call(value) == numberTag;
}

function setCookie(cName, value, expiredays) {
  var expiremins = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

  var exdate = new Date();
  exdate.setDate(exdate.getDate() + expiredays);
  exdate.setMinutes(exdate.getMinutes() + expiremins);
  document.cookie = cName + '=' + value + ('' + (expiredays == null ? '' : ';expires=' + exdate.toUTCString())) + '; path=/; secure';
}

function setCookieToBrowser(cookieName, cookieValue, expiredays, path, domain) {
  var expiremins = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  var exdate = new Date();
  exdate.setDate(exdate.getDate() + expiredays);
  exdate.setMinutes(exdate.getMinutes() + expiremins);
  document.cookie = cookieName + '=' + escape(cookieValue) + ('' + (exdate ? ';expires=' + exdate.toUTCString() : '')) + ('' + (path ? ';path=' + path : '')) + ('' + (domain ? ';domain=' + domain : '')) + ';secure';
}

function getCookie(cName) {
  var cookies = document.cookie;
  if (cookies.length > 0) {
    var cStart = cookies.indexOf(cName + '=');
    if (cStart != -1) {
      cStart = cStart + cName.length + 1;
      var cEnd = cookies.indexOf(';', cStart);
      if (cEnd == -1) cEnd = cookies.length;
      return cookies.substring(cStart, cEnd);
    }
  }
  return '';
}

function getUserIdfromCookie() {
  return getCookie(cookieBase + '_USER_ID');
}

// DEPRECATED. Just use cookieBase from 'server-data/flconfigs'
// const getCookieBase;

function getAuthHeader() {
  var authHashV2 = getCookie(cookieBase + '_AUTH_HASH_V2');
  var userId = getUserIdfromCookie();
  return { 'Freelancer-Auth-V2': userId + ';' + authHashV2 };
}

function randomString(length, chars) {
  var result = '';
  for (var i = length; i > 0; --i) {
    result += chars[Math.round(Math.random() * (chars.length - 1))];
  }
  return result;
}

function getCSRFToken() {
  var token = getCookie('XSRF-TOKEN');
  if (!token) {
    token = randomString(64, '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ');
    setCookie('XSRF-TOKEN', token, 7);
  }
  return token;
}

var TRANSLATE_MODE_COOKIE = cookieBase + '_TRANSLATE_MODE';

var isTranslateModeEnabled = function isTranslateModeEnabled() {
  return getCookie(TRANSLATE_MODE_COOKIE) === '1';
};

var getTokenizedMessage = function getTokenizedMessage(id, message) {
  return isTranslateModeEnabled() ? '~=[' + id + '|^|' + message + ']=~' : message;
};

var translate = function translate(first) {
  for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    rest[_key - 1] = arguments[_key];
  }

  switch (true) {
    case isString(first):
      {
        var text = first;
        var vars = rest[0];
        if (typeof vars === 'undefined' || !vars) {
          return text;
        }
        var result = template(text, {
          evaluate: /<\[([\s\S]+?)\]>/g,
          interpolate: /<\[=([\s\S]+?)\]>/g,
          escape: /<\[-([\s\S]+?)\]>/g
        })(vars);
        result = template(result)(vars);
        return result;
      }
    case isArray(first):
      {
        return oneLine([translate.raw.apply(translate, [first].concat(rest))]);
      }
    case isNumber(first):
      {
        var _ret = function () {
          var sourceTextId = first;
          return {
            v: function v() {
              return getTokenizedMessage(sourceTextId, translate.apply(undefined, arguments));
            }
          };
        }();

        if (typeof _ret === "object") return _ret.v;
      }
    default:
      {
        throw new TypeError('Invalid argument types');
      }
  }
};

translate.raw = function rawT(literals) {
  for (var _len2 = arguments.length, placeholders = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    placeholders[_key2 - 1] = arguments[_key2];
  }

  return literals.raw.reduce(function (str, current, index) {
    var temp = str + current;
    if (index < placeholders.length) {
      temp += placeholders[index].toString();
    }
    return temp;
  }, '');
};

function LibnotifyFactory() {
  var socket = void 0;
  var isReady = false;
  var readyList = [];
  var registeredFunctions = [];
  var registeredFilters = [];
  var maxSeenPackets = 5;
  var seenPackets = {
    last: undefined,
    first: undefined,
    packets: {}
  };
  var jobChannels = void 0;
  var eventHistory = [];

  var addPacketNoDelete = function addPacketNoDelete(id, packetId) {
    seenPackets.packets[id] = {
      id: packetId,
      next: undefined
    };
    seenPackets.packets[seenPackets.first].next = id;
    seenPackets.first = id;
  };

  var addPacket = function addPacket(id) {
    var last = seenPackets.last;
    var lastPacket = seenPackets.packets[last];
    var newLast = lastPacket.next;

    addPacketNoDelete(id, id);
    seenPackets.last = newLast;
    delete seenPackets.packets[last];
  };

  // Packet is only considered seen if it exists and if it's not a placeholder
  var newPacket = function newPacket(id) {
    return !(seenPackets.packets[id] && seenPackets.packets[id].id === id);
  };

  (function () {
    seenPackets.packets[0] = {
      id: false,
      next: undefined
    };
    seenPackets.first = 0;
    seenPackets.last = 0;

    for (var i = 1; i <= maxSeenPackets; i++) {
      addPacketNoDelete(i, false);
    }
  })();

  var messageReceived = function messageReceived(obj) {
    var key = obj.parent_type + ':' + obj.type;
    if (newPacket(obj.id)) {
      addPacket(obj.id);

      var allowed = true;
      jq(registeredFilters[key]).each(function (i, e) {
        if (e(obj) === false) {
          allowed = false;
          return false;
        }
      });

      if (!allowed) {
        return false;
      }

      jq(registeredFunctions[key]).each(function (i, e) {
        var objCopy = jq.extend(true, {}, obj);
        e(objCopy);
      });
    }
  };

  var register = function register(parentType, channel, callback) {
    var key = parentType + ':' + channel;
    if (registeredFunctions[key]) {
      var callbackExists = _.find(registeredFunctions[key], function (cb) {
        return cb == callback;
      });
      if (!callbackExists) {
        registeredFunctions[key].push(callback);
      }
    } else {
      registeredFunctions[key] = new Array(callback);
    }

    return this;
  };

  var registerFilter = function registerFilter(parentType, channel, callback) {
    var key = parentType + ':' + channel;
    if (registeredFilters[key]) {
      var callbackExists = _.find(registeredFilters[key], function (cb) {
        return cb == callback;
      });
      if (!callbackExists) {
        registeredFilters[key].push(callback);
      }
    } else {
      registeredFilters[key] = new Array(callback);
    }

    return this;
  };

  var ready = function ready(f, args, context) {
    context = context || window;
    args = args || [];
    if (isReady) {
      f.apply(context, args);
    } else {
      readyList.push({
        f: f,
        args: args,
        context: context
      });
    }
  };

  var setReady = function setReady() {
    for (var i = 0; i < readyList.length; i++) {
      var obj = readyList[i];
      obj.f.apply(obj.context, obj.args);
    }
    readyList = [];
  };

  var send = function send(channel, data) {
    socket.send(JSON.stringify({
      channel: channel,
      body: data
    }));
  };

  var closeSocket = function closeSocket() {
    if (socket) {
      socket.close();
    }
  };

  var setJobChannel = function setJobChannel(channels) {
    if (typeof channels !== 'undefined') {
      if (typeof jobChannels === 'undefined' || jobChannels.join('') !== channels.join('')) {
        jobChannels = channels;
        closeSocket();
      }
    }
  };

  var getJobChannel = function getJobChannel() {
    if (typeof jobChannels === 'undefined') {
      jobChannels = userJobs;
    }
    return jobChannels;
  };

  var getSocketReadyState = function getSocketReadyState() {
    return socket && socket.readyState;
  };

  var Backoff = function Backoff(name, resetTime, firstTimeout) {
    this.name = name;

    // Is this the first time its failed
    this.first_fail = true;

    // How long is the wait for first failure
    this.first_timeout = firstTimeout;

    // The current failure wait time
    this.wait_time = resetTime;

    // The base failure wait time
    this.reset_time = resetTime;
  };

  Backoff.prototype.fail = function () {
    var delay = void 0;
    if (this.first_fail) {
      this.first_fail = false;
      delay = this.first_timeout;
    } else {
      delay = this.wait_time;
      this.wait_time *= 2;
      this.wait_time = Math.min(this.wait_time, 60000);
    }
    window.console.log(this.name + ' Failed retrying in ' + delay);
    return delay;
  };

  Backoff.prototype.ok = function () {
    var _this = this;

    if (!this.first_fail) {
      (function () {
        window.console.log(_this.name + ' Recovered');
        var event = void 0;
        var eventString = 'libnotify.connected';
        var eventImmediate = void 0;
        var eventImmediateString = 'libnotify.connected.immediate';
        try {
          event = new Event(eventString);
          eventImmediate = new Event(eventImmediateString);
        } catch (error) {
          event = document.createEvent('Event');
          eventImmediate = document.createEvent('Event');
          event.initEvent(eventString, true, false);
          eventImmediate.initEvent(eventImmediateString, true, false);
        }
        setTimeout(function () {
          document.dispatchEvent(event);
        }, Math.random() * 30000);
        document.dispatchEvent(eventImmediate);
      })();
    }
    this.first_fail = true;
    this.wait_time = this.reset_time;
  };

  var init = function init(authFailCallback) {
    var connectBackoff = new Backoff('sockJS Connect', 1000, 200);
    var reconnectBackoff = new Backoff('sockJS Reconnect', 1000, 200);
    var authBackoff = new Backoff('sockJS Auth', 4000, 500);

    var cookies = {
      hash: getCookie(cookieBase + '_AUTH_HASH'),
      hash2: getCookie(cookieBase + '_AUTH_HASH_V2'),
      user_id: getCookie(cookieBase + '_USER_ID'),
      channels: getJobChannel()
    };

    // Dont talk to node if not loged in
    if (cookies.hash2 == '' && cookies.hash == '' || cookies.user_id == '') {
      return false;
    }

    var newSocket = function newSocket() {
      socket = new SockJS(notifyServer);
      // Always get latest channels when socket reopens
      cookies.channels = getJobChannel();

      socket.onmessage = function (e) {
        var message = JSON.parse(e.data);
        if (eventHistory.length < 100 && (message.body.parent_type === 'onlineoffline' || message.channel === 'subscribe')) {
          eventHistory.push(message);
        }

        if (message.channel == 'user') {
          messageReceived(message.body);
        } else if (message.channel == 'subscribe') {
          reconnectBackoff.ok();
          if (message.body == 'NO') {
            authFailCallback();
            socket.close(4000, 'Auth Failure');
          } else {
            authBackoff.ok();
            isReady = true;
            setReady();
          }
        }
      };

      socket.onopen = function () {
        // This is a temporary hack to help track a bug with online offline...
        // Will fix in a week 20/07/17.
        var sessionId = void 0;
        if (socket && socket._transport && socket._transport.url && socket._transport.url.split('/').length !== 0) {
          sessionId = socket._transport.url.split('/')[4];
        }
        var sessionIdTimestamp = new Date().getTime();
        if (window.sessionStorage) {
          window.sessionStorage.setItem('notification_socket_session_id', sessionId);
          window.sessionStorage.setItem('notification_socket_session_time', sessionIdTimestamp);
        }
        connectBackoff.ok();
        socket.send(JSON.stringify({
          channel: 'auth',
          body: cookies
        }));
      };

      socket.onclose = function (e) {
        socket = undefined;
        isReady = false;
        if (e.code === 4000) {
          setTimeout(newSocket, authBackoff.fail());
        } else if (!e.wasClean) {
          setTimeout(newSocket, connectBackoff.fail());
        } else {
          setTimeout(newSocket, reconnectBackoff.fail());
        }
      };
    };
    newSocket();
  };

  var getEventHistory = function getEventHistory() {
    return eventHistory;
  };

  init(function () {
    // console.log('auth failure');
  });

  // public interface
  return {
    log: true,
    register: register,
    register_filter: registerFilter,
    close: closeSocket,
    packets: seenPackets,
    send: send,
    ready: ready,
    set_job_channel: setJobChannel,
    getSocketReadyState: getSocketReadyState,
    getEventHistory: getEventHistory
  };
}

window.libnotify = window.libnotify || LibnotifyFactory();
var libnotify = window.libnotify;

var watchedUsers = {};
var userCache = {};

var statusMap = {
  1: 'offline',
  2: 'online'
};

var sendWithLibnotify = function sendWithLibnotify(command, userList) {
  libnotify.ready(function () {
    libnotify.send('onlineoffline', {
      route: command,
      users: userList
    });
  });
};

var splitNewUsers = function splitNewUsers(userList) {
  var newUsers = [];
  var existing = [];

  if (_.isArray(userList)) {
    for (var i = 0; i < userList.length; i++) {
      if (userList[i] in watchedUsers) {
        existing.push(parseInt(userList[i], 10));
      } else {
        newUsers.push(parseInt(userList[i], 10));
      }
    }
  } else if (userList) {
    Object.keys(userList).forEach(function (user) {
      if (user in watchedUsers) {
        existing.push(parseInt(user, 10));
      } else {
        newUsers.push(parseInt(user, 10));
      }
    });
  }

  return {
    new_users: newUsers,
    existing: existing
  };
};

var addToWatched = function addToWatched(userList) {
  for (var i = 0; i < userList.length; i++) {
    watchedUsers[userList[i]] = true;
  }
};

// CSS functions
var styleIdPrefix = 'onlineoffline_style_';

var stateColours = {
  online: '#77be56 !important',
  offline: '#aaaaaa !important'
};

var styleTemplate = _.template('.online-status.onlineoffline_<%= user %> {background: <%= colour %>;}\n' + "<% if (state != 'online') { %>" + '.onlineoffline.online_<%= user %>{display: none !important;}<% } %>\n' + '.onlineoffline.online_<%= user %>{display: ' + "<% if (state != 'online') { %>none !important<% } " + 'else { %> block <% } %>;}\n.onlineoffline.offline_<%= user %>{' + "display: <% if (state != 'offline') { %>none !important<% } " + 'else { %> block <% } %>;}\n');

var destroyStyle = function destroyStyle(userId) {
  jq('#' + styleIdPrefix + userId).remove();
};

var setStyle = function setStyle(userId, state) {
  var styleText = styleTemplate({
    user: userId,
    colour: stateColours[state],
    state: state
  });
  var $style = jq('<style type=\'text/css\' id=\'' + styleIdPrefix + userId + '\'>' + (styleText + '</style>'));

  destroyStyle(userId);
  jq('head').append($style);
};

var setStatus = function setStatus(userId, stateId) {
  userCache[userId] = stateId;

  var state = statusMap[stateId] || 'offline';

  setStyle(userId, state);
};

// Public Functions
var getSync = function getSync(userId) {
  return statusMap[userCache[userId]] || 'offline';
};

var sub = function sub(userList) {
  var res = splitNewUsers(userList);
  addToWatched(res.new_users);

  if (res.new_users.length) {
    sendWithLibnotify('getsub', res.new_users);
  }
};

// Initilisation code
libnotify.register('onlineoffline', 'statuschange', function (msg) {
  setStatus(msg.data.user, msg.data.to);
});

libnotify.register('onlineoffline', 'statusget', function (msg) {
  if (msg.data) {
    Object.keys(msg.data).forEach(function (user) {
      setStatus(user, msg.data[user]);
    });
  }
});

libnotify.register('onlineoffline', 'reregister', function () {
  setTimeout(function () {
    // console.log('Onlineoffline: Reregistering');
    var watched = [];
    if (userCache) {
      Object.keys(userCache).forEach(function (user) {
        watched.push(user);
      });
    }
    sendWithLibnotify('getsub', watched);
  }, 500);
});

var onlineoffline = {
  set_status: setStatus,
  get: getSync,
  sub: sub,
  map: statusMap
};

var webappABTestServiceReady = new Promise(function (resolve) {
  if (window.webappCompatABTest) {
    resolve();
  } else {
    window.webappCompatABTestReadyCallback = function () {
      return resolve();
    };
  }
});

var ABTest = {
  // returns a Promise of the variation name, based on the experiment name and
  // the user's current tracking session ID.
  getSessionExperimentVariation: function getSessionExperimentVariation(experimentName) {
    return webappABTestServiceReady.then(function () {
      return window.webappCompatABTest.getSessionExperimentVariation(experimentName);
    });
  },

  // returns a Promise of the variation name, based on the experiment name and
  // an optional user id. If the user id is not specify, it falls back to using
  // the user's current ID (we run tests based on other users' IDs, e.g.
  // project owners IDs).
  getUserExperimentVariation: function getUserExperimentVariation(experimentName, userId) {
    return webappABTestServiceReady.then(function () {
      return window.webappCompatABTest.getUserExperimentVariation(experimentName, userId);
    });
  },

  // returns a Promise of the variation name, based on the experiment name and
  // a project ID.
  getProjectExperimentVariation: function getProjectExperimentVariation(experimentName, projectId) {
    return webappABTestServiceReady.then(function () {
      return window.webappCompatABTest.getProjectExperimentVariation(experimentName, projectId);
    });
  },

  // Determines whether or not to enrol a user/project based on a percentage split.
  shouldEnrol: function shouldEnrol(experimentName, contextId, testProportion) {
    return webappABTestServiceReady.then(function () {
      return window.webappCompatABTest.shouldEnrol(experimentName, contextId, testProportion);
    });
  }
};

/*
  QTS Binding Library
  This includes functions for binding qts pushing to events, as follows:
  init()
  - initializes default values for all qts events
    this may set two separate default values for the navbar and for the page
    push()
  - used for js process events, not directly w/ user interaction
    bind()
  - bind to an element click event.
    if contains a link, it shall prevent & setTimeout to allow qts pixel
    request, before redirecting.
*/

// general container for all qtsbinds data;
var qtsv = {
  timeout: false,
  defaults: {},
  page: {},
  nav: {}
};

qtsv.defaults = {
  pageContainer: '.gaf-container:first',
  navContainer: '.header-and-nav'
};

var setDefault = function setDefault(params, isNav) {
  if (typeof isNav === 'boolean' && isNav) {
    if (params) {
      Object.keys(params).forEach(function (pkey) {
        qtsv.nav[pkey] = params[pkey];
      });
    }
  } else if (params) {
    Object.keys(params).forEach(function (pkey) {
      qtsv.page[pkey] = params[pkey];
    });
  }
  qtsv.timeout = false;
};

var push = function push(params, url, isNav) {
  var qvars = qtsv;
  if (!qvars.timeout) {
    (function () {
      var paramSet = typeof isNav === 'undefined' ? JSON.parse(JSON.stringify(qvars.page)) : JSON.parse(JSON.stringify(qvars.nav));

      if (typeof params === 'object') {
        if (params) {
          Object.keys(params).forEach(function (pkey) {
            if (pkey != 'eventName') {
              paramSet[pkey] = params[pkey];
            }
          });
        }
      } else if (typeof params === 'string') {
        paramSet.label = params;
      }

      if (typeof params.eventName !== 'undefined') {
        _t.push([params.eventName, paramSet]);
      } else {
        _t.push(['user_action', paramSet]);
      }

      setTimeout(function () {
        if (typeof url === 'string') {
          window.location = url;
        }
      }, 1000);

      setTimeout(function () {
        qvars.timeout = false;
      }, 100);

      qvars.timeout = true;
    })();
  }
};

var createBind = function createBind(ifselector, params, isNav) {
  var qvars = qtsv;

  params = params || {};

  var containerEl = qvars.defaults.pageContainer;
  var selector = '[data-qts]';

  if (typeof ifselector === 'string') {
    selector = ifselector;
  } else if (typeof ifselector === 'object') {
    selector = ifselector.id;
    // attach conditional values to element so it won't be lost after binding
    jq(selector).attr('data-qtcon', ifselector.con);
    jq(selector).attr('data-qt0', ifselector.falsy);
    jq(selector).attr('data-qt1', ifselector.truthy);
  }

  if (typeof isNav === 'string') {
    containerEl = isNav;
  } else if (typeof isNav === 'boolean' && isNav == true) {
    containerEl = qvars.defaults.navContainer;
  }

  jq(containerEl).on('click', selector, function (e) {
    e.preventDefault();
    // if navbar is a link, assign triggerable flag so it can be triggered after
    // qts is pushed.
    var paramSet = typeof isNav === 'undefined' ? JSON.parse(JSON.stringify(qvars.page)) : JSON.parse(JSON.stringify(qvars.nav));

    var thisEl = jq(e.currentTarget);
    var triggerable = false;
    if (typeof thisEl.attr('href') !== 'undefined') {
      triggerable = true;
    }

    if (!qtsv.timeout) {
      if (params) {
        Object.keys(params).forEach(function (pkey) {
          if (pkey != 'eventName') {
            paramSet[pkey] = params[pkey];
          }
        });
      }

      var label = thisEl.data('qts');

      if (typeof label !== 'undefined') {
        paramSet.label = label;
      }

      // for conditional selectors
      var hasCondition = typeof thisEl.data('qtcon') !== 'undefined';

      if (hasCondition) {
        // toggle text value (qt1 or qt0) depending on condition (qtcon)
        if (thisEl.data('qtcon') == false) {
          paramSet.label = thisEl.data('qt1');
          thisEl.data('qtcon', true);
        } else {
          paramSet.label = thisEl.data('qt0');
          thisEl.data('qtcon', false);
        }
      }

      if (typeof paramSet.action === 'undefined') {
        paramSet.action = 'click';
      }

      if (typeof params.eventName !== 'undefined') {
        _t.push([params.eventName, paramSet]);
      } else {
        _lt.push(['user_action', paramSet]);
      }

      // sets a timeout fxn & timer to measure if qts push taking too long.
      qtsv.timer = setTimeout(function () {
        qtsv.timeout = false;
        if (triggerable) {
          window.location = thisEl.attr('href');
        }
      }, 1000);

      qtsv.timeout = true;
      qtsv.timerRun = 0;
    }
  });
};

qtsv.push = push;

var qtsp = {
  init: setDefault,
  bind: createBind,
  push: push
};

// Compute the CRC32 of a string
var table = '00000000 77073096 EE0E612C 990951BA 076DC419\n  706AF48F E963A535 9E6495A3 0EDB8832 79DCB8A4 E0D5E91E 97D2D988 09B64C2B\n  7EB17CBD E7B82D07 90BF1D91 1DB71064 6AB020F2 F3B97148 84BE41DE 1ADAD47D\n  6DDDE4EB F4D4B551 83D385C7 136C9856 646BA8C0 FD62F97A 8A65C9EC 14015C4F\n  63066CD9 FA0F3D63 8D080DF5 3B6E20C8 4C69105E D56041E4 A2677172 3C03E4D1\n  4B04D447 D20D85FD A50AB56B 35B5A8FA 42B2986C DBBBC9D6 ACBCF940 32D86CE3\n  45DF5C75 DCD60DCF ABD13D59 26D930AC 51DE003A C8D75180 BFD06116 21B4F4B5\n  56B3C423 CFBA9599 B8BDA50F 2802B89E 5F058808 C60CD9B2 B10BE924 2F6F7C87\n  58684C11 C1611DAB B6662D3D 76DC4190 01DB7106 98D220BC EFD5102A 71B18589\n  06B6B51F 9FBFE4A5 E8B8D433 7807C9A2 0F00F934 9609A88E E10E9818 7F6A0DBB\n  086D3D2D 91646C97 E6635C01 6B6B51F4 1C6C6162 856530D8 F262004E 6C0695ED\n  1B01A57B 8208F4C1 F50FC457 65B0D9C6 12B7E950 8BBEB8EA FCB9887C 62DD1DDF\n  15DA2D49 8CD37CF3 FBD44C65 4DB26158 3AB551CE A3BC0074 D4BB30E2 4ADFA541\n  3DD895D7 A4D1C46D D3D6F4FB 4369E96A 346ED9FC AD678846 DA60B8D0 44042D73\n  33031DE5 AA0A4C5F DD0D7CC9 5005713C 270241AA BE0B1010 C90C2086 5768B525\n  206F85B3 B966D409 CE61E49F 5EDEF90E 29D9C998 B0D09822 C7D7A8B4 59B33D17\n  2EB40D81 B7BD5C3B C0BA6CAD EDB88320 9ABFB3B6 03B6E20C 74B1D29A EAD54739\n  9DD277AF 04DB2615 73DC1683 E3630B12 94643B84 0D6D6A3E 7A6A5AA8 E40ECF0B\n  9309FF9D 0A00AE27 7D079EB1 F00F9344 8708A3D2 1E01F268 6906C2FE F762575D\n  806567CB 196C3671 6E6B06E7 FED41B76 89D32BE0 10DA7A5A 67DD4ACC F9B9DF6F\n  8EBEEFF9 17B7BE43 60B08ED5 D6D6A3E8 A1D1937E 38D8C2C4 4FDFF252 D1BB67F1\n  A6BC5767 3FB506DD 48B2364B D80D2BDA AF0A1B4C 36034AF6 41047A60 DF60EFC3\n  A867DF55 316E8EEF 4669BE79 CB61B38C BC66831A 256FD2A0 5268E236 CC0C7795\n  BB0B4703 220216B9 5505262F C5BA3BBE B2BD0B28 2BB45A92 5CB36A04 C2D7FFA7\n  B5D0CF31 2CD99E8B 5BDEAE1D 9B64C2B0 EC63F226 756AA39C 026D930A 9C0906A9\n  EB0E363F 72076785 05005713 95BF4A82 E2B87A14 7BB12BAE 0CB61B38 92D28E9B\n  E5D5BE0D 7CDCEFB7 0BDBDF21 86D3D2D4 F1D4E242 68DDB3F8 1FDA836E 81BE16CD\n  F6B9265B 6FB077E1 18B74777 88085AE6 FF0F6A70 66063BCA 11010B5C 8F659EFF\n  F862AE69 616BFFD3 166CCF45 A00AE278 D70DD2EE 4E048354 3903B3C2 A7672661\n  D06016F7 4969474D 3E6E77DB AED16A4A D9D65ADC 40DF0B66 37D83BF0 A9BCAE53\n  DEBB9EC5 47B2CF7F 30B5FFE9 BDBDF21C CABAC28A 53B39330 24B4A3A6 BAD03605\n  CDD70693 54DE5729 23D967BF B3667A2E C4614AB8 5D681B02 2A6F2B94 B40BBE37\n  C30C8EA1 5A05DF1B 2D02EF8D';

/* Number */
function crc32( /* String */str, /* Number */crc) {
  if (crc == undefined) crc = 0;
  var n = 0; // a number between 0 and 255
  var x = 0; // an hex number

  crc ^= -1;
  for (var i = 0, iTop = str.length; i < iTop; i++) {
    n = (crc ^ str.charCodeAt(i)) & 0xff;
    x = '0x' + table.substr(n * 9, 8);
    crc = crc >>> 8 ^ x;
  }
  return crc ^ -1;
}

function cdn_url(url, protocol) {
  // forcing https this way for backwards compat
  protocol = 'https://';

  var host = cdnUrls[Math.abs(crc32(url)) % cdnUrls.length];
  return protocol + host + url;
}

/**
 * Loads the contents of an SVG file and injects it to where it's being called.
 * In its originality this function is only used with the Underscore templating
 * engine, so it only works if the template is being rendered right after
 * compilation.
 * @param  {String} icon The icon name. Consult with FEDs or the
 * [Pattern Library](https://patternlibrary.freelancer.com)
 *                       for the naming convention of the icon you're using.
 * @return {String}      A temporary placeholder element to be replaced later
 * after the XHR fetches the SVG.
 */

function generateUniqueIdentifier() {
  var identifier = 'uiIcon-' + Math.floor(Math.random() * 1024);
  // Does the passwordless form with that identifier exist? Reroll the
  // dice again to get a new unique one.
  if (document.getElementById(identifier)) {
    return generateUniqueIdentifier();
  }

  return identifier;
}

function uiIcon(icon) {
  // Make a placeholder element to be replaced with the SVG later.
  var identifier = generateUniqueIdentifier();
  var placeholderHTML = '<span id="' + identifier + '"></span>';

  // Fetch the contents of the SVG file we're going to replace it with.
  var placeholderNode = void 0;
  // DO NOT use the SystemJS API without talking to @laurent first! Things
  // might go really bad if you do.
  fetch(SystemJS.normalizeSync('icons/' + icon + '.svg')).then(function (response) {
    if (response.ok) {
      return response.text();
    }

    // Remove the placeholder element if the icon is not found or some server
    // problems happened.
    placeholderNode = document.getElementById('' + identifier);
    if (placeholderNode.parentNode) {
      placeholderNode.parentNode.removeChild(placeholderNode);
    }
    throw new Error();
  }).then(function (html) {
    var replace = function replace() {
      placeholderNode = document.getElementById('' + identifier);
      // Sometimes the templates are rendered but never inserted in the DOM
      // ¯\_(ツ)_/¯
      if (placeholderNode) {
        placeholderNode.outerHTML = html;
      }
    };

    // Replace the placeholder element at the next animation frame if possible
    if ('requestAnimationFrame' in window) {
      requestAnimationFrame(replace);
    } else {
      replace();
    }
    // 404 or something else happened. Don't worry about it.
  }).catch(function () {
    return undefined;
  });

  // While that call's happening return the placeholder element to be injected
  // to the template first.
  return placeholderHTML;
}

var paymentsSourceTemplate = "<div class=\"payment-from\">\n    <div class=\"need-deposit payment-from-option\" style=\"display:none\">\n        <%- T_('Você será direcionado para a página de depósito para fazer esse pagamento.') %>\n    </div>\n    <div class=\"may-need-deposit payment-from-option\" style=\"display:none\">\n        <%- T_('Isto será debitado dos saldos disponíveis  da sua conta, então se requerido, você será direcionado para a página de depósito para fazer este pagamento:') %>\n    </div>\n    <div class='form-only-balance only-balance payment-from-option' style=\"display:none\">\n        <%- T_('Isso será debitado dos seus saldos disponíveis da sua conta:') %>\n    </div>\n    <%  if (templateData.firstAvailablePaymentMethod) {  %>\n        <div class=\"only-vpm payment-from-option\" style=\"display:none\">\n            <%  if (templateData.verifiedPaymentSourceCount == 1) {  %>\n                <%- T_('Isso será debitado do seu método de pagamento verificado.') %>\n            <%  } else {  %>\n                <%- T_('Isso será debitado de seus métodos de pagamento verificados.') %>\n            <%  }  %>\n            <%  if (templateData.showWireTransferLink) {  %>\n                <%= T_('Se você prefere pagar por transferência bancária, por favor, clique <a class=\"handover-wire-transfer-link\">aqui</a>') %>\n            <%  }  %>\n        </div>\n        <div class=\"mixed-balance-vpm payment-from-option\" style=\"display:none\">\n            <%  if (templateData.verifiedPaymentSourceCount == 1) {  %>\n                <%- T_('Isso será debitado de seus saldos disponíveis, então, se requirido iremos tentar processar esse pagamento de seu método de pagamento verificado:') %>\n            <%  } else {  %>\n                <%- T_('Isto será debitado de seus saldos disponíveis, então se requirido iremos tentar processar este pagamento de seus métodos de pagamento verificados:') %>\n            <%  }  %>\n        </div>\n    <%  }  %>\n    <p class=\"form-account-balance account-balances\" style=\"display:none\">\n        <strong><%- T_('Saldo da Conta:') %></strong>\n        <%  if (templateData.balances) {  %>\n            <%  for (var i = 0; i < templateData.balances.length; i++) {  %>\n                <%-  templateData.balances[i].currency.sign  %><%-  templateData.balances[i].balance.toFixed(2)  %> <%-  templateData.balances[i].currency.code  %><%-  (i == templateData.balances.length - 1) ? '' : ','  %>\n            <%  }  %>\n        <%  }  %>\n    </p>\n</div>\n<%  if (templateData.firstAvailablePaymentMethod) {  %>\n    <div class=\"payment-logos-container\" style=\"display:none\">\n        <h6>\n            <%- T_('Método de pagamento verificado:') %>\n        </h6>\n\n        <img src=\"<%=  cdn_url('/img/ajax-loader.gif')  %>\" class=\"loading-img-change-preferred-method margin-r20\" style=\"display:none\" />\n        <div class=\"payment-logo-container paypal gatewayPP\" <%  if (templateData.firstAvailablePaymentMethod != 'gatewayPP') {  %> style=\"display:none\" <%  }  %>>\n            <span class=\"payment-icon-paypal\"></span>\n            <div class=\"clear\"></div>\n        </div>\n        <div class=\"payment-logo-container cc gatewayGC gatewayWP gatewayNAB gatewayAdyen\" <%  if (templateData.firstAvailablePaymentMethod != 'gatewayGC' && templateData.firstAvailablePaymentMethod != 'gatewayWP' && templateData.firstAvailablePaymentMethod != 'gatewayNAB' && templateData.firstAvailablePaymentMethod != 'gatewayAdyen') {  %> style=\"display:none\" <%  }  %>>\n            <span class=\"payment-icon-mastercard\"></span>\n            <span class=\"payment-icon-amex\"></span>\n            <span class=\"payment-icon-visa\"></span>\n            <div class=\"clear\"></div>\n        </div>\n        <div class=\"payment-logo-container skrill gatewayMB\" <%  if (templateData.firstAvailablePaymentMethod != 'gatewayMB') {  %> style=\"display:none\" <%  }  %>>\n            <span class=\"payment-icon-skrill\"></span>\n        </div>\n        <div class=\"PaymentMethodSettings\">\n            <span class=\"showing-method-account-details gatewayPP\" <%  if (templateData.firstAvailablePaymentMethod != 'gatewayPP') {  %> style=\"display:none\" <%  }  %>>\n                <%  if (templateData.paymentMethods.ppEmail) {  %>\n                    <%-  templateData.paymentMethods.ppEmail  %>\n                <%  } %>\n            </span>\n            <span class=\"showing-method-account-details gatewayWP\" <%  if (templateData.firstAvailablePaymentMethod != 'gatewayWP') {  %> style=\"display:none\" <%  }  %>>\n                <%  if (templateData.paymentMethods.wpRecurring.length == 1) {  %>\n                    <span class=\"margin-l20\"><%-  templateData.paymentMethods.wpRecurring[0]['cc_number']  %></span>\n                <%  } else {  %>\n                    <span class=\"payment-source-tooltip gatewayWP margin-l20\"><%= T_('<[-numberOfAccounts]> contas disponíveis', { 'numberOfAccounts': templateData.paymentMethods.wpRecurring.length }) %></span>\n                <%  }  %>\n            </span>\n            <span class=\"showing-method-account-details gatewayNAB\" <%  if (templateData.firstAvailablePaymentMethod != 'gatewayNAB') {  %> style=\"display:none\" <%  }  %>>\n                <%  if (templateData.paymentMethods.nabRecurring.length == 1) {  %>\n                    <span class=\"margin-l20\"><%-  templateData.paymentMethods.nabRecurring[0]['cc_number']  %></span>\n                <%  } else {  %>\n                    <span class=\"payment-source-tooltip gatewayNAB margin-l20\"><%= T_('<[-numberOfAccounts]> contas disponíveis', { 'numberOfAccounts': templateData.paymentMethods.nabRecurring.length }) %></span>\n                <%  }  %>\n            </span>\n            <span class=\"showing-method-account-details gatewayAdyen\" <%  if (templateData.firstAvailablePaymentMethod != 'gatewayAdyen') {  %> style=\"display:none\" <%  }  %>>\n                <%  if (templateData.paymentMethods.adyenRecurring.length == 1) {  %>\n                    <span class=\"margin-l20\"><%-  templateData.paymentMethods.adyenRecurring[0]['cc_number']  %></span>\n                <%  } else {  %>\n                    <span class=\"payment-source-tooltip gatewayAdyen margin-l20\"><%= T_('<[-numberOfAccounts]> contas disponíveis', { 'numberOfAccounts': templateData.paymentMethods.adyenRecurring.length }) %></span>\n                <%  }  %>\n            </span>\n            <div class=\"payment-method-selector\">\n                <%  if (templateData.verifiedPaymentSourceCount > 1) {  %>\n                    <a href=\"#\" onclick=\"return false\" class=\"PaymentMethodSettings-control open-change-preferred-method\">\n                        <%- T_('Editar preferência') %>\n                    </a>\n                    <a href=\"#\" onclick=\"return false\" class=\"PaymentMethodSettings-control close-change-preferred-method\" style=\"display:none\">\n                        <%- T_('Cancelar') %>\n                    </a>\n                    <span class=\"PaymentMethodSettings-control PaymentMethodSettings-control-separator\" <%  if (templateData.preferredPaymentMethod != templateData.firstAvailablePaymentMethod) {  %> style=\"display:none\" <%  }  %>> | </span>\n                <%  }  %>\n                <span class=\"PaymentMethodSettings-control is-PaymentMethodSettings-control-active\" <%  if (templateData.preferredPaymentMethod != templateData.firstAvailablePaymentMethod) {  %> style=\"display:none\" <%  }  %>><%- T_('Preferencial') %></span>\n            </div>\n            <span class=\"showing-method-account-details gatewayGC\" <%  if (templateData.firstAvailablePaymentMethod != 'gatewayGC') {  %> style=\"display:none\" <%  }  %>>\n                <%  if (templateData.paymentMethods.gcRecurring.length == 1) {  %>\n                    <span class=\"margin-l20\"><%-  templateData.paymentMethods.gcRecurring[0]['cc_number']  %></span>\n                <%  } else {  %>\n                    <span class=\"payment-source-tooltip gatewayGC margin-l20\"><%= T_('<[-numberOfAccounts]> contas disponíveis', { 'numberOfAccounts': templateData.paymentMethods.gcRecurring.length }) %></span>\n                <%  }  %>\n            </span>\n            <span class=\"showing-method-account-details gatewayMB\" <%  if (templateData.firstAvailablePaymentMethod != 'gatewayMB') {  %> style=\"display:none\" <%  }  %>>\n                <%  if (templateData.paymentMethods.skrillPaymentVerified.length == 1) {  %>\n                    <%- T_('ID da Encomenda') %> <%-  templateData.paymentMethods.skrillPaymentVerified[0].onetap_invoice_id  %>\n                <%  } else {  %>\n                    <span class=\"payment-source-tooltip gatewayMB\"><%= T_('<[-numberOfAccounts]> contas disponíveis', { 'numberOfAccounts': templateData.paymentMethods.skrillPaymentVerified.length }) %></span>\n                <%  }  %>\n            </span>\n            <div class=\"clear\"></div>\n            <select class=\"default-select change-preferred-method\" style=\"display:none\">\n                <option value=\"\" selected=\"selected\"><%- T_('Selecione seu método de pagamento preferencial') %></option>\n                <%  if (templateData.paymentMethods.ppEmail) {  %>\n                    <option value=\"gatewayPP\"><%- T_('PayPal:') %> (<%-  templateData.paymentMethods.ppEmail  %>)</option>\n                <%  }  %>\n                <%  if (templateData.paymentMethods.gcRecurring) {  %>\n                    <option value=\"gatewayGC\"><%- T_('Cartão de Crédito:') %>\n                        <%  if (templateData.paymentMethods.gcRecurring.length == 1) {  %>\n                            (<%-  templateData.paymentMethods.gcRecurring[0]['cc_number']  %>)\n                        <%  } else {  %>\n                            (<%= T_('<[-numberOfAccounts]> contas disponíveis', { 'numberOfAccounts': templateData.paymentMethods.gcRecurring.length }) %>)\n                        <%  }  %>\n                    </option>\n                <%  }  %>\n                <%  if (templateData.paymentMethods.wpRecurring) {  %>\n                    <option value=\"gatewayWP\"><%- T_('Cartão de Crédito:') %>\n                    <%  if (templateData.paymentMethods.wpRecurring.length == 1) {  %>\n                        (<%-  templateData.paymentMethods.wpRecurring[0]['cc_number']  %>)\n                    <%  } else {  %>\n                        (<%= T_('<[-numberOfAccounts]> contas disponíveis', { 'numberOfAccounts': templateData.paymentMethods.wpRecurring.length }) %>)\n                    <%  }  %>\n                    </option>\n                <%  }  %>\n                <%  if (templateData.paymentMethods.skrillPaymentVerified) {  %>\n                    <option value=\"gatewayMB\"><%-  T_('Skrill:')  %>\n                    <%  if (templateData.paymentMethods.skrillPaymentVerified.length == 1) {  %>\n                        (<%- T_('ID da Encomenda:') %> <%-  templateData.paymentMethods.skrillPaymentVerified[0].onetap_invoice_id  %>)\n                    <%  } else {  %>\n                        (<%= T_('<[-numberOfAccounts]> contas disponíveis', { 'numberOfAccounts': templateData.paymentMethods.skrillPaymentVerified.length }) %>)\n                    <%  }  %>\n                    </option>\n                <%  }  %>\n            </select>\n        </div>\n        <div class=\"payments-source-generic-error margin-t10 alert alert-error\" style=\"display:none\"></div>\n    </div>\n<%  }  %>\n";

/**
 * NOTE: This file needs to be kept in sync with the non-SystemJS variant:
 * /public/static/js/payments/module-payments-source.js
 * Please replicate all changes to the other file.
 */

var moduleData = false;
var $el = false;
var moduleSettings = {
  disableCC: false,
  disableBalance: false,
  showWireTransferLink: false };

function init(paymentsSourceDetails, paymentsSourceContainer, preferredSettings) {
  jq.extend(moduleSettings, preferredSettings);

  if (typeof paymentsSourceDetails === 'object') {
    moduleData = paymentsSourceDetails;
  } else {
    return;
  }
  if (typeof paymentsSourceContainer !== 'undefined') {
    $el = paymentsSourceContainer;
  } else {
    return;
  }
  if (!validateAndPrepareData()) {
    return;
  }
  $el.html('<img src="' + cdn_url('/img/ajax-loader.gif') + '" ' + 'class="loading-payment-source-module margin-center block" />');

  jq.ajax({
    type: 'post',
    data: {
      currency: moduleData.currencyDetails.id },

    url: '/ajax/payment/getUserPaymentMethodInfo.php',
    dataType: 'json',
    success: function success(response) {
      if (response.status == 'success') {
        moduleData.balances = response.balances;
        moduleData.paymentMethods = response.paymentMethods;
        moduleData.firstAvailablePaymentMethod = response.firstAvailablePaymentMethod;
        moduleData.preferredPaymentMethod = response.preferredPaymentMethod;
        for (var i = 0; i < moduleData.balances.length; i++) {
          if (parseFloat(moduleData.balances[i].balance) > 0) {
            moduleData.totalBalanceIsEmpty = false;
            break;
          }
        }

        if (moduleSettings.disableCC) {
          removeCC();
        }

        if (moduleSettings.disableBalance) {
          removeBalance();
        }

        if (moduleSettings.showWireTransferLink) {
          includeWireTransferLink();
        }

        reconstructBalances();
        countVerifiedPaymentSource();
        render();
        buildBinds();
        checkPaymentSource(moduleData.amount);
      }
    },
    complete: function complete() {
      $el.find('.loading-payment-source-module').remove();
    }
  });
}

function removeCC() {
  moduleData.hasVerifiedCreditCard = moduleData.paymentMethods.gcRecurring || moduleData.paymentMethods.wpRecurring;
  moduleData.removedCC = true;
  moduleData.paymentMethods.gcRecurring = false;
  moduleData.paymentMethods.wpRecurring = false;

  moduleData.preferredPaymentMethod = 'gatewayPP';
  moduleData.firstAvailablePaymentMethod = 'gatewayPP';
}

function removeBalance() {
  moduleData.balances = [];
  moduleData.totalBalanceIsEmpty = true;
}

function includeWireTransferLink() {
  moduleData.showWireTransferLink = true;
}

function validateAndPrepareData() {
  if (typeof moduleData.amount === 'undefined' || Number.isNaN(moduleData.amount) || !moduleData.amount || typeof moduleData.currencyDetails === 'undefined') {
    return false;
  }
  moduleData.amount = parseFloat(moduleData.amount);
  moduleData.primaryBalanceForPayment = false;
  moduleData.totalBalanceIsEmpty = true;
  moduleData.verifiedPaymentSourceCount = 0;
  return true;
}

function render() {
  var tpl = paymentsSourceTemplate;

  if (typeof tpl === 'undefined') {
    tpl = jq('#payment-source-template').html();
  }

  $el.html(_.template(tpl)({
    templateData: moduleData,
    T_: translate,
    cdn_url: cdn_url }));
}

function checkPaymentSource(amountToCheck) {
  $el.find('.payment-from-option, .account-balances, .payment-logos-container').hide();
  if (Number.isNaN(amountToCheck) || !amountToCheck) {
    return;
  }

  amountToCheck = parseFloat(amountToCheck);

  if (moduleData.totalBalanceIsEmpty) {
    // If all balances are zero
    if (moduleData.firstAvailablePaymentMethod) {
      $el.find('.only-vpm, .payment-logos-container').show();
    } else {
      customizePaymentSourceNeedDepositContent();
      $el.find('.need-deposit').show();
    }
  } else if (moduleData.primaryBalanceForPayment && amountToCheck <= moduleData.primaryBalanceForPayment.balance) {
    // If primary balance is sufficient
    $el.find('.only-balance, .account-balances').show();
    // Primary balance is insufficient but not zero balances among all balances
  } else if (moduleData.firstAvailablePaymentMethod) {
    $el.find('.mixed-balance-vpm, .account-balances, .payment-logos-container').show();
  } else if (moduleData.balances.length === 1 && moduleData.balances[0].currency.id == moduleData.currencyDetails.id) {
    customizePaymentSourceNeedDepositContent();
    $el.find('.need-deposit').show();
  } else {
    $el.find('.may-need-deposit, .account-balances').show();
  }
}

function buildBinds() {
  jq(document).ready(function () {
    $el.off('change', '.change-preferred-method').on('change', '.change-preferred-method', function () {
      var that = jq(this);
      var method = that.val();
      if (!method) {
        return;
      }
      var existingMethod = $el.find('.payment-logo-container:visible, ' + '.showing-method-account-details:visible');

      jq.ajax({
        url: '/ajax/user/setUserPreferedPayment.php',
        dataType: 'json',
        type: 'post',
        data: {
          method: method },

        beforeSend: function beforeSend() {
          that.hide();
          $el.find('.payment-logo-container, .close-change-preferred-method, ' + '.showing-method-account-details').hide();
          $el.find('.loading-img-change-preferred-method, ' + '.open-change-preferred-method').show();
          $el.find('.payments-source-generic-error').html('').hide();
          $el.closest('.modal').find('.btn').attr('disabled', true);
        },
        success: function success(response) {
          if (response.result == 'success') {
            $el.find('.is-preferred, .is-preferred-separator, ' + ('.payment-logo-container.' + method + ', ') + ('.showing-method-account-details.' + method)).show();
            moduleData.preferredPaymentMethod = method;
          } else {
            $el.find('.payments-source-generic-error').html(translate('Falha ao salvar o seu método de pagamento preferido. Por favor, tente novamente.')).show();
            existingMethod.show();
          }
        },
        error: function error() {
          $el.find('.payments-source-generic-error').html(translate('Erro do Servidor')).show();
          existingMethod.show();
        },
        complete: function complete() {
          $el.find('.loading-img-change-preferred-method').hide();
          // front end delay for potential slave drift
          setTimeout(function () {
            $el.closest('.modal').find('.btn').removeAttr('disabled');
          }, 1200);
        }
      });
    });

    $el.off('click', '.open-change-preferred-method').on('click', '.open-change-preferred-method', function () {
      jq(this).hide();
      $el.find('.is-preferred').hide();
      $el.find('.change-preferred-method, .close-change-preferred-method').show();
    });

    $el.off('click', '.close-change-preferred-method').on('click', '.close-change-preferred-method', function () {
      jq(this).hide();
      $el.find('.change-preferred-method').hide();
      if (moduleData.preferredPaymentMethod) {
        $el.find('.is-preferred').show();
      }
      $el.find('.open-change-preferred-method').show();
    });

    $el.find('.payment-source-tooltip.gatewayGC').popover({
      content: function content() {
        var gatewayGCAccounts = [];
        if (moduleData.paymentMethods.gcRecurring) {
          for (var i = 0; i < moduleData.paymentMethods.gcRecurring.length; i++) {
            gatewayGCAccounts.push(moduleData.paymentMethods.gcRecurring[i].cc_number);
          }
        }
        return gatewayGCAccounts.join('<br>');
      },

      title: 'Credit cards',
      placement: 'top',
      html: true,
      trigger: 'hover' });

    $el.find('.payment-source-tooltip.gatewayWP').popover({
      content: function content() {
        var gatewayWPAccounts = [];
        if (moduleData.paymentMethods.wpRecurring) {
          for (var i = 0; i < moduleData.paymentMethods.wpRecurring.length; i++) {
            gatewayWPAccounts.push(moduleData.paymentMethods.wpRecurring[i].cc_number);
          }
        }
        return gatewayWPAccounts.join('<br>');
      },

      title: translate('Cartões de crédito'),
      placement: 'top',
      html: true,
      trigger: 'hover' });

    $el.find('.payment-source-tooltip.gatewayMB').popover({
      content: function content() {
        var gatewayMBAccounts = [];
        if (moduleData.paymentMethods.skrillPaymentVerified) {
          for (var i = 0; i < moduleData.paymentMethods.skrillPaymentVerified.length; i++) {
            gatewayMBAccounts.push(moduleData.paymentMethods.skrillPaymentVerified[i].onetap_invoice_id);
          }
        }
        return gatewayMBAccounts.join('<br>');
      },

      placement: 'top',
      html: true,
      trigger: 'hover' });
  });
}

function reconstructBalances() {
  // Remove balances with zero amount and set the primary balance to balance
  // with payment's currency
  for (var i = 0; i < moduleData.balances.length;) {
    moduleData.balances[i].balance = parseFloat(moduleData.balances[i].balance);
    if (moduleData.balances[i].balance == 0) {
      moduleData.balances.splice(i, 1);
    } else if (moduleData.balances[i].currency.id == moduleData.currencyDetails.id) {
      moduleData.primaryBalanceForPayment = moduleData.balances[i];
      moduleData.balances.splice(i, 1);
    } else {
      i++;
    }
  }
  if (moduleData.primaryBalanceForPayment) {
    moduleData.balances.unshift(moduleData.primaryBalanceForPayment);
  }
}

function countVerifiedPaymentSource() {
  if (moduleData.firstAvailablePaymentMethod) {
    if (moduleData.paymentMethods.ppEmail) {
      moduleData.verifiedPaymentSourceCount++;
    }
    if (moduleData.paymentMethods.gcRecurring) {
      moduleData.verifiedPaymentSourceCount++;
    }
    if (moduleData.paymentMethods.wpRecurring) {
      moduleData.verifiedPaymentSourceCount++;
    }
    if (moduleData.paymentMethods.skrillPaymentVerified) {
      moduleData.verifiedPaymentSourceCount++;
    }
  }
}

function customizePaymentSourceNeedDepositContent() {
  if (typeof moduleData.needDepositCustomTitle !== 'undefined') {
    $el.closest('.modal').find('.modal-header h3').html(moduleData.needDepositCustomTitle);
  }

  if (typeof moduleData.needDepositCustomBody !== 'undefined') {
    $el.find('.need-deposit').html(moduleData.needDepositCustomBody);
  }
  if (typeof moduleData.needDepositAmountDiv !== 'undefined' && !moduleData.needDepositAmountDiv) {
    $el.find('.payment-from').hide();
    $el.closest('.modal-body').find('p:first').hide();
  }

  if (typeof moduleData.needDepositConfirmText !== 'undefined') {
    $el.closest('.modal').find('.modal-footer .modal-btn-confirm-payment').html(moduleData.needDepositConfirmText);
  }
  if (typeof moduleData.needDepositCancelText !== 'undefined') {
    $el.closest('.modal').find('.modal-footer .modal-btn-cancel-payment').html(moduleData.needDepositCancelText);
  }
}

var modulePaymentsSource = {
  init: init,
  checkPaymentSource: checkPaymentSource };

var awardUpgradeTemplate = "<thead>\n  <tr>\n      <th class=\"milestone-table-name\" colspan=\"4\"><%- T_('Melhorias Recomendadas') %></th>\n  </tr>\n</thead>\n<tbody class=\"project-displayed-upgrades\">\n    <%  if (!templateVars.upgraded.nda) {  %>\n    <tr class=\"upgrade-listing-upgrade js-upgrade\">\n        <td class=\"upgrade-listing-select\">\n            <input type=\"checkbox\" name=\"chkbx_nda\" data-name=\"nda\"\n                   class=\"custom-checkbox upgrade-checkbox\" id=\"checkbox_nda\"\n                   <%  if (templateVars.hireMeNdaPreTick) {  %> checked <%  } %>>\n            <label class=\"custom-checkbox\" for=\"checkbox_nda\"></label>\n        </td>\n        <td class=\"upgrade-listing-type\">\n            <label class=\"upgrade-listing-select-label custom-checkbox\" for=\"checkbox_nda\">\n            <span class=\"promotion-tag has-no-icon promotion-nda\"><%- T_('ADC') %></span>\n            </label>\n        </td>\n        <td class=\"upgrade-listing-description\">\n            <label class=\"upgrade-listing-select-label custom-checkbox\" for=\"checkbox_nda\">\n            <%= T_('Os freelancers devem assinar um <a href=\"/NDA/NDA-print-contract.php\" target=\"_blank\">Acordo de Confidencialidade</a>  para trabalhar em seu projeto.') %>\n            </label>\n        </td>\n        <td class=\"upgrade-listing-price js-upgrade-price\">\n            <label class=\"upgrade-listing-select-label custom-checkbox\" for=\"checkbox_nda\">\n            <%  if (templateVars.upgrade_prices.nda == 0) { %>\n            <span><%- T_('GRÁTIS') %></span>\n            <%  } else {  %>\n            <span class=\"currency-sign\"><%-  templateVars.currency  %></span><span class='upgrade-price' id=\"nda-upgrade-price\"><%-  (templateVars.upgrade_prices.nda).toFixed(2)  %></span>\n            <%  }  %>\n            </label>\n        </td>\n    </tr>\n    <%  }  %>\n</tbody>\n<tbody class=\"is-hidden project-hidden-upgrades\">\n    <%  if (!templateVars.upgraded.nonpublic) {  %>\n    <tr class=\"upgrade-listing-upgrade js-upgrade project-upgrade-item\">\n        <td class=\"upgrade-listing-select\">\n            <input type=\"checkbox\" name=\"chkbx_nonpublic\" data-name=\"private\" class=\"custom-checkbox upgrade-checkbox\" id=\"checkbox_private\">\n            <label class=\"custom-checkbox\" for=\"checkbox_private\"></label>\n        </td>\n        <td class=\"upgrade-listing-type\">\n          <label class=\"upgrade-listing-select-label custom-checkbox\" for=\"checkbox_private\">\n            <span class=\"promotion-tag has-no-icon promotion-private\"><%- T_('Privado') %></span>\n          </label>\n        </td>\n        <td class=\"upgrade-listing-description\">\n          <label class=\"upgrade-listing-select-label custom-checkbox\" for=\"checkbox_private\">\n            <%= T_('Quero <strong>ocultar os detalhes do projeto</strong> de mecanismos de busca e usuários que não estão logados.') %>\n            <%- T_('Este recurso é recomendado para projetos em que a confidencialidade é indispensável.') %>\n          </label>\n        </td>\n        <td class=\"upgrade-listing-price js-upgrade-price\">\n            <label class=\"upgrade-listing-select-label custom-checkbox\" for=\"checkbox_private\">\n            <%  if (templateVars.upgrade_prices.nonpublic == 0) { %>\n            <span><%- T_('GRÁTIS') %></span>\n            <%  } else {  %>\n            <span class=\"currency-sign\"><%-  templateVars.currency  %></span><span class='upgrade-price' id=\"private-upgrade-price\"><%-  (templateVars.upgrade_prices.nonpublic).toFixed(2)  %></span>\n            <%  }  %>\n            </label>\n        </td>\n    </tr>\n    <%  }  %>\n    <%  if (!templateVars.upgraded.fulltime) {  %>\n    <tr class=\"upgrade-listing-upgrade js-upgrade project-upgrade-item\" style=\"display: table-row;\">\n        <td class=\"upgrade-listing-select\">\n            <input type=\"checkbox\" name=\"chkbx_fulltime\" data-name=\"fulltime\" class=\"custom-checkbox upgrade-checkbox\" id=\"checkbox_fulltime\">\n            <label class=\"custom-checkbox\" for=\"checkbox_fulltime\"></label>\n        </td>\n        <td class=\"upgrade-listing-type\">\n            <label class=\"upgrade-listing-select-label custom-checkbox\" for=\"checkbox_fulltime\">\n            <span class=\"promotion-tag has-no-icon promotion-fulltime\"><%- T_('Tempo Integral') %></span>\n            </label>\n        </td>\n        <td class=\"upgrade-listing-description\">\n            <label class=\"upgrade-listing-select-label custom-checkbox\" for=\"checkbox_fulltime\">\n            <%- T_('Este projeto é para contratar uma posição em tempo integral ou baseada em comissões (ex. Vendas) e você irá poupar dinheiro se tiver um trabalho continuado. As taxas são apenas cobradas se o valor do projeto exceder os $5000 Dólares.') %>\n            </label>\n        </td>\n        <td class=\"upgrade-listing-price js-upgrade-price\">\n            <label class=\"upgrade-listing-select-label custom-checkbox\" for=\"checkbox_fulltime\">\n            <%  if (templateVars.upgrade_prices.fulltime == 0) { %>\n            <span><%- T_('GRÁTIS') %></span>\n            <%  } else {  %>\n            <span class=\"currency-sign\"><%-  templateVars.currency  %></span><span class='upgrade-price' id=\"fulltime-upgrade-price\"><%-  (templateVars.upgrade_prices.fulltime).toFixed(2)  %></span>\n            <%  }  %>\n            </label>\n        </td>\n    </tr>\n    <%  }  %>\n</tbody>\n";

var $el$1 = void 0;
var createMilestone = void 0;
var milestoneScope = void 0;
var milestoneData = void 0;

var project = void 0;
var upgradePrices = {};
var upgraded = {};
var projectConfig = {};

var showUpgrade = true;
var upgradeData = [];

var abTestPrehire = false;

function init$1() {
  if (!showUpgrade) {
    return;
  }
  if (jq('#milestone-modal-upgrade-section').is(':empty')) {
    render$1();
  }
  // Add QTS events for different upgrades.
  jq('input[type="checkbox"]').change(function () {
    var qtsData = {
      section: 'ProjectUpgrade',
      subsection: 'HireMe Milestone',
      label: this.checked ? 'select' : 'unselect',
      action: this.checked ? 'click' : 'unclick',
      name: 'Upgrade Type',
      value: jq(this).data('name') };

    if (typeof project !== 'undefined') {
      qtsData.reference = 'project_id';
      qtsData.reference_id = project.id;
    }
    window._t.push(['user_action', qtsData]);
  });
}

function render$1() {
  jq('#milestone-modal-upgrade-section').append(_.template(awardUpgradeTemplate)({
    templateVars: prepareVars(),
    T_: translate })).removeClass('is-hidden');
  $el$1 = jq('#milestone-modal-upgrade-section');
  buildBind();
}

// determine whether to show upgrades upsell section
function prepareUpgradeABTest(id, master) {
  var deferred = jq.Deferred();
  var data = {
    id: id };

  if (master) {
    data.m = 1;
  }
  jq.ajax({
    type: 'get',
    url: '/ajax/buyer/upgrade_info.php',
    data: data,
    dataType: 'json',
    success: function success(response) {
      if (response.status === 'success') {
        // if can not be upgrade then skip upsell upgrade step
        if (!response.can_be_upgraded) {
          showUpgrade = false;
        }
        // if no more upgrades to upsell then skip upsell upgrade step
        upgraded.nda = response.project.NDA !== 'N';
        upgraded.nonpublic = response.project.nonpublic !== '0';
        upgraded.fulltime = response.project.fulltime !== '0' || response.project.hourly !== '0';
        if (upgraded.nda && upgraded.nonpublic && upgraded.fulltime) {
          showUpgrade = false;
        }
        project = response.project;
        projectConfig = response.project_config;
      } else {
        showUpgrade = false;
      }
      deferred.resolve(showUpgrade);
    },
    error: function error() {
      showUpgrade = false;
      deferred.resolve(showUpgrade);
    }
  });

  return deferred.promise();
}

function prepareUpgradeForPreHireChat(currency_id) {
  abTestPrehire = true;
  var deferred = jq.Deferred();
  var data = {
    raw: true,
    currency: currency_id };

  jq.ajax({
    type: 'get',
    url: '/buyers/on-currency-control.php',
    data: data,
    dataType: 'json',
    success: function success(response) {
      if (response.status === 'success') {
        projectConfig = {
          nonpublic_price: parseFloat(response.projectConfig.nonpublic_price),
          NDA_price: parseFloat(response.projectConfig.NDA_price),
          fulltime_price: parseFloat(response.projectConfig.fulltime_price),
          currency: response.currencyArray.sign };
      } else {
        showUpgrade = false;
      }
      deferred.resolve(showUpgrade);
    },
    error: function error() {
      showUpgrade = false;
      deferred.resolve(showUpgrade);
    }
  });

  return deferred.promise();
}

function prepareVars() {
  var vars = {};
  upgradePrices.nonpublic = projectConfig.nonpublic_price;
  upgradePrices.nda = projectConfig.NDA_price;
  upgradePrices.fulltime = projectConfig.fulltime_price;
  vars.upgrade_prices = upgradePrices;
  vars.upgraded = upgraded;
  if (!abTestPrehire) {
    vars.currency = project.currency.sign;
  } else {
    vars.currency = projectConfig.currency;
  }
  return vars;
}

function buildBind() {
  if (jq.trim($el$1.find('.project-displayed-upgrades').html()) === '') {
    var hiddenUpgrades = $el$1.find('.project-hidden-upgrades');
    jq(hiddenUpgrades).find('tr').first().appendTo($el$1.find('.project-displayed-upgrades'));
  }
  if (jq.trim($el$1.find('.project-hidden-upgrades').html()) !== '') {
    var viewMore = translate('Ver mais melhorias');
    var viewMoreHTML = '\n      <a href="#" class="upgrade-listing-more">' + viewMore + '</a>';
    $el$1.find('.upgrade-listing-upgrade .upgrade-listing-description').first().append(viewMoreHTML);
    $el$1.find('.upgrade-listing-more').click(function (e) {
      jq(e.target).remove();
      $el$1.find('.project-hidden-upgrades').removeClass('is-hidden');
    });
  }
}

function doUpgrade(projectId) {
  var deferred = jq.Deferred();
  var ajaxData = {};
  ajaxData.csrf_token = getCSRFToken();
  ajaxData.data = {};
  getUpgrades();
  jq.each(upgradeData, function (i, upgrade) {
    ajaxData.data[upgrade] = 'on';

    window._t.push(['user_action', {
      section: 'ProjectUpgrade',
      subsection: 'HireMe Milestone',
      label: 'confirm payment',
      action: 'click',
      name: 'Upgrade Type',
      value: upgrade,
      reference: 'project_id',
      reference_id: projectId }]);
  });
  ajaxData.id = projectId;
  jq.ajax({
    type: 'post',
    url: '/ajax/buyer/onupgrade.php',
    dataType: 'json',
    data: ajaxData,
    success: function success(resp) {
      if (resp.status === 'failed') {
        deferred.reject(resp.error);
      } else if (resp.status === 'insuffunds') {
        window.location.replace(resp.depositLink);
        deferred.reject('');
      } else {
        deferred.resolve(true);
      }
    },
    error: function error() {
      var errorMessage = translate('Erro interno, por favor, tente novamente mais tarde.');
      deferred.reject(errorMessage);
    }
  });

  return deferred.promise();
}

// // used for upgrade and create milestone on nonhireme award
function upgradeAndCreateMilestoneBreakdowns(data, callback, scope) {
  milestoneData = data;
  createMilestone = callback;
  milestoneScope = scope;
  var $footer = jq('.milestone-modal .modal-footer');
  var spinner = '\n    <img id="award-loading" src="' + cdn_url('/img/ajax-loader.gif') + '"/>';
  jq('#milestone-error').html('');
  if (upgradeData.length > 0) {
    $footer.append(spinner).find('.btn').hide();
    // preprocess
    prepareAmount(upgradeData, milestoneData).then(function () {
      // milestone
      createMilestone.call(milestoneScope, milestoneData);
      // upgrade
      var upgradeCallData = {
        id: project.id,
        data: {} };

      jq.each(upgradeData, function (key, upgrade) {
        upgradeCallData.data[upgrade] = 'on';
      });
      jq('#upgradeProjectContainer').trigger('onupgradeCall', [upgradeCallData]);
    }, function (error) {
      if (error) {
        jq('#milestone-error').html(error);
      }
    }).always(function () {
      $footer.find('#award-loading').remove();
      $footer.find('.btn').show();
    });
  } else {
    createMilestone.call(milestoneScope, milestoneData);
  }
}

// used for upgrade and create milestone on hireme
function upgradeAndCreateMilestone(data, form, callback, scope) {
  var isPrehireProject = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  milestoneData = {};
  milestoneData.milestone_amount = form.find('.milestone-amount').val();
  milestoneData.description = form.find('.milestone-descr').val();
  milestoneData.project_id = data.project_id;
  milestoneData.currency_id = data.currency_id;
  milestoneData.seller_id = data.seller_id;
  milestoneData.seller_name = data.seller_username;

  createMilestone = callback;
  var $footer = jq('.milestone-modal .modal-footer');
  var spinner = '\n    <img id="award-loading" src="' + cdn_url('/img/ajax-loader.gif') + '" />';
  jq('#milestone-error').html('');
  if (upgradeData.length > 0) {
    $footer.append(spinner).find('.btn').hide();
    // preprocess
    prepareAmount(upgradeData, milestoneData).then(function () {
      // upgrade
      doUpgrade(data.project_id).then(function () {
        // milestone
        createMilestone.call(scope, form, isPrehireProject);
      }, function (error) {
        if (error) {
          jq('#milestone-error').html(error);
        }
        $footer.find('.btn').show();
      }).always(function () {
        $footer.find('#award-loading').remove();
      });
    }, function (error) {
      jq('#milestone-error').html(error);
    });
  } else {
    createMilestone.call(scope, form, isPrehireProject);
  }
}

function prepareAmount(upgradeData, milestoneData) {
  var deferred = jq.Deferred();
  var ajaxData = milestoneData;
  ajaxData.chosen_upgrades = upgradeData;
  jq.ajax({
    type: 'post',
    url: '/ajax/payment/on-preprocess-upgrades-and-milestones.php',
    dataType: 'json',
    data: ajaxData,
    headers: { 'X-XSRF-TOKEN': getCSRFToken() },
    success: function success(response) {
      if (response.status === 'success') {
        if (response.force_pv) {
          window.location.href = '/payments/verify.php?referral-program=true\n            &new_signup=true&project_id=' + milestoneData.project_id + '&data_token=' + response.data_token;
          deferred.reject('');
        } else if (response.diff_amount) {
          var uri = '/deposit/?' + ('amount=' + encodeURIComponent(response.diff_amount)) + ('&currency=' + encodeURIComponent(response.currency_id)) + ('&id=' + encodeURIComponent(response.project_id));
          if (response.ref_action && response.data_token) {
            uri += '&refAction=' + response.ref_action;
            uri += '&dataToken=' + response.data_token;
          }
          if (response.back_url) {
            uri += '&back=' + response.back_url;
          }
          window.location = uri;
          deferred.reject('');
        } else {
          deferred.resolve(true);
        }
      } else {
        deferred.reject(response.msg);
      }
    },
    error: function error() {
      var errorMessage = translate('Erro interno, por favor, tente novamente mais tarde.');
      deferred.reject(errorMessage);
    }
  });

  return deferred.promise();
}

function getUpgrades() {
  upgradeData = [];
  if ($el$1.find('#checkbox_nda').length > 0 && $el$1.find('#checkbox_nda').is(':checked')) {
    upgradeData.push('nda');
  }
  if ($el$1.find('#checkbox_private').length > 0 && $el$1.find('#checkbox_private').is(':checked')) {
    upgradeData.push('nonpublic');
  }
  if ($el$1.find('#checkbox_fulltime').length > 0 && $el$1.find('#checkbox_fulltime').is(':checked')) {
    upgradeData.push('fulltime');
  }
}

function getUpgradeTotal() {
  getUpgrades();
  var total = 0;
  jq.each(upgradeData, function (i, upgrade) {
    total += upgradePrices[upgrade];
  });
  return total;
}

var awardUpgrades = {
  init: init$1,
  prepareUpgradeABTest: prepareUpgradeABTest,
  prepareUpgradeForPreHireChat: prepareUpgradeForPreHireChat,
  upgradeAndCreateMilestoneBreakdowns: upgradeAndCreateMilestoneBreakdowns,
  upgradeAndCreateMilestone: upgradeAndCreateMilestone,
  getUpgradeTotal: getUpgradeTotal };

var _classCallCheck = (function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
});

var _createClass = (function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
})();

var template$1 = "<div id=\"<%=  id  %>\" class=\"Modal <%=  extraClass  %>\" data-modal aria-hidden=\"<%=  hideModal  %>\">\n  <div class=\"Modal-inner\" <%  if (backdropClose) {  %> data-modal-outbound <%  }  %>>\n    <div class=\"Modal-dialog\" role=\"dialog\">\n      <div class=\"Modal-content Card\" role=\"document\">\n        <%  if (closeButton) {  %>\n        <button class=\"Modal-close\" type=\"button\" data-modal-hide aria-label=\"Close this modal window\">\n          <span class=\"Icon Icon--small\"><%=  uiIcon('ui-close')  %></span>\n        </button>\n        <%  }  %>\n        <%  if (header) {  %>\n        <header class=\"Modal-header\">\n          <%=  header  %>\n        </header>\n        <%  }  %>\n        <%  if (body) {  %>\n        <div class=\"Modal-body\">\n          <%=  body  %>\n        </div>\n        <%  }  %>\n        <%  if (footer) {  %>\n        <footer class=\"Modal-footer\">\n          <%=  footer  %>\n        </footer>\n        <%  }  %>\n      </div>\n    </div>\n  </div>\n  <div class=\"Modal-overlay\" tabindex=\"-1\"></div>\n</div>\n";

var OPEN_EVENT = {
  METHOD: 'method'
};

var CLOSE_EVENT = {
  ESC: 'esc',
  OUTOFBOUNDS: 'outofbounds',
  ELEMENT: 'element'
};

var defaultOptions = {
  main: document.querySelector('#main'),
  closeButton: true,
  backdropClose: true,
  extraClass: '',
  size: '',
  type: ''
};

// Template the modal's scaffolding by injecting header, body and footer
var scaffold = template(template$1);

/**
 * Modal constructor
 * @param {Node} node Dialog element
 * @param {Node} main Main element of the page
 */

var Modal = function () {
  /**
   * Modal constructor
   * @param  {String}   id                       An ID to apply to the modal.
   * @param  {Object}   content                  Content object to inject in the
   *                                             modal.
   * @param  {String}   content.header           Content for the header.
   * @param  {String}   content.body             Content for the body.
   * @param  {String}   content.footer           Content for the footer.
   * @param  {Object}   [options={}]             Options object for customise
   *                                             behaviour of modal.
   * @param  {Node}     [options.main]           An element to treat as the main
   *                                             content so that
   *                                             aria-hidden="true" can be
   *                                             toggled. Defaults to #main.
   * @param  {Boolean}  [options.closeButton]    Shows the x close button.
   *                                             Defaults to true.
   * @param  {Boolean}  [options.backdropClose]  Enables closing of modal via
   *                                             clicking on the backdrop.
   *                                             Defaults to true.
   * @param  {String}   [options.extraClass]     Adds extra classes to the
   *                                             modal.
   * @param  {String}   [options.size]           Sets the size of the modal.
   * @param  {String}   [options.type]           Sets the type of the modal.
   * @param  {Function} [options.onShow]         Callback function after showing
   *                                             the modal.
   * @param  {Function} [options.onHide]        Callback function after closing
   *                                             the modal.
   * @return {Modal}                             Modal instance.
   */
  function Modal(id, content, opts) {
    _classCallCheck(this, Modal);

    // Merge user options with defaultOptions
    var options = Object.assign({}, defaultOptions, opts);

    // Build configuration
    this.config = {
      id: id,
      content: {
        header: content.header,
        body: content.body,
        footer: content.footer
      },
      options: options
    };

    // Errors
    if (typeof this.config.id === 'undefined') {
      throw new TypeError('Modal id cannot be undefined.');
    }

    if (typeof this.config.content === 'undefined') {
      throw new TypeError('Modal content cannot be undefined.');
    }

    if (typeof this.config.options.main === 'undefined') {
      throw new TypeError('#main element does not exist.');
    }

    this.namespace = 'data-modal';
    this.body = document.body;
    this.main = this.config.options.main;

    // Appends markup to the body just before the </body>
    this.body.insertAdjacentHTML('beforeend', scaffold({
      uiIcon: uiIcon,
      id: this.config.id,
      hideModal: true,
      header: this.config.content.header,
      body: this.config.content.body,
      footer: this.config.content.footer,
      closeButton: this.config.options.closeButton,
      backdropClose: this.config.options.backdropClose,
      extraClass: this.config.options.extraClass + ' ' + (this.config.options.size + ' ') + ('' + this.config.options.type)
    }));

    this.node = document.getElementById(this.config.id);
    this.shown = false;

    this._bindEventsToModal();
    return this;
  }

  /**
   * Helper function that binds modal events to the modal element
   */

  _createClass(Modal, [{
    key: '_bindEventsToModal',
    value: function _bindEventsToModal() {
      var _this = this;

      // Bind show modal event to elements with <this.namespace>-show="<modal-id>"
      // data attributes
      Array.from(
      // Get all the elements with <this.namespace>-show="<modal-id>"
      document.querySelectorAll('[' + this.namespace + '-show="' + this.node.id + '"]')).forEach(function (opener) {
        opener.addEventListener('click', function () {
          return _this.show();
        });
      });

      // Bind hide modal event to elements with <this.namespace>-hide data
      // attributesmodules/membership/index.js
      Array.from(
      // Get all elements with <this.namespace>-hide inside the modal
      this.node.querySelectorAll('[' + this.namespace + '-hide]'))
      // Then combine it with all elements on the page that targets the modal
      // with <this.namespace>-hide="<modal-id>" for hiding
      .concat(Array.from(document.querySelectorAll('[' + this.namespace + '-hide="' + this.node.id + '"]'))).forEach(function (closer) {
        closer.addEventListener('click', function () {
          return _this.hide(CLOSE_EVENT.ELEMENT);
        });
      });

      // Hides modal when the user clicks out of bounds
      this.node.addEventListener('click', function (event) {
        if (event.target.hasAttribute(_this.namespace + '-outbound')) {
          _this.hide(CLOSE_EVENT.OUTOFBOUNDS);
        }
      });

      document.addEventListener('keydown', function (event) {
        // keydown on Esc key
        if (_this.shown && event.which === 27) {
          event.preventDefault();
          _this.hide(CLOSE_EVENT.ESC);
        }

        // keydown on Tab key
        if (_this.shown && event.which === 9) {
          _this._trapTabKey(_this.node, event);
        }
      });

      this.body.addEventListener('focus', function (event) {
        if (_this.shown && !_this.node.contains(event.target)) {
          _this._setFocusToFirstItem(_this.node);
        }
      }, true);
    }

    /**
     * Helper function to get all focusable children from a node
     * @param  {Node} node Node to look in
     * @return {Array}     Array of focusable nodes
     */

  }, {
    key: '_getFocusableChildren',
    value: function _getFocusableChildren(node) {
      var focusableElements = ['a[href]', 'area[href]', 'input:not([disabled])', 'select:not([disabled])', 'textarea:not([disabled])', 'button:not([disabled])', 'iframe', 'object', 'embed', '[contenteditable]', '[tabindex]:not([tabindex^="-"])'];

      return Array.from(node.querySelectorAll(focusableElements.join(','))).filter(function (child) {
        return !!(child.offsetWidth || child.offsetHeight || child.getClientRects().length);
      });
    }

    /**
     * Helper function trapping the tab key inside a node
     * @param  {Node} node    Node to trap tab key in
     * @param  {Object} event Event to intercept
     */

  }, {
    key: '_trapTabKey',
    value: function _trapTabKey(node, event) {
      var focusableChildren = this._getFocusableChildren(node);
      var focusedItemIndex = focusableChildren.indexOf(document.activeElement);

      if (event.shiftKey && focusedItemIndex === 0) {
        focusableChildren[focusableChildren.length - 1].focus();
        event.preventDefault();
      } else if (!event.shiftKey && focusedItemIndex === focusableChildren.length - 1) {
        focusableChildren[0].focus();
        event.preventDefault();
      }
    }

    /**
     * Helper function to focus first focusable item in node
     * @param {Node} node Node to search in for first focusable
     */

  }, {
    key: '_setFocusToFirstItem',
    value: function _setFocusToFirstItem(node) {
      var focusableChildren = this._getFocusableChildren(node);
      if (focusableChildren.length) focusableChildren[0].focus();
    }

    /**
     * Checks if scrollbar is visible.
     * Ported from the bootstrap v3.3.6.
     */

  }, {
    key: '_checkScrollbar',
    value: function _checkScrollbar() {
      var fullWindowWidth = window.innerWidth;

      this.bodyIsOverflowing = this.body.clientWidth < fullWindowWidth;
      this.scrollbarWidth = this._measureScrollbar();
    }

    /**
     * Sets the scrollbar padding offset on the body element.
     * Ported from the bootstrap v3.3.6.
     */

  }, {
    key: '_setScrollbar',
    value: function _setScrollbar() {
      var bodyPadding = parseInt(this.body.style.paddingRight || 0, 10);

      this.originalBodyPadding = this.body.style.paddingRight || '';

      if (this.bodyIsOverflowing) {
        this.body.style.paddingRight = '' + bodyPadding + this.scrollbarWidth + 'px';
      }
    }

    /**
     * Resets the padding on the body to the way it was with the scrollbar.
     * Ported from the bootstrap v3.3.6.
     */

  }, {
    key: '_resetScrollbar',
    value: function _resetScrollbar() {
      this.body.style.paddingRight = this.originalBodyPadding;
    }

    /**
     * Measures the width of the scrollbar.
     * Ported from the bootstrap v3.3.6.
     *
     * @return {Number} Width of the scrollbar.
     */

  }, {
    key: '_measureScrollbar',
    value: function _measureScrollbar() {
      var scrollDiv = document.createElement('div');
      // Injects some styling to the element which forces the display of a scroll
      // bar and places it off the page to ensure it is never visible.
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.overflow = 'scroll';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '100px';
      scrollDiv.style.height = '100px';

      this.body.appendChild(scrollDiv);
      var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      this.body.removeChild(scrollDiv);
      return scrollbarWidth;
    }

    /**
     * Show the modal with optional eventType identifier
     * @param  {String} eventType An identifier string to pass into the onShow
     *                            callback method.
     */

  }, {
    key: 'show',
    value: function show(eventType) {
      this.shown = true;
      this._checkScrollbar();
      this._setScrollbar();
      this.body.setAttribute(this.namespace + '-open', '');
      this.node.removeAttribute('aria-hidden');
      this.main.setAttribute('aria-hidden', 'true');
      this.focusedBeforeDialog = document.activeElement;
      this._setFocusToFirstItem(this.node);
      eventType = eventType || OPEN_EVENT.METHOD;

      if (this.config.options.onShow) {
        this.config.options.onShow(eventType);
      }
    }

    /**
     * Hide the modal
     * @param  {String} eventType An identifier string to pass into the onHide
     *                            callback method.
     */

  }, {
    key: 'hide',
    value: function hide(eventType) {
      this.shown = false;
      this._resetScrollbar();
      this.body.removeAttribute(this.namespace + '-open', '');
      this.node.setAttribute('aria-hidden', 'true');
      this.main.removeAttribute('aria-hidden');
      this.focusedBeforeDialog.focus();

      if (this.config.options.onHide) {
        this.config.options.onHide(eventType);
      }
    }

    /**
     * Dynamically change the template of the modal given the new template.
     * Use this if you want to change the content without creating a new modal
     * as this does not automatically hide the new content upon replacement
     *
     * @param  {Object} content Content object to inject in the modal.
     */

  }, {
    key: 'replaceTemplate',
    value: function replaceTemplate(content) {
      var newModalContent = scaffold({
        uiIcon: uiIcon,
        id: this.config.id,
        hideModal: false,
        header: content.header,
        body: content.body,
        footer: content.footer,
        closeButton: this.config.options.closeButton,
        backdropClose: this.config.options.backdropClose,
        extraClass: this.config.options.extraClass + ' ' + (this.config.options.size + ' ') + ('' + this.config.options.type)
      });

      // convert content to nodes
      var newModal = document.createElement('div');
      newModal.innerHTML = newModalContent;
      var newTemplate = newModal.childNodes[0];

      // replace with new template
      var fragment = document.createDocumentFragment();
      Array.prototype.forEach.call(newTemplate.children, function (child) {
        var childNode = child instanceof Node ? child : document.createTextNode(String(child));
        fragment.appendChild(childNode);
      });

      this.node.replaceChild(fragment, this.node.children[0]);

      // bind modal events
      this.node = document.getElementById(this.config.id);
      this._bindEventsToModal();
    }
  }]);

  return Modal;
}();

/**
* @ngdoc overview
* @name flTranslate
* @module flTranslate
* @description
*
* # flTranslate
* [flTranslate](https://gitlab.freelancer.com/angular/fl-translate) is a Web
* application translation framework using an innovating approach to extract the
* translatable strings JS templates, which mean that you should no longer need
* to annotate your application for translation. If the default extraction
* strategy is failing or returning unexpecting results, check the
* [documentation](https://gitlab.freelancer.com/angular/fl-translate) to learn
* how to handle them.
*
* This specific `flAngular` module is the client side component of that
* framework: once that the strings extracted from the HTML views & JavaScript
* source files have been translated,  
*/
var threepio = angular.module('threepio', [ngRoute]).name;

angular.module(threepio)
/**
 * @ngdoc directive
 * @name threepio.directive:i18nId
 * @element A
 * @function
 *
 * @description
*/
.directive('i18nId', ['$rootScope', '$compile', '$interpolate', 'Translation', 'Localization', function ($rootScope, $compile, $interpolate, Translation, Localization) {
  return {
    restrict: 'A',
    priority: -1,
    link: function link(scope, element) {
      function escapeRegExp(string) {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      }

      function translate(language) {
        $rootScope.$broadcast('threepio:beforeTranslate');
        Translation.loadTranslations(language).then(function () {
          Translation.translate(element[0]);
        }).finally(function () {
          // Only recompile element if it contains an interpolated expression
          if (scope && element.html() && element.html().match(escapeRegExp($interpolate.startSymbol()))) {
            $compile(element, null, 0)(scope);
          }
          element.removeAttr('i18n-cloak');
          $rootScope.$broadcast('threepio:afterTranslate');
        });
      }

      // Re-translate if the language has changed
      var unsub = $rootScope.$on('TranslationLanguageChange', function () {
        element.data('lang', Localization.language());
        translate(Localization.language());
      });
      scope.$on('$destroy', unsub);

      // Translate at link time if needed
      var lang = Localization.language();
      if (element.data('lang') !== lang) {
        element.data('lang', lang);
        translate(lang);
      }
    }
  };
}]);

angular.module('threepio')
/**
 * @ngdoc directive
 * @name threepio.directive:i18nId
 * @element A
 * @function
 *
 * @description
*/
.directive('i18nSrc', ['$rootScope', 'Localization', function ($rootScope, Localization) {
  return {
    restrict: 'A',
    link: function link(scope, element, attr) {
      function selectSrc() {
        var lang = Localization.language();
        if (lang !== Localization.defaultLanguage()) {
          attr.$set('src', attr.i18nSrc.replace(/\.[^.]*$/, '.' + lang + '$&'));
        } else {
          attr.$set('src', attr.i18nSrc);
        }
      }
      selectSrc();
      // Re-download if the language has changed
      $rootScope.$on('LocalizationLanguageChange', function () {
        selectSrc();
      });
    }
  };
}]);

angular.module('threepio')
/**
 * @ngdoc directive
 * @name threepio.directive:script
 * @restrict E
 *
 * @description
 * Load the content of a `<script>` element with a 'text/threepio'
 * type into the {@link threepio.translationCache `translationCache`}, so
 * that the catalog can be used by the
 * {@link threepio.service:translation `Translation Service`}.
 *
 * @param {string} type Must be set to `'text/threepio'`.
 * @param {string} lang Language of catalog
 */
.directive('script', ['TranslationsCache', function (TranslationsCache) {
  return {
    restrict: 'E',
    terminal: true,
    compile: function compile(element, attr) {
      if (attr.type === 'text/threepio') {
        var lang = attr.lang;
        // IE is not consistent, in scripts we have to read .text but in
        // other nodes we have to read .textContent
        var text = element[0].textContent.trim();
        TranslationsCache.put(lang, text);
      }
    }
  };
}]);

// FIXME: this is imported from flAngular to make threepio work with

/**
 *
 *
 * @param {any} expires   expiration in seconds
 * @returns               UTC string representation of the date
 *                        plus "expires" seconds
 */
function todayUTCString(expires) {
  var today = new Date();

  today.setTime(today.getTime() + expires * 1000);
  return today.toUTCString();
}

/**
* @ngdoc overview
* @name flCookies
* @module flCookies
* @description
*
* # flCookies
* The `flCookies` module provides a single
* {@link flCookies.CookieStore CookieStore} service that
* streamlines the interaction with the browser's cookies.
* AngularJS has
* {@link https://docs.angularjs.org/api/ngCookies/service/$cookieStore
* its own $cookieStore implementation} but it doesn't support setting any
* cookie option (e.g. *path*, *domain*, *secure*,
* and *expiration*) as of today. The APIs are the same than Angular's
* {@link https://docs.angularjs.org/api/ngCookies/service/$cookieStore
* $cookieStore} with an extra parameter (an object with
* ``expires``, ``path``, ``domain`` and ``secure`` as keys, ``expires``
* accepting different formats).
* It is currently used by ``flAuth`` (auth cookies) and ``flAnalytics``
* (tracking cookies), but you can easily use it in a custom service:
*
* ```
  angular.module('myApp')
  .factory('myAwesomeService', function(CookieStore) {
    return {
      setMagicCookie: function(magicNumber) {
        CookieStore.put('CHUCK_NORRIS', magicNumber, {
          expires: Infinity
        });

      ...
    }
  }
* ```
*/
angular.module('threepio')
/**
 * @ngdoc service
 * @name flCookies.CookieStore
 *
 * @description
 * A factory which creates a service that lets you interact with the browser's
 * cookies.
 *
 * The returned object has action methods which provide high-level behaviors
 * without the need to interact with the low level cookies implementation.
 */
.factory('ThreepioCookieStore', ['$document', function ($document) {
  return {
    /**
     * @ngdoc method
     * @name flCookies.CookieStore#get
     * @methodOf flCookies.CookieStore
     *
     * @description
     * Returns the value of given cookie key
     *
     * @param {String} key Id to use for lookup.
     * @returns {Object} Deserialized cookie value.
     */
    get: function get(key) {
      var re = new RegExp('(?:(?:^|.*;)\\s*' + encodeURIComponent(key).replace(/[-.+*]/g, '\\$&') + '\\s*\\=\\s*([^;]*).*$)|^.*$');
      var value = $document[0].cookie.replace(re, '$1');

      return decodeURIComponent(value) || null;
    },

    /**
     * @ngdoc method
     * @name flCookies.CookieStore#put
     * @methodOf flCookies.CookieStore
     *
     * @description
     * Sets a value for given cookie key
     *
     * @param {String} key Id for the `value`.
     * @param {Object} value The value you want to store in this cookie
     * @param {Object} options Additional settings for the cookie (optional):
     *
     * - expires: expiration date for the cookie
     * - domain: the domain for which the cookie is valid
     * - path: the path for which the cookie is valid
     * - secure: is cookie HTTPS only?
     */
    put: function put(key, value, options) {
      // Set cookie
      var cookie = encodeURIComponent(key) + '=' + encodeURIComponent(value);
      // See options
      if (options) {
        // Expiration date
        if (options.expires) {
          var date = void 0;

          switch (options.expires.constructor) {
            case Number:
              {
                if (options.expires === Infinity) {
                  date = 'Fri, 31 Dec 9999 23:59:59 GMT';
                } else {
                  // Note: we don't use max-age here because it's
                  // not supported in IE8.
                  date = todayUTCString(options.expires);
                }
                break;
              }
            case String:
              {
                date = options.expires;
                break;
              }
            case Date:
              {
                date = options.expires.toUTCString();
                break;
              }
            default:
              {
                date = todayUTCString(0);
                break;
              }
          }

          cookie += ';expires=' + date;
        }
        // Domain
        cookie += options.domain ? ';domain=' + options.domain : '';
        // Path
        cookie += options.path ? ';path=' + options.path : ';path=/';
        // HTTPS Only
        cookie += options.secure ? ';secure' : '';
      }
      // Save the cookie
      // Note: $document is a jqLite wrapper
      $document[0].cookie = cookie;
    },

    /**
     * @ngdoc method
     * @name flCookies.CookieStore#remove
     * @methodOf flCookies.CookieStore
     *
     * @description
     * Remove given cookie
     *
     * @param {String} key Id of the key-value pair to delete.
     * @param {Object} options Additional settings for the cookie (optional)
     */
    remove: function remove(key, options) {
      var opt = options || {};
      // Setting expiry date to a past date deletes a cookie
      opt.expires = new Date(0);
      this.put(key, '', opt);
    }
  };
}]);

angular.module('threepio')
/**
 * @ngdoc service
 * @name flTranslate.service:TranslationCache
 *
 * @description
 * Load the content of a `<script>` element with a 'text/fl-translate-catalog'
 * type into the {@link flTranslate.TranslationCache `TranslationCache`}, so
 * that the catalog can be used by the
 * {@link flTranslate.service:Translation `Translation Service`}.
 *
 * @param {string} type Must be set to `'text/fl-translate-catalog'`.
 * @param {string} lang Language of catalog
 */
.factory('TranslationsCache', ['$cacheFactory', function ($cacheFactory) {
  return $cacheFactory('translationscache');
}]);

function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function replaceVariables(message, variables) {
  var fixedMessage = message;

  angular.forEach(variables, function (val, name) {
    fixedMessage = fixedMessage.replace(new RegExp(escapeRegExp('${' + name + '}'), 'g'), val);
  });
  return fixedMessage;
}

angular.module('threepio')
/**
 * @ngdoc service
 * @name threepio.service:i18n
 *
 * @description
 */
.factory('i18n', function () {
  return function (message, variables) {
    if (angular.isObject(message)) {
      // plural form
      if (variables.count === 1) {
        return replaceVariables(message.one, variables);
      }
      if (angular.isDefined(message[variables.count])) {
        return replaceVariables(message[variables.count], variables);
      }
      return replaceVariables(message.other, variables);
    }
    return replaceVariables(message, variables);
  };
});

angular.module(threepio)
/**
 * @ngdoc provider
 * @name threepio.LocalizationProvider
 *
 * @description
 */
.provider('Localization', function LocalizationProvider() {
  var _defaultLanguage = 'en'; /* language of the site */
  var languageCookie = void 0;
  var languageCode$$1 = void 0;
  var cookieOptions = void 0;

  /**
  * @ngdoc method
  * @name threepio.LocalizationProvider#defaultLanguage
  *
  * @description Wrapper around Angular $routeProvider.when() method
  * acception the same parameters and returning the same value, creating
  * language-specific subdirectories for each language without a dedicated
  * ccTLD or subdomain (retrieved from the LocalizationProvider).
  */
  this.defaultLanguage = function (code) {
    if (code) {
      _defaultLanguage = code;
    }
    return _defaultLanguage;
  };

  /**
  * @ngdoc method
  * @name threepio.LocalizationProvider#setLanguageCookie
  *
  * @description
  * Set the name of the language cookie used to store the current
  * language of the user
  *
  * @param {String} Name of the language cookie
  */
  this.setLanguageCookie = function (name, options) {
    languageCookie = name;
    cookieOptions = options;
  };

  /**
  * @ngdoc method
  * @name threepio.LocalizationProvider#setLanguage
  *
  * @description
  * Sets the language code - will be the selected language
  * if the language cookie is not set
  *
  * @param {String} code ISO 639‑1 language code
  */
  this.setLanguage = function (code) {
    languageCode$$1 = code;
  };

  /**
  * @ngdoc service
  * @name threepio.Localization
  *
  * @description
  */
  this.$get = ['$q', '$injector', '$timeout', '$rootScope', 'ThreepioCookieStore', function ($q, $injector, $timeout, $rootScope, ThreepioCookieStore) {
    var _language = ThreepioCookieStore.get(languageCookie) || languageCode$$1 || _defaultLanguage;

    return {
      /**
      * @ngdoc method
      * @name threepio.Localization#language
      *
      * @description
      * Get/set the current language
      *
      * @param {String} ISO 639‑1 language code
      * @param {String} ifDefault Only set the language is the current
      * language is the default one
      * @return {String} When used as a getter, the current language code
      */
      language: function language(code, ifDefault) {
        var d = $q.defer();
        if (code && (!ifDefault || ifDefault && !ThreepioCookieStore.get(languageCookie))) {
          _language = code;
          ThreepioCookieStore.put(languageCookie, _language, cookieOptions);
          $injector.invoke(['Translation', function (Translation) {
            Translation.loadTranslations(_language).then(function () {
              d.resolve();
              $rootScope.$broadcast('LocalizationLanguageChange');
            }).catch(function () {
              d.reject();
            });
          }]);
          return d.promise;
        }
        return _language;
      },
      /**
      * @ngdoc method
      * @name threepio.Localization#defaultLanguage
      *
      * @description
      */
      defaultLanguage: function defaultLanguage() {
        return _defaultLanguage;
      }
    };
  }];
});

var _templateObject = _taggedTemplateLiteral(['', '://', '\n            ', '', '\n            ', ''], ['', '://', '\n            ', '', '\n            ', '']);

angular.module(threepio)
/**
 * @ngdoc provider
 * @name threepio.provider:LocalizedRouteProvider
 *
 * @description
 * Angular $routeProvider wrapper creating language-specific subdirectories
 * for each language without a dedicated ccTLD or subdomain.
 */
.provider('LocalizedRoute', ['$provide', '$routeProvider', 'LocalizationProvider', function LocalizedRouteProvider($provide, $routeProvider, LocalizationProvider) {
  var _this = this;

  var _languages = void 0;
  var localDomains = void 0;
  var primaryDomain = void 0;

  /**
  * @ngdoc method
  * @name threepio.LocalizedRouteProvider#languages
  *
  * @description
  * Set the supported languages
  *
  * @param arr {object} Map (3-letters ISO code -> Language name) of the
  * supported languages
  */
  this.languages = function (arr) {
    _languages = arr;
    return _this;
  };

  /**
  * @ngdoc method
  * @name threepio.LocalizedRouteProvider#localDomains
  *
  * @description
  * Set the ccTLDs used (if any) and their default language
  *
  * @param arr {object} Map (domain name -> 3-letters ISO code) of the
  * supported ccTLDs
  */
  this.localDomains = function (def, arr) {
    primaryDomain = def;
    localDomains = arr;
    return _this;
  };

  /**
  * @ngdoc method
  * @name threepio.LocalizedRouteProvider#when
  *
  * @description Wrapper around Angular $routeProvider.when() method
  * acception the same parameters and returning the same value, creating
  * language-specific subdirectories for each language without a dedicated
  * ccTLD or subdomain (retrieved from the LocalizationProvider).
  */
  this.when = function (path, route) {
    $routeProvider.when(path, route);
    angular.forEach(_languages, function (name, code) {
      if (code !== LocalizationProvider.defaultLanguage()) {
        $routeProvider.when('/' + code + path, route);
      }
    });
    return _this;
  };

  /**
  * @ngdoc method
  * @name threepio.LocalizedRouteProvider#when
  *
  * @description Wrapper around Angular $routeProvider.when() method
  * acception the same parameters and returning the same value, creating
  * language-specific subdirectories for each language (retrieved from the
  * LocalizationProvider).
  */
  this.otherwise = function (params) {
    $routeProvider.otherwise(params);
    return _this;
  };

  this.$get = ['$window', '$location', '$rootScope', 'Localization', function ($window, $location, $rootScope, Localization) {

    function isValidLanguage(code) {
      return angular.isDefined(_languages[code]);
    }

    // Get the language code from a specified url or from the current url
    function urlToLangCode(url) {
      var langCode = void 0;
      if (url) {
        // Url rewriting
        var urlEl = $window.document.createElement('a');
        urlEl.href = url;
        // Fix IE inconsistency
        urlEl.pathname = urlEl.pathname[0] !== '/' ? '/' + urlEl.pathname[0] : urlEl.pathname;
        langCode = isValidLanguage(urlEl.pathname.split('/')[1]) ? urlEl.pathname.split('/')[1] : null;
      } else {
        langCode = localDomains[$location.host()] ? localDomains[$location.host()].split('-')[0] : null;

        if (!langCode) {
          langCode = isValidLanguage($location.path().split('/')[1]) ? $location.path().split('/')[1] : null;
        }
      }

      return langCode;
    }

    function unlocalizedPath() {
      var path = $location.path();
      var languageCode$$1 = path.split('/')[1];
      if (isValidLanguage(languageCode$$1)) {
        return path.replace('/' + languageCode$$1, '');
      }
      return path;
    }

    var langCode = urlToLangCode();
    if (isValidLanguage(langCode)) {
      Localization.language(langCode, true);
    }

    $rootScope.$on('$locationChangeStart', function (e, current, previous) {
      // hreflang
      function setHrefLang(lang, baseUrl) {
        // Remove the previous link element if any
        var oldHrefLand = $window.document.querySelector('link[hreflang=' + lang + ']');
        if (oldHrefLand) {
          angular.element(oldHrefLand).remove();
        }
        // Create a new link element for the locale
        var hrefLang = angular.element('<link></link>');
        hrefLang.attr('ref', 'alternate');
        hrefLang.attr('hreflang', lang);
        // Set href value
        var href = oneLineTrim(_templateObject, $location.protocol(), baseUrl, unlocalizedPath(), $window.location.search, $window.location.hash);
        hrefLang.attr('href', href);
        // Add it to the document head
        angular.element($window.document).find('head').append(hrefLang);
      }
      // Write the hreflang tags for the generic language pages, i.e. not
      // specific to a region, using a
      // https://<primary_domain>/<lang_code>/<path> url scheme
      angular.forEach(_languages, function (languageName, lang) {
        var baseUrl = primaryDomain;
        if (lang !== Localization.defaultLanguage()) {
          baseUrl += '/' + lang;
        }
        setHrefLang(lang, baseUrl);
      });
      // Write the hreflang tags for local domains (ccTLDs)
      angular.forEach(localDomains, function (lang, domain) {
        setHrefLang(lang, domain);
      });
      // Keep the language code if any and if the current language is not the
      // default one
      var prevLangCode = urlToLangCode(previous);
      var curLangCode = urlToLangCode(current);
      if (isValidLanguage(curLangCode)) {
        Localization.language(curLangCode);
      }
      if (prevLangCode && curLangCode !== prevLangCode && Localization.language() !== Localization.defaultLanguage()) {
        $location.path('/' + prevLangCode + $location.path());
        $location.replace();
      }
    });

    $rootScope.$on('LocalizationLanguageChange', function () {
      var lang = Localization.language();
      var urlLang = isValidLanguage($location.path().split('/')[1]) ? $location.path().split('/')[1] : null;
      if (lang === Localization.defaultLanguage() && urlLang) {
        $location.path($location.path().split('/')[2]);
      }
    });

    return {
      /**
       * @ngdoc method
       * @name threepio.Localization#languageList
       *
       * @description
       */
      languages: function languages() {
        return _languages;
      }
    };
  }];
}]);

angular.module('threepio')
/**
 * @ngdoc service
 * @name flTranslate.service:TranslationCache
 *
 * @description
 * Load the content of a `<script>` element with a 'text/fl-translate-catalog'
 * type into the {@link flTranslate.TranslationCache `TranslationCache`}, so
 * that the catalog can be used by the
 * {@link flTranslate.service:Translation `Translation Service`}.
 *
 * @param {string} type Must be set to `'text/fl-translate-catalog'`.
 * @param {string} lang Language of catalog
 */
.factory('TemplateCache', ['$cacheFactory', function ($cacheFactory) {
  return $cacheFactory('templatecache');
}]);

/* global document */

angular.module('threepio')
/**
 * @ngdoc service
 * @name threepio.service:ThreepioLib
 *
 * @description
 * Angular wrapper from Threepio translation library
 */
.factory('ThreepioLib', ['$interpolate', function ($interpolate) {
  return new ThreepioLib(document, {
    startExpr: $interpolate.startSymbol(),
    endExpr: $interpolate.endSymbol(),
    // FIXME: ngPluralize plugin is broken for now
    /*
    attributes: {
      when: isGlobal ? $window.Threepio.Plugins.ngPluralize :
        require('Threepio.Plugins.ngPluralize')
    },
    */
    missing: true
  });
}]);

angular.module(threepio)
/**
 * @ngdoc provider
 * @name threepio.TranslationProvider
 *
 * @description
 * Configure the Translation service by setting the translation domain &
 * preparing the DOM & HTML template for dynamic translation
 */
.provider('Translation', ['$provide', function TranslationProvider($provide) {

  var translationsRequest = void 0;

  /**
  * @ngdoc method
  * @name threepio.TranslationProvider#setDomain
  *
  * @description
  * Set the translation domain of the application (namespace used to
  * retrieve the translation catalogs).
  *
  * @param {String} Name of the translation domain
  */
  this.setTranslationsRequest = function (fn) {
    translationsRequest = fn;
  };

  // Angular $compile service decorator tagging the compiled element for
  // translation
  this.translateRootElement = function () {
    var first = false;
    $provide.decorator('$compile', ['$delegate', 'ThreepioLib', function ($delegate, ThreepioLib$$1) {
      function clone(func) {
        var temp = function temporary() {
          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          if (!first) {
            first = true;
            var el = args[0];
            ThreepioLib$$1.prepare(el);
          }
          return func.apply(this, args);
        };
        Object.keys(func).forEach(function (key) {
          if (Object.prototype.hasOwnProperty.call(func, key)) {
            temp[key] = func[key];
          }
        });
        return temp;
      }
      var compile = clone($delegate);
      return compile;
    }]);
  };

  // Angular $templateRequest service decorator tagging the HTML templates for
  // translation
  $provide.decorator('$templateRequest', ['$delegate', '$q', 'ThreepioLib', 'TemplateCache', function ($delegate, $q, ThreepioLib$$1, TemplateCache) {
    return function (url, ignoreError) {
      var cachedTemplate = TemplateCache.get(url);
      if (cachedTemplate) {
        return $q.when(cachedTemplate);
      }
      return $delegate(url, ignoreError).then(function (template) {
        ThreepioLib$$1.prepare(template);
        var processedTemplate = ThreepioLib$$1.serialize();
        TemplateCache.put(url, processedTemplate);
        return processedTemplate;
      });
    };
  }]);

  /**
  * @ngdoc service
  * @name threepio.Translation
  *
  * @description
  * Translate the application between multiple languages
  */
  this.$get = ['$document', '$rootScope', '$q', '$injector', 'ThreepioLib', 'TranslationsCache', 'Localization', function ($document, $rootScope, $q, $injector, ThreepioLib$$1, TranslationsCache, Localization) {
    var catalog = {};
    var hasBeenTranslated = false;

    function getTranslations(language) {
      var cachedCatalog = TranslationsCache.get(language);
      if (cachedCatalog) {
        return $q.when(cachedCatalog);
      }
      return $injector.invoke(translationsRequest)(language).then(function (newCatalog) {
        TranslationsCache.put(language, newCatalog);
        return newCatalog;
      });
    }

    function _loadTranslations(language) {
      return getTranslations(language).then(function (newCatalog) {
        catalog = newCatalog;
        return catalog;
      });
    }

    /* Preload the translations in the current language before that the
       translate method gets called */
    var currentLanguage = Localization.language();
    if (currentLanguage !== Localization.defaultLanguage()) {
      _loadTranslations(currentLanguage).then(function () {
        $rootScope.$broadcast('TranslationLanguageChange');
      });
    }

    /* Add cloaking CSS style to prevent flash of untranslated content */
    var css = '[i18n-cloak] { display: none !important; }';
    var style = $document[0].createElement('style');
    style.type = 'text/css';
    style.appendChild($document[0].createTextNode(css));
    $document[0].head.appendChild(style);

    $rootScope.$on('LocalizationLanguageChange', function () {
      var language = Localization.language();
      if (language !== Localization.defaultLanguage()) {
        _loadTranslations(language).then(function () {
          $rootScope.$broadcast('TranslationLanguageChange');
        });
      } else {
        $rootScope.$broadcast('TranslationLanguageChange');
      }
    });

    return {
      /**
       * Used by the i18n service for JS translations
       */
      translations: catalog,
      /**
       * @ngdoc method
       * @name threepio.Translation#translate
       *
       * @description
       * Translate an element to the current language
       *
       * @param {HTMLElement} HTML element to translate
       * @param {String} Message ID of the element
       * @return {Promise} Promise resolve or rejected when the translation is
       * done
       */
      translate: function translate(el) {
        var language = Localization.language();
        if (language !== Localization.defaultLanguage()) {
          hasBeenTranslated = true;
          ThreepioLib$$1.process(el, function (message, replace) {
            var translation = catalog.translations[message.getId()] ? catalog.translations[message.getId()] : null;
            if (!translation) {
              /* Use the original message if the translation is missing */
              translation = message.text;
            }
            replace(translation);
          });
        } else if (hasBeenTranslated) {
          // Restore original text
          ThreepioLib$$1.process(el, function (message, replace) {
            replace(message.text);
          });
        }
      },

      /**
       * Load translations
       */
      loadTranslations: function loadTranslations(language) {
        if (language !== Localization.defaultLanguage()) {
          return _loadTranslations(language);
        }
        return $q.when();
      },

      /**
       * @ngdoc method
       * @name threepio.Translation#annotateTemplate
       *
       * @description
       * Annotate an inline template for translation
       *
       * @param {String} HTML template string to annotate for translation
       * @return {String} Annotated template
       */
      annotateTemplate: function annotateTemplate(template) {
        ThreepioLib$$1.prepare(template);
        return ThreepioLib$$1.serialize();
      }
    };
  }];
}]);

/*
 * Common Angular constants used in flAngular.
 * DEPRECATED: A better way to handle these configs should be looked for
 * /!\ DO NOT ADD ANY CODE TO THIS FILE BUT SHARED ANGULAR CONSTANTS /!\
 */

var OPAQUE_MODULE_NAME = 'flConfigs';

if (!window.__karma__) {
  angular.module(OPAQUE_MODULE_NAME, []).constant('API_BASE_URL', '/api').constant('AUTH_BASE_URL', '/auth').constant('AUTH_TOKEN_COOKIE', cookieBase + '_AUTH_HASH_V2').constant('FACEBOOK_APP_ID', facebookAppId).constant('GAF_BASE_URL', '').constant('GAF_CDN_URLS', cdnUrls.map(function (url) {
    return 'https://' + url;
  })).constant('USER_ID_COOKIE', cookieBase + '_USER_ID').constant('DEFAULT_AVATAR_URL', '/img/unknown.png').constant('LANGUAGE_COOKIE', cookieBase + '_LANGUAGE').constant('LANGUAGE_COOKIE_DOMAIN', cookieBase).constant('LANGUAGE_COOKIE_EXPIRES', 60 * 60 * 24 * 60) /* 60 days */
  .constant('FLN_BILLING_BASE_URL', flnBillingBaseUrl).constant('TRANSLATE_MODE_COOKIE', cookieBase + '_TRANSLATE_MODE').constant('LOOKING_FOR_COOKIE', cookieBase + '_LOOKING_FOR').constant('RECAPTCHA_PUBLIC_KEY', recaptchaPublicKey);
} else {
  angular.module(OPAQUE_MODULE_NAME, []).constant('API_BASE_URL', 'https://api-mock.freelancer.com').constant('AUTH_BASE_URL', 'https://auth-mock.freelancer.com').constant('AUTH_TOKEN_COOKIE', 'GETAFREE_AUTH_HASH_V2').constant('FACEBOOK_APP_ID', 123123123123).constant('GAF_BASE_URL', 'https://mock.freelancer.com').constant('GAF_CDN_URLS', ['https://cdn-mock.freelancer.com']).constant('USER_ID_COOKIE', 'GETAFREE_USER_ID').constant('DEFAULT_AVATAR_URL', '/img/unknown.png').constant('LANGUAGE_COOKIE', 'languageCookieMock').constant('LANGUAGE_COOKIE_DOMAIN', 'languageCookieDomainMock').constant('LANGUAGE_COOKIE_EXPIRES', 'languageCookieDomainExpires').constant('FLN_BILLING_BASE_URL', 'https://fln_billing_base_url').constant('TRANSLATE_MODE_COOKIE', 'GETAFREEST__TRANSLATE_MODE').constant('LOOKING_FOR_COOKIE', 'GETAFREEST__LOOKING_FOR').constant('RECAPTCHA_PUBLIC_KEY', recaptchaPublicKey);
  // FIXME: get rid of that (fix flAnalytics)
  window.dataLayer = [];
}

/*
 * Angular service wrapper to abstract the creation of Angular services in your
 * applications.
 *
 * ```
 * import ngResource from 'angular-resource';
 * import { flService } from 'fl-forward';
 *
 * export default flService('MyService',
 *   [ngResource],
 *   MyService
 * );
 *
 * class MyService {
 *   constructor($resource) {
 *     ...
 *   }
 * }
 * ```
 */
function flService(name, deps, classFn) {
  return angular.module('flForward.Service.' + name, deps).service(name, classFn).name;
}

/**
 * annotateTemplate - uses threepio to annotate AngularJS templates with
 * HTML attributes required for the translation system.
 *
 * @param  {string} template raw HTML template
 * @return {string}          annotated template
 */
function annotateTemplate(template) {
  if (typeof template === 'function') {
    return annotateTemplate(template());
  }
  if (typeof template !== 'string') {
    return template;
  }

  var threepio = new ThreepioLib(document, {
    startExpr: '{[{',
    endExpr: '}]}'
  });

  threepio.prepare(template);
  return threepio.serialize();
}

var _templateObject$1 = _taggedTemplateLiteral(['Invalid component selector\n      (', '): the selector must be a dash-delimited\n      element selectors starting with the \'fl\' prefix,\n      e.g. \'fl-laurent-rocks\''], ['Invalid component selector\n      (', '): the selector must be a dash-delimited\n      element selectors starting with the \'fl\' prefix,\n      e.g. \'fl-laurent-rocks\'']),
    _templateObject2 = _taggedTemplateLiteral(['Components cannot have link functions. If you need\n      to do DOM manipulations, use the $postLink hook instead.'], ['Components cannot have link functions. If you need\n      to do DOM manipulations, use the $postLink hook instead.']),
    _templateObject3 = _taggedTemplateLiteral(['Components need to provide views through the\n      \'template\' property.'], ['Components need to provide views through the\n      \'template\' property.']);

var _templateObject$2 = _taggedTemplateLiteral(['Invalid component selector\n      (', '): the selector must be a dash-delimited\n      element selectors starting with the \'fl\' prefix, e.g. \'fl-laurent-rocks\',\n      or dash-delimited attributes selectors starting with the \'fl\' prefix,\n      e.g. \'[fl-laurent-rocks]\''], ['Invalid component selector\n      (', '): the selector must be a dash-delimited\n      element selectors starting with the \'fl\' prefix, e.g. \'fl-laurent-rocks\',\n      or dash-delimited attributes selectors starting with the \'fl\' prefix,\n      e.g. \'[fl-laurent-rocks]\'']);

function flDirective(directiveCtrl, directiveObj) {
  // Lint for invalid selector
  // TODO: this should be a lint rule in eslint-plugin-fl-forward
  if (!directiveObj.selector || !/^\[?fl-[a-z-]+\]?$/.test(directiveObj.selector)) {
    throw new Error(oneLine(_templateObject$2, directiveObj.selector));
  }

  // Compute the directive's name from the selector & the "restrict" attribute
  var directiveName = directiveObj.selector.replace(/-([a-z])/g, function (g) {
    return g[1].toUpperCase();
  });
  var decorator = false;
  if (directiveName[0] === '[') {
    directiveName = directiveName.slice(1, -1);
    decorator = true;
  }

  // The controllerAs value is the directive's name (without the 'fl' prefix)
  var controllerAs = directiveName.slice(2);

  // Create factory wrapper
  var ddo = function ddo() {
    return {
      restrict: decorator ? 'A' : 'E',
      replace: directiveObj.replace || false,
      scope: directiveObj.scope || false,
      transclude: directiveObj.transclude,
      require: directiveObj.require,
      template: annotateTemplate(directiveObj.template),
      compile: function compile() {
        return function (scope) {
          for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          // call the link function in the context of the controller
          if (scope[controllerAs].link) {
            var _scope$controllerAs;

            return (_scope$controllerAs = scope[controllerAs]).link.apply(_scope$controllerAs, [scope].concat(args));
          }
          return function noop() {};
        };
      },
      controller: directiveCtrl,
      bindToController: true,
      controllerAs: controllerAs
    };
  };

  // Create the directive itself
  return angular.module('flForward.Directive.' + directiveName, [].concat(directiveObj.providers || []).concat(directiveObj.directives || [])).directive(directiveName, ddo).name;
}

/**
* @ngdoc service
* @name flApi.flResourceInterceptor
* @description
* Global HTTP interceptor working in conjunction with flResource to allow
* custom endpoint-specific request transformations
*/

var flResourceInterceptor = function flResourceInterceptor() {
  _classCallCheck(this, flResourceInterceptor);

  return {
    /**
     * @ngdoc method
     * @name flApi.flResourceInterceptor#request
     * @methodOf flApi.flResourceInterceptor
     *
     * @description
     * Transform the request using the custom _flRequestInterceptor set on
     * the request configuration if any.
     *
     * @param {Object} config The request configuration object
     * @returns {Object} The config object received as a parameter,
     * eventually modified.
     */
    request: function request(config) {
      if (config._flRequestInterceptor) {
        return config._flRequestInterceptor(config);
      }
      return config;
    }
  };
};

var flResourceInterceptorModule = flService('flResourceInterceptor', [], flResourceInterceptor);

angular.module(flResourceInterceptorModule).config(['$httpProvider', function ($httpProvider) {
  $httpProvider.interceptors.push('flResourceInterceptor');
}]);

/**
 * @ngdoc service
 * @name flApi.flResource
 *
 * @description
 * The HTTP interceptors design in Angular is pretty bad as they have to be
 * installed globally and end up relying on crazy RegExes to match or not some
 * specific endpoints.
 *
 * flResource is an Angular $resource wrapper that handle request & response
 * interceptors on a per $resource and per action basics. This wrapper
 * introduces an extra mandatory "interceptor" argument in the 2nd position,
 * i.e. its prototype is:
 *
 * ```
 *    flResource(url, interceptor, [paramDefaults], [actions], options);
 * ```
 *
 * This extra arguments sets the defaults interceptor for the resource and all
 * its actions, the default ones and the one specific or overwritten in the
 * actions param. This interceptor is a standard Angular HTTP interceptor,
 * i.e. an object with one or many of the 3 methods "request, response, and
 * responseError". The ApiInterceptor and GafInterceptors can be use with
 * flResource:
 *
 * ```
 *    const DepositsConfirm = flResource(
 *    API_BASE_URL + '/payments/0.1/deposits/',
 *    ApiInterceptor, {}, { 'update': { method: 'PUT' }});
 * ```
 *
 * This wrapper also extend the interceptor key on the actions objects: by
 * default Angular $resource service only support response & responseError for
 * these. flResource extends that behavior by using a global interceptor to
 * set action-specific request interceptors. This is quite useful for
 * flResource objects that deal with different kind of endpoints:
 *
 * ```
 *    const Invoices = flResource(API_BASE_URL +
 *      '/projects/0.1/invoices/', ApiInterceptor, null, {
 *      fetch: {
 *        method: 'GET',
 *        url: GAF_BASE_URL + '/ajax/project/getProjectInvoices.php',
 *        interceptor: GafInterceptor
 *      },
 *      pay: {
 *        method: 'POST',
 *        url: GAF_BASE_URL + '/ajax/payment/payinvoice.php',
 *        interceptor: GafInterceptor
 *      },
 *      requestChange: {
 *        method: 'GET',
 *        url: GAF_BASE_URL + '/ajax/payment/on-request-invoice-change.php',
 *        interceptor: GafInterceptor
 *      }
 *    });
 *```
 */

var flResourceFactory = function flResourceFactory($resource) {
  _classCallCheck(this, flResourceFactory);

  return function flResource(url, defaultInterceptor, paramDefaults) {
    var actions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : { stripTrailingSlashes: false };

    if (!defaultInterceptor || !defaultInterceptor.request) {
      throw new Error('No default interceptor set');
    }

    // Set the default interceptor for the custom actions if not specified
    angular.forEach(actions, function (value, action) {
      if (!angular.isDefined(actions[action].interceptor)) {
        actions[action].interceptor = defaultInterceptor;
        actions[action]._flRequestInterceptor = defaultInterceptor.request;
      } else {
        actions[action]._flRequestInterceptor = actions[action].interceptor.request;
      }
    });

    // Set the default interceptor for the default $resource action if not
    // defined
    var defaultActions = {
      get: { method: 'GET' },
      save: { method: 'POST' },
      query: { method: 'GET', isArray: true },
      remove: { method: 'DELETE' },
      delete: { method: 'DELETE' }
    };

    angular.forEach(defaultActions, function (value, action) {
      if (!angular.isDefined(actions[action])) {
        actions[action] = value;
        actions[action].interceptor = defaultInterceptor;
        actions[action]._flRequestInterceptor = defaultInterceptor.request;
      }
    });

    return $resource(url, paramDefaults, actions, options);
  };
};

flResourceFactory.$inject = ['$resource'];


var flResourceProvider = flService('flResource', [ngResource, flResourceInterceptorModule], flResourceFactory);

var _templateObject$3 = _taggedTemplateLiteral(['(?:(?:^|.*;)\\s*\n      ', '\n      \\s*\\=\\s*([^;]*).*$)|^.*$'], ['(?:(?:^|.*;)\\\\s*\n      ', '\n      \\\\s*\\\\=\\\\s*([^;]*).*$)|^.*$']);

/**
 * @ngdoc service
 * @name flCookies.CookieStore
 *
 * @description
 * A factory which creates a service that lets you interact with the browser's
 * cookies.
 *
 * AngularJS has
 * {@link https://docs.angularjs.org/api/ngCookies/service/$cookieStore
 * its own $cookieStore implementation} but it doesn't support setting any
 * cookie option (e.g. *path*, *domain*, *secure*,
 * and *expiration*) as of today. The APIs are the same than Angular's
 * {@link https://docs.angularjs.org/api/ngCookies/service/$cookieStore
 * $cookieStore} with an extra parameter (an object with
 * ``expires``, ``path``, ``domain`` and ``secure`` as keys, ``expires``
 * accepting different formats).
 * It is currently used by ``flAuth`` (auth cookies) and ``flAnalytics``
 * (tracking cookies), but you can easily use it in a custom service:
 *
 * ```
   angular.module('myApp')
   .factory('myAwesomeService', function(CookieStore) {
     return {
       setMagicCookie: function(magicNumber) {
         CookieStore.put('CHUCK_NORRIS', magicNumber, {
           expires: Infinity
         });

       ...
     }
   }
 * ```
 *
 * The returned object has action methods which provide high-level behaviors
 * without the need to interact with the low level cookies implementation.
 */

var CookieStoreProvider = function () {
  function CookieStoreProvider($document) {
    _classCallCheck(this, CookieStoreProvider);

    this.$document = $document;
  }
  /**
   * @ngdoc method
   * @name flCookies.CookieStore#get
   * @methodOf flCookies.CookieStore
   *
   * @description
   * Returns the value of given cookie key
   *
   * @param {String} key Id to use for lookup.
   * @returns {Object} Deserialized cookie value.
   */


  _createClass(CookieStoreProvider, [{
    key: 'get',
    value: function get(key) {
      var re = new RegExp(oneLineTrim(_templateObject$3, encodeURIComponent(key).replace(/[\-\.\+\*]/g, '\\$&')));
      var value = this.$document[0].cookie.replace(re, '$1');

      return decodeURIComponent(value) || null;
    }
    /**
     * @ngdoc method
     * @name flCookies.CookieStore#put
     * @methodOf flCookies.CookieStore
     *
     * @description
     * Sets a value for given cookie key
     *
     * @param {String} key Id for the `value`.
     * @param {Object} value The value you want to store in this cookie
     * @param {Object} options Additional settings for the cookie (optional):
     *
     * - expires: expiration date for the cookie
     * - domain: the domain for which the cookie is valid
     * - path: the path for which the cookie is valid
     * - secure: is cookie HTTPS only?
     */

  }, {
    key: 'put',
    value: function put(key, value, options) {
      // Set cookie
      var cookie = encodeURIComponent(key) + '=' + encodeURIComponent(value);
      // See options
      if (options) {
        // Expiration date
        if (options.expires) {
          var date = void 0;

          switch (options.expires.constructor) {
            case Number:
              if (options.expires === Infinity) {
                date = 'Fri, 31 Dec 9999 23:59:59 GMT';
              } else {
                // Note: we don't use max-age here because it's
                // not supported in IE8.
                var d = new Date();
                d.setTime(d.getTime() + options.expires * 1000);
                date = d.toUTCString();
              }
              break;
            case String:
              date = options.expires;
              break;
            case Date:
              date = options.expires.toUTCString();
              break;
            default:
              break;
          }

          cookie += ';expires=' + date;
        }
        // Domain
        cookie += options.domain ? ';domain=' + options.domain : '';
        // Path
        cookie += options.path ? ';path=' + options.path : ';path=/';
        // HTTPS Only
        cookie += options.secure ? ';secure' : '';

        var sameSite = options.sameSite;
        if (sameSite === 'None') {
          // some browsers reject cookies with SameSite=None
          // we can test functionality by trying to set and checking if it worked
          // https://www.chromium.org/updates/same-site/incompatible-clients
          this.remove('testsamesitenone');
          this.$document[0].cookie = 'testsamesitenone=1; secure; SameSite=None';
          if (this.get('testsamesitenone') !== '1') {
            // cookie didn't come back: don't set SameSite=None
            sameSite = '';
          }
          this.remove('testsamesitenone');
        }
        cookie += sameSite ? '; SameSite=' + sameSite : '';
      }
      // Save the cookie
      // Note: this.$document is a jqLite wrapper
      this.$document[0].cookie = cookie;
    }
    /**
    * @ngdoc method
    * @name flCookies.CookieStore#remove
    * @methodOf flCookies.CookieStore
    *
    * @description
    * Remove given cookie
    *
    * @param {String} key Id of the key-value pair to delete.
    * @param {Object} options Additional settings for the cookie (optional)
    */

  }, {
    key: 'remove',
    value: function remove(key, options) {
      var opt = options || {};
      // Setting expiry date to a past date deletes a cookie
      opt.expires = new Date(0);
      this.put(key, '', opt);
    }
    /**
     * @ngdoc method
     * @name flCookies.CookieStore#getDomain
     * @methodOf flCookies.CookieStore
     *
     * @description
     * Get Cookie Domain by matching the regex `freelancer.*$`
     * and adding `.` front of it.
     * If it doesn't match the regex, just return the hostName.
     *
     * @param {String} hostName current host name
     *
     * @returns {String} Cookie Domain
     */

  }, {
    key: 'getDomain',
    value: function getDomain(hostName) {
      return hostName.match(/freelancer.*$/) ? '.' + hostName.match(/freelancer.*$/)[0] : '' + hostName;
    }
  }]);

  return CookieStoreProvider;
}();

CookieStoreProvider.$inject = ['$document'];


var CookieStoreProvider$1 = flService('CookieStore', [], CookieStoreProvider);

var _templateObject$4 = _taggedTemplateLiteral(['afpro=', ';\n      afpro_id=', ';\n      afro_sess=', ''], ['afpro=', ';\n      afpro_id=', ';\n      afro_sess=', '']),
    _templateObject2$1 = _taggedTemplateLiteral(['', '-\n        ', '-', '-', '-\n        ', ''], ['', '-\n        ', '-', '-', '-\n        ', '']);

/**
 * @ngdoc service
 * @name flAnalytics.Analytics
 *
 * @description
 * A service that allows you to perform common tasks
 * on Google Analytics.
 */

var AnalyticsProvider = function () {
  function AnalyticsProvider($window, CookieStore, md5) {
    _classCallCheck(this, AnalyticsProvider);

    this.$window = $window;
    this.CookieStore = CookieStore;
    this.md5 = md5;
  }
  /**
   * @ngdoc method
   * @name flAnalytics.Analytics#trackAction
   * @methodOf flAnalytics.Analytics
   *
   * @description
   * Tracks an event/action, i.e. something the app is doing
   *
   * @param {String} category The `eventCategory` parameter
   * @param {String} action The `eventAction` parameter
   * @param {String} result The `eventResult` parameter
   */


  _createClass(AnalyticsProvider, [{
    key: 'trackAction',
    value: function trackAction(category, action, result) {
      this.$window.dataLayer.push({
        event: 'app_action',
        eventCategory: category,
        eventAction: action,
        eventResult: result
      });
    }
    /**
     * @ngdoc method
     * @name flAnalytics.Analytics#trackAction
     * @methodOf flAnalytics.Analytics
     *
     * @description
     * Track a DOM event / user action, e.g. a `click` on a button or
     * a `change` on a select input
     *
     * @param {String} section The `eventSection` parameter
     * @param {String} subsection The `eventSubsection` parameter
     * @param {String} name The `eventName` parameter
     * @param {String} action The `eventAction` parameter
     * @param {String} value The `eventValue` parameter
     * @param {String} label The `eventLabel` parameter
     * @param {String} reference The `eventReference` parameter
     * @param {String} referenceId The `eventReferenceId` parameter
     */

  }, {
    key: 'trackEvent',
    value: function trackEvent(section, subsection, name, action, value, label, reference, referenceId) {
      this.$window.dataLayer.push({
        event: 'user_action',
        eventSection: section,
        eventSubsection: subsection,
        eventName: name,
        eventAction: action,
        eventValue: value,
        eventLabel: label,
        eventReference: reference,
        eventReferenceId: referenceId
      });
    }
    /**
    * @ngdoc method
    * @name flAnalytics.Analytics#trackAjaxTiming
    * @methodOf flAnalytics.Analytics
    *
    * @description
    * Push user timing data to Google Tag Manager
    *
    * @param {String} method The `ajaxMethod` parameter
    * @param {String} url The `ajaxUrl` parameter
    * @param {String} status The `ajaxStatus` parameter
    * @param {String} timeSpent The `ajaxValue` parameter
    * @param {String} label The `ajaxLabel` parameter
    */

  }, {
    key: 'trackAjaxTiming',
    value: function trackAjaxTiming(method, url, status, timeSpent, label) {
      this.$window.dataLayer.push({
        event: 'ajax_timing',
        ajaxMethod: method,
        ajaxUrl: url,
        ajaxStatus: status,
        ajaxValue: timeSpent,
        ajaxLabel: label
      });
    }
    /**
    * @ngdoc method
    * @name flAnalytics.Analytics#trackAjaxTiming
    * @methodOf flAnalytics.Analytics
    *
    * @description
    * Track an error (not a JS error, an app error)
    *
    * @param {String} category The `eventCategory` parameter
    * @param {String} action The `eventAction` parameter
    * @param {String} result The `eventResult` parameter
    * @param {String} error The `eventData` parameter
    */

  }, {
    key: 'trackError',
    value: function trackError(category, action, result, error) {
      this.$window.dataLayer.push({
        event: 'app_error',
        eventCategory: category,
        eventAction: action,
        eventResult: result,
        eventLabel: error ? JSON.stringify(error) : undefined
      });
    }
    /**
    * @ngdoc method
    * @name flAnalytics.Analytics#trackABTest
    * @methodOf flAnalytics.Analytics
    *
    * @description
    * Track an ab test with variation
    *
    * @param {String} category The `test` parameter
    * @param {String} variation The `variation` parameter
    */

  }, {
    key: 'trackABTest',
    value: function trackABTest(name, variation) {
      this.$window.dataLayer.push({
        event: 'abtest',
        testName: name,
        testVariation: variation
      });
    }

    /**
    * @ngdoc method
    * @name flAnalytics.Analytics#trackMobileUserTiming
    * @methodOf flAnalytics.Analytics
    *
    * @description
    * Push user timing data in Mobile Web to Google Tag Manager
    *
    * @param {String} markName The name of the user timing mark
    * @param {String} markTime The time when the mark was recorded
    */

  }, {
    key: 'trackMobileUserTiming',
    value: function trackMobileUserTiming(markName, markTime) {
      this.$window.dataLayer.push({
        event: 'mobile_user_timing',
        markName: markName,
        markTime: markTime
      });
    }

    /**
     * @ngdoc method
     * @name flAnalytics.Analytics#trackMobileCountryDomain
     * @methodOf flAnalytics.Analytics
     *
     * @description
     * Push country domain data in Mobile Web to data layer
     *
     * @param {String} currentDomain The country domain being used
    */

  }, {
    key: 'trackMobileCountryDomain',
    value: function trackMobileCountryDomain(currentDomain) {
      this.$window.dataLayer.push({
        currentDomain: currentDomain
      });
    }

    /**
    * @ngdoc method
    * @name flAnalytics.Analytics#trackGTMConversion
    * @methodOf flAnalytics.Analytics
    *
    * @description
    * Push GTM conversion tracking first with orderId, then conversion
    * type and then fire a QTS event together with the GTM tracking
    *
    * @param {String} type The order type, i.e. can be either 'project' or
    * 'contest'
    * @param {String} orderId The order Id
    * @param {String} conversionType The name of conversion type as
    * specified in the GTM console
    */

  }, {
    key: 'trackGTMConversion',
    value: function trackGTMConversion(type, orderId, conversionType) {
      var formattedOrderId = void 0;
      if (type === 'project') {
        formattedOrderId = 'P' + orderId;
      } else if (type === 'contest') {
        formattedOrderId = 'C' + orderId;
      } else {
        return;
      }

      this.$window.dataLayer.push({ order_id: formattedOrderId });
      this.$window.dataLayer.push({ event: conversionType });

      this.trackEvent('GTMTracking', conversionType, false, false, false, formattedOrderId);
    }

    /**
    * @ngdoc method
    * @name flAnalytics.Analytics#trackPageView
    * @methodOf flAnalytics.Analytics
    *
    * @description
    * Track the referrer of the given URL
    *
    * @param {String} url of the page
    * @param {String} referrer of the page
    */

  }, {
    key: 'trackPageView',
    value: function trackPageView(url, referrerUrl) {
      this.$window.dataLayer.push({
        event: 'page_view',
        referrerUrl: referrerUrl,
        url: url
      });
    }

    /**
     * @ngdoc method
     * @name flAnalytics.Analytics#trackLocation
     * @methodOf flAnalytics.Analytics
     *
     * @description
     * Tracks the latitude and longitude of the user
     */

  }, {
    key: 'trackLocation',
    value: function trackLocation(lat, lon) {
      this.$window.dataLayer.push({
        event: 'user_location',
        lat: lat,
        lon: lon
      });
    }

    /**
    * @ngdoc method
    * @name flAnalytics.Analytics#getAFPROHeader
    * @methodOf flAnalytics.Analytics
    *
    * @description
    * Get the affiliate program tracking data. The affiliate tracking
    * cookies are set by GAF when redirecting marketing campaigns links,
    * a.k.a. with a pattern like
    * https://www.freelancer.com/campaign/0XYZ123/.
    *
    * @returns {String} a string containing the encoded value
    * of the affiliate tracking cookies
    */

  }, {
    key: 'getAFPROHeader',
    value: function getAFPROHeader() {
      var program = this.CookieStore.get('GETAFREE_AFPRO');
      var programId = this.CookieStore.get('GETAFREE_AFPRO_ID');
      var session = this.CookieStore.get('GETAFREE_AFPRO_SESS');
      if (!program || !programId || !session) {
        // Don't set the header if there's no data
        return undefined;
      }
      return oneLineTrim(_templateObject$4, encodeURIComponent(program), encodeURIComponent(programId), encodeURIComponent(session));
    }
    /**
    * @ngdoc method
    * @name flAnalytics.Analytics#getTrackingHeader
    * @methodOf flAnalytics.Analytics
    *
    * @description
    * Get the tracking data (QTS session ID for now).
    *
    * @returns {String} a string containing the encoded value
    * of the affiliate tracking session cookie
    */

  }, {
    key: 'getTrackingHeader',
    value: function getTrackingHeader() {
      var tracking = this.CookieStore.get('_tracking_session');
      // Don't set the header if there's no data
      if (!tracking) {
        return undefined;
      }
      return encodeURIComponent(tracking);
    }
    /**
     * @ngdoc method
     * @name flAnalytics.Analytics#setTrackingHeader
     * @methodOf flAnalytics.Analytics
     *
     * @description
     * Generates session ID cookie from md5 hash
     *
     * @returns {String} Session ID string
     */

  }, {
    key: 'setTrackingHeader',
    value: function setTrackingHeader() {
      var sessionId = this.getTrackingHeader();
      if (!sessionId) {
        var date = new Date();
        var hashed = this.md5.createHash(Math.random().toString());
        var md5SessionId = oneLineTrim(_templateObject2$1, hashed.substr(0, 8), hashed.substr(8, 4), hashed.substr(12, 4), hashed.substr(16, 4), hashed.substr(20, 12));

        this.CookieStore.put('_tracking_session', md5SessionId, {
          expires: date.getTime() + 60 * 60 * 24 * 365,
          domain: this.CookieStore.getDomain(this.$window.location.hostname)
        });

        return md5SessionId;
      }
      return sessionId;
    }
    /**
    * @ngdoc method
    * @name flAnalytics.Analytics#getTTREFHeader
    * @methodOf flAnalytics.Analytics
    *
    * @description
    * Get the TTREF tracking data. The TTREF tracking cookies are used to
    * store the entry points (e.g., button click) that lead to a certain
    * action (e.g., post project).
    *
    * @returns {String} a string containing the encoded value
    * of the GETAFREE_TTREF cookie
    */

  }, {
    key: 'getTTREFHeader',
    value: function getTTREFHeader() {
      var ttref = this.CookieStore.get('GETAFREE_TTREF');
      // Don't set the header if there's no data
      if (!ttref) {
        return undefined;
      }
      return ttref;
    }
  }]);

  return AnalyticsProvider;
}();

AnalyticsProvider.$inject = ['$window', 'CookieStore', 'md5'];


var AnalyticsModule = flService('Analytics', [CookieStoreProvider$1, OPAQUE_MODULE_NAME, md5Provider], AnalyticsProvider);

// HTTP interceptor for tracking ajax requests timings
angular.module(AnalyticsModule).factory('AjaxTimingInterceptor', ['$q', 'Analytics', 'API_BASE_URL', 'AUTH_BASE_URL', 'GAF_BASE_URL', function ($q, Analytics, API_BASE_URL, AUTH_BASE_URL, GAF_BASE_URL) {
  var startTime = {};
  var logTimeSpent = function logTimeSpent(response) {
    // Compute the request end time
    var endTime = new Date().getTime();
    var timeSpent = endTime - startTime[response.config.url].shift();
    // Label the timing event
    var label = void 0;
    var url = response.config.url;
    if (url.match(/^\/views\//)) {
      label = 'HTML_PARTIAL';
    } else if (url.match(/^\/data\//)) {
      label = 'JSON_DATA';
    } else if (url.indexOf(API_BASE_URL) === 0) {
      label = 'REST_API';
    } else if (url.indexOf(AUTH_BASE_URL) === 0) {
      label = 'AUTH';
    } else if (url.indexOf(GAF_BASE_URL) === 0) {
      label = 'GAF';
    }
    // Log the data
    Analytics.trackAjaxTiming(response.config.method, response.config.url, response.status, timeSpent, label);
    // Do not leak memory!
    if (startTime[response.config.url].length === 0) {
      delete startTime[response.config.url];
    }
  };
  return {
    request: function request(config) {
      // Save the request start time
      if (!startTime[config.url]) {
        startTime[config.url] = [];
      }
      startTime[config.url].push(new Date().getTime());
      return config;
    },
    response: function response(_response) {
      logTimeSpent(_response);
      return _response;
    },
    responseError: function responseError(response) {
      logTimeSpent(response);
      return $q.reject(response);
    }
  };
}]);

// Insert the affiliate tracking header on user GET & POST requests
angular.module(AnalyticsModule).factory('AFPROInterceptor', ['Analytics', 'API_BASE_URL', function (Analytics, API_BASE_URL) {
  return {
    request: function request(config) {
      var newConfig = config;
      if (config.url.match(API_BASE_URL + '/users/0.1/users/')) {
        newConfig.headers['Freelancer-AFPRO'] = Analytics.getAFPROHeader();
      }
      return newConfig;
    }
  };
}]);

// Insert the tracking header on all request to the REST API
angular.module(AnalyticsModule).factory('TrackingInterceptor', ['Analytics', 'API_BASE_URL', function (Analytics, API_BASE_URL) {
  return {
    request: function request(config) {
      var newConfig = config;
      if (config.url.match(API_BASE_URL)) {
        newConfig.headers['Freelancer-Tracking'] = Analytics.getTrackingHeader();
      }
      return newConfig;
    }
  };
}]);

// Insert the TTREF tracking header on POST project request
angular.module(AnalyticsModule).factory('TTREFInterceptor', ['API_BASE_URL', 'Analytics', function (API_BASE_URL, Analytics) {
  return {
    request: function request(config) {
      var newConfig = config;
      if (config.url.match(API_BASE_URL + '/projects/0.1/projects/') && config.method === 'POST') {
        newConfig.headers['Freelancer-TTREF'] = Analytics.getTTREFHeader();
      }
      return newConfig;
    }
  };
}]);

angular.module(AnalyticsModule).config(['$httpProvider', function ($httpProvider) {
  $httpProvider.interceptors.push('AjaxTimingInterceptor');
  $httpProvider.interceptors.push('AFPROInterceptor');
  $httpProvider.interceptors.push('TrackingInterceptor');
  $httpProvider.interceptors.push('TTREFInterceptor');
}]);

angular.module(AnalyticsModule).run(['$window', function ($window) {
  // Log User Agent string.
  // Let's make sure the string is kinda safe while keeping it readable.
  var userAgent = encodeURIComponent($window.navigator.userAgent).replace(/%20/g, ' ').replace(/%2F/g, '/').replace(/%3B/g, ';').replace(/%2C/g, ',');

  $window.dataLayer.push({
    event: 'user_agent',
    uaString: userAgent
  });
}]);

/**
 * @ngdoc service
 * @name flApi.RequestTransformation
 * @description
 * Exposes data transformation methods used for encoding requests and
 * transforming events from realtime fl-notification.
 */

var RequestTransformation = function () {
  function RequestTransformation() {
    _classCallCheck(this, RequestTransformation);
  }

  _createClass(RequestTransformation, [{
    key: 'formUrlEncoded',

    /**
     * @ngdoc method
     * @name flApi.RequestTransformation#formUrlEncoded
     * @methodOf flApi.RequestTransformation
     *
     * @description
     * This method encodes parameters in form encoding, with special handling of
     * array types NOT to use commas, e.g. users[]=123,345 is NOT allowed. This
     * method replaces it with users[]=123&users[]=345
     *
     * @param {Object} data the object intended to be encoded
     * @returns {String} an encoded string
     */
    value: function formUrlEncoded() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var i = void 0;
      var theData = void 0;
      var result = [];

      // If we are sending a Form Encoded request, don't apply the key-value
      // string to the URL. This is bad and makes the request empty :(
      if (data instanceof FormData) {
        return data;
      }

      // Split array parameters into multiple entries
      Object.keys(data).forEach(function (key) {
        if (data[key]) {
          theData = data[key];
          if (Array.isArray(theData)) {
            // Append a '[]' to the param so switching to non-formencoded
            // will be more seamless down the line
            for (i = 0; i < theData.length; i++) {
              var k = encodeURIComponent(key + '[]');
              var d = encodeURIComponent(theData[i]);

              result.push(k + '=' + d);
            }
          } else {
            // Just a normal parameter, encode and push it through
            var _k = encodeURIComponent(key);
            var _d = encodeURIComponent(theData);

            result.push(_k + '=' + _d);
          }
        }
      });
      return result.join('&');
    }
  }, {
    key: 'buildParams',
    value: function buildParams(prefix, obj, add) {
      var _this = this;

      if (Array.isArray(obj)) {
        // Serialize array item.
        angular.forEach(obj, function (v, i) {
          var r = typeof v === 'object' ? i : '';

          // Item is non-scalar (array or object), encode its numeric index.
          _this.buildParams(prefix + '[' + r + ']', v, add);
        });
      } else if (angular.isObject(obj)) {
        // Serialize object item.
        Object.keys(obj).forEach(function (name) {
          _this.buildParams(prefix + '[' + name + ']', obj[name], add);
        });
      } else {
        // Serialize scalar item.
        add(prefix, obj);
      }
    }

    /**
     * @ngdoc method
     * @name flApi.RequestTransformation#formUrlEncodedRecursive
     * @methodOf flApi.RequestTransformation
     *
     * @description
     * Serialize an array of form elements or a set of key/values into a query
     * string
     *
     * @param {Object} data the object intended to be encoded
     * @returns {String} an encoded string
     */

  }, {
    key: 'formUrlEncodedRecursive',
    value: function formUrlEncodedRecursive() {
      var _this2 = this;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var s = [];
      var add = function add(key, value) {
        // If value is a function, invoke it and return its value
        var v = angular.isFunction(value) ? value() : value;

        if (value === null) {
          v = '';
        }

        s[s.length] = encodeURIComponent(key) + '=' + encodeURIComponent(v);
      };

      // If an array was passed in, assume that it is an array of form elements.
      if (Array.isArray(data) && data !== {}) {
        // Serialize the form elements
        angular.forEach(data, function (v, i) {
          add(i, v);
        });
      } else {
        // otherwise encode params recursively.
        Object.keys(data).forEach(function (prefix) {
          _this2.buildParams(prefix, data[prefix], add);
        });
      }
      // update data with final serialization
      return s.join('&');
    }

    /**
     * @ngdoc method
     * @name flApi.RequestTransformation#parseBidNotification
     * @methodOf flApi.RequestTransformation
     *
     * @description
     * This method converts the bid data object from the realtime bid
     * notifications into a raw bid object which can be used to create a bid
     * factory
     *
     * @param {Object} data the bid data object returned by a realtime bid
     * notification
     * @returns {Object} a raw bid object
     */

  }, {
    key: 'parseBidNotification',
    value: function parseBidNotification(data) {
      return {
        id: parseInt(data.bid.id, 10),
        amount: parseInt(data.bid.sum, 10),
        fix_project_hourly_rate: parseFloat(data.bid.fix_project_hourly_rate),
        bidder_id: parseInt(data.bid.users_id, 10),
        description: data.bid.descr,
        award_status: data.bid.award_status,
        frontend_bid_status: 'active',
        hidden: data.bidHidden,
        highlighted: data.bid.highlighted,
        milestone_percentage: data.bid.milestone_percentage,
        period: parseInt(data.bid.period, 10),
        project_id: parseInt(data.bid.project_id, 10),
        project_owner_id: parseInt(data.accountId, 10),
        ranking: data.bid.ranking,
        retracted: false,
        shortlisted: data.bid.isShortlisted || false,
        submitdate: parseInt(data.bid.submitdate_ts, 10),
        time_submitted: parseInt(data.bid.submitdate_ts, 10),
        score: parseFloat(data.bid.score)
      };
    }

    /**
     * @ngdoc method
     * @name flApi.RequestTransformation#parseUserNotification
     * @methodOf flApi.RequestTransformation
     *
     * @description
     * This method converts the user data object from the realtime bid
     * notifications into a raw user object which can be used to create a user
     * factory
     *
     * @param {Object} data the bid data object returned by a realtime bid
     * notification
     * @returns {Object} a raw user object
     */

  }, {
    key: 'parseUserNotification',
    value: function parseUserNotification(data) {
      if (Array.isArray(data.bid.user.insignia)) {
        data.bid.user.insignia = data.bid.user.insignia.map(function (item) {
          return {
            id: parseInt(item.examId, 10),
            name: item.title,
            description: item.description,
            icon_name: item.name
            /* TODO: Data that cannot be parse from Notification's data
             * - icon_url
             * - level
             * - score_percentage
             * - type
             * - user_percentile
             */
          };
        });
      }
      var timezone = void 0;
      if (data.bid.user.timezone_info && data.bid.user.timezone_info.country && data.bid.user.timezone_info.id && data.bid.user.timezone_info.offset && data.bid.user.timezone_info.timezone) {
        timezone = {
          country: data.bid.user.timezone_info.country,
          id: data.bid.user.timezone_info.id,
          offset: data.bid.user.timezone_info.offset,
          timezone: data.bid.user.timezone_info.timezone
        };
      }

      return {
        avatar_cdn: data.imgUrl,
        hourly_rate: data.bid.user.hourlyrate,
        id: parseInt(data.bid.user.id, 10),
        location: {
          country: {
            code: data.bid.user.address.code,
            name: data.bid.user.flag.name
          }
        },
        registration_date: data.bid.user.reg_unixtime,
        reputation: {
          earnings_score: data.bid.user.earnings,
          entire_history: {
            all: data.bid.user.seller_rating.projectCount.entire_history.all,
            completion_rate: data.bid.user.seller_rating.projectCount.entire_history.completion_rate,
            overall: data.bid.user.seller_rating.avg,
            reviews: data.bid.user.seller_rating.count,
            on_time: data.bid.user.seller_rating.reputation.entire_history.ont,
            on_budget: data.bid.user.seller_rating.reputation.entire_history.onb,
            category_ratings: {
              quality: data.bid.user.seller_rating.reputation.entire_history.qua,
              communication: data.bid.user.seller_rating.reputation.entire_history.com,
              expertise: data.bid.user.seller_rating.reputation.entire_history.exp,
              professionalism: data.bid.user.seller_rating.reputation.entire_history.pro,
              hire_again: data.bid.user.seller_rating.reputation.entire_history.hag
            }
          },
          user_id: parseInt(data.bid.user.id, 10)
        },
        username: data.bid.user.username,
        isPortfolioCreated: data.bid.user.isPortfolioCreated,
        qualifications: data.bid.user.insignia,
        corporate: data.bid.user.corporate,
        public_name: data.bid.user.publicName,
        timezone: timezone
      };
    }
  }]);

  return RequestTransformation;
}();

var RequestTransformationProvider = flService('RequestTransformation', [], RequestTransformation);

var _templateObject$5 = _taggedTemplateLiteral(['\n      ', '/contacts/0.1/requests/pending_sent/'], ['\n      ', '/contacts/0.1/requests/pending_sent/']),
    _templateObject2$2 = _taggedTemplateLiteral(['\n            ', ' ', ''], ['\n            ', ' ', '']);

/**
* @ngdoc service
* @name flApi.ApiInterceptor
* @description
* Transform the requests to and from the REST API. Use it with flResource.
*/

var ApiInterceptor = function ApiInterceptor($q, $log, Analytics, RequestTransformation, API_BASE_URL) {
  _classCallCheck(this, ApiInterceptor);

  // In contacts and messaging APIs, the parameters for a request to the API
  // need to be form encoded. These are the exceptions, using a primitive
  // wildcard expression for threads.
  var contactRequestUrl = oneLineTrim(_templateObject$5, API_BASE_URL);
  var threadServiceUrl = API_BASE_URL + '/messages/0.1/threads/*';
  var messageServiceUrl = API_BASE_URL + '/messages/0.1/messages/*';
  var videochatServiceUrl = API_BASE_URL + '/messages/0.1/videochat/*';

  var encodeAsFormExceptionMatcher = function encodeAsFormExceptionMatcher(config) {
    var method = config.method;
    return config.url.match(threadServiceUrl) && (method === 'POST' || method === 'PUT') || config.url.match(messageServiceUrl) || config.url.match(videochatServiceUrl) || config.url.match(contactRequestUrl);
  };

  // Encode parameters in form encoding, with special handling of array
  // types NOT to use commas, e.g. users[]=123,345 is NOT allowed. This
  // function replaces it with users[]=123&users[]=345
  var encodeFormUrlEncoded = function encodeFormUrlEncoded(config) {
    // If we are sending a Form Encoded request, don't apply the key-value
    // string to the URL. This is bad and makes the request empty :(
    if (config.data instanceof FormData) {
      return;
    }

    config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    config.data = RequestTransformation.formUrlEncoded(config.data);
  };

  // In the translations API, parameter flags are indicated are indicating
  // with either it's the presence (indicating true) or absence (indicating
  // false). As a result, parameters with a "false" value should simply be
  // removed.
  var translationsApiUrl = API_BASE_URL + '/translations/0.1/*';
  var removeFalseParams = function removeFalseParams(config) {
    Object.keys(config.params).forEach(function (key) {
      if (config.params[key] === false) {
        delete config.params[key];
      }
    });
  };
  return {
    /**
     * @ngdoc method
     * @name flApi.ApiInterceptor#request
     * @methodOf flApi.ApiInterceptor
     *
     * @description
     * Intercepts requests to `API_BASE_URL` and applies some modifications
     * to them according to certain criteria (e.g. some header could be
     * added/modified).
     *
     * @param {Object} config The request configuration object
     * @returns {Object} The config object received as a parameter,
     * eventually modified.
     */
    request: function request(config) {
      // Activate the "compact" mode on all requests to the API
      if (config.params) {
        config.params.compact = true;
      } else if (config.data && config.data instanceof FormData) {
        config.data.append('compact', 'true');
      } else if (config.data) {
        config.data.compact = true;
      }

      // Fix the "action" PATH & PUT requests being form submission
      // instead of application/json
      if (encodeAsFormExceptionMatcher(config)) {
        encodeFormUrlEncoded(config);
      } else if ((config.method === 'PUT' || config.method === 'PATCH') && config.data && config.data.action &&
      // Dirty hack, but we have no choice until we fix these global
      // interceptors
      !config.url.match('/api/users/0.1/showcase_items/') && !config.url.match('/api/users/0.1/phone_verifications/') && !config.url.match('/api/users/0.1/webhooks/')) {
        encodeFormUrlEncoded(config);
      }

      // Removing false params from all requests to the translations API
      if (config.url.match(translationsApiUrl)) {
        removeFalseParams(config);
      }
      return config;
    },
    /**
     * @ngdoc method
     * @name flApi.ApiInterceptor#response
     * @methodOf flApi.ApiInterceptor
     *
     * @description
     * Intercepts responses from `API_BASE_URL` and applies some
     * modifications to them according to certain criteria (e.g. some content
     * could be added/modified).
     *
     * @param {Object} response The content of the response.
     * @returns {Object} The object received as a parameter,
     * eventually modified.
     */
    response: function response(_response) {
      // Check the response validity
      if (_response.data && _response.data.status === 'success') {
        if (_response.data.result) {
          _response.data = _response.data.result;
        }
      } else {
        // Shouldn't happen, report the error
        var errorCode = 'INVALID_RESPONSE';
        $log.error('api: invalid server response: ' + _response.data);
        if (typeof Raven !== 'undefined') {
          Raven.captureMessage(errorCode, {
            extra: {
              response: JSON.stringify(_response.data),
              config: JSON.stringify(_response.config),
              status: _response.status,
              status_text: _response.statusText
            }
          });
        }
        Analytics.trackError('api', oneLineTrim(_templateObject2$2, _response.config.method, _response.config.url), _response.status, _response.data);
        _response.code = errorCode;
        return $q.reject(_response);
      }
      return _response.data;
    },
    /**
    * @ngdoc method
    * @name flApi.ApiInterceptor#responseError
    * @methodOf flApi.ApiInterceptor
    *
    * @description
    * `responseError` interceptor gets called when a previous interceptor
    * threw an error or resolved with a rejection.
    *
    * @param {Object} response The request configuration object
    * @returns {Object} The object received as a parameter,
    * eventually modified.
    */
    responseError: function responseError(response) {
      var errorCode = void 0;

      // Provide human-oriented error messages in response blob
      var humanError = {
        title: 'Something went wrong',
        message: 'Please check your internet connection and refresh the page.'
      };
      if (response.status >= 400 && response.status < 500) {
        humanError = {
          title: 'Something went wrong',
          message: 'If this problem persists, please contact support with ' + ('Error: ' + response.data.message)
        };
      } else if (response.status >= 500 && response.status < 600) {
        humanError = {
          title: 'Something went wrong with our service',
          message: 'To continue, please refresh the page and try again.'
        };
      }
      response.humanError = humanError;

      // We should always have an error message
      if (response.data && response.data.error_code) {
        var errors = response.data.error_code.match(/\.(.*$)/);
        if (errors && errors[1]) {
          errorCode = errors[1];
        } else {
          errorCode = 'INVALID_ERROR';
        }
      } else {
        errorCode = 'INVALID_RESPONSE';
      }

      // Push interesting errors into Sentry
      if (errorCode === 'UNKNOWN_ERROR' || errorCode === 'GAF_EXCEPTION' || errorCode === 'INVALID_ERROR' || errorCode === 'INVALID_RESPONSE' || errorCode === 'GENERAL') {
        if (typeof Raven !== 'undefined') {
          Raven.captureMessage(errorCode, {
            tags: {
              api: JSON.stringify(response.config.url)
            },
            extra: {
              response: JSON.stringify(response.data),
              config: JSON.stringify(response.config),
              status: response.status,
              status_text: response.statusText
            }
          });
        }
        Analytics.trackError('api', oneLineTrim(_templateObject2$2, response.config.method, response.config.url), response.status, response.data);
      }
      if (!response.data) {
        response.data = {};
      }
      response.code = errorCode;
      return $q.reject(response);
    }
  };
};

ApiInterceptor.$inject = ['$q', '$log', 'Analytics', 'RequestTransformation', 'API_BASE_URL'];


var ApiInterceptorProvider = flService('ApiInterceptor', [OPAQUE_MODULE_NAME, AnalyticsModule, RequestTransformationProvider], ApiInterceptor);

/**
 * @ngdoc service
 * @name flApiTranslations.Translations
 *
 * @description
 * A service that provides a convenient way to interact with the translations
 * API
 */
var OPAQUE_MODULE_NAME$1 = 'flAngular.TranslationsProvider';

var TranslationsProviderProvider = angular.module(OPAQUE_MODULE_NAME$1, [threepio, OPAQUE_MODULE_NAME, flResourceProvider, ApiInterceptorProvider]).provider('Translations', ['TranslationProvider', 'LocalizationProvider', 'LANGUAGE_COOKIE', 'LANGUAGE_COOKIE_EXPIRES', function TranslationsProvider(TranslationProvider, LocalizationProvider, LANGUAGE_COOKIE, LANGUAGE_COOKIE_EXPIRES) {
  var translationsDomain = void 0;

  this.translate = function (domain, translateRootEl) {
    translationsDomain = domain;
    TranslationProvider.setTranslationsRequest(['Translations', function (Translations) {
      return function (language) {
        return Translations.getStrings(domain, language);
      };
    }]);
    if (translateRootEl) {
      TranslationProvider.translateRootElement();
    }
    LocalizationProvider.setLanguageCookie(LANGUAGE_COOKIE, {
      domain: window.location.hostname.match(/freelancer.*$/) ? window.location.hostname.match(/freelancer.*$/)[0] : undefined,
      expires: LANGUAGE_COOKIE_EXPIRES
    });
  };

  this.setLanguage = function (languageCode$$1) {
    LocalizationProvider.setLanguage(languageCode$$1);
  };

  this.$get = ['flResource', 'ApiInterceptor', 'API_BASE_URL', function (flResource, ApiInterceptor, API_BASE_URL) {
    // The `/translations` GET API endpoint uses the `Accept` header to
    // indicate the preferred response media type. The default `Accept`
    // header for `$http` includes `application/json`, `text/plain`, and
    // `*/*` without any weights, which would create an ambiguous resulting
    // in a `300` status code.
    // Because of this we explicitly specify `application/json` as the sole
    // accepted media type.
    var Translations = flResource(API_BASE_URL + '/translations/0.1/translations/', ApiInterceptor, {
      hashed: true,
      legacy: true
    }, {
      get: {
        cache: true,
        headers: { Accept: 'application/json' }
      }
    });
    var Languages = flResource(API_BASE_URL + '/translations/0.1/languages/', ApiInterceptor);

    return {
      /**
       * @ngdoc method
       * @name flApiTranslations.Translations#getStrings
       * @methodOf flApiTranslations.Translations
       *
       * @description
       * Get the all the strings of a translation domain for a language
       *
       * @param {String} domain The domain for which to get the translations
       * @returns {Object} language The language code (e.g., "fr") of the
       * locale
       */
      getStrings: function getStrings(domain, language) {
        return Translations.get({
          domain: domain,
          language_code: language
        }).$promise;
      },

      /**
       * @ngdoc method
       * @name flApiTranslations.Translations#getDomain
       * @methodOf flApiTranslations.Translations
       *
       * @description
       * Get the translation domain set by the Angular app via .config()
       *
       * @returns {String} domain The domain for which to get the translations
       */
      getDomain: function getDomain() {
        return translationsDomain;
      },

      /**
       * @ngdoc method
       * @name flApiTranslations.Translations#getLanguages
       * @methodOf flApiTranslations.Translations
       *
       * @description
       * Fetch a list of all languages in the translations system
       *
       * @param {Boolean} activeOnly      Indicates whether or not inactive
       *                                  languages should also be returned
       * @param {Array}   languageCodes   An optional array of codes for the
       *                                  specific languages to return
       * @returns {Object}                A promise that resolves to an
       *                                  object hash of language codes and
       *                                  names
       */
      getLanguages: function getLanguages() {
        var activeOnly = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        var languageCodes = arguments[1];

        return Languages.get({
          'language_codes[]': languageCodes,
          active_only: activeOnly
        }).$promise;
      }
    };
  }];
}]).name;

/**
 * @ngdoc directive
 * @name flAnalytics.Analytics
 *
 * @description
 * A directive which defines a section that is being tracked.
 */

var flAnalyticsSection = function flAnalyticsSection($attrs) {
  _classCallCheck(this, flAnalyticsSection);

  this.section = $attrs.flAnalyticsSection;
};

flAnalyticsSection.$inject = ['$attrs'];


var flAnalyticsSection$1 = flDirective(flAnalyticsSection, {
  selector: '[fl-analytics-section]'
});

/**
 * @ngdoc directive
 * @name flAnalytics.Analytics
 *
 * @description
 * A directive which defines a subsection that is being tracked.
 */

var flAnalyticsSubsection = function flAnalyticsSubsection($attrs) {
  _classCallCheck(this, flAnalyticsSubsection);

  this.subsection = $attrs.flAnalyticsSubsection;
};

flAnalyticsSubsection.$inject = ['$attrs'];


var flAnalyticsSubsection$1 = flDirective(flAnalyticsSubsection, {
  selector: '[fl-analytics-subsection]'
});

/**
 * @ngdoc directive
 * @name flAnalytics.Analytics
 *
 * @description
 * A directive which defines an element that is being tracked. The event that
 * is being tracked is inferred by the type of the element.
 */

// Infer the DOM event type from the element tagName & type
function inferEventType(element) {
  if (['button', 'submit'].indexOf(element.type) !== -1) {
    return 'click';
  } else if (['select', 'input', 'textarea'].indexOf(element.tagName.toLowerCase()) !== -1) {
    return 'change';
  } else if (element.isContentEditable) {
    // contenteditable elements don't have change events
    return 'blur';
  }
  return 'click';
}

// Event section is mandotary, event subsection is optional

var flAnalytics = function () {
  function flAnalytics($parse, $log, Analytics) {
    _classCallCheck(this, flAnalytics);

    this.$parse = $parse;
    this.$log = $log;
    this.Analytics = Analytics;
  }

  _createClass(flAnalytics, [{
    key: 'link',
    value: function link(scope, element, attrs, ctrls) {
      var _this = this;

      // The name of the event (mandatory)
      var name = attrs.flAnalytics;
      // The section on the site (mandatory)
      var section = ctrls[0].section;
      // The subsection (optional)
      var subsection = ctrls[1] ? ctrls[1].subsection : undefined;

      if (name && section) {
        (function () {
          // DOM event type
          var type = inferEventType(element[0]);
          element.on(type, function (e) {
            var el = e.target;
            // Get the event value from the attributes (Angular expression) or
            // use the DOM element value is not specified
            var value = _this.$parse(attrs.flAnalyticsValue)(scope);
            // Get the action from the event type if no action is specified
            var action = attrs.flAnalyticsAction ? attrs.flAnalyticsAction : type;
            // Get the element label: if it's a select input & an element is
            // selected, get the selected text, otherwise we use the content
            var label = attrs.flAnalyticsLabel;
            if (!label && !el.isContentEditable) {
              label = el.value && el.options ? el.options[el.selectedIndex].text : el.textContent.trim();
            }
            var reference = attrs.flAnalyticsReference;
            var referenceId = attrs.flAnalyticsReferenceId;

            _this.Analytics.trackEvent(section, subsection, name, action, value, label, reference, referenceId);
          });
        })();
      } else {
        this.$log.warn('invalid event name or section');
      }
    }
  }]);

  return flAnalytics;
}();

flAnalytics.$inject = ['$parse', '$log', 'Analytics'];


var flAnalytics$1 = flDirective(flAnalytics, {
  selector: '[fl-analytics]',
  providers: [AnalyticsModule],
  directives: [flAnalyticsSection$1, flAnalyticsSubsection$1],
  require: ['^flAnalyticsSection', '?^flAnalyticsSubsection'],
  scope: false
});

var _templateObject$6 = _taggedTemplateLiteral(['Invalid app name selector (', '): the selector\n      must be a dash-delimited element selectors starting with the \'fl\' prefix,\n      e.g. \'fl-laurent-rocks\''], ['Invalid app name selector (', '): the selector\n      must be a dash-delimited element selectors starting with the \'fl\' prefix,\n      e.g. \'fl-laurent-rocks\'']);

/*
 * `angular.module` wrapper to abtract the Angular apps common configurations
 * in GAF. Use it instead of `angular.module` to create & bootstrap your app:
 *
 * ```
 * export default flApp('phoneVerification', [
 *   PhoneVerification
 * ]);
 * ```
 */
function flApp(name, deps, appController) {
  // Lint for invalid selector
  // TODO: this should be a lint rule
  if (!/^fl-[a-z-]+$/.test(name)) {
    throw new Error(oneLine(_templateObject$6, name));
  }

  var app = angular.module(name + 'App', deps.concat([TranslationsProviderProvider, flAnalytics$1, flAnalyticsSection$1, flAnalyticsSubsection$1])).config(['$compileProvider', function ($compileProvider) {
    $compileProvider.debugInfoEnabled(false);
  }]).config(['TranslationsProvider', function (TranslationsProvider) {
    var translationName = name.replace(/^fl-/, '');
    TranslationsProvider.translate('gaf|' + translationName);
    TranslationsProvider.setLanguage(languageCode);
  }]).config(['$interpolateProvider', function ($interpolateProvider) {
    $interpolateProvider.startSymbol('{[{');
    $interpolateProvider.endSymbol('}]}');
  }]);
  // FIXME: There's no way we're gonna to load the TranslationModal for
  // non-translators
  /* .run(function(TranslationModal, CookieStore, TRANSLATE_MODE_COOKIE) {
      TranslationModal.setTranslationMode(
        CookieStore.get(TRANSLATE_MODE_COOKIE) === '1'
      );
    }); */

  if (appController) {
    app.controller('appController', appController);
  }

  setTimeout(function () {
    var app = angular.element(document.querySelector(name));
    if (!app.injector()) {
      angular.bootstrap(app, [name + 'App']);
    }
  });
  return app;
}

/*
 * Angular service wrapper to abstract the creation of Angular services in your
 * applications.
 *
 * ```
 * import ngResource from 'angular-resource';
 * import { flService } from 'fl-forward';
 *
 * export default flService('MyService',
 *   [ngResource],
 *   MyService
 * );
 *
 * class MyService {
 *   constructor($resource) {
 *     ...
 *   }
 * }
 * ```
 */
function flService$1(name, deps, classFn) {
  return angular.module('flForward.Service.' + name, deps).service(name, classFn).name;
}

/**
 * annotateTemplate - uses threepio to annotate AngularJS templates with
 * HTML attributes required for the translation system.
 *
 * @param  {string} template raw HTML template
 * @return {string}          annotated template
 */
function annotateTemplate$1(template) {
  if (typeof template !== 'string') {
    return template;
  }

  var threepio = new ThreepioLib$1(document, {
    startExpr: '{[{',
    endExpr: '}]}'
  });

  threepio.prepare(template);
  return threepio.serialize();
}

var _templateObject$7 = _taggedTemplateLiteral(['Invalid component selector\n      (', '): the selector must be a dash-delimited\n      element selectors starting with the \'fl\' prefix,\n      e.g. \'fl-laurent-rocks\''], ['Invalid component selector\n      (', '): the selector must be a dash-delimited\n      element selectors starting with the \'fl\' prefix,\n      e.g. \'fl-laurent-rocks\'']),
    _templateObject2$3 = _taggedTemplateLiteral(['Components cannot have link functions. If you need\n      to do DOM manipulations, use the $postLink hook instead.'], ['Components cannot have link functions. If you need\n      to do DOM manipulations, use the $postLink hook instead.']),
    _templateObject3$1 = _taggedTemplateLiteral(['Components need to provide views through the\n      \'template\' property.'], ['Components need to provide views through the\n      \'template\' property.']);

function flComponent$1(componentCtrl, componentOptions) {
  // Lint for invalid selector
  // TODO: this should be a lint rule in eslint-plugin-fl-forward
  if (!componentOptions.selector || !/^fl-[a-z-]+$/.test(componentOptions.selector)) {
    throw new Error(oneLine(_templateObject$7, componentOptions.selector));
  }

  // Lint for invalid use of link function
  // TODO: this should be a lint rule in eslint-plugin-fl-forward
  if (componentCtrl && componentCtrl.prototype.link) {
    throw new Error(oneLine(_templateObject2$3));
  }

  // The templates must be loaded through SystemJS
  // TODO: this should be a lint rule in eslint-plugin-fl-forward
  if (componentOptions.templateUrl) {
    throw new Error(oneLine(_templateObject3$1));
  }

  // Get the component name from its selector
  var camelCasedName = componentOptions.selector.replace(/-([a-z])/g, function (g) {
    return g[1].toUpperCase();
  });

  // The controllerAs value is the component's name (without the 'fl' prefix)
  var controllerAs = camelCasedName.slice(2);

  return angular.module('flForward.Component.' + camelCasedName, [].concat(componentOptions.providers || []).concat(componentOptions.directives || [])).component(camelCasedName, {
    controller: componentCtrl,
    controllerAs: controllerAs,
    template: annotateTemplate$1(componentOptions.template),
    transclude: componentOptions.transclude,
    bindings: componentOptions.bindings,
    restrict: 'E',
    require: componentOptions.require
  }).name;
}

var _templateObject$8 = _taggedTemplateLiteral(['Invalid component selector\n      (', '): the selector must be a dash-delimited\n      element selectors starting with the \'fl\' prefix, e.g. \'fl-laurent-rocks\',\n      or dash-delimited attributes selectors starting with the \'fl\' prefix,\n      e.g. \'[fl-laurent-rocks]\''], ['Invalid component selector\n      (', '): the selector must be a dash-delimited\n      element selectors starting with the \'fl\' prefix, e.g. \'fl-laurent-rocks\',\n      or dash-delimited attributes selectors starting with the \'fl\' prefix,\n      e.g. \'[fl-laurent-rocks]\'']);

function flDirective$1(directiveCtrl, directiveObj) {
  // Lint for invalid selector
  // TODO: this should be a lint rule in eslint-plugin-fl-forward
  if (!directiveObj.selector || !/^\[?fl-[a-z-]+\]?$/.test(directiveObj.selector)) {
    throw new Error(oneLine(_templateObject$8, directiveObj.selector));
  }

  // Compute the directive's name from the selector & the "restrict" attribute
  var directiveName = directiveObj.selector.replace(/-([a-z])/g, function (g) {
    return g[1].toUpperCase();
  });
  var decorator = false;
  if (directiveName[0] === '[') {
    directiveName = directiveName.slice(1, -1);
    decorator = true;
  }

  // The controllerAs value is the directive's name (without the 'fl' prefix)
  var controllerAs = directiveName.slice(2);

  // Create factory wrapper
  var ddo = function ddo() {
    return {
      restrict: decorator ? 'A' : 'E',
      replace: directiveObj.replace || false,
      scope: directiveObj.scope || false,
      transclude: directiveObj.transclude,
      require: directiveObj.require,
      template: annotateTemplate$1(directiveObj.template),
      compile: function compile() {
        return function (scope) {
          for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          // call the link function in the context of the controller
          if (scope[controllerAs].link) {
            var _scope$controllerAs;

            return (_scope$controllerAs = scope[controllerAs]).link.apply(_scope$controllerAs, [scope].concat(args));
          }
          return function noop() {};
        };
      },
      controller: directiveCtrl,
      bindToController: true,
      controllerAs: controllerAs
    };
  };

  // Create the directive itself
  return angular.module('flForward.Directive.' + directiveName, [].concat(directiveObj.providers || []).concat(directiveObj.directives || [])).directive(directiveName, ddo).name;
}

/*
 * Angular constant wrapper to abstract the creation of Angular constant
 *
 * ```
 * import { flConstant } from 'fl-forward';
 *
 * export default flConstant('CONNECTION_URL', 'http://foo');
 * ```
 */
function flConstant$1(varName, varValue) {
  return angular.module('flForward.Constant.' + varName, []).constant(varName, varValue).name;
}

/**
 * @ngdoc service
 * @name flAuth.Auth
 *
 * @description
 * Implementation of the Freelancer Auth API
 */

var AuthProvider = function () {
  function AuthProvider($http, $q, $rootScope, $window, CookieStore, AUTH_BASE_URL, AUTH_TOKEN_COOKIE, USER_ID_COOKIE, FACEBOOK_APP_ID) {
    _classCallCheck(this, AuthProvider);

    this.CookieStore = CookieStore;
    this.$rootScope = $rootScope;
    this.$http = $http;
    this.$q = $q;
    this.$window = $window;
    this.AUTH_BASE_URL = AUTH_BASE_URL;
    this.AUTH_TOKEN_COOKIE = AUTH_TOKEN_COOKIE;
    this.USER_ID_COOKIE = USER_ID_COOKIE;
    this.FACEBOOK_APP_ID = FACEBOOK_APP_ID;
    this.accessToken = CookieStore.get(AUTH_TOKEN_COOKIE);
    this.userId = parseInt(CookieStore.get(USER_ID_COOKIE), 10);

    // Avoid using $location in fl-api as it breaks backbone.js routers
    // and we need to support legacy code for now
    this.defaultCookieOptions = {
      domain: this.CookieStore.getDomain(this.$window.location.hostname),
      secure: $window.location.protocol === 'https:',
      // SameSite=None can only be set on Secure cookies
      sameSite: $window.location.protocol === 'https:' ? 'None' : ''
    };
  }
  // Start new session / Login user


  _createClass(AuthProvider, [{
    key: 'login',
    value: function login(username, password, remember) {
      var _this = this;

      // Auth endpoit is using multipart/form-data instead of
      // application/json! Or application/x-www-form-urlencoded! WTF?
      // TODO: Use application/json
      var payload = new FormData();
      payload.append('user', username);
      payload.append('password', password);

      return this.$http.post(this.AUTH_BASE_URL + '/login/', payload, {
        // Let the XHR implementation fill the 'Content-Type'
        // with the correct boundary Id
        headers: {
          'Content-Type': undefined
        },
        // Tell Angular do not transform (toJSON'd) the request
        transformRequest: angular.identity
      }).then(function (response) {
        _this.set(response.data.token, response.data.user, remember);
        return response.data;
      });
    }

    // Reset session

  }, {
    key: 'reset',
    value: function reset() {
      // Reset state
      this.accessToken = null;
      this.userId = null;
      // Remove auth cookies
      this.CookieStore.remove(this.AUTH_TOKEN_COOKIE, this.defaultCookieOptions);
      this.CookieStore.remove(this.USER_ID_COOKIE, this.defaultCookieOptions);
      // Unset Raven userId
      if (typeof Raven !== 'undefined') {
        Raven.setUser();
      }
      this.$rootScope.$broadcast('user.logout');
    }
    // Set a new session

  }, {
    key: 'set',
    value: function set(accessToken, userId, remember) {
      // Save auth params
      this.accessToken = accessToken;
      this.userId = parseInt(userId, 10);
      // Store the auth params as cookies
      // Only send the session cookie over SSL to prevent session hijacking
      // Remember for a 2 weeks. Yes GAF remembers you for 5 years but
      // that's maybe a bit too much.
      var options = this.defaultCookieOptions;
      // TODO: ^This should be a shallow copy instead of copy by reference.
      // Copy by reference means `options.expires` will
      // also change this.defaultCookieOptions.expires value.
      options.expires = remember ? 60 * 60 * 24 * 14 : null;
      this.CookieStore.put(this.AUTH_TOKEN_COOKIE, accessToken, options);
      this.CookieStore.put(this.USER_ID_COOKIE, userId, options);
      // Set the user id into Raven
      if (typeof Raven !== 'undefined') {
        Raven.setUser({
          id: this.userId
        });
      }
      this.$rootScope.$broadcast('user.login');
    }

    // Set Extra Cookies

  }, {
    key: 'setExtraCookies',
    value: function setExtraCookies(cookies) {
      var _this2 = this;

      Object.keys(cookies).forEach(function (cookieName) {
        var cookie = cookies[cookieName];
        var options = Object.assign({}, _this2.defaultCookieOptions);
        if ('ttl' in cookie) {
          options.expires = cookie.ttl;
        }

        if ('value' in cookie) {
          _this2.CookieStore.put(cookieName, cookie.value, options);
        }
      });
    }

    // End session / Logout user

  }, {
    key: 'logout',
    value: function logout() {
      var _this3 = this;

      if (!this.isAuthenticated()) {
        return this.$q.reject();
      }
      // Auth endpoit is using multipart/form-data instead of
      // application/json! Or application/x-www-form-urlencoded! WTF?
      // TODO: Use application/json
      var payload = new FormData();
      payload.append('user', this.userId);
      payload.append('token', this.accessToken);

      // Destroys the session token
      return this.$http.post(this.AUTH_BASE_URL + '/logout/', payload, {
        // Let the XHR implementation fill the 'Content-Type'
        // with the correct boundary Id
        headers: { 'Content-Type': undefined },
        // Tell Angular do not transform (toJSON'd) the request
        transformRequest: angular.identity
      }).then(function () {
        _this3.reset();
      }).catch(function (error) {
        // Reset the session anyway if the token is invalid
        _this3.reset();
        return error;
      });
    }
    // Is the user currently authenticated?

  }, {
    key: 'isAuthenticated',
    value: function isAuthenticated() {
      return this.userId && this.accessToken;
    }
    // Get userId

  }, {
    key: 'getUserId',
    value: function getUserId() {
      return this.userId;
    }
    // Get accessToken

  }, {
    key: 'getAccessToken',
    value: function getAccessToken() {
      return this.accessToken;
    }
    // Freelancer-Auth-V2 auth header params for the REST API

  }, {
    key: 'getAuthHeader',
    value: function getAuthHeader() {
      // Do not set the header if not authenticated
      if (this.isAuthenticated()) {
        return this.userId + '; ' + encodeURIComponent(this.accessToken);
      }
      return undefined;
    }
    // Returns a promise

  }, {
    key: 'checkAuthenticated',
    value: function checkAuthenticated() {
      if (!this.isAuthenticated()) {
        return this.$q.reject();
      }
      return this.$http.get(this.AUTH_BASE_URL + '/check/', {
        params: {
          user: this.userId,
          token: this.token
        }
      }).then(function (response) {
        return response.data.expiry;
      });
    }

    // Set a new password
    // - INVALID_USER
    // - WEAK_PASSWORD
    // - INVALID_CREDENTIALS

  }, {
    key: 'changePassword',
    value: function changePassword(oldPassword, newPassword) {
      var _this4 = this;

      if (!this.isAuthenticated()) {
        return this.$q.reject();
      }
      // Auth endpoit is using multipart/form-data instead of
      // application/json! Or application/x-www-form-urlencoded! WTF?
      // TODO: Use application/json
      var payload = new FormData();
      payload.append('user', this.userId);
      payload.append('old_password', oldPassword);
      payload.append('new_password', newPassword);

      return this.$http.post(this.AUTH_BASE_URL + '/change/', payload, {
        // Let the XHR implementation fill the 'Content-Type'
        // with the correct boundary Id
        headers: { 'Content-Type': undefined },
        // Tell Angular do not transform (toJSON'd) the request
        transformRequest: angular.identity
      }).then(function (response) {
        _this4.set(response.data.token, response.data.user, true);
      });
    }

    // Send reset password email
    // - UNKOWN_EMAIL

  }, {
    key: 'resetPassword',
    value: function resetPassword(email) {
      // Auth endpoit is using multipart/form-data instead of
      // application/json! Or application/x-www-form-urlencoded! WTF?
      // TODO: Use application/json
      var payload = new FormData();
      payload.append('email', email);
      return this.$http.post(this.AUTH_BASE_URL + '/forgot/', payload, {
        // Let the XHR implementation fill the 'Content-Type'
        // with the correct boundary Id
        headers: { 'Content-Type': undefined },
        // Tell Angular do not transform (toJSON'd) the request
        transformRequest: angular.identity
      });
    }
    /**
    * @ngdoc method
    * @name flthis.Auth#login
    * @methodOf flthis.Auth
    *
    * @description
    * Use facebook credentials to login to Freelancer
    * Makes use of the FB.login call to the facebook api
    * to ensure the user is logged in to facebook and has
    * granted permissions to Freelance.
    *
    * @returns {Object} a Promise object that will be resolved with an
    * auth response object from the freelancer api
    */

  }, {
    key: 'loginWithFacebook',
    value: function loginWithFacebook(facebookAuthParams) {
      return this.oAuthLogin(this.FACEBOOK_APP_ID, 'facebook', facebookAuthParams.signedRequest);
    }
    // Login the user using OAuth credentials
    // INVALID_USER
    // INVALID_TOKEN

  }, {
    key: 'oAuthLogin',
    value: function oAuthLogin(appId, oauthType, credentials) {
      var _this5 = this;

      // Auth endpoit is using multipart/form-data instead of
      // application/json! Or application/x-www-form-urlencoded! WTF?
      // TODO: Use application/json
      var payload = new FormData();
      payload.append('app_id', appId);
      payload.append('oauth_type', oauthType);
      payload.append('credentials', credentials);

      return this.$http.post(this.AUTH_BASE_URL + '/login/oauth/', payload, {
        // Let the XHR implementation fill the 'Content-Type'
        // with the correct boundary Id
        headers: { 'Content-Type': undefined },
        // Tell Angular do not transform (toJSON'd) the request
        transformRequest: angular.identity
      }).then(function (response) {
        _this5.set(response.data.token, response.data.user, true);
        return response.data;
      });
    }

    /**
     * @ngdoc method
     * @name flAuth.Auth#getDeviceToken
     * @methodOf flAuth.Auth
     *
     * @description
     * Fetch a unique token provided to a device, intended to be
     * stored by the device independent of user sessions.
     *
     * @returns {String} a Promise string token
     */

  }, {
    key: 'getDeviceToken',
    value: function getDeviceToken() {
      return this.$http.get(this.AUTH_BASE_URL + '/device/').then(function (response) {
        return response.data.token;
      });
    }

    /**
     * @ngdoc method
     * @name flAuth.Auth#loginWith2FA
     * @methodOf flAuth.Auth
     *
     * @description
     * Use Freelancer login API with additional device token parameter to
     * determine if user 2FA is required or not. This will also send the TOTP
     * token to the delivery mechanism available for the user.
     *
     * @returns {Object} a Promise object that will throw an error if
     * 2FA is required, otherwise it will be resolved with an
     * auth token and user id.
     */

  }, {
    key: 'loginWith2FA',
    value: function loginWith2FA(username, password, remember, deviceToken) {
      var _this6 = this;

      var payload = new FormData();
      payload.append('user', username);
      payload.append('password', password);
      payload.append('device_token', deviceToken);

      return this.$http.post(this.AUTH_BASE_URL + '/login/', payload, {
        // Let the XHR implementation fill the 'Content-Type'
        // with the correct boundary Id
        headers: {
          'Content-Type': undefined
        },
        // Tell Angular do not transform (toJSON'd) the request
        transformRequest: angular.identity
      }).then(function (response) {
        if (response.data.pre_login_token) {
          var error = response.data;
          error.code = '2FA_REQUIRED';

          return _this6.$q.reject(error);
        }

        // No 2FA required
        _this6.set(response.data.token, response.data.user, remember);

        return response.data;
      });
    }

    /**
     * @ngdoc method
     * @name flAuth.Auth#verifyTotp
     * @methodOf flAuth.Auth
     *
     * @description
     * Use Freelancer login API to verify if the prelogin token, TOTP
     * and device token are valid.
     *
     * @returns {Object} a Promise object that will be resolved with
     * an auth token and user id.
     */

  }, {
    key: 'verifyTotp',
    value: function verifyTotp(preLoginToken, totp, deviceToken, remember) {
      var _this7 = this;

      var payload = new FormData();
      payload.append('pre_login_token', preLoginToken);
      payload.append('totp', totp);
      payload.append('device_token', deviceToken);

      return this.$http.post(this.AUTH_BASE_URL + '/login/verify/', payload, {
        // Let the XHR implementation fill the 'Content-Type'
        // with the correct boundary Id
        headers: {
          'Content-Type': undefined
        },
        // Tell Angular do not transform (toJSON'd) the request
        transformRequest: angular.identity
      }).then(function (response) {
        _this7.set(response.data.token, response.data.user, remember);

        return response.data;
      });
    }

    /**
     * @ngdoc method
     * @name flAuth.Auth#switchAccount
     * @methodOf flAuth.Auth
     *
     * @description
     * Use Freelancer switch account API to login linked corporate accounts
     *
     * @returns {Object} a Promise object that will be resolved with an
     * auth response object from the Freelancer Api
     */

  }, {
    key: 'switchAccount',
    value: function switchAccount(fromUserId, toUserId, remember) {
      var _this8 = this;

      var payload = new FormData();
      payload.append('user', fromUserId);
      payload.append('other_user', toUserId);
      payload.append('token', this.accessToken);

      return this.$http.post(this.AUTH_BASE_URL + '/switch_account/', payload, {
        // Let the XHR implementation fill the 'Content-Type'
        // with the correct boundary Id
        headers: {
          'Content-Type': undefined
        },
        // Tell Angular do not transform (toJSON'd) the request
        transformRequest: angular.identity
      }).then(function (response) {
        _this8.set(response.data.token, response.data.user, remember);

        return response.data;
      });
    }
  }]);

  return AuthProvider;
}();

AuthProvider.$inject = ['$http', '$q', '$rootScope', '$window', 'CookieStore', 'AUTH_BASE_URL', 'AUTH_TOKEN_COOKIE', 'USER_ID_COOKIE', 'FACEBOOK_APP_ID'];


var AuthModule = flService('Auth', [AnalyticsModule, CookieStoreProvider$1, OPAQUE_MODULE_NAME], AuthProvider);

// HTTP interceptor for 401 UNAUTHORIZED
// Logout the current user if it happens (it should not!)
angular.module(AuthModule).factory('AutoLogoutInterceptor', ['$q', '$injector', function ($q, $injector) {
  return {
    responseError: function responseError(response) {
      // Filter out login requests with invalid credentials
      if (response.status === 401 && response.config.url.indexOf('/auth/login') === -1) {
        // Clear invalid session token
        // Differed injection is need to work around circular
        // dependency between Auth & $http
        $injector.invoke(['Auth', function (Auth) {
          Auth.reset();
        }]);
      }
      return $q.reject(response);
    }
  };
}]);

// Add the REST API auth header
angular.module(AuthModule).factory('RESTAuthInterceptor', ['$injector', 'API_BASE_URL', function ($injector, API_BASE_URL) {
  return {
    request: function request(config) {
      if (config.url.match(API_BASE_URL)) {
        // Differed injection is need to work around circular
        // dependency between Auth & $http
        $injector.invoke(['Auth', function (Auth) {
          config.headers['Freelancer-Auth-V2'] = Auth.getAuthHeader();
        }]);
      }
      return config;
    }
  };
}]);

/**
 * @ngdoc service
 * @name flAuth.AuthBackendInterceptor
 *
 * @description
 * HTTP interceptor abstracting the comminutation with the auth backend
 */
angular.module(AuthModule).factory('AuthBackendInterceptor', ['$q', '$log', 'AUTH_BASE_URL', 'Analytics', function ($q, $log, AUTH_BASE_URL, Analytics) {
  return {
    /**
    * @ngdoc method
    * @name flAuth.AuthBackendInterceptor#response
    * @methodOf flAuth.AuthBackendInterceptor
    *
    * @description
    * Process auth related response -
    *    1. Replace response.data with response.data.result on success
    *    2. Report error and returns a rejected promise
    *
    * @param {Object} response The http response object
    * @returns {Object} successful resonse or a rejected promise
    */
    response: function response(_response) {
      // Only handles auth related urls
      if (_response.config.url.match(AUTH_BASE_URL + '(?:[?/]|$)')) {
        // Check the response validity
        if (_response.data && _response.data.status === 'success' && (_response.config.url.match(/\/logout\/$/) || _response.config.url.match(/\/forgot\/$/))) ; else if (_response.data && _response.data.status === 'success' && _response.data.result) {
          _response.data = _response.data.result;
        } else {
          // Shouldn't happen, report the error
          $log.error('auth: invalid server response: ' + _response.data);
          var errorCode = 'INVALID_RESPONSE';
          if (typeof Raven !== 'undefined') {
            Raven.captureMessage(errorCode, {
              extra: {
                response: JSON.stringify(_response.data),
                config: JSON.stringify(_response.config),
                status: _response.status,
                status_text: _response.statusText
              }
            });
          }
          Analytics.trackError('auth', _response.config.method + ' ' + _response.config.url, _response.status, _response.data);
          _response.code = errorCode;
          return $q.reject(_response);
        }
      }
      return _response;
    },
    /**
    * @ngdoc method
    * @name flAuth.AuthBackendInterceptor#responseError
    * @methodOf flAuth.AuthBackendInterceptor
    *
    * @description
    * Process auth related error response
    *
    * @param {Object} response The http response object
    * @returns {Object} A rejected promise with proper reason code
    */
    responseError: function responseError(response) {
      // Only handles auth related urls
      if (response.config.url.match(AUTH_BASE_URL + '(?:[?/]|$)')) {
        var errorCode = void 0;
        if (response.data && (response.data.error_code || response.data.message)) {
          if (response.data.error_code && response.data.error_code !== 'None') {
            var errors = response.data.error_code.match(/\.(.*$)/);
            if (errors && errors[1]) {
              errorCode = errors[1];
            } else {
              errorCode = 'INVALID_ERROR';
            }
          } else if (response.data.message) {
            // Error message -> error code mapping
            // TODO: Use error codes
            switch (response.data.message) {
              case 'Incorrect username or password provided':
                errorCode = 'INVALID_CREDENTIALS';
                break;
              case 'Invalid user provided':
                errorCode = 'INVALID_USER';
                break;
              case 'Invalid token provided':
                errorCode = 'INVALID_TOKEN';
                break;
              case 'Cannot find a user with that email address':
                errorCode = 'UNKNOWN_EMAIL';
                break;
              case 'Unable to authenticate user':
                errorCode = 'INVALID_USER';
                break;
              case 'An error occured verifying OAuth token':
                errorCode = 'INVALID_TOKEN';
                break;
              case 'User could not be found':
                errorCode = 'INVALID_USER';
                break;
              case 'Your new password is too weak. ' + 'Please choose a better password':
                errorCode = 'WEAK_PASSWORD';
                break;
              case 'Invalid user credentials provided':
                errorCode = 'INVALID_CREDENTIALS';
                break;
              case 'You are performing too many requests.':
                errorCode = 'TOO_MANY_REQUESTS';
                break;
              default:
                errorCode = 'UNKNOWN_ERROR';
                break;
            }
          }
        } else {
          errorCode = 'INVALID_RESPONSE';
          $log.error('auth: invalid server response: ' + response.data);
        }
        // Push interesting errors into Sentry
        if (errorCode === 'UNKNOWN_ERROR' || errorCode === 'INVALID_RESPONSE' || errorCode === 'TOO_MANY_REQUESTS') {
          if (typeof Raven !== 'undefined') {
            Raven.captureMessage(errorCode, {
              tags: {
                api: JSON.stringify(response.config.url)
              },
              extra: {
                response: JSON.stringify(response.data),
                config: JSON.stringify(response.config),
                status: response.status,
                status_text: response.statusText
              }
            });
          }
          Analytics.trackError('auth', response.config.method + ' ' + response.config.url, response.status, response.data);
        }
        response.code = errorCode;
        return $q.reject(response);
      }
      return $q.reject(response);
    }
  };
}]);

angular.module(AuthModule).config(['$httpProvider', function ($httpProvider) {
  $httpProvider.interceptors.push('AutoLogoutInterceptor');
  $httpProvider.interceptors.push('RESTAuthInterceptor');
  $httpProvider.interceptors.push('AuthBackendInterceptor');
}]);

/**
 * @ngdoc service
 * @name flCdn.Cdn
 *
 * @description
 * A service to interact with Freelancer Content Delivery Network  ("f-cdn")
 */

var crcTable = '00000000 77073096 EE0E612C 990951BA 076DC419\n  706AF48F E963A535 9E6495A3 0EDB8832 79DCB8A4 E0D5E91E 97D2D988 09B64C2B\n  7EB17CBD E7B82D07 90BF1D91 1DB71064 6AB020F2 F3B97148 84BE41DE 1ADAD47D\n  6DDDE4EB F4D4B551 83D385C7 136C9856 646BA8C0 FD62F97A 8A65C9EC 14015C4F\n  63066CD9 FA0F3D63 8D080DF5 3B6E20C8 4C69105E D56041E4 A2677172 3C03E4D1\n  4B04D447 D20D85FD A50AB56B 35B5A8FA 42B2986C DBBBC9D6 ACBCF940 32D86CE3\n  45DF5C75 DCD60DCF ABD13D59 26D930AC 51DE003A C8D75180 BFD06116 21B4F4B5\n  56B3C423 CFBA9599 B8BDA50F 2802B89E 5F058808 C60CD9B2 B10BE924 2F6F7C87\n  58684C11 C1611DAB B6662D3D 76DC4190 01DB7106 98D220BC EFD5102A 71B18589\n  06B6B51F 9FBFE4A5 E8B8D433 7807C9A2 0F00F934 9609A88E E10E9818 7F6A0DBB\n  086D3D2D 91646C97 E6635C01 6B6B51F4 1C6C6162 856530D8 F262004E 6C0695ED\n  1B01A57B 8208F4C1 F50FC457 65B0D9C6 12B7E950 8BBEB8EA FCB9887C 62DD1DDF\n  15DA2D49 8CD37CF3 FBD44C65 4DB26158 3AB551CE A3BC0074 D4BB30E2 4ADFA541\n  3DD895D7 A4D1C46D D3D6F4FB 4369E96A 346ED9FC AD678846 DA60B8D0 44042D73\n  33031DE5 AA0A4C5F DD0D7CC9 5005713C 270241AA BE0B1010 C90C2086 5768B525\n  206F85B3 B966D409 CE61E49F 5EDEF90E 29D9C998 B0D09822 C7D7A8B4 59B33D17\n  2EB40D81 B7BD5C3B C0BA6CAD EDB88320 9ABFB3B6 03B6E20C 74B1D29A EAD54739\n  9DD277AF 04DB2615 73DC1683 E3630B12 94643B84 0D6D6A3E 7A6A5AA8 E40ECF0B\n  9309FF9D 0A00AE27 7D079EB1 F00F9344 8708A3D2 1E01F268 6906C2FE F762575D\n  806567CB 196C3671 6E6B06E7 FED41B76 89D32BE0 10DA7A5A 67DD4ACC F9B9DF6F\n  8EBEEFF9 17B7BE43 60B08ED5 D6D6A3E8 A1D1937E 38D8C2C4 4FDFF252 D1BB67F1\n  A6BC5767 3FB506DD 48B2364B D80D2BDA AF0A1B4C 36034AF6 41047A60 DF60EFC3\n  A867DF55 316E8EEF 4669BE79 CB61B38C BC66831A 256FD2A0 5268E236 CC0C7795\n  BB0B4703 220216B9 5505262F C5BA3BBE B2BD0B28 2BB45A92 5CB36A04 C2D7FFA7\n  B5D0CF31 2CD99E8B 5BDEAE1D 9B64C2B0 EC63F226 756AA39C 026D930A 9C0906A9\n  EB0E363F 72076785 05005713 95BF4A82 E2B87A14 7BB12BAE 0CB61B38 92D28E9B\n  E5D5BE0D 7CDCEFB7 0BDBDF21 86D3D2D4 F1D4E242 68DDB3F8 1FDA836E 81BE16CD\n  F6B9265B 6FB077E1 18B74777 88085AE6 FF0F6A70 66063BCA 11010B5C 8F659EFF\n  F862AE69 616BFFD3 166CCF45 A00AE278 D70DD2EE 4E048354 3903B3C2 A7672661\n  D06016F7 4969474D 3E6E77DB AED16A4A D9D65ADC 40DF0B66 37D83BF0 A9BCAE53\n  DEBB9EC5 47B2CF7F 30B5FFE9 BDBDF21C CABAC28A 53B39330 24B4A3A6 BAD03605\n  CDD70693 54DE5729 23D967BF B3667A2E C4614AB8 5D681B02 2A6F2B94 B40BBE37\n  C30C8EA1 5A05DF1B 2D02EF8D';

// Compute the CRC32 of a string
var crc32$1 = function crc32(str) {
  var crc = 0 ^ -1;

  for (var i = 0; i < str.length; i++) {
    crc = crc >>> 8 ^ crcTable[(crc ^ str.charCodeAt(i)) & 0xFF];
  }

  return (crc ^ -1) >>> 0;
};

var Cdn = function () {
  function Cdn(GAF_BASE_URL, GAF_CDN_URLS) {
    _classCallCheck(this, Cdn);

    this.GAF_BASE_URL = GAF_BASE_URL;
    this.GAF_CDN_URLS = GAF_CDN_URLS;
  }
  /**
  * @ngdoc method
  * @name flCdn.Cdn#getCdnUrl
  * @methodOf flCdn.Cdn
  *
  * @description
  * Tries to retrieve a CDN URL for a given URL, and falls back to
  * GAF_BASE_URL if it fails.
  *
  * @param {String} url The URL we want to convert to a CDN URL.
  * @returns {String} A CDN URL in case a CDN is available, otherwise it
  * returns a regular url.
  */


  _createClass(Cdn, [{
    key: 'getCdnUrl',
    value: function getCdnUrl(url) {
      if (this.GAF_CDN_URLS.length > 0) {
        var host = this.GAF_CDN_URLS[Math.abs(crc32$1(url)) % this.GAF_CDN_URLS.length];
        return host + url;
      }
      return this.GAF_BASE_URL + url;
    }
  }]);

  return Cdn;
}();

Cdn.$inject = ['GAF_BASE_URL', 'GAF_CDN_URLS'];


var CdnProvider = flService('Cdn', [OPAQUE_MODULE_NAME], Cdn);

/**
* @ngdoc service
* @name flApi.GafInterceptor
* @description
*
* HTTP Interceptor for most GAF endpoints.

* DO NOT MODIFY THAT INTERCEPTOR.
* If you need to deal with an endpoint in GAF which behaves differently than
* the others, use a custom interceptor like the HourlyContract service:
*
*```
*    const customInterceptor = {
*      request: GafInterceptor.request,
*
*      response: function(response) {
*        return $q.when(GafInterceptor.response(response))
*        .then(function(data) {
*          return data.message;
*        });
*      },
*
*      responseError: function(response) {
*        switch(response.status) {
*          case 403:
*            response.code = 'CREDENTIAL_ERROR';
*            break;
*          case 400:
*            response.code = 'BAD_REQUEST';
*            break;
*          default:
*            response.code = 'UNKNOWN_ERROR';
*            break;
*        }
*        return $q.reject(response);
*      }
*    };
*```
*
* Note how the request method of the GafInterceptor is reused since only the
* response is different here. In doubt, ask for advices on the Angular HipChat
* channel.
*/

var GafInterceptor = function GafInterceptor($q, RequestTransformation) {
  _classCallCheck(this, GafInterceptor);

  return {
    /**
     * @ngdoc method
     * @name flApi.GafInterceptor#request
     * @methodOf flApi.GafInterceptor
     *
     * @description
     * Url Form encode the HTTP requests
     * ('application/x-www-form-urlencoded')
     *
     * @param {Object} config The request configuration object
     * @returns {Object} The config object received as a parameter,
     * eventually modified.
     */
    request: function request(config) {
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
      config.transformRequest = [];
      config.data = RequestTransformation.formUrlEncodedRecursive(config.data);
      return config;
    },
    /**
     * @ngdoc method
     * @name flApi.GafInterceptor#response
     * @methodOf flApi.GafInterceptor
     *
     * @description
     * Unpack the response from some of the GAF endpoint.
     * DO NOT EXTEND THAT BOOLEAN EXPRESSION. This is very ugly and will be
     * removed at some point. Write you own interceptor like the
     * HourlyContract service if needed
     *
     * @param {Object} response The content of the response.
     * @returns {Object} The object received as a parameter,
     * eventually modified.
     */
    response: function response(_response) {
      if (_response.data && (_response.data === 'success' || _response.data === 'true' || _response.data.success === true || _response.data.status === 'success' || _response.data.status === true)) {
        if (_response.data.data) {
          _response.data = _response.data.data;
        }
      } else {
        _response.defaultError = 'Internal error, please try again later.';
        return $q.reject(_response);
      }
      return _response.data;
    }
  };
};

GafInterceptor.$inject = ['$q', 'RequestTransformation'];


var GafInterceptorProvider = flService('GafInterceptor', [RequestTransformationProvider], GafInterceptor);

/**
 * @ngdoc service
 * @name flApi.Currencies
 *
 * @description
 * A factory that returns an object that exposes methods to easily interact
 * with the `currencies` API
 */

var Currencies = function () {
  function Currencies(flResource, ApiInterceptor, API_BASE_URL) {
    _classCallCheck(this, Currencies);

    this.ApiInterceptor = ApiInterceptor;
    this.API_BASE_URL = API_BASE_URL;
    this.resource = flResource(API_BASE_URL + '/projects/0.1/currencies/', ApiInterceptor, null, { get: { cache: true } });
  }

  /**
   * @ngdoc method
   * @name flApi.Currencies#currencyFactory
   * @methodOf flApi.Currencies
   *
   * @description
   * A factory that generates Currency objects
   *
   * @param {Object} c An object containing a raw currency information
   * @returns {Object} The returned Currency object exposes 1 methods:
   *
   * - get() returns the raw currency information
   */


  _createClass(Currencies, [{
    key: 'currencyFactory',
    value: function currencyFactory(c) {
      var currency = c;

      return {
        get: function get() {
          return currency;
        }
      };
    }

    /**
     * @ngdoc method
     * @name flApi.Currencies#get
     * @methodOf flApi.Currencies
     *
     * @description
     * Return a list of all currencies, or a subset if currencies specified.
     *
     * @param {Object} params An object containing a list of currencies.
     * Available options for params are:
     *
     * currency_codes[]: codes of the currencies
     * currency_ids[]: ids of the currencies
     * @returns {Object} An object generated by currencyListFactory
     */

  }, {
    key: 'get',
    value: function get(params) {
      var _this = this;

      return this.resource.get(params).$promise.then(function (data) {
        return _this.currencyListFactory(data.currencies);
      });
    }

    /**
     * @ngdoc method
     * @name flApi.Currencies#currencyListFactory
     * @methodOf flApi.Currencies
     *
     * @description
     * A factory that generates CurrencyList objects
     *
     * @param {Object} c An object containing a list of currencies
     * @returns {Object} The returned CurrencyList object exposes 3 methods:
     *
     * - getMap() returns the raw list of Currencies
     * - getById(id) returns a currency object, given a currencyId
     * - get(params) returns a currency object, given a list of parameters
     */

  }, {
    key: 'currencyListFactory',
    value: function currencyListFactory(c) {
      var _this2 = this;

      var currencies = c;

      return {
        getMap: function getMap() {
          return currencies;
        },
        getList: function getList() {
          return Array.from(Object.keys(currencies).map(function (key) {
            return currencies[key];
          }));
        },
        getById: function getById(id) {
          var currency = Object.keys(currencies).map(function (key) {
            return currencies[key];
          }).find(function (cu) {
            return cu.id === id;
          });
          if (currency) {
            return _this2.currencyFactory(currency);
          }
          return undefined;
        },
        get: function get(params) {
          if (Object.keys(params).length === 1) {
            var _ret = function () {
              var key = Object.keys(params)[0];

              var currency = Object.keys(currencies).map(function (k) {
                return currencies[k];
              }).find(function (cu) {
                return cu[key] === params[key];
              });
              if (currency) {
                return {
                  v: _this2.currencyFactory(currency)
                };
              }
            }();

            if (typeof _ret === "object") return _ret.v;
          }
          return undefined;
        }
      };
    }
  }]);

  return Currencies;
}();

Currencies.$inject = ['flResource', 'ApiInterceptor', 'API_BASE_URL'];


var CurrenciesProvider = flService('Currencies', [flResourceProvider, ApiInterceptorProvider, OPAQUE_MODULE_NAME], Currencies);

var User = function () {
  function User(user, Cdn, DEFAULT_AVATAR_URL, Currencies) {
    _classCallCheck(this, User);

    this.user = user;
    this.Cdn = Cdn;
    this.Currencies = Currencies;
    this.DEFAULT_AVATAR_URL = DEFAULT_AVATAR_URL;
  }

  _createClass(User, [{
    key: 'canBeQuickHiredBy',
    value: function canBeQuickHiredBy(otherUser) {
      // A user can only be quick hired if that user is a freelancer (or
      // 'both'), and the other user is an employer (or 'both').
      var freelancerRoles = ['freelancer', 'both'];
      var employerRoles = ['employer', 'both'];

      return freelancerRoles.indexOf(this.getRole()) !== -1 && employerRoles.indexOf(otherUser.getRole()) !== -1;
    }
  }, {
    key: 'get',
    value: function get() {
      return this.user;
    }
  }, {
    key: 'getAvatarUrl',
    value: function getAvatarUrl() {
      if (this.user && this.user.avatar) {
        return this.Cdn.getCdnUrl(this.user.avatar);
      }

      // Fallback as sometimes user object is malformed at times
      return this.Cdn.getCdnUrl(this.DEFAULT_AVATAR_URL);
    }
  }, {
    key: 'getPrimaryCurrency',
    value: function getPrimaryCurrency() {
      return this.Currencies.currencyFactory(this.user.primary_currency);
    }
  }, {
    key: 'getBalanceForCurrency',
    value: function getBalanceForCurrency(currencyId$$1) {
      var result = void 0;

      angular.forEach(this.user.account_balances.balances, function (balance) {
        if (balance.currency.id === parseInt(currencyId$$1, 10)) {
          result = balance;
        }
      });

      return result;
    }
  }, {
    key: 'getRole',
    value: function getRole() {
      // Before a user bids or posts a project, their role type is
      // completely wrong. It doesn't just contain an inaccurate value, it
      // contains a value that doesn't make any sense what so ever. I'm
      // talking like apostrophe's in the db. APOSTROPHES. YES.
      //
      // That a side, even when the user has the role specified, it may be
      // inaccurate if it set to 'freelancer'. So if the role is
      // freelancer, AND their self chosen role is set AND is set to a
      // different value, we will assume their self chosen role is
      // correct, and use that.
      var role = this.user.role;
      var chosenRole = this.user.chosen_role;

      if (role === 'freelancer' && role !== chosenRole && chosenRole) {
        role = chosenRole;
      }
      return role;
    }
  }, {
    key: 'set',
    value: function set(updatedUser) {
      angular.extend(this.user, updatedUser);
    }
  }]);

  return User;
}();

var UserList = function () {
  function UserList(users, searchTotal, order, Cdn, DEFAULT_AVATAR_URL, Currencies) {
    _classCallCheck(this, UserList);

    this.users = users;
    this.searchTotal = searchTotal;
    this.order = order;
    this.Cdn = Cdn;
    this.Currencies = Currencies;
    this.DEFAULT_AVATAR_URL = DEFAULT_AVATAR_URL;
  }

  _createClass(UserList, [{
    key: 'getMap',
    value: function getMap() {
      return this.users;
    }
  }, {
    key: 'getList',
    value: function getList() {
      var _this = this;

      if (angular.isUndefined(this.list)) {
        this.list = [];
        this.order.forEach(function (id) {
          _this.list.push(_this.users[id]);
        });
      }

      return this.list;
    }
  }, {
    key: 'getById',
    value: function getById(id) {
      if (angular.isDefined(this.users[id])) {
        return new User(this.users[id], this.Cdn, this.DEFAULT_AVATAR_URL, this.Currencies);
      }
      return undefined;
    }
  }, {
    key: 'getCount',
    value: function getCount() {
      return this.getList().length;
    }
  }, {
    key: 'getSearchTotal',
    value: function getSearchTotal() {
      if (angular.isDefined(this.searchTotal) && this.searchTotal !== null) {
        return this.searchTotal;
      }
      return undefined;
    }
  }]);

  return UserList;
}();

/**
 * @ngdoc service
 * @name flApi.Users
 *
 * @description
 * A factory which creates a convenient service for interacting with
 * Users API.
 */


var Users = function () {
  function Users($q, Auth, Cdn, Currencies, flResource, ApiInterceptor, GafInterceptor, API_BASE_URL, GAF_BASE_URL, DEFAULT_AVATAR_URL) {
    _classCallCheck(this, Users);

    this.Cdn = Cdn;
    this.$q = $q;
    this.Auth = Auth;
    this.DEFAULT_AVATAR_URL = DEFAULT_AVATAR_URL;
    this.Currencies = Currencies;

    this.Users = flResource(API_BASE_URL + '/users/0.1/users/:userId/', ApiInterceptor, null, {
      get: {
        cache: true
      },
      getList: {
        url: API_BASE_URL + '/users/0.1/users/'
      },
      getDirectory: {
        url: API_BASE_URL + '/users/0.1/users/directory/'
      },
      getSelf: {
        url: API_BASE_URL + '/users/0.1/users/self/'
      },
      updateUserInfo: {
        method: 'PUT',
        url: API_BASE_URL + '/users/0.1/users/self/'
      },
      setJobs: {
        method: 'POST',
        url: API_BASE_URL + '/users/0.1/self/jobs/'
      },
      setLocation: {
        method: 'POST',
        url: API_BASE_URL + '/users/0.1/self/location/'
      },
      check: {
        method: 'POST',
        url: API_BASE_URL + '/users/0.1/users/check/'
      },
      sendPhoneVerification: {
        method: 'POST',
        url: API_BASE_URL + '/users/0.1/phone_verifications/'
      },
      submitPhoneVerification: {
        method: 'PUT',
        url: API_BASE_URL + '/users/0.1/phone_verifications/'
      },
      alertBoxClose: {
        method: 'POST',
        url: GAF_BASE_URL + '/ajax/alertbox_dont_show_next_time.php',
        interceptor: GafInterceptor
      },
      search: {
        url: API_BASE_URL + '/users/0.1/users/directory/'
      },
      deprecatedSearch: {
        url: GAF_BASE_URL + '/ajax/directory/getFreelancer.php',
        interceptor: GafInterceptor
      },
      getProfile: {
        url: GAF_BASE_URL + '/ajax/getUserProfileData.php',
        interceptor: GafInterceptor
      },
      setProfile: {
        method: 'PUT',
        url: API_BASE_URL + '/users/0.1/users/self/account'
      },
      setPhoneNumber: {
        method: 'POST',
        url: GAF_BASE_URL + '/ajax/signup/register.php',
        interceptor: GafInterceptor
      },
      getPortfolios: {
        url: API_BASE_URL + '/users/0.1/portfolios/',
        interceptor: GafInterceptor
      },
      isReferralInvitationsEligible: {
        method: 'GET',
        url: API_BASE_URL + '/users/0.1/referral_invitations/check/'
      },
      getReferralInvitationsList: {
        method: 'GET',
        url: API_BASE_URL + '/users/0.1/referral_invitations/'
      },
      createReferralInvitation: {
        method: 'POST',
        url: API_BASE_URL + '/users/0.1/referral_invitations/'
      }
    });

    this.FBUsers = flResource(API_BASE_URL + '/users/0.1/users/facebook/', ApiInterceptor, null, {
      link: {
        method: 'POST',
        url: API_BASE_URL + '/users/0.1/users/facebook/link/'
      }
    });
  }

  /**
   * @ngdoc method
   * @name flApi.Users#userFactory
   * @methodOf flApi.Users
   *
   * @description
   * A factory that generates User objects
   *
   * @returns {Object} The returned User object exposes 5 methods:
   *
   * - canBeQuickHiredBy(user) Checks if the given user can hire the current
   *   user. returns true iff the current user role is either 'freelancer'
   *   or 'both', AND the other users role is either 'employer' or 'both'.
   * - get() returns the raw user information
   * - getAvatarUrl() returns the users avatar url
   * - getPrimaryCurrency() returns the users primary currency
   * - getBalanceForCurrency() returns the user's balance for for specific
   *   currency id
   * - getRole() returns the users role (freelancer/employer/both). This
   *   function takes into account the users 'role' and their 'chosen role'.
   * - set(updatedUser) extends the user object with the specified
   *   parameters
   */


  _createClass(Users, [{
    key: 'userFactory',
    value: function userFactory(u) {
      return new User(u, this.Cdn, this.DEFAULT_AVATAR_URL, this.Currencies);
    }

    /**
    * @ngdoc method
    * @name flApi.Users#userListFactory
    * @methodOf flApi.Users
    *
    * @description
    * A factory that generated UserList objects
    *
    * @param {Object} users An object containing a map of users
    * @param {Number} [searchTotal] Total number of users matching the search
    * criteria, see Users.search()
    * @param {Array} [order] List of user ids in specific order; if specified,
    * affects the order returned by userListFactory.getList()
    * @returns {Object} The returned UserList object exposes 4 methods:
    *
    * - getMap() returns the raw object of users
    * - getList() returns a list of user objects NOTE: the ordering of users
    *   is undefined. If you need it to be ordered, you will need to order it
    *   yourself.
    * - getById(id) returns the user object, given a userId
    * - getCount() returns the number of users
    * - getSearchTotal() for search, Users.search(), this returns the total
    *   number of users matching the search criteria; otherwise this will
    *   be undefined
    */

  }, {
    key: 'userListFactory',
    value: function userListFactory(users, searchTotal) {
      var order = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Object.keys(users);

      return new UserList(users, searchTotal, order, this.Cdn, this.DEFAULT_AVATAR_URL, this.Currencies);
    }

    /**
    * @ngdoc method
    * @name flApi.Users#get
    * @methodOf flApi.Users
    *
    * @description
    * Get user info given a list of parameters
    *
    * @param {Object} params list of parameters for the requested user.
    * Possible values are:
    *
    * - users[] – Optional list of user IDs to search on.
    * - usernames[] – Optional list of usernames
    * - avatar – Return avatar for each user.
    * - reputation – Return freelancer reputation for each user.
    * - reputation_extra – Return full freelancer reputation info
    * - (jobhistory/projstats).
    * - employer_reputation – Return employer reputation for each user.
    * - employer_reputation_extra – Return full employer reputation info
    * - (jobhistory/projstats).
    * - country_details – Return country flag/code for each user.
    * - profile_description – Return user’s profile blurb
    * - display_info – Return user’s profile name/tagline
    * - jobs – Return jobs (i.e. skills) that the user currently has
    * - status – Return additional status info about user (see UserStatus).
    * @returns {Object} a Promise object that will be resolved with a user
    * object created by userFactory
    */

  }, {
    key: 'get',
    value: function get(params) {
      var _this2 = this;

      return this.Users.get(params).$promise.then(function (user) {
        return _this2.userFactory(user);
      });
    }

    /**
    * @ngdoc method
    * @name flApi.Users#getDirectory
    * @methodOf flApi.Users
    *
    * @description
    * Get list of freelancers from directory. This method calls the
    * GET /api/users/0.1/users/directory/ endpoint, documented here:
    * https://rtfm.freelancer.com/rtfm/flapi-rest-docs/users_api_0_1.html
    * #get--api-users-0.1-users-directory-
    *
    * @param {Object} params list of parameters for the requested user.
    * Possible values are:
    *
    * - jobs[] – A list of job ids to search for
    * - countries[] – A list of country names to fetch freelancers from.
    * - username – The username of a freelancer to fetch
    * - hourly_rate_min – The minimum hourly rate of freelancers fetched.
    * - hourly_rate_max – The maximum hourly rate of freelancers fetched.
    * - online_only – Only fetch freelancers who are online.
    * - location_latitude – Fetch freelancers close to this latitude
    * - location_longitude – Fetch freelancers close to this longitude
    * - insignias[] – Fetch freelancers who have completed exams with these id
    * - rating – Search for freelancers with a minimum star rating
    * - offset – A pagination offset when fetching the list of users
    * - limit – The number of users to return in the list. Default is 10
    *
    * @returns {Object} a Promise object that will be resolved with a user
    * object created by userFactory
    */

  }, {
    key: 'getDirectory',
    value: function getDirectory(params) {
      var _this3 = this;

      return this.Users.getDirectory(params).$promise.then(function (users) {
        return _this3.userListFactory(users);
      });
    }

    /**
    * @ngdoc method
    * @name flApi.Users#getByUserId
    * @methodOf flApi.Users
    *
    * @description
    * Get user info given a specific user id and a list of parameters
    *
    * @param {Number} userId the id of the user you want to get
    * @param {Object} params list of parameters for the requested user
    * See Users.get() for a list of all possible values.
    * @returns {Object} a Promise object that will be resolved with a user
    * object created by userFactory
    */

  }, {
    key: 'getByUserId',
    value: function getByUserId(userId, params) {
      var p = params || {};
      p.userId = userId;

      return this.get(p);
    }

    /**
    * @ngdoc method
    * @name flApi.Users#getByUsername
    * @methodOf flApi.Users
    *
    * @description
    * Get user info given a specific username and a list of parameters
    *
    * @param {String} username the username of the user you want to get
    * @param {Object} params list of parameters for the requested user
    * See Users.get() for a list of all possible values.
    * @returns {Object} a Promise object that will be resolved with a user
    * object created by userFactory
    */

  }, {
    key: 'getByUsername',
    value: function getByUsername(username, params) {
      var _this4 = this;

      var p = params || {};
      p['usernames[]'] = [username];

      return this.Users.get(params).$promise.then(function (response) {
        if (Object.keys(response.users).length) {
          return _this4.userFactory(response.users[Object.keys(response.users)[0]]);
        }

        return _this4.$q.reject({
          code: 'NOT_FOUND'
        });
      });
    }

    /**
    * @ngdoc method
    * @name flApi.Users#getLoggedInUser
    * @methodOf flApi.Users
    *
    * @description
    * Get user info for current user
    *
    * @param {Object} params list of parameters for the requested user
    * See Users.get() for a list of all possible values.
    * @returns {Object} a Promise object that will be resolved with a user
    * object created by userFactory
    */

  }, {
    key: 'getLoggedInUser',
    value: function getLoggedInUser(params) {
      var _this5 = this;

      return this.Users.getSelf(params).$promise.then(function (user) {
        return _this5.userFactory(user);
      });
    }

    /**
    * @ngdoc method
    * @name flApi.Users#getList
    * @methodOf flApi.Users
    *
    * @description
    * Returns list of users. As per the api, users[] or usernames[] must be
    * provided.
    *
    * @param {Object} params An object containing a set of query parameters
    * that will be used as search criteria. Possible values for params are:
    *
    * - users[]: the ids of specific users
    * - usernames[]: the usernames of specific users
    * @returns {Object} A userList object generated by userListFactory
    */

  }, {
    key: 'getList',
    value: function getList(params) {
      var _this6 = this;

      return this.Users.getList(params).$promise.then(function (result) {
        return _this6.userListFactory(result.users);
      });
    }
    /**
    * @ngdoc method
    * @name flApi.Users#getPortfolios
    * @methodOf flApi.Users
    *
    * @description
    * Returns list of users and portfolios. As per the api, users[] must be
    * provided.
    *
    * @param {Object} params An object containing a set of query parameters
    * that will be used as search criteria. Possible values for params are:
    *
    * - users[]: the ids of specific users
    * - limit
    * - offset
    * @returns {Object} portfolio and users object.
    */

  }, {
    key: 'getPortfolios',
    value: function getPortfolios() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return this.Users.getPortfolios(params).$promise.then(function (response) {
        return response.result;
      });
    }

    /**
    * @ngdoc method
    * @name flApi.Users#create
    * @methodOf flApi.Users
    *
    * @description
    * Sign up a new user and logs in
    *
    * @param {Object} user an object containing info about the user to create
    * e.g. user.id, user.avatar etc...
    * @param {String} password the password for this user
    * @param {String} captcha captcha string
    * @param {Object} extra extra information for signup, either only used
    *                       temporarily and removed later or eventually move
    *                       to signupMeta.
    * @param {Object} signupMeta Information for Signup that we know is
    *                            used for signup
    * @returns {Object} a Promise object that will be resolved with a user
    * object created by userFactory, or a String in case of error, with one
    * of the following values (quite self-explanatory):
    *
    * - CAPTCHA_REQUIRED
    * - INVALID_CAPTCHA
    * - USERNAME_TAKEN
    * - EMAIL_TAKEN
    */

  }, {
    key: 'create',
    value: function create(user, password, captcha) {
      var _this7 = this;

      var extra = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var signupMeta = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

      var newUser = {
        user: {
          email: user.email,
          username: user.username,
          role: user.role
        },
        password: password,
        captcha: captcha || {},
        extra: extra,
        signup_meta: signupMeta
      };

      return this.Users.save(newUser).$promise.then(function (data) {
        _this7.Auth.set(data.auth_hash, data.user.id, true);
        return _this7.userFactory(data.user);
      });
    }

    /**
    * @ngdoc method
    * @name flApi.Users#createWithFacebook
    * @methodOf flApi.Users
    *
    * @description
    * Sign up a new user and logs in using facebook credentials
    *
    * @param {Object} user an object containing info about the user to create
    * e.g. user.id, user.avatar etc...
    * @param {String} facebookId the facebook id of the user
    * @param {String} accessToken the token used to authenticate the user
    * @param {Object} extra an object containing extra data to pass through API
    * @returns {Object} a Promise object that will be resolved with a user
    * object created by userFactory, or a String in case of error
    */

  }, {
    key: 'createWithFacebook',
    value: function createWithFacebook(user, facebookAuthParams) {
      var _this8 = this;

      var extra = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var newUser = {
        user: {
          email: user.email,
          username: user.username,
          role: user.role
        },
        facebook_id: facebookAuthParams.userID,
        access_token: facebookAuthParams.accessToken,
        extra: extra
      };

      return this.FBUsers.save(newUser).$promise.then(function (data) {
        _this8.Auth.set(data.auth_hash, data.user.id, true);
        return _this8.userFactory(data.user);
      });
    }

    /**
    * @ngdoc method
    * @name flApi.Users#linkFacebook
    * @methodOf flApi.Users
    *
    * @description
    * Link facebook account to existing user account. The user needs to be
    * logged in before calling this method.
    *
    * @param {String} email email address of user
    * @param {password} email password of user
    * @param {String} facebook_id the facebook id of the user
    * @param {String} access_token the token used to authenticate the user
    * @returns {Object} a Promise object that will be resolved with a user
    * object created by userFactory, or an error object in case of error
    */

  }, {
    key: 'linkFacebook',
    value: function linkFacebook(facebookAuthParams) {
      var _this9 = this;

      var linkInfo = {
        facebook_id: facebookAuthParams.userID,
        access_token: facebookAuthParams.signedRequest
      };

      return this.FBUsers.link(linkInfo).$promise.then(function (user) {
        return _this9.userFactory(user);
      });
    }

    /**
    * @ngdoc method
    * @name flApi.Users#check
    * @methodOf flApi.Users
    *
    * @description Check if the user's fields are valid for a user signup
    * request. Validated field are "username" and "email". Support a
    * "recommanded_name" param to get a suggested username based on a
    * submitted email/invalid username.
    *
    * @param {Object} user user object with "username" and/or "email" fields.
    * Checks each params individually.
    * @param {Object} params extra params. Only recommended_name is supported
    * for now, which gives back a recommended_name. The recommended username
    * is based off the email address when the email is valid, or based off
    * the username when the email is invalid
    */

  }, {
    key: 'check',
    value: function check(user, params) {
      var p = params || {};

      return this.Users.check(p, { user: user }).$promise.then(function (response) {
        return response;
      });
    }

    /**
     * @ngdoc method
     * @name flApi.Users#updateUserInfo
     * @methodOf flApi.Users
     *
     * @description
     * Updates a user info given the action
     *
     * @param {String} Valid prams are [email_verify, local_jobs_enable,
     * local_email_subscribe, local_email_unsubscribe].
     */

  }, {
    key: 'updateUserInfo',
    value: function updateUserInfo(action) {
      return this.Users.updateUserInfo({ action: action }).$promise;
    }

    /**
    * @ngdoc method
    * @name flApi.Users#setJobs
    * @methodOf flApi.Users
    *
    * @description
    * Updates ths skills for a logged in user
    *
    * @param {Object} jobs list(int) a list of job ids
    * ```
    *  {
    *    "jobs[]": [2, 3]
    *  }
    * ```
    */

  }, {
    key: 'setJobs',
    value: function setJobs(jobs) {
      return this.Users.setJobs({ 'jobs[]': jobs }).$promise;
    }

    /**
    * @ngdoc method
    * @name flApi.Users#setLocation
    * @methodOf flApi.Users
    *
    * @description
    * Updates the location information for the logged in user.
    *
    * @param {Object} loc location object with the as followed:
    * ```
    *  {
    *    country: {
    *      name: 'Australia'
    *    },
    *    city: 'Sydney',
    *    latitude: -33.873651,
    *    longitude: 151.2068896,
    *    vicinity: 'Sydney',
    *    administrativeArea: 'Sydney',
    *    fullAddress: '42 Wallaby Way, Sydney, NSW, 2008, Australia'
    *  }
    * ```
    */

  }, {
    key: 'setLocation',
    value: function setLocation(loc) {
      return this.Users.setLocation({
        country: loc.country,
        city: loc.city,
        latitude: loc.latitude,
        longitude: loc.longitude,
        vicinity: loc.vicinity,
        administrative_area: loc.administrativeArea,
        full_address: loc.fullAddress
      }).$promise;
    }

    /**
    * @ngdoc method
    * @name flApi.Users#alertBoxClose
    * @methodOf flApi.Users
    *
    * @description
    * Adds an entry to alert_box_dont_show_next_time table which keeps track
    * of what alerts/messages the user encounters
    *
    * @param {String} event the name of the alert or event
    * @param {Number} eventId an id associated with the event such as a
    * project id
    * @param {Number} otherPartyId Optional an id associated with a secondary
    * party such as another user id
    *
    */

  }, {
    key: 'alertBoxClose',
    value: function alertBoxClose(event, eventId, otherPartyId) {
      return this.Users.alertBoxClose({
        event: event,
        event_id: eventId,
        otherparty_user_id: otherPartyId
      }).$promise;
    }

    /**
     * @ngdoc method
     * @name flApi.Users#search
     * @methodOf flApi.Users
     *
     * @description
     * Search for users.
     *
     * @param {String} keyword Search filter to query by profile
     * description, username and jobs
     * @param {Object} params A list of additional parameters to be used as
     * search criteria.
     * @returns {Object} a Promise object that will be resolved with a user
     * list object created by userListFactory.
     */

  }, {
    key: 'search',
    value: function search(keywords) {
      var _this10 = this;

      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      params.query = keywords;

      return this.Users.search(params).$promise.then(function (result) {
        var users = {};
        var order = [];

        Object.keys(result.users).forEach(function (key) {
          var user = result.users[key];
          users[user.id] = user;
          order.push(user.id);
        });

        return _this10.userListFactory(users, result.total_count, order);
      });
    }

    /**
     * @ngdoc method
     * @name flApi.Users#search
     * @methodOf flApi.Users
     *
     * @description
     * Search for users using the GAF endpoint.
     *
     * Taken from v1. This will be used by the search page when it is migrated
     * to ES6. At the moment, there are still some data missing from the Users
     * API, such as the top skills.
     *
     * This should be removed once the Users API and Search module have been
     * updated.
     *
     * @param {String} keywords A set of terms, space separated.
     * @param {Object} params A list of additional parameters to be used as
     * search criteria.
     * @returns {Object} a Promise object that will be resolved with a user
     * list object created by userListFactory.
     */

  }, {
    key: 'deprecatedSearch',
    value: function deprecatedSearch(keywords) {
      var _this11 = this;

      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      params.freeSearch = keywords;

      return this.Users.deprecatedSearch(params).$promise.then(function (result) {
        var users = {};
        var order = [];

        Object.keys(result.users).forEach(function (key) {
          var user = result.users[key];
          users[user.user_id] = user;
          order.push(user.user_id);
        });

        return _this11.userListFactory(users, result.count, order);
      });
    }

    /**
     * @ngdoc method
     * @name flApi.Users#setPhoneNumber
     * @methodOf flApi.Users
     *
     * @description
     * Updates the phone number info for the logged in user.
     *
     * @param {Number} phone The phone number to be associated with the user.
     * @param {Number} timestamp The timestamp of expiry.
     * @param {String} token Sha1 generated token from phone, timestamp and
     * CSRF token.
     */

  }, {
    key: 'setPhoneNumber',
    value: function setPhoneNumber(phone, timestamp, token) {
      var _this12 = this;

      return this.Users.setPhoneNumber({
        tm: timestamp,
        ph: phone,
        t: token
      }).$promise
      // Assign error code when ajax endpoint returns error: invalid request
      .catch(function () {
        return _this12.$q.reject({
          code: 'LOCAL_BID_INVALID_REQUEST'
        });
      });
    }

    /**
    * @ngdoc method
    * @name flApi.Users#getProfile
    * @methodOf flApi.Users
    * @description
    * get the profile info for the logged in user.
    * @returns {Object} a Promise object that will be resolved with user
    * profile information.
    **/

  }, {
    key: 'getProfile',
    value: function getProfile() {
      return this.Users.getProfile().$promise;
    }

    /**
    * @ngdoc method
    * @name flApi.Users#setProfile
    * @methodOf flApi.Users
    *
    * @description
    * Updates the profile info for the logged in user.
    *
    * @param {Object} name userData user profile information
    * fields to be updated
    * @returns {Object} a Promise object that will be resolved
    * with profile update success
    */

  }, {
    key: 'setProfile',
    value: function setProfile(userData) {
      return this.Users.setProfile({
        first_name: userData.firstname,
        last_name: userData.lastname,
        date_of_birth: userData.dateOfBirth,
        address1: userData.address1,
        city: userData.city,
        company: userData.company,
        zip: userData.zip,
        state_code: userData.state_code,
        timezone: userData.timezone,
        thm_session: userData.thm_session,
        token: userData.token
      }).$promise;
    }

    /**
     * @ngdoc method
     * @name flApi.Users#sendPhoneVerification
     * @methodOf flApi.Users
     *
     * @description
     * Requests a verification code to be sent to a given phone number.
     *
     * @param {Object} params Query parameters.
     * @param {String} params.phone_number The phone number you wish to
     * verify.
     * @param {String} params.country_code The numeric code which is prefixed
     * to the phone number.
     * @param {String} params.operation The string enum of the type of
     * message you want to receive (either 'sms' or 'call').
     * @param {String} params.requested_country The string country code of
     * the phone's country.
     * @param {Boolean} params.request_phone_change Whether the user already
     * has a verified phone number.
     *
     * @returns {Object} a Promise object that will be resolved with a
     * boolean value 'reference_id', which is used by the phone verification
     * submit endpoint.
     */

  }, {
    key: 'sendPhoneVerification',
    value: function sendPhoneVerification(params) {
      return this.Users.sendPhoneVerification(params).$promise;
    }

    /**
     * @ngdoc method
     * @name flApi.Users#submitPhoneVerification
     * @methodOf flApi.Users
     *
     * @description
     * Updates a phone verification process with a given action.
     *
     * @param {Object} params Query parameters.
     * @param {String} params.action 'verify'.
     * @param {Object} params.verification_details Verification details.
     * @param {String} params.verification_details.reference_id The
     * identifier returned by the verification request.
     * @param {String} params.verification_details.verification_code The code
     * sent to the phone.
     * @param {Boolean} params.verification_details.request_phone_change
     * Whether the user already has a verified phone number.
     * @param {Object} params.verification_details.phone_details Phone
     * details of the phone the code was sent to.
     * @param {String} params.verification_details.phone_details.phone_number
     * The phone number you wish to verify
     * @param {String} params.verification_details.phone_details.country_code
     * The numeric code which is prefixed to the phone number.
     * @param {String}
     * params.verification_details.phone_details.requested_country The string
     * country code of the phone's country.
     *
     * @returns {Object} a Promise object that will be resolved with a
     * boolean value 'id_verification_required', which is set to true if a
     * user must complete their ID verification before the phone verification
     * process is complete.
     *
     */

  }, {
    key: 'submitPhoneVerification',
    value: function submitPhoneVerification(params) {
      return this.Users.submitPhoneVerification(params).$promise;
    }

    /**
    * @ngdoc method
    * @name flApi.Users#isGiveGetEligible
    * @methodOf flApi.Users
    *
    * @description
    * Is user eligible in Give Get referral program
    *
    * @returns {Object} a Promise object that will be resolved with a boolean
    * value which is set to true if user is eligible for give get and false
    * otherwise
    */

  }, {
    key: 'isGiveGetEligible',
    value: function isGiveGetEligible() {
      return this.Users.isReferralInvitationsEligible({ bonus_id: 16 }).$promise.catch(function () {
        return false;
      }).then(function (data) {
        if (typeof data === 'object') {
          return data.result;
        }
        return data;
      });
    }

    /**
    * @ngdoc method
    * @name flApi.Users#getGiveGetInvitationsList
    * @methodOf flApi.Users
    *
    * @description
    * Get list of invitations of Give Get referral program.
    * Each element of the array has status, email and send_date.
    *
    * @returns {Object} a Promise object that will be resolved with array of
    *   invitation list
    */

  }, {
    key: 'getGiveGetInvitationsList',
    value: function getGiveGetInvitationsList() {
      return this.Users.getReferralInvitationsList({ bonus_id: 16 }).$promise;
    }

    /**
    * @ngdoc method
    * @name flApi.Users#createGiveGetInvitation
    * @methodOf flApi.Users
    *
    * @description
    * Create GiveGet invitation. Give Get bonus Id = 16
    * @param {object}   emails    array of email addresses
    * @returns {array} List of user
    */

  }, {
    key: 'createGiveGetInvitation',
    value: function createGiveGetInvitation(emails) {
      return this.Users.createReferralInvitation({
        bonus_id: 16,
        emails: emails
      }).$promise;
    }
  }]);

  return Users;
}();

Users.$inject = ['$q', 'Auth', 'Cdn', 'Currencies', 'flResource', 'ApiInterceptor', 'GafInterceptor', 'API_BASE_URL', 'GAF_BASE_URL', 'DEFAULT_AVATAR_URL'];


var UsersProvider = flService('Users', [flResourceProvider, AuthModule, CdnProvider, CurrenciesProvider, ApiInterceptorProvider, GafInterceptorProvider, OPAQUE_MODULE_NAME], Users);

var UsersService = function () {
  function UsersService($http, $log, $window, Auth, FACEBOOK_APP_ID, Localization, Users) {
    _classCallCheck(this, UsersService);

    this.$http = $http;
    this.$window = $window;
    this.Auth = Auth;
    this.Users = Users;
    this.$log = $log;
    this.newAuthUrl = '/auth'; // TODO replace this to use config
    this.FACEBOOK_APP_ID = FACEBOOK_APP_ID;
    this.LOCALSTORAGE_DEVICE_KEY = 'deviceToken';
    this.Localization = Localization;
  }

  /**
   * get device token from Auth Server and saves it to local storage for token reuse
   * The priority to retrieve is:
   * 1. From UserData that parsed in
   * 2. From localStorage
   * 3. From auth server
   * @param UserData user UserData object in UsersService
   */

  _createClass(UsersService, [{
    key: 'getDeviceToken',
    value: function getDeviceToken(user) {
      var _this = this;

      var deviceToken = void 0;
      if (user.deviceToken) {
        return user.deviceToken;
      }

      if (window.localStorage) {
        deviceToken = window.localStorage.getItem(this.LOCALSTORAGE_DEVICE_KEY);
      }

      if (deviceToken) {
        user.deviceToken = deviceToken;
        return Promise.resolve(deviceToken);
      }

      return this.$http.get(this.newAuthUrl + '/device/').then(function (response) {
        if (response.status === 200 && response.data) {
          if (window.localStorage) {
            try {
              window.localStorage.setItem(_this.LOCALSTORAGE_DEVICE_KEY, response.data.token);
            } catch (e) {
              // throws QuotaExceededError in Safari <11.
              _this.trackError('QuotaExceededError', e);
            }
          }
          user.deviceToken = response.data.token;
          return response.data.token;
        }
        throw new Error('auth: invalid server response: ' + response.data);
      }).catch(function (e) {
        return _this.trackError('GetDeviceToken', e);
      });
    }
  }, {
    key: 'verifyNewEmail',
    value: function verifyNewEmail(email) {
      var _this2 = this;

      var params = {
        existing: true,
        json: true,
        email: email
      };
      return this.$http.get('/ajax/users/email/check_email_valid.php', { params: params }).then(function (response) {
        return response.data;
      }).catch(function (e) {
        return _this2.trackError('EmailExistsCheck', e);
      });
    }
  }, {
    key: 'checkBlockedEmail',
    value: function checkBlockedEmail(email) {
      var _this3 = this;

      var params = { email: email };
      return this.$http.get('/ajax/check-email-blocked.php', { params: params }).then(function (response) {
        return response.data;
      }).catch(function (e) {
        return _this3.trackError('BlockedEmailCheck', e);
      });
    }
  }, {
    key: 'autofillUsername',
    value: function autofillUsername(email) {
      var _this4 = this;

      var user = { email: email };
      return this.Users.check(user, { recommend_name: true }).catch(function (e) {
        return _this4.trackError('AutofillUsername', e);
      });
    }
  }, {
    key: 'getSuggestedUsernames',
    value: function getSuggestedUsernames(email) {
      var _this5 = this;

      var user = { email: email };
      return this.Users.check(user, { recommend_name: true }).catch(function (e) {
        return _this5.trackError('GetSuggestedUsernames', e);
      });
    }
  }, {
    key: 'checkUsernameExists',
    value: function checkUsernameExists(username) {
      var _this6 = this;

      var params = {
        validator: true,
        username: username
      };
      return this.$http.get('/ajax/check-username-exist.php', { params: params }).then(function (response) {
        return response.data;
      }).catch(function (e) {
        return _this6.trackError('UniqueUsernameCheck', e);
      });
    }
  }, {
    key: 'checkEmailExists',
    value: function checkEmailExists(email) {
      var _this7 = this;

      var params = {
        email: email,
        validator: true
      };
      return this.$http.get('/ajax/check-email-exist.php', { params: params }).then(function (response) {
        return response.data;
      }).catch(function (e) {
        return _this7.trackError('UniqueEmailCheck', e);
      });
    }
  }, {
    key: 'setExtraCookies',
    value: function setExtraCookies() {
      var _this8 = this;

      // sets a cookie to identify users who have logged in
      // at least once, separating them "from new_users"
      setCookieToBrowser(cookieBase + '_NOTNEW', true, 365, '/', cookieDomain);

      this.Users.getLoggedInUser().then(function (user) {
        _this8.Localization.language(user.get().primary_language);
      });

      var quickLoginFencePromise = this.getQuickLoginFenceCookie();

      Promise.all([quickLoginFencePromise]).then(function (responses) {
        var cookies = {};
        responses.forEach(function (cookie) {
          cookies = Object.assign(cookies, cookie);
        });

        _this8.Auth.setExtraCookies(cookies);
      });
    }

    /**
     * New 2FA Login Endpoint.
     *
     * Example request without device token:
     * {
     *   "status": "success",
     *   "result": {
     *     "token": "xx6IBy22+ve4rjkMAA1p5Q+fu/NvAeMz0vzeqQ6CcVY=",
     *     "user": 23521511
     *   },
     *   "request_id": "unknown"
     * }
     *
     * Example request with device token:
     * {
     *   "status": "success",
     *   "result": {
     *     "pre_login_token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVC..",
     *     "message": "We've temporarily blocked this login attempt. Get a verification code from your Email."
     *   },
     *   "request_id": "unknown"
     * }
     */

  }, {
    key: 'login',
    value: function login(user, rememberLogin, old2FAToken) {
      var _this9 = this;

      var headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: 'application/json'
      };
      var data = {
        user: user.username,
        password: user.password
      };
      if (user.deviceToken) {
        data.device_token = user.deviceToken;
      }
      if (old2FAToken) {
        data.old_2FA_token = old2FAToken;
      }
      return this.$http({
        method: 'POST',
        url: '/ajax/auth/login.php',
        headers: headers,
        data: this.serializeData(data)
      }).then(function (response) {
        if (response.status !== 200) {
          return Promise.reject(response);
        }
        if (response.data && response.data.token) {
          // Successfully login
          _this9.Auth.set(response.data.token, response.data.user, rememberLogin);
          _this9.setExtraCookies();
          return response;
        } else if (response.data && response.data.pre_login_token) {
          user.preLoginToken = response.data.pre_login_token;
          return response;
        }
      }).then(function (response) {
        return _this9.crossDomainSSO(response, rememberLogin);
      }).catch(function (response) {
        _this9.trackError('NewLoginUser', response.data.error_code);
        if (response.status === 401 || response.status === 429 || response.status === 500) {
          return Promise.reject(response);
        }
      });
    }

    /**
     * 2FA, Time-based One Time Password Login
     *
     * Example request:
     * {
     *   "status": "success",
     *   "result": {
     *     "token": "xx6IBy22+ve4rjkMAA1p5Q+fu/NvAeMz0vzeqQ6CcVY=",
     *     "user": 23521511
     *   },
     *   "request_id": "unknown"
     * }
     *
     * Example error request:
     * {
     *   "status": "error",
     *   "message": "There was a problem logging in with your account.Please contact support.",
     *   "error_code": "ExceptionCodes.EXPIRED_PRELOGIN_TOKEN",
     *   "request_id": "unknown"
     * }
     */

  }, {
    key: 'totpLogin',
    value: function totpLogin(user, rememberLogin) {
      var _this10 = this;

      var headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: 'application/json'
      };
      var data = {
        device_token: user.deviceToken,
        pre_login_token: user.preLoginToken,
        totp: user.TOTP
      };

      return this.$http({
        method: 'POST',
        url: '/ajax/auth/login_verify.php',
        headers: headers,
        data: this.serializeData(data)
      }).then(function (response) {
        if (response.status !== 200) {
          return Promise.reject(response);
        }
        if (response.data && response.data.token) {
          // Successfully login
          _this10.Auth.set(response.data.token, response.data.user, rememberLogin);
          _this10.setExtraCookies();
          return response;
        }
      }).then(function (response) {
        return _this10.crossDomainSSO(response, rememberLogin);
      }).catch(function (response) {
        _this10.trackError('totpLogin', response.data.error_code);
        if (response.status === 401) {
          return Promise.reject(response);
        } else if (response.status === 429) {
          return Promise.reject(response);
        } else if (response.status === 500) {
          return Promise.reject(response);
        }
      });
    }
  }, {
    key: 'getAvailableTotpMethods',
    value: function getAvailableTotpMethods(userId) {
      var _this11 = this;

      var headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: 'application/json'
      };
      var data = { user_id: userId };

      return this.$http({
        method: 'POST',
        url: '/ajax/auth/get_totp_methods.php',
        headers: headers,
        data: this.serializeData(data)
      }).then(function (response) {
        if (response.status === 200) {
          return Promise.resolve(response.data);
        }
      }).catch(function (response) {
        _this11.trackError('getAvailableTotpMethods', response.data.message);
        return Promise.reject(response);
      });
    }
  }, {
    key: 'deliverToken',
    value: function deliverToken(user, method) {
      var _this12 = this;

      var headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: 'application/json'
      };
      var data = {
        device_token: user.deviceToken,
        pre_login_token: user.preLoginToken,
        '2fa_method': method
      };

      return this.$http({
        method: 'POST',
        url: '/ajax/auth/delivery_token.php',
        headers: headers,
        data: this.serializeData(data)
      }).then(function (response) {
        if (response.status === 200) {
          if (response.data && response.data.pre_login_token) {
            user.preLoginToken = response.data.pre_login_token;
          }

          return Promise.resolve(response.data);
        }
      }).catch(function (response) {
        _this12.trackError('deliverToken', response.data.message);
        return Promise.reject(response);
      });
    }

    /**
     * Login through Facebook.
     */

  }, {
    key: 'loginWithFacebook',
    value: function loginWithFacebook(user) {
      var _this13 = this;

      var data = {
        app_id: this.FACEBOOK_APP_ID,
        oauth_type: 'facebook',
        credentials: user.facebookSignedRequest,
        access_token: user.facebookAccessToken
      };

      return this.$http({
        method: 'POST',
        url: '/ajax/auth/fb_login.php',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Accept: 'application/json'
        },
        data: this.serializeData(data)
      }).then(function (response) {
        if (response.status !== 200) {
          return Promise.reject(response);
        }
        if (response.data && response.data.token) {
          // Successfully login
          _this13.Auth.set(response.data.token, response.data.user);
          _this13.setExtraCookies();
          return response;
        } else if (response.data && response.data.pre_login_token) {
          user.preLoginToken = response.data.pre_login_token;
          return response;
        }
      }).then(function (response) {
        return _this13.crossDomainSSO(response);
      }).catch(function (response) {
        _this13.trackError('FacebookLogin', response.data.error_code);
        return Promise.reject(response);
      });
    }

    /**
     * Link Facebook Account.
     * - Given User Details and Facebook Tokens
     * - Able to bypass the TOTP Login.
     * - Default remembers login. (Same as loginWithFacebook->oAuthLogin)
     */

  }, {
    key: 'linkFacebookAccount',
    value: function linkFacebookAccount(user) {
      var _this14 = this;

      var headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: 'application/json'
      };
      var data = {
        email: user.email,
        password: user.password,
        credentials: user.facebookSignedRequest,
        access_token: user.facebookAccessToken
      };

      return this.$http({
        method: 'POST',
        url: '/ajax/auth/fb_link_login.php',
        headers: headers,
        data: this.serializeData(data)
      }).then(function (response) {
        if (response.status !== 200) {
          return Promise.reject(response);
        }
        if (response.data && response.data.token) {
          // Successfully login.
          _this14.Auth.set(response.data.token, response.data.user, true);
          _this14.setExtraCookies();
          return response;
        }
      }).then(function (response) {
        return _this14.crossDomainSSO(response);
      }).catch(function (response) {
        _this14.trackError('LinkFacebookAccount', response.data.error_code);
        if (response.status === 401 || response.status === 429 || response.status === 500) {
          return Promise.reject(response);
        }
      });
    }
  }, {
    key: 'crossDomainSSO',
    value: function crossDomainSSO(originalResponse, rememberLogin) {
      var _this15 = this;

      if (!originalResponse || !originalResponse.data || !originalResponse.data.token || !originalResponse.data.user) {
        return originalResponse;
      }
      var ssoPromise = function ssoPromise(domain) {
        return _this15.$http({
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Accept: 'application/json'
          },
          url: domain + '/ajax/auth/cross_domain_sso.php',
          withCredentials: true,
          data: _this15.serializeData({
            authToken: originalResponse.data.token,
            userId: originalResponse.data.user,
            rememberLogin: !!rememberLogin
          })
        }).catch(function (e) {
          return _this15.trackError('CrossDomainSSOProcess', e);
        });
      };

      return this.$http({
        headers: { 'Content-Type': 'application/json' },
        url: '/ajax/auth/cross_domain_sso_domains.php'
      }).then(function (response) {
        if (response.status === 200 && response.data && response.data.domains) {
          var _ret = function () {
            var ssoPromises = [];
            var current = _this15.$window.location.protocol.concat('//').concat(_this15.$window.location.hostname);
            response.data.domains.forEach(function (domain) {
              if (domain !== current) {
                ssoPromises.push(ssoPromise(domain));
              }
            });
            return {
              v: Promise.all(ssoPromises).then(function () {
                return originalResponse;
              })
            };
          }();

          if (typeof _ret === "object") return _ret.v;
        }
        return originalResponse;
      }).catch(function (e) {
        return _this15.trackError('CrossDomainSSOGetDomains', e);
      });
    }
  }, {
    key: 'getQuickLoginFenceCookie',
    value: function getQuickLoginFenceCookie() {
      return this.$http({
        method: 'GET',
        url: '/ajax/signup/get-quick-login-fence.php'
      }).then(function (response) {
        if (response.status !== 200) {
          return Promise.reject(response);
        }
        if (response.data) {
          return response.data;
        }
      }).catch(function () {});
    }
  }, {
    key: 'forgotPassword',
    value: function forgotPassword(email) {
      var headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-XSRF-TOKEN': getCSRFToken(),
        Accept: 'application/json'
      };
      var data = { email: email };
      return this.$http({
        method: 'POST',
        url: '/users/ajaxonforgotpassword.php',
        headers: headers,
        data: this.serializeData(data)
      });
    }
  }, {
    key: 'serializeData',
    value: function serializeData(obj) {
      var result = [];

      Object.keys(obj).forEach(function (key) {
        var value = obj[key];
        if (value === null) {
          value = '';
        }
        result.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
      });
      return result.join('&');
    }
  }, {
    key: 'trackError',
    value: function trackError(label, e) {
      qtsp.push({
        section: 'newAuth2FA',
        subsection: 'usersService',
        label: label,
        action: 'error',
        value: JSON.stringify(e)
      });
    }
  }, {
    key: 'getLoginRedirectUrl',
    value: function getLoginRedirectUrl(redirectDisabled, isModal, goto) {
      var headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: 'application/json'
      };

      var data = {
        redirect_disabled: redirectDisabled,
        is_modal: isModal,
        goto: goto
      };

      return this.$http({
        method: 'POST',
        url: '/ajax/auth/login_redirect.php',
        headers: headers,
        data: this.serializeData(data)
      });
    }
  }, {
    key: 'getSignupRedirectUrl',
    value: function getSignupRedirectUrl(redirectDisabled, isModal, goto, projectCollaborationInvitation, contestCollaborationInvitation) {
      var headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: 'application/json'
      };

      var data = {
        redirect_disabled: redirectDisabled,
        is_modal: isModal,
        goto: goto,
        project_collaboration_invitation: projectCollaborationInvitation,
        contest_collaboration_invitation: contestCollaborationInvitation
      };

      return this.$http({
        method: 'POST',
        url: '/ajax/auth/signup_redirect.php',
        headers: headers,
        data: this.serializeData(data)
      });
    }
  }]);

  return UsersService;
}();

UsersService.$inject = ['$http', '$log', '$window', 'Auth', 'FACEBOOK_APP_ID', 'Localization', 'Users'];

var UsersProvider$1 = flService$1('UsersService', [AuthModule, UsersProvider, OPAQUE_MODULE_NAME], UsersService);

var UserData = function () {
  function UserData(UsersService) {
    _classCallCheck(this, UserData);

    this.user = {
      fullName: '',
      username: '',
      email: '',
      password: '',
      country: '',
      deviceToken: '',
      preLoginToken: '',
      TOTP: '',
      role: '',
      isNewUser: false,
      captcha: {
        challenge: '',
        response: ''
      },
      // Facebook
      facebookConnected: false,
      facebookName: '',
      facebookEmail: '',
      facebookPictureUrl: '',
      facebookAccessToken: '',
      facebookSignedRequest: '',
      // Privacy Consent
      isFromEU: false,
      privacyConsent: false,
      privateUser: null
    };
    this.UsersService = UsersService;
  }

  _createClass(UserData, [{
    key: 'setFacebookName',
    value: function setFacebookName(name) {
      this.user.facebookName = name;
    }
  }, {
    key: 'getFacebookName',
    value: function getFacebookName() {
      return this.user.facebookName;
    }
  }, {
    key: 'setFacebookEmail',
    value: function setFacebookEmail(email) {
      this.user.facebookEmail = email;
    }
  }, {
    key: 'getFacebookEmail',
    value: function getFacebookEmail() {
      return this.user.facebookEmail;
    }
  }, {
    key: 'setFacebookPictureUrl',
    value: function setFacebookPictureUrl(url) {
      this.user.facebookPictureUrl = url;
    }
  }, {
    key: 'getFacebookPictureUrl',
    value: function getFacebookPictureUrl() {
      return this.user.facebookPictureUrl;
    }
  }, {
    key: 'setFacebookUserId',
    value: function setFacebookUserId(id) {
      this.user.facebookUserId = id;
    }
  }, {
    key: 'getFacebookUserId',
    value: function getFacebookUserId() {
      return this.user.facebookUserId;
    }
  }, {
    key: 'setFacebookAccessToken',
    value: function setFacebookAccessToken(token) {
      this.user.facebookAccessToken = token;
    }
  }, {
    key: 'getFacebookAccessToken',
    value: function getFacebookAccessToken() {
      return this.user.facebookAccessToken;
    }
  }, {
    key: 'setFacebookConnected',
    value: function setFacebookConnected(isFacebook) {
      this.user.facebookConnected = isFacebook;
    }
  }, {
    key: 'isFacebookConnected',
    value: function isFacebookConnected() {
      return this.user.facebookConnected;
    }
  }]);

  return UserData;
}();

UserData.$inject = ['UsersService'];

var UserData$1 = flService$1('UserData', [UsersProvider$1], UserData);

/**
 * @ngdoc directive
 * @name flBlockedEmailCheck
 * @restrict A
 * @description
 * Validate if user email address is blocked
 */

var BlockedEmailCheck = function () {
  function BlockedEmailCheck($q, $timeout, UsersService) {
    _classCallCheck(this, BlockedEmailCheck);

    this.$q = $q;
    this.$timeout = $timeout;
    this.UsersService = UsersService;
  }

  _createClass(BlockedEmailCheck, [{
    key: 'link',
    value: function link(scope, elm, attr, ngModel) {
      var _this = this;

      ngModel.$asyncValidators.unblockedEmail = function (modelValue, email) {
        var deferred = _this.$q.defer();
        _this.UsersService.checkBlockedEmail(email).then(function (isValidEmail) {
          _this.$timeout(function () {
            if (isValidEmail) {
              deferred.resolve();
            } else {
              deferred.reject();
            }
          }, 500);
        });
        return deferred.promise;
      };
    }
  }]);

  return BlockedEmailCheck;
}();

BlockedEmailCheck.$inject = ['$q', '$timeout', 'UsersService'];

var flBlockedEmailCheck = flDirective$1(BlockedEmailCheck, {
  selector: '[fl-blocked-email-check]',
  require: 'ngModel',
  providers: [UsersProvider$1]
});

var _templateObject$9 = _taggedTemplateLiteral(['^(([^<>()\\[\\]\\.,;:\\s@"]+(\\.[^<>()\\[\\]\n    \\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]\n    {1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$'], ['^(([^<>()\\\\[\\\\]\\\\\\.,;:\\\\s@"]+(\\\\.[^<>()\\\\[\\\\]\n    \\\\\\.,;:\\\\s@"]+)*)|(".+"))@((\\\\[[0-9]{1,3}\\\\.[0-9]{1,3}\\\\.[0-9]{1,3}\\\\.[0-9]\n    {1,3}])|(([a-zA-Z\\\\-0-9]+\\\\.)+[a-zA-Z]{2,}))$']);

function isValidEmail(email) {
  // TODO: Check unit test as the regex has failed to catch no TLD domains.
  var re = new RegExp(oneLineTrim(_templateObject$9));
  return re.test(email);
}

/*
 * Opposite to ajax/check-email-blocked.php
 * Returns Promise
 * - If Email is Blocked, return true
 * - If Email is not Blocked, return false
 */
function isBlockedEmail(email) {
  var encodedEmail = encodeURIComponent(email);
  return fetch('/ajax/check-email-blocked.php?email=' + encodedEmail).then(function (response) {
    return response.text();
  }).then(function (response) {
    if (response == 'true') {
      return false;
    }
    return true;
  });
}

function isValidUsernameFormat(username) {
  var re = /^[a-z][a-z0-9]{2,15}$/i;
  return re.test(username);
}

/**
 * @ngdoc directive
 * @name flEmailUsernameValidCheck
 * @restrict A
 * @description
 * Validates email pattern and is not equal to username
 */

var flEmailUsernameValidCheck = function () {
  function flEmailUsernameValidCheck(UserData) {
    _classCallCheck(this, flEmailUsernameValidCheck);

    this.user = UserData.user;
  }

  _createClass(flEmailUsernameValidCheck, [{
    key: 'link',
    value: function link(scope, elm, attr, ngModel) {
      var _this = this;

      var field = attr.flEmailUsernameValidCheck;
      if (field === 'email') {
        ngModel.$validators.validEmail = isValidEmail;
      } else if (field === 'username') {
        ngModel.$validators.validUsername = isValidUsernameFormat;
        ngModel.$validators.uniqueFromPassword = function (username) {
          if (!username) {
            return true;
          }

          return username !== _this.user.password;
        };
      } else {
        ngModel.$validators.validEmailUsername = function (email) {
          if (!email) {
            return true;
          }
          return isValidEmail(email) || isValidUsernameFormat(email);
        };
      }
    }
  }]);

  return flEmailUsernameValidCheck;
}();

flEmailUsernameValidCheck.$inject = ['UserData'];

var flEmailUsernameValidCheck$1 = flDirective$1(flEmailUsernameValidCheck, {
  selector: '[fl-email-username-valid-check]',
  require: 'ngModel',
  providers: [UserData$1]
});

/**
 * @ngdoc directive
 * @name flPasswordCheck
 * @restrict A
 * @description
 * Validates password pattern and is not equal to username
 */

var PasswordCheck = function () {
  function PasswordCheck(UserData) {
    _classCallCheck(this, PasswordCheck);

    this.user = UserData.user;
  }

  _createClass(PasswordCheck, [{
    key: 'link',
    value: function link(scope, elm, attr, ngModel) {
      var _this = this;

      ngModel.$validators.uniqueFromUsername = function (password) {
        if (!password) {
          return true;
        }
        return password !== _this.user.username;
      };

      ngModel.$validators.strongPassword = function (password) {
        if (!password) {
          return true;
        }
        var nums = password.match(/\d/g);
        var lowers = password.match(/[a-z]/g);
        var uppers = password.match(/[A-Z]/g);

        var pattern = /^.{6,}$/i;
        var pattern_result = pattern.test(password);

        if (pattern_result) {
          var strengthLevel = 0;
          if (nums) {
            strengthLevel += 2;
          }
          if (lowers) {
            strengthLevel += uppers ? 4 : 3;
          }
          if (uppers) {
            strengthLevel += lowers ? 4 : 3;
          }
          return strengthLevel > 4;
        }
        return false;
      };
    }
  }]);

  return PasswordCheck;
}();

PasswordCheck.$inject = ['UserData'];

var flPasswordCheck = flDirective$1(PasswordCheck, {
  selector: '[fl-password-check]',
  require: 'ngModel',
  providers: [UserData$1]
});

/**
 * @ngdoc directive
 * @name flArrowPasswordCheck
 * @restrict A
 * @description
 * Validates password meets Arrow password requirements
 */

var ArrowPasswordCheck = function () {
  function ArrowPasswordCheck(UserData) {
    _classCallCheck(this, ArrowPasswordCheck);

    this.user = UserData.user;
  }

  _createClass(ArrowPasswordCheck, [{
    key: 'link',
    value: function link(scope, elm, attr, ngModel) {
      ngModel.$validators.strongArrowPassword = function (password) {
        // Arrow passwords require there to be at least one lowercase,
        // one uppercase, and a number in passwords.
        if (!password) {
          return true;
        }
        var nums = password.match(/\d/g);
        var lowers = password.match(/[a-z]/g);
        var uppers = password.match(/[A-Z]/g);

        var pattern = /^.{8,}$/i;
        var pattern_result = pattern.test(password);

        if (pattern_result) {
          return Boolean(nums) && Boolean(lowers) && Boolean(uppers);
        }
        return false;
      };

      // Arrow allows a certain set of special characters: ~!@#$%^*()-_=+[]|;:,.<>/?
      // We must check that special characters in the password are allowed.
      ngModel.$validators.arrowPasswordAllowedCharacters = function (password) {
        return (/^[\w~!@#$%^*()\-_=+[\]\|;:,.<>\/?]*$/.test(password)
        );
      };
    }
  }]);

  return ArrowPasswordCheck;
}();

ArrowPasswordCheck.$inject = ['UserData'];

var flArrowPasswordCheck = flDirective$1(ArrowPasswordCheck, {
  selector: '[fl-arrow-password-check]',
  require: 'ngModel',
  providers: [UserData$1]
});

/**
 * @ngdoc directive
 * @name flUniqueEmailUsernameCheck
 * @restrict A
 * @description
 * Async Validator to check if email or username given already exists
 */

var UniqueEmailUsernameCheck = function () {
  function UniqueEmailUsernameCheck($q, $timeout, UsersService) {
    _classCallCheck(this, UniqueEmailUsernameCheck);

    this.$q = $q;
    this.$timeout = $timeout;
    this.UsersService = UsersService;
  }

  _createClass(UniqueEmailUsernameCheck, [{
    key: 'link',
    value: function link(scope, elm, attr, ngModel) {
      var _this = this;

      var field = attr.flUniqueEmailUsernameCheck;
      if (field === 'username') {
        ngModel.$asyncValidators.uniqueUsername = function (modelValue, username) {
          var deferred = _this.$q.defer();
          if (!username) {
            deferred.resolve();
          }
          _this.UsersService.checkUsernameExists(username).then(function (response) {
            _this.$timeout(function () {
              if (response === 'true') {
                deferred.resolve();
              } else {
                deferred.reject();
              }
            }, 500);
          });
          return deferred.promise;
        };
      } else {
        ngModel.$asyncValidators.uniqueEmail = function (modelValue, email) {
          var deferred = _this.$q.defer();
          if (!email) {
            deferred.resolve();
          }
          _this.UsersService.checkEmailExists(email).then(function (response) {
            _this.$timeout(function () {
              if (response === 'true') {
                deferred.resolve();
              } else {
                deferred.reject();
              }
            }, 500);
          });
          return deferred.promise;
        };
      }
    }
  }]);

  return UniqueEmailUsernameCheck;
}();

UniqueEmailUsernameCheck.$inject = ['$q', '$timeout', 'UsersService'];

var flUniqueEmailUsernameCheck = flDirective$1(UniqueEmailUsernameCheck, {
  selector: '[fl-unique-email-username-check]',
  require: 'ngModel',
  providers: [UsersProvider$1]
});

/**
 * @ngdoc directive
 * @name flUniqueArrowEmailCheck
 * @restrict A
 * @description
 * Async Validator to check if email exists on Arrow already.
 */

var UniqueArrowEmailCheck = function () {
  function UniqueArrowEmailCheck($http, $q, $timeout) {
    _classCallCheck(this, UniqueArrowEmailCheck);

    this.$http = $http;
    this.$q = $q;
    this.$timeout = $timeout;
  }

  _createClass(UniqueArrowEmailCheck, [{
    key: 'link',
    value: function link(scope, elm, attr, ngModel) {
      var _this = this;

      ngModel.$asyncValidators.uniqueArrowEmail = function (modelValue, email) {
        var deferred = _this.$q.defer();
        _this.$http({
          method: 'GET',
          url: '/ajax/auth/arrow/check-email-exists.php',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Accept: 'application/json'
          },
          params: { email: email }
        }).then(function (response) {
          _this.$timeout(function () {
            if (response.status !== 200) {
              return Promise.reject();
            }
            deferred.resolve();
          }, 500);
        }).catch(function () {
          deferred.reject();
        });
        return deferred.promise;
      };
    }
  }]);

  return UniqueArrowEmailCheck;
}();

UniqueArrowEmailCheck.$inject = ['$http', '$q', '$timeout'];

var flUniqueArrowEmailCheck = flDirective$1(UniqueArrowEmailCheck, {
  selector: '[fl-unique-arrow-email-check]',
  require: 'ngModel'
});

var CorporateService = function () {
  function CorporateService($http, $log, Auth) {
    _classCallCheck(this, CorporateService);

    this.$http = $http;
    this.$log = $log;
    this.Auth = Auth;
    this.newAuthUrl = '/auth'; // TODO: Replace this to use config
    this.CORPORATE_COOKIE_KEY = 'CORPORATE_ID';
  }

  _createClass(CorporateService, [{
    key: 'checkCorporate',
    value: function checkCorporate() {
      if (getCookie(this.CORPORATE_COOKIE_KEY) !== '') {
        return true;
      }
      return false;
    }
  }, {
    key: 'serializeData',
    value: function serializeData(obj) {
      var result = [];

      Object.keys(obj).forEach(function (key) {
        result.push(encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]));
      });
      return result.join('&');
    }
  }, {
    key: 'swapAccount',
    value: function swapAccount(rememberLogin) {
      var _this = this;

      var user = this.Auth.getUserId();
      var token = this.Auth.getAccessToken();
      var otherUser = getCookie(this.CORPORATE_COOKIE_KEY);
      var headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: 'application/json'
      };
      var data = {
        user: user,
        token: token,
        other_user: otherUser
      };
      if (user != otherUser) {
        return this.$http({
          method: 'POST',
          url: this.newAuthUrl + '/switch_account/',
          headers: headers,
          data: this.serializeData(data)
        }).then(function (response) {
          if (response.status !== 200) {
            return;
          }
          if (response.data && response.data.token) {
            // Successfully login
            _this.Auth.reset();
            _this.Auth.set(response.data.token, response.data.user, rememberLogin);
            return response;
          }
        }).catch(function (response) {
          _this.trackError('SwitchCorporateUserLogin', response.data.error_code);
          // Auth HTTP Interceptor will log the user out if a response status is 401.
          // Add the Auth Cookie for the current user if this happens.
          _this.Auth.reset();
          _this.Auth.set(token, user, rememberLogin);
          return response;
        });
      }
      return Promise.resolve();
    }
  }, {
    key: 'trackError',
    value: function trackError(label, e) {
      qtsp.push({
        section: 'newAuth2FA',
        subsection: 'corporateService',
        label: label,
        action: 'error',
        value: JSON.stringify(e)
      });
    }
  }]);

  return CorporateService;
}();

CorporateService.$inject = ['$http', '$log', 'Auth'];

var CorporateProvider = flService$1('CorporateService', [AuthModule], CorporateService);

// This allows Webapp Modals to be used from the SystemJS (static/modules) code.
var webappCompatModalsReady = new Promise(function (resolve) {
  if (window.webappCompatModals) {
    resolve();
  } else {
    window.webappCompatModalsReadyCallback = function () {
      return resolve();
    };
  }
});

var WebappModals = function () {
  function WebappModals() {
    _classCallCheck(this, WebappModals);
  }

  _createClass(WebappModals, [{
    key: "open",
    value: function open(componentName, config, afterCloseCallback) {
      return webappCompatModalsReady.then(function () {
        return window.webappCompatModals.open(componentName, config, afterCloseCallback);
      });
    }
  }]);

  return WebappModals;
}();

// e.g.,
// webappModals.open('AwardModalComponent',
//   inputs: {
//     userId: 233223243,
//   }
// );
var webappModals = new WebappModals();

/**
 * @ngdoc directive
 * @name flUtils.directive:flIcon
 * @element A
 * @function
 *
 * @description
 * Our own md-icon.
 *
 * @example
  ```
    <fl-icon name="icon-name"></fl-icon>
  ```
 */
var OPAQUE_MODULE_NAME$2 = 'flAngular.flIcon';

var flIconProvider = angular.module(OPAQUE_MODULE_NAME$2, []).directive('flIcon', ['$sce', '$window', function ($sce, $window) {
  return {
    templateUrl: function templateUrl(elem, attrs) {
      return $sce.trustAsResourceUrl($window.SystemJS.normalizeSync('icons/' + attrs.name + '.svg'));
    },
    link: function link(scope, element, attrs) {
      if (attrs.class) {
        element.find('svg').addClass(attrs.class);
        element.removeAttr('class');
      }
    }
  };
}]).name; // exports the opaque token

var template$2 = "<div class=\"Modal\" ng-class=\"UiModal.modalProps.classes\">\n  <div class=\"Modal-inner\" outbounds=\"true\">\n    <div class=\"Modal-dialog\" role=\"dialog\">\n      <div class=\"Modal-content Card\" role=\"document\">\n        <fl-compiled bind-html-compile=\"{[{UiModal.bodyTemplate}]}\"></fl-compiled>\n      </div>\n      <fl-compiled ng-if=\"UiModal.shadowFooterTemplate\" bind-html-compile=\"{[{UiModal.shadowFooterTemplate}]}\"></fl-compiled>\n    </div>\n  </div>\n  <div class=\"Modal-overlay\" tabindex=\"-1\"></div>\n</div>\n";

var Compiled = function () {
  function Compiled($scope, $element, $attrs, $compile) {
    _classCallCheck(this, Compiled);

    this.$compile = $compile;
    this.scope = $scope;
    this.element = $element;
    this.attrs = $attrs;
  }

  _createClass(Compiled, [{
    key: '$postLink',
    value: function $postLink() {
      var _this = this;

      this.scope.$watch(function () {
        return _this.attrs.bindHtmlCompile;
      }, function (value) {
        _this.element.html(value && value.toString());
        var compileScope = _this.scope.$parent;
        _this.$compile(_this.element.contents())(compileScope);
      });
    }
  }]);

  return Compiled;
}();

Compiled.$inject = ['$scope', '$element', '$attrs', '$compile'];

var flCompiled = flComponent$1(Compiled, {
  selector: 'fl-compiled'
});

var Modal$1 = function () {
  function Modal($scope, $element, $document) {
    var _this = this;

    _classCallCheck(this, Modal);

    this.scope = $scope;
    if ($element.length) {
      this.element = $element[0];
    } else {
      this.element = $element;
    }
    if ($document.length) {
      this.body = $document[0].body;
    } else {
      this.body = $document.body;
    }
    this.bodyTemplate = '<' + this.modalSelector + ' ' + 'modal-props="UiModal.modalProps" ' + 'modal-visible="UiModal.modalVisible">' + ('</' + this.modalSelector + '>');

    this.shadowFooterTemplate = this.modalShadowFooterSelector ? '<' + this.modalShadowFooterSelector + ' ' + 'modal-props="UiModal.modalProps" ' + 'modal-visible="UiModal.modalVisible">' + ('</' + this.modalShadowFooterSelector + '>') : null;

    this.element.addEventListener('click', function (event) {
      if (event.target.hasAttribute('outbounds')) {
        _this.backdropClicked();
      }
    });

    document.addEventListener('keydown', function (event) {
      // keydown on Esc key
      if (event.which === 27) {
        event.preventDefault();
        _this.backdropClicked();
      }
    });
  }

  _createClass(Modal, [{
    key: '$postLink',
    value: function $postLink() {
      this.body.appendChild(this.element);
    }
  }, {
    key: 'backdropClicked',
    value: function backdropClicked() {
      if (typeof this.modalProps.onBackdropClick === 'function') {
        this.modalProps.onBackdropClick();
      }
      if (!this.modalProps.disableBackdropClose) {
        this.modalVisible = false;
        this.scope.$apply();
      }
    }
  }]);

  return Modal;
}();

Modal$1.$inject = ['$scope', '$element', '$document'];

var flUiModalProvider = flComponent$1(Modal$1, {
  selector: 'fl-ui-modal',
  template: template$2,
  bindings: {
    modalSelector: '=',
    modalShadowFooterSelector: '=',
    modalVisible: '=',
    modalProps: '='
  },
  providers: [flCompiled]
});

/**
 * - disableRedirect option will disable redirects & reloads, but not force
 *   redirects in on login. Note it will also cancel default redirects into
 *   the usual signup funnel.
 * - Best not to directly edit varaibles showSignup and visible, but to use the
 *   appropriate function calls.
 */
var DEFAULT_OPTIONS = {
  showAsModal: true,
  hideFb: false,
  showSignupOption: true,
  showLoginOption: true,
  showAppLinks: true,
  pageName: '',
  signupTitle: '',
  loginTitle: '',
  signupSuccessMessage: '',
  loginSuccessMessage: '',
  forcedAccountType: '',
  redirectUrl: '',
  redirectUrlEncoded: '',
  disableRedirect: false,
  disableBackdropClose: false,
  visible: false,
  showSignup: false,
  projectCollaborationInvitation: '',
  contestCollaborationInvitation: '',
  old2FAToken: ''
};

/**
 * @ngdoc service
 * @name loginSignupApp.LoginSignupConfig
 *
 * @description
 * Customisable Login Signup Config.
 * Acts as an angularjs service which can be accessed by legacy code
 *
 * Usage:
 */

var LoginSignupConfig = function () {
  function LoginSignupConfig($rootScope, UserData) {
    var _this = this;

    _classCallCheck(this, LoginSignupConfig);

    this.$rootScope = $rootScope;
    this.UserData = UserData;

    // Auth Messages returned in onAuthPromise, on signup and login
    this.authMessages = {
      SIGNUP_EMPLOYER: 'signup_success_employer',
      SIGNUP_FREELANCER: 'signup_success_freelancer',
      LOGIN_SUCCESS: 'login_success',
      CLOSE_MODAL: 'close_modal'
    };

    // Customisable options: Can be changed on the fly. For example each time
    // you show the Login/Signup Modal.
    this.options = Object.assign({}, DEFAULT_OPTIONS);

    this.$rootScope.$watch(function () {
      return _this.options.visible;
    }, function (newValue) {
      // If Login/Signup has been hidden, reject the auth promise
      if (newValue === false && typeof _this.rejectAuth === 'function') {
        _this.rejectAuth(_this.authMessages.CLOSE_MODAL);
      }
    });
  }

  /**
   * @ngdoc method
   * @name loginSignupApp.LoginSignupConfig#showSignup
   * @param {object} customOptions Custom modal options. (optional)
   * @description
   * Show the signup angular modal.
   * This can be called from within angular code and legacy code.
   */

  _createClass(LoginSignupConfig, [{
    key: 'showSignup',
    value: function showSignup(customOptions) {
      var _this2 = this;

      this.$rootScope.$evalAsync(function () {
        _this2.options = Object.assign({}, _this2.options, customOptions);
        _this2.options.visible = true;
        _this2.options.showSignup = true;
      });

      return new Promise(function (resolve, reject) {
        _this2.resolveAuth = resolve;
        _this2.rejectAuth = reject;
      });
    }

    /**
     * @ngdoc method
     * @name loginSignupApp.LoginSignupConfig#showLogin
     * @param {object} customOptions Custom modal options. (optional)
     * @description
     * Show the login angular modal.
     * This can be called from within angular code and legacy code.
     */

  }, {
    key: 'showLogin',
    value: function showLogin(customOptions) {
      var _this3 = this;

      this.$rootScope.$evalAsync(function () {
        _this3.options = Object.assign({}, _this3.options, customOptions);

        _this3.options.visible = true;
        _this3.options.showSignup = false;
      });

      return new Promise(function (resolve, reject) {
        _this3.resolveAuth = resolve;
        _this3.rejectAuth = reject;
      });
    }
  }, {
    key: 'switchToSignup',
    value: function switchToSignup() {
      this.options.showSignup = true;
      // reset the username value
      this.UserData.user.username = '';
      // if username is valid email, move to email input on Signup Form.
      if (this.UserData.user.username && isValidEmail(this.UserData.user.username)) {
        this.UserData.user.email = this.UserData.user.username;
      }
    }
  }, {
    key: 'switchToLogin',
    value: function switchToLogin() {
      this.options.showSignup = false;
      if (this.UserData.user.email) {
        this.UserData.user.username = this.UserData.user.email;
      }
    }
  }, {
    key: 'hide',
    value: function hide() {
      var _this4 = this;

      this.$rootScope.$evalAsync(function () {
        _this4.options.visible = false;
      });
    }
  }, {
    key: 'isModal',
    value: function isModal() {
      return this.options.showAsModal;
    }
  }, {
    key: 'isVisible',
    value: function isVisible() {
      return this.options.visible;
    }
  }, {
    key: 'isDisableBackdropClose',
    value: function isDisableBackdropClose() {
      return this.options.disableBackdropClose;
    }
  }, {
    key: 'showSignupOption',
    value: function showSignupOption() {
      return this.options.showSignupOption;
    }
  }, {
    key: 'showLoginOption',
    value: function showLoginOption() {
      return this.options.showLoginOption;
    }
  }, {
    key: 'showAppLinks',
    value: function showAppLinks() {
      return this.options.showAppLinks;
    }
  }, {
    key: 'getPageName',
    value: function getPageName() {
      return this.options.pageName;
    }
  }, {
    key: 'getSignupTitle',
    value: function getSignupTitle() {
      return this.options.signupTitle;
    }
  }, {
    key: 'getLoginTitle',
    value: function getLoginTitle() {
      return this.options.loginTitle;
    }
  }, {
    key: 'getSignupSuccessMessage',
    value: function getSignupSuccessMessage() {
      return this.options.signupSuccessMessage;
    }
  }, {
    key: 'getLoginSuccessMessage',
    value: function getLoginSuccessMessage() {
      return this.options.loginSuccessMessage;
    }
  }, {
    key: 'getRedirectUrl',
    value: function getRedirectUrl() {
      return this.options.redirectUrl;
    }
  }, {
    key: 'getRedirectUrlEncoded',
    value: function getRedirectUrlEncoded() {
      return this.options.redirectUrlEncoded;
    }
  }, {
    key: 'getForcedAccountType',
    value: function getForcedAccountType() {
      return this.options.forcedAccountType;
    }
  }, {
    key: 'isHideFb',
    value: function isHideFb() {
      return this.options.hideFb;
    }
  }, {
    key: 'getSkipCaptchaHash',
    value: function getSkipCaptchaHash() {
      return this.options.skipCaptchaHash;
    }
  }, {
    key: 'isRedirectDisabled',
    value: function isRedirectDisabled() {
      return this.options.disableRedirect;
    }
  }, {
    key: 'getEmailPrefill',
    value: function getEmailPrefill() {
      return this.options.emailPrefill;
    }
  }, {
    key: 'getProjectCollaborationInvitation',
    value: function getProjectCollaborationInvitation() {
      return this.options.projectCollaborationInvitation;
    }
  }, {
    key: 'getContestCollaborationInvitation',
    value: function getContestCollaborationInvitation() {
      return this.options.contestCollaborationInvitation;
    }
  }, {
    key: 'getOld2FAToken',
    value: function getOld2FAToken() {
      return this.options.old2FAToken;
    }
  }]);

  return LoginSignupConfig;
}();

LoginSignupConfig.$inject = ['$rootScope', 'UserData'];

var LoginSignupConfigProvider = flService$1('LoginSignupConfig', [UserData$1], LoginSignupConfig);

var APP_LINKS = flConstant$1('APP_LINKS', {
  appStoreLink: 'https://bnc.lt/Ed5l/nPQu9RdcWr',
  playStoreLink: 'https://bnc.lt/Ed5l/nPQu9RdcWr'
});

var linkTemplate = "<div class=\"ModalLoginSignup-appLinks\">\n  <a id='appStore' href=\"{{AppLinks.appStoreUrl}}\" class=\"app-store-link\" target=\"_blank\"\n    title=\"Download from the iTunes store\"\n    ng-click=\"AppLinks.trackAppStoreClick()\">\n    <img ng-src=\"{{AppLinks.cdn_url('/static/img/appstoreicons/apple-app-store-badge.png')}}\" height=\"100%\" />\n  </a>\n  <a id='playStore' href=\"{{AppLinks.playStoreUrl}}\" class=\"app-store-link\" target=\"_blank\"\n    title=\"Download from Google play\"\n    ng-click=\"AppLinks.trackPlayStoreClick()\">\n    <img ng-src=\"{{AppLinks.cdn_url('/static/img/appstoreicons/google-play-store-badge.png')}}\" height=\"100%\" />\n  </a>\n</div>\n";

var flAppLinks = function () {
  function flAppLinks(APP_LINKS$$1, LoginSignupConfig) {
    _classCallCheck(this, flAppLinks);

    this.appStoreUrl = APP_LINKS$$1.appStoreLink;
    this.playStoreUrl = APP_LINKS$$1.playStoreLink;
    this.cdn_url = cdn_url;
    this.loginSignupConfig = LoginSignupConfig;
  }

  _createClass(flAppLinks, [{
    key: 'trackPlayStoreClick',
    value: function trackPlayStoreClick() {
      qtsp.push({
        section: this.loginSignupConfig.getPageName(),
        sub_section: 'LoginSignup',
        label: 'DownloadPlayStore',
        action: 'click'
      });
    }
  }, {
    key: 'trackAppStoreClick',
    value: function trackAppStoreClick() {
      qtsp.push({
        section: this.loginSignupConfig.getPageName(),
        sub_section: 'LoginSignup',
        label: 'DownloadAppStore',
        action: 'click'
      });
    }
  }]);

  return flAppLinks;
}();

flAppLinks.$inject = ['APP_LINKS', 'LoginSignupConfig'];

var flAppLinks$1 = flComponent$1(flAppLinks, {
  selector: 'fl-app-links',
  template: linkTemplate,
  providers: [APP_LINKS, LoginSignupConfigProvider]
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
* @ngdoc directive
* @name flUi.directive:flFocusOn
* @element input
* @function
*
* @description
* Focus an element when the attached expression is true
*
* @usage
* <!-- This input will gain focus when focus evaluates to true -->
* <input type="text" fl-focus-on="focus">
* </input>
*
* @example
*  <example module="flUi">
*    <file name="index.html">
*      <div ng-controller="myController">
*        <input type="text" fl-focus-on="result.willBeTrue"
*          ng-model="confirmation">
*        </input>
*        <a ng-click="startInterval()" class="btn btn-primary" href="">
*          Run example again
*        </a>
*      </div>
*    </file>
*    <file name="index.js">
*        angular.module('flUi', []).controller('myController',
*        ($scope, $interval) => {
*          // Here we store our $interval so we can cancel it (stop it) later
*          let interval;
*          // Initialize this to false. As soon as it turns to true,
*          // our input element will gain focus.
*          $scope.result = {
*            willBeTrue: false
*          };
*          // The value of this var will appear in the text input
*          //after 5 secs
*          $scope.confirmation = null;
*
*          // Make expression evaluate to true after 3 seconds
*          $scope.startInterval = () => {
*            $scope.result.willBeTrue = false;
*            $scope.confirmation = 5;
*
*            interval = $interval(() => {
*              $scope.confirmation--;
*
*              if($scope.confirmation === 0) {
*                $scope.confirmation = "I should have focus now...";
*                $scope.result.willBeTrue = true;
*                $interval.cancel(interval);
*              };
*            }, 1000);
*          };
*
*          $scope.startInterval();
*        })
*    </file>
*  </example>
*/

var flFocusOn = function () {
  function flFocusOn() {
    _classCallCheck(this, flFocusOn);
  }

  _createClass(flFocusOn, [{
    key: 'link',
    value: function link(scope, element, attrs) {
      scope.$watch(attrs.flFocusOn, function (doFocus) {
        if (doFocus) {
          element[0].focus();
        }
      });
    }
  }]);

  return flFocusOn;
}();

var flFocusOnProvider = flDirective(flFocusOn, {
  selector: '[fl-focus-on]'
});

var arrowLoginFormTemplate = "<div class=\"Modal-header\">\n  <button class=\"Modal-close\"\n    ng-if=\"ArrowLoginForm.showAsModal\"\n    ng-click=\"ArrowLoginForm.closeModal()\"\n    type=\"button\"\n    data-modal-hide aria-label=\"Close this modal window\">\n    <span class=\"Icon Icon--small\">\n      <fl-icon name=\"ui-close\"></fl-icon>\n    </span>\n  </button>\n  <div class=\"ModalLoginSignup-header-logo\">\n    <fl-icon name=\"fl-arrow-logo\"></fl-icon>\n  </div>\n</div>\n\n<div class=\"Modal-body ModalLoginSignup-body ModalLoginSignup-body--arrow\"\n  fl-analytics-section=\"Login\">\n  <div class=\"ModalLoginSignup-body-heading\">\n    <span>\n      Welcome Back\n    </span>\n  </div>\n\n  <form name=\"ArrowLoginForm.form\"\n    class=\"user-login-form fl-form large-form responsive-form\">\n    <aside ng-class=\"{'is-hidden': !ArrowLoginForm.showErrorMessage}\"\n      class=\"alert alert-error\">\n      <span ng-if=\"ArrowLoginForm.errorStatus === 200 && ArrowLoginForm.errorCode === 'EXTERNAL_AW_LINK_EXISTING_BOTH'\">\n        Sorry we were unable to login to your account, there was a Freelancer account under the same email address. Please contact <a href=\"/support\">support</a>.\n      </span>\n      <span ng-if=\"ArrowLoginForm.errorStatus === 401 && (ArrowLoginForm.errorCode === 'EXTERNAL_AW_NOT_FOUND' || ArrowLoginForm.errorCode === 'EXTERNAL_AW_UNAUTHORIZED')\">\n        Incorrect email address or password provided.\n      </span>\n      <span ng-if=\"ArrowLoginForm.errorStatus === 401 && ArrowLoginForm.errorCode === 'GAF_ACCOUNT_CLOSED'\">\n        This account has been closed. Please contact <a href=\"/support\">support</a> for more assistance.\n      </span>\n      <span ng-if=\"ArrowLoginForm.errorStatus === 400 && ArrowLoginForm.errorCode === 'EXTERNAL_AW_USER_LOCKED'\">\n        You have attempted to log in too many times, and your account has been locked. Please reset your password to unlock your account.\n      </span>\n      <span ng-if=\"(\n            ArrowLoginForm.errorStatus === 401\n            && ArrowLoginForm.errorCode !== 'EXTERNAL_AW_NOT_FOUND'\n            && ArrowLoginForm.errorCode !== 'EXTERNAL_AW_UNAUTHORIZED'\n            && ArrowLoginForm.errorCode !== 'GAF_ACCOUNT_CLOSED'\n        )\n        || ArrowLoginForm.errorStatus === 500\">\n        There was a problem logging in with your account. Please contact <a href=\"/support\">support</a> for assistance.\n      </span>\n      <span ng-if=\"ArrowLoginForm.errorStatus === 429\">\n        You are performing too many requests. Please try again later.\n      </span>\n    </aside>\n    <div class=\"form-feedback-success login-success alert alert-success\"\n      ng-if=\"ArrowLoginForm.loginSuccess\">\n      Login Success!\n      <div class=\"Loader Loader--small\"></div>\n    </div>\n    <ol>\n      <li class=\"form-step username-step\"\n        ng-class=\"{'is-invalid': ArrowLoginForm.form.username.$invalid && ArrowLoginForm.form.username.$dirty}\">\n        <p class=\"ModalLoginSignup-body-credential\">\n          Sign in with your Arrow credentials\n        </p>\n        <label for=\"username\" class=\"is-accessibly-hidden\">\n          Email Address\n        </label>\n        <input id=\"username\"\n          class=\"large-input\"\n          name=\"username\"\n          type=\"text\"\n          placeholder=\"Email\"\n          maxlength=\"150\"\n          ng-model=\"ArrowLoginForm.UserData.user.email\"\n          ng-model-options=\"{ debounce: {'default': 300, 'blur': 0}, allowInvalid: true }\"\n          ng-required=\"true\"\n          ng-change=\"ArrowLoginForm.hideErrorMessage()\"\n          fl-email-username-valid-check=\"email\"\n          fl-focus-on=\"ArrowLoginForm.focusEmailInput\"\n        />\n        <div ng-messages=\"ArrowLoginForm.form.username.$error\"\n          tabindex=\"-1\">\n          <div class=\"form-error\"\n            ng-message=\"required\">\n              Please enter your email address.\n          </div>\n          <div class=\"form-error\"\n            ng-message=\"validEmail\">\n              Please enter a valid email address.\n          </div>\n        </div>\n      </li>\n      <li class=\"form-step password-step\"\n        ng-class=\"{'is-invalid': ArrowLoginForm.form.password.$invalid && ArrowLoginForm.form.password.$dirty}\">\n          <label class=\"is-accessibly-hidden\"\n            for=\"password\">\n            Password\n          </label>\n          <input id=\"password\"\n            class=\"large-input\"\n            name=\"password\"\n            type=\"password\"\n            placeholder=\"Password\"\n            maxlength=\"150\"\n            ng-model=\"ArrowLoginForm.UserData.user.password\"\n            ng-required=\"true\"\n          />\n          <div ng-messages=\"ArrowLoginForm.form.password.$error\"\n            tabindex=\"-1\">\n            <div class=\"form-error\"\n              ng-message=\"required\">\n                Please enter your password.\n            </div>\n          </div>\n      </li>\n      <li class=\"form-step has-label login-form-options\">\n          <a class=\"login-form-forgot forgot-password\"\n            ng-click=\"ArrowLoginForm.showStep({step: ArrowLoginForm.steps.RESET_PASSWORD})\"\n            fl-analytics=\"ArrowForgotPassword\">\n            Forgot Password?\n          </a>\n          <div class=\"Checkbox\">\n            <input id=\"loginpermanent\"\n              ng-model=\"ArrowLoginForm.rememberLogin\"\n              class=\"Checkbox-input\"\n              type=\"checkbox\"\n              name=\"remember\"\n            />\n            <label class=\"ModalLoginSignup-body-label Checkbox-label checkbox\"\n              for=\"loginpermanent\">\n                Remember me\n            </label>\n          </div>\n      </li>\n      <li class=\"form-step\">\n        <button id=\"login_btn\"\n          class=\"btn btn-black btn-large btn-submit ModalLoginSignup-loginForm-submitBtn\"\n          ng-click=\"ArrowLoginForm.login($event)\"\n          ng-disabled=\"ArrowLoginForm.isSubmitting\"\n          type=\"submit\"\n          fl-analytics=\"NormalLogin\">\n          Log In\n        </button>\n      </li>\n      <li class=\"form-step\">\n        <div class=\"ModalLoginSignup-body-loginFl\">\n          <a href=\"{{ArrowLoginForm.loginWithFreelancerUrl}}\">\n            or log in with Freelancer.com\n          </a>\n        </div>\n      </li>\n    </ol>\n  </form>\n  <span class=\"ModalLoginSignup-switchLoginSignupType\">\n    Don't have an account?\n    <a ng-click=\"ArrowLoginForm.showSignupForm({event: $event})\"\n      fl-analytics=\"ArrowSignupLink\">\n      Sign Up\n    </a>\n  </span>\n</div>\n";

var flArrowLoginForm = function () {
  function flArrowLoginForm($http, $timeout, UserData, UsersService, LoginSignupConfig) {
    var _this = this;

    _classCallCheck(this, flArrowLoginForm);

    this.$http = $http;
    this.$timeout = $timeout;
    this.UserData = UserData;
    this.UsersService = UsersService;
    this.loginSignupConfig = LoginSignupConfig;
    this.form = {};
    this.isSubmitting = false;
    this.showErrorMessage = false;
    this.loginSuccess = false;

    // Focus on the email input after timeout
    this.$timeout(function () {
      _this.focusEmailInput = true;
    }, 50);

    // Set the redirect url if a user decides to login with their freelancer
    // account on Freelancer.com
    var redirectUrlEncoded = this.loginSignupConfig.getRedirectUrlEncoded();
    // If there is no goto provided, the login component is in a modal, so we
    // must use the `next` url param to provide the actual path in the param.
    var nextPath = encodeURIComponent(window.location.pathname + window.location.search);
    this.loginWithFreelancerUrl = 'https://www.freelancer.com/partner-login?' + (redirectUrlEncoded ? 'goto=' + redirectUrlEncoded : 'nextSite=arrow&next=' + nextPath);
  }

  _createClass(flArrowLoginForm, [{
    key: 'login',
    value: function login($event) {
      var _this2 = this;

      $event.preventDefault();
      this.showErrorMessage = false;

      // Set form fields as dirty if it has any errors
      angular.forEach(this.form.$error, function (type) {
        angular.forEach(type, function (field) {
          field.$setDirty();
        });
      });

      // Do not make any submitting actions if submission has begun already,
      // or if the form is invalid.
      if (!this.form.$valid || this.isSubmitting || this.loginSuccess) {
        return;
      }

      this.isSubmitting = true;

      // Make login request
      return this.$http({
        method: 'POST',
        url: '/ajax/auth/arrow/login.php',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Accept: 'application/json'
        },
        data: this.UsersService.serializeData({
          email: this.UserData.user.email,
          password: this.UserData.user.password
        })
      }).then(function (response) {
        // An error occurred
        if (response.status !== 200) {
          return Promise.reject(response);
        }
        if (response.data && response.data.token) {
          // Successful login
          _this2.loginSuccess = true;
          _this2.onLoginSuccess({ response: response });
        }
      }).catch(function (response) {
        if (response.data && response.data.error === 'EXTERNAL_AW_LINK_EXISTING_AW') {
          // Arrow account exists without a linked FLN account
          _this2.showStep({ step: _this2.steps.USERNAME_INPUT });
          return;
        }
        if (response.data && response.data.error === 'GAF_ACCOUNT_SUSPENDED') {
          _this2.onLoginSuccess({
            response: response,
            forceRedirectUrl: '/users/usersuspended.php'
          });
          return;
        }
        _this2.showErrorMessage = true;
        _this2.isSubmitting = false;
        _this2.errorStatus = response.status;
        _this2.errorCode = response.data.error;
      });
    }
  }, {
    key: 'hideErrorMessage',
    value: function hideErrorMessage() {
      this.showErrorMessage = false;
    }
  }]);

  return flArrowLoginForm;
}();

flArrowLoginForm.$inject = ['$http', '$timeout', 'UserData', 'UsersService', 'LoginSignupConfig'];

var flArrowLoginForm$1 = flComponent$1(flArrowLoginForm, {
  selector: 'fl-arrow-login-form',
  template: arrowLoginFormTemplate,
  providers: [flEmailUsernameValidCheck$1, flFocusOnProvider, UserData$1, UsersProvider$1, LoginSignupConfigProvider],
  bindings: {
    rememberLogin: '=',
    steps: '=',
    showAsModal: '=',
    closeModal: '&',
    onLoginSuccess: '&',
    showSignupForm: '&',
    showStep: '&'
  }
});

var arrowLoginSuccessTemplate = "<div class=\"Modal-header\">\n  <div class=\"ModalLoginSignup-header\">\n    <button class=\"Modal-close\"\n      ng-click=\"ArrowLoginSuccess.closeModal($event)\"\n      type=\"button\"\n      data-modal-hide aria-label=\"Close this modal window\"\n      ng-if=\"ArrowLoginSuccess.showAsModal\">\n      <span class=\"Icon Icon--small\">\n        <fl-icon name=\"ui-close\"></fl-icon>\n      </span>\n    </button>\n    <div id=\"fl-logo\" class=\"ModalLoginSignup-header-logo\">\n      <fl-icon name=\"fl-arrow-logo\"></fl-icon>\n    </div>\n  </div>\n</div>\n\n<div class=\"Modal-body\"\n  fl-analytics-section=\"ArrowLogin\">\n  <div class=\"ModalLoginSignup-loginSuccess\">\n    <h2 class=\"ModalLoginSignup-body-title\">Login Success!</h2>\n    <p class=\"ModalLoginSignup-body-subtitle\">Please wait while we redirect you...</p>\n    <div class=\"ModalLoginSignup-signupSuccess-spinner\">\n      <div class=\"Loader Loader--large\"></div>\n    </div>\n  </div>\n</div>\n";

var flArrowLoginSuccess = function flArrowLoginSuccess() {
  _classCallCheck(this, flArrowLoginSuccess);
};

var flArrowLoginSuccess$1 = flComponent$1(flArrowLoginSuccess, {
  selector: 'fl-arrow-login-success',
  template: arrowLoginSuccessTemplate,
  bindings: {
    showAsModal: '=',
    closeModal: '&'
  }
});

var arrowLoginUsernameInputTemplate = "<div class=\"Modal-header\">\n    <div class=\"ModalLoginSignup-header\">\n      <div class=\"ModalLoginSignup-header-previousStep\"\n        ng-click=\"ArrowLoginUsernameInput.showStep({step: ArrowLoginUsernameInput.steps.LOGIN_FORM})\">\n        <fl-icon class=\"ModalLoginSignup-header-previousStep-icon\"\n          name=\"ui-chevron-left\">\n        </fl-icon>\n      </div>\n      <button class=\"Modal-close\"\n        ng-if=\"ArrowLoginUsernameInput.showAsModal\"\n        ng-click=\"ArrowLoginUsernameInput.closeModal()\"\n        type=\"button\"\n        data-modal-hide aria-label=\"Close this modal window\">\n        <span class=\"Icon Icon--small\">\n          <fl-icon name=\"ui-close\"></fl-icon>\n        </span>\n      </button>\n      <div id=\"fl-logo\" class=\"ModalLoginSignup-header-logo\">\n        <fl-icon name=\"fl-arrow-logo\"></fl-icon>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"Modal-body\"\n    fl-analytics-section=\"Signup\">\n    <h2 class=\"ModalLoginSignup-body-title ModalLoginSignup-body-title--center\">\n      Choose a username\n    </h2>\n    <aside ng-class=\"{'is-hidden': !ArrowLoginUsernameInput.showErrorMessage}\"\n      class=\"alert alert-error\">\n      <span ng-if=\"ArrowLoginUsernameInput.errorStatus === 400 && ArrowLoginUsernameInput.errorCode === 'GAF_EMAIL_EXISTS'\">\n        This email address is already in use. Please log in to your account.\n      </span>\n      <span ng-if=\"ArrowLoginUsernameInput.errorStatus === 400 && ArrowLoginUsernameInput.errorCode === 'GAF_EMAIL_BLOCKED'\">\n        This email domain you are using is blocked. Please use another email address.\n      </span>\n      <span ng-if=\"ArrowLoginUsernameInput.errorStatus === 401\n        || ArrowLoginUsernameInput.errorStatus === 500\">\n        There was a problem logging in with your account. Please contact <a href=\"/support\">support</a> for assistance.\n      </span>\n      <span ng-if=\"ArrowLoginUsernameInput.errorStatus === 429\">\n        You are performing too many requests. Please try again later.\n      </span>\n    </aside>\n    <div class=\"form-feedback-success login-success alert alert-success\"\n      ng-if=\"ArrowLoginUsernameInput.loginSuccess\">\n      Login Success!\n      <div class=\"Loader Loader--small\"></div>\n    </div>\n    <p class=\"ModalLoginSignup-body-subtitle\">\n      Please note that a username cannot be changed, once chosen.\n    </p>\n    <form class=\"user-signup-form fl-form responsive-form\"\n      name=\"ArrowLoginUsernameInput.form\">\n      <div class=\"form-step email-step\"\n        ng-class=\"{'is-invalid': ArrowLoginUsernameInput.form.username.$invalid && ArrowLoginUsernameInput.form.username.$dirty,\n                    'is-valid': ArrowLoginUsernameInput.form.username.$valid}\">\n        <label class=\"is-accessibly-hidden\"\n          for=\"new-username\">\n          Username\n        </label>\n        <input id=\"new-username\"\n          class=\"large-input\"\n          type=\"text\"\n          name=\"username\"\n          rel=\"popover\"\n          placeholder=\"Username\"\n          ng-model=\"ArrowLoginUsernameInput.UserData.user.username\"\n          ng-model-options=\"{ debounce: {'default': 300, 'blur': 0} }\"\n          ng-required=\"true\"\n          ng-minlength=\"3\"\n          ng-maxlength=\"16\"\n          fl-email-username-valid-check=\"username\"\n          fl-unique-email-username-check=\"username\"\n          fl-focus-on=\"ArrowLoginUsernameInput.focusUsernameInput\">\n        <div class=\"Loader Loader--small ModalLoginSignup-inputLoader\"\n          ng-if=\"ArrowLoginUsernameInput.form.username.$pending\">\n        </div>\n        <div ng-messages=\"ArrowLoginUsernameInput.form.username.$error\" tabindex=\"-1\">\n          <div class=\"form-error\" ng-message=\"required\">\n            Please enter a username.\n          </div>\n          <div class=\"form-error\" ng-message=\"minlength\">\n            Please enter at least 3 characters.\n          </div>\n          <div class=\"form-error\" ng-message=\"maxlength\">\n            Please enter at most 16 characters.\n          </div>\n          <div class=\"form-error\" ng-message=\"validUsername\">\n            Username must be alphanumeric starting with a letter.\n          </div>\n          <div class=\"form-error\" ng-message=\"uniqueUsername\">\n            This username already exists, please choose another.\n          </div>\n          <div class=\"form-error\" ng-message=\"uniqueFromPassword\">\n            Username must be different to password.\n          </div>\n        </div>\n        <div id=\"new-username-suggestion\"\n          class=\"ModalLoginSignup-signupUsernameInput-suggestions\"\n          ng-if=\"ArrowLoginUsernameInput.usernameSuggestions\">\n          <span class=\"ModalLoginSignup-signupUsernameInput-suggestionTitle\">\n            Suggestions:\n          </span>\n          <span ng-repeat=\"name in ArrowLoginUsernameInput.usernameSuggestions\">\n            <a ng-click=\"ArrowLoginUsernameInput.updateUsername(name)\">\n              {{name}}\n            </a>\n            <span class=\"ModalLoginSignup-signupUsernameInput-suggestions-separator\"\n              ng-show=\"!$last\">\n              /\n            </span>\n          </span>\n        </div>\n      </div>\n      <button class=\"btn btn-black btn-large ModalLoginSignup-signupUsernameInput-submitBtn\"\n        ng-disabled=\"ArrowLoginUsernameInput.isSubmitting\"\n        ng-click=\"ArrowLoginUsernameInput.login($event)\"\n        fl-analytics=\"NormalSignupUsername\">\n        Next\n        <span class=\"Loader Loader--small\"\n          ng-if=\"ArrowLoginUsernameInput.isSubmitting\">\n        </span>\n      </button>\n    </form>\n  </div>\n";

var flArrowLoginUsernameInput = function () {
  function flArrowLoginUsernameInput($http, $timeout, Users, UserData, UsersService) {
    var _this = this;

    _classCallCheck(this, flArrowLoginUsernameInput);

    this.$http = $http;
    this.$timeout = $timeout;
    this.Users = Users;
    this.UserData = UserData;
    this.UsersService = UsersService;

    this.isSubmitting = false;
    this.loginSuccess = false;
    this.showErrorMessage = false;

    this.generateSuggestedUsernames();

    this.$timeout(function () {
      _this.focusUsernameInput = true;
    }, 50);
  }

  _createClass(flArrowLoginUsernameInput, [{
    key: 'login',
    value: function login($event) {
      var _this2 = this;

      $event.preventDefault();
      // Set form fields as dirty if it has any errors.
      angular.forEach(this.form.$error, function (type) {
        angular.forEach(type, function (field) {
          field.$setDirty();
        });
      });
      if (!this.form.$valid || this.isSubmitting || this.loginSuccess) {
        return;
      }

      this.isSubmitting = true;

      return this.$http({
        method: 'POST',
        url: '/ajax/auth/arrow/login-create.php',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Accept: 'application/json'
        },
        data: this.UsersService.serializeData({
          email: this.UserData.user.email,
          password: this.UserData.user.password,
          username: this.UserData.user.username
        })
      }).then(function (response) {
        if (response.status !== 200) {
          return Promise.reject(response);
        }
        if (response.data && response.data.token) {
          _this2.loginSuccess = true;
          _this2.onLoginSuccess({ response: response });
        }
      }).catch(function (response) {
        _this2.showErrorMessage = true;
        _this2.isSubmitting = false;
        _this2.errorStatus = response.status;
        _this2.errorCode = response.data.error;
      });
    }
  }, {
    key: 'generateSuggestedUsernames',
    value: function generateSuggestedUsernames() {
      var _this3 = this;

      this.Users.check({ email: this.UserData.user.email }, { recommend_name: true }).then(function (result) {
        _this3.usernameSuggestions = [];
        _this3.usernameSuggestions.push(result.recommended_name);
        _this3.usernameSuggestions = _this3.usernameSuggestions.concat(result.alternate_names);
      });
    }
  }, {
    key: 'updateUsername',
    value: function updateUsername(name) {
      this.form.username.$setDirty();
      this.UserData.user.username = name;
    }
  }]);

  return flArrowLoginUsernameInput;
}();

flArrowLoginUsernameInput.$inject = ['$http', '$timeout', 'Users', 'UserData', 'UsersService'];

var flArrowLoginUsernameInput$1 = flComponent$1(flArrowLoginUsernameInput, {
  selector: 'fl-arrow-login-username-input',
  template: arrowLoginUsernameInputTemplate,
  providers: [flFocusOnProvider, flEmailUsernameValidCheck$1, flUniqueEmailUsernameCheck, UserData$1, UsersProvider, UsersProvider$1],
  bindings: {
    rememberLogin: '=',
    steps: '=',
    showAsModal: '=',
    closeModal: '&',
    onLoginSuccess: '&',
    showStep: '&'
  }
});

var arrowResetPasswordFormTemplate = "<div class=\"Modal-header\">\n  <div class=\"ModalLoginSignup-header\">\n    <div class=\"ModalLoginSignup-header-previousStep\"\n      ng-click=\"ArrowResetPasswordForm.showStep({step: ArrowResetPasswordForm.steps.LOGIN_FORM})\">\n      <fl-icon class=\"ModalLoginSignup-header-previousStep-icon\"\n        name=\"ui-chevron-left\">\n      </fl-icon>\n    </div>\n    <button class=\"Modal-close\"\n      ng-if=\"ArrowResetPasswordForm.showAsModal\"\n      ng-click=\"ArrowResetPasswordForm.closeModal()\"\n      type=\"button\"\n      data-modal-hide aria-label=\"Close this modal window\">\n      <span class=\"Icon Icon--small\">\n        <fl-icon name=\"ui-close\"></fl-icon>\n      </span>\n    </button>\n    <div id=\"fl-logo\" class=\"ModalLoginSignup-header-logo\">\n      <fl-icon name=\"fl-arrow-logo\"></fl-icon>\n    </div>\n  </div>\n</div>\n\n<div class=\"Modal-body ModalLoginSignup-body\">\n  <h4 class=\"ModalLoginSignup-body-heading ModalLoginSignup-body-title--center\">\n    Reset your password\n  </h4>\n  <p class=\"alert alert-info\"\n    ng-class=\"{'is-hidden': !ArrowResetPasswordForm.showSuccessMessage}\">\n    Email sent. If the email address you entered is registered at Arrow.com, you'll receive an email with instructions on how to set a new password.\n  </p>\n  <form name=\"ArrowResetPasswordForm.form\" class=\"recover-password-form fl-form large-form ModalLoginSignup-resetPassword-form\">\n    <fieldset>\n      <ol>\n        <li class=\"form-step recover-email-step\"\n          ng-class=\"{'is-invalid': ArrowResetPasswordForm.form.email.$invalid && ArrowResetPasswordForm.form.email.$dirty,\n          'is-valid': ArrowResetPasswordForm.form.email.$valid}\">\n          <label class=\"is-accessibly-hidden\"\n            for=\"forgotten-email\">\n            Email Address\n          </label>\n          <p class=\"ModalLoginSignup-body-subtitle\">\n            Enter your email address\n          </p>\n          <input id=\"forgotten-email\"\n            class=\"large-input\"\n            name=\"email\"\n            maxlength=\"100\"\n            type=\"text\"\n            placeholder=\"Email address\"\n            ng-model=\"ArrowResetPasswordForm.UserData.user.email\"\n            ng-model-options=\"{ debounce: {'default': 300, 'blur': 0} }\"\n            ng-required=\"true\"\n            fl-email-username-valid-check=\"email\"\n            fl-focus-on=\"ArrowResetPasswordForm.focusEmailInput\"\n          />\n          <div ng-messages=\"ArrowResetPasswordForm.form.email.$error\" tabindex=\"-1\">\n            <div class=\"form-error\" ng-message=\"required\">\n                Please enter your email address.\n            </div>\n            <div class=\"form-error\" ng-message=\"validEmail\">\n                Please enter a valid email address.\n            </div>\n          </div>\n        </li>\n        <li class=\"form-step\">\n          <button class=\"btn btn-black btn-large btn-primary btn-submit ModalLoginSignup-resetPassword-submitBtn\"\n            ng-disabled=\"ArrowResetPasswordForm.isSubmitting\"\n            ng-click=\"ArrowResetPasswordForm.resetPassword($event)\"\n            type=\"submit\">\n            Reset Password\n          </button>\n        </li>\n      </ol>\n    </fieldset>\n  </form>\n  <span class=\"login-form-signup-link\">\n    Don't have an account?\n    <a ng-click=\"ArrowResetPasswordForm.showSignupForm({event: $event})\">\n      Sign Up\n    </a>\n  </span>\n</div>\n";

var flArrowResetPasswordForm = function () {
  function flArrowResetPasswordForm($http, $timeout, UserData, UsersService) {
    var _this = this;

    _classCallCheck(this, flArrowResetPasswordForm);

    this.$http = $http;
    this.$timeout = $timeout;
    this.UserData = UserData;
    this.UsersService = UsersService;
    this.form = {};
    this.isSubmitting = false;
    this.showSuccessMessage = false;
    this.showErrorMessage = false;
    this.errorMessage = '';

    // Focus on the email input after timeout
    this.$timeout(function () {
      _this.focusEmailInput = true;
    }, 50);
  }

  _createClass(flArrowResetPasswordForm, [{
    key: 'resetPassword',
    value: function resetPassword($event) {
      var _this2 = this;

      $event.preventDefault();
      this.showErrorMessage = false;

      // Set form fields as dirty for each form input type with any errors.
      angular.forEach(this.form.$error, function (type) {
        angular.forEach(type, function (field) {
          field.$setDirty();
        });
      });
      if (!this.form.$valid || this.isSubmitting) {
        return;
      }
      this.isSubmitting = true;

      return this.$http({
        method: 'POST',
        url: '/ajax/auth/arrow/reset-password.php',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Accept: 'application/json'
        },
        data: this.UsersService.serializeData({
          email: this.UserData.user.email
        })
      }).then(function () {
        _this2.showSuccessMessage = true;
      });
    }
  }]);

  return flArrowResetPasswordForm;
}();

flArrowResetPasswordForm.$inject = ['$http', '$timeout', 'UserData', 'UsersService'];

var flArrowResetPasswordForm$1 = flComponent$1(flArrowResetPasswordForm, {
  selector: 'fl-arrow-reset-password-form',
  template: arrowResetPasswordFormTemplate,
  providers: [flEmailUsernameValidCheck$1, flFocusOnProvider, UserData$1, UsersProvider$1],
  bindings: {
    steps: '=',
    showAsModal: '=',
    closeModal: '&',
    showStep: '&',
    showSignupForm: '&'
  }
});

var arrowLoginTemplate = "<fl-arrow-login-form\n  ng-if=\"ArrowLogin.currentStep === ArrowLogin.steps.LOGIN_FORM\"\n  remember-login=\"ArrowLogin.rememberLogin\"\n  steps=\"ArrowLogin.steps\"\n  show-step=\"ArrowLogin.showStep(step)\"\n  show-signup-form=\"ArrowLogin.showSignupForm(event)\"\n  show-as-modal=\"ArrowLogin.showAsModal\"\n  close-modal=\"ArrowLogin.closeModal()\"\n  on-login-success=\"ArrowLogin.onLoginSuccess(response, forceRedirectUrl)\"\n></fl-arrow-login-form>\n<fl-arrow-reset-password-form\n  ng-if=\"ArrowLogin.currentStep === ArrowLogin.steps.RESET_PASSWORD\"\n  steps=\"ArrowLogin.steps\"\n  show-step=\"ArrowLogin.showStep(step)\"\n  show-signup-form=\"ArrowLogin.showSignupForm(event)\"\n  show-as-modal=\"ArrowLogin.showAsModal\"\n  close-modal=\"ArrowLogin.closeModal()\"\n></fl-arrow-reset-password-form>\n<fl-arrow-login-username-input\n  ng-if=\"ArrowLogin.currentStep === ArrowLogin.steps.USERNAME_INPUT\"\n  remember-login=\"ArrowLogin.rememberLogin\"\n  steps=\"ArrowLogin.steps\"\n  show-step=\"ArrowLogin.showStep(step)\"\n  show-as-modal=\"ArrowLogin.showAsModal\"\n  close-modal=\"ArrowLogin.closeModal()\"\n  on-login-success=\"ArrowLogin.onLoginSuccess(response, forceRedirectUrl)\"\n  ></fl-arrow-login-username-input>\n<fl-arrow-login-success\n  ng-if=\"ArrowLogin.currentStep === ArrowLogin.steps.LOGIN_SUCCESS\"\n  show-as-modal=\"ArrowLogin.showAsModal\"\n  close-modal=\"ArrowLogin.closeModal()\"\n></fl-arrow-login-success>\n";

var flArrowLogin = function () {
  function flArrowLogin($http, $window, Auth, LoginSignupConfig, UsersService) {
    _classCallCheck(this, flArrowLogin);

    this.$http = $http;
    this.$window = $window;
    this.Auth = Auth;
    this.loginSignupConfig = LoginSignupConfig;
    this.UsersService = UsersService;
    this.steps = {
      LOGIN_FORM: 1,
      RESET_PASSWORD: 2,
      USERNAME_INPUT: 3,
      LOGIN_SUCCESS: 4
    };
    this.showStep(this.steps.LOGIN_FORM);
    this.rememberLogin = false;

    this.urlParams = new Map(window.location.search.slice(1).split('&').map(function (kv) {
      return kv.split('=');
    }));
  }

  _createClass(flArrowLogin, [{
    key: 'onLoginSuccessRedirect',
    value: function onLoginSuccessRedirect(forceRedirectUrl) {
      var _this = this;

      if (forceRedirectUrl) {
        this.$window.location.href = forceRedirectUrl;
        return;
      }

      this.UsersService.getLoginRedirectUrl(this.loginSignupConfig.isRedirectDisabled(), this.loginSignupConfig.isModal(), this.loginSignupConfig.getRedirectUrl()).then(function (response) {
        if (response.data) {
          var redirectUrl = response.data.redirect_url;
          if (redirectUrl === 'reload') {
            _this.$window.location.reload();
          } else if (redirectUrl !== '') {
            _this.$window.location.href = redirectUrl;
          } else {
            _this.$window.location.href = '/dashboard/';
          }
        }
      }).catch(function () {
        _this.$window.location.href = '/dashboard/';
      });
    }
  }, {
    key: 'onLoginSuccess',
    value: function onLoginSuccess(response, forceRedirectUrl) {
      var _this2 = this;

      this.showStep(this.steps.LOGIN_SUCCESS);

      return new Promise(function (resolve) {
        _this2.setCookiesOnLogin(response);
        resolve();
      }).then(function () {
        return _this2.UsersService.crossDomainSSO({
          data: {
            token: _this2.Auth.getAccessToken(),
            user: _this2.Auth.getUserId()
          }
        }, _this2.rememberLogin);
      }).then(function () {
        return new Promise(function (resolve) {
          _this2.loginSignupConfig.resolveAuth(_this2.loginSignupConfig.authMessages.LOGIN_SUCCESS);
          resolve();
        });
      }).then(function () {
        return new Promise(function (resolve) {
          var postProjectObject = JSON.parse(window.localStorage.getItem('postProjectObject'));
          var draftProject = JSON.parse(window.localStorage.getItem('arrowPostProjectDraft'));

          var postProjectOnLogin = _this2.urlParams.get('postProjectOnLogin') === 'true';

          if (postProjectOnLogin && postProjectObject && postProjectObject['logged-out']) {
            // Post a project
            _this2.postProject(postProjectObject['logged-out'].item).then(function (response) {
              var project = response.data.result;

              // Clear draft of the just posted project if it is in localStorage
              if (draftProject) {
                delete draftProject['logged-out'];
                window.localStorage.setItem('arrowPostProjectDraft', JSON.stringify(draftProject));
              }

              // Clear localStorage entry of object that was just posted
              delete postProjectObject['logged-out'];
              window.localStorage.setItem('postProjectObject', JSON.stringify(postProjectObject));
              // Redirect to PVP
              _this2.$window.location.href = '/projects/' + project.id;
              resolve();
            }).catch(function (response) {
              // TODO: Redirect to PJP, populate with draft data, and then show
              // error message. If funds are required for upgrades, do something else

              // Clear localStorage entry of project so it doesn't randomly get posted later
              delete postProjectObject['logged-out'];
              window.localStorage.setItem('postProjectObject', JSON.stringify(postProjectObject));

              // If posting the project failed and the user requires payment verification
              // send them to be payment verified, and also move the draft project in
              // localstorage from logged-out to their user id.
              if (response.data && response.data.status === 'error' && response.data.error_code === 'ProjectExceptionCodes.UNVERIFIED_PAYMENT') {
                if (draftProject && draftProject['logged-out']) {
                  draftProject['id-' + _this2.Auth.getUserId()] = draftProject['logged-out'];
                  delete draftProject['logged-out'];
                  window.localStorage.setItem('arrowPostProjectDraft', JSON.stringify(draftProject));
                }
                _this2.$window.location.href = '/post-project';
                return;
              }

              _this2.$window.location.href = '/dashboard';
            });
          } else {
            resolve();
          }
        });
      }).then(function () {
        _this2.onLoginSuccessRedirect(forceRedirectUrl);
      });
    }
  }, {
    key: 'postProject',
    value: function postProject(project) {
      var _this3 = this;

      var projectData = {
        title: project.title,
        description: project.description,
        currency: { id: project.currency.id },
        budget: {
          minimum: project.budget.minimum,
          maximum: project.budget.maximum,
          currency_id: project.currency.id,
          project_type: project.type
        },
        jobs: project.jobs,
        type: project.type,
        hourly_project_info: project.type === 'hourly' ? project.hourlyProjectInfo : undefined,
        hireme: project.hireme,
        location: project.local ? project.location : undefined,
        upgrades: _extends({}, project.upgrades, {
          recruiter: project.upgrades.assisted,
          project_management: project.upgrades.projectManagement,
          ip_contract: project.upgrades.ipContract
        }),
        nda_details: {
          hidden_description: project.ndaDetails.hiddenDescription
        },
        files: project.files
      };

      return new Promise(function (resolve, reject) {
        _this3.$http({
          method: 'POST',
          url: '/api/projects/0.1/projects/',
          data: projectData,
          headers: {
            'Content-type': 'application/json'
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    }
  }, {
    key: 'setCookiesOnLogin',
    value: function setCookiesOnLogin(response) {
      this.Auth.set(response.data.token, response.data.user, this.rememberLogin);
      this.UsersService.setExtraCookies();
      // TODO: Set any other AFLN specific cookies (ARROW_FED_AUTH_TOKEN)
      this.setExternalCookies(response);
    }
  }, {
    key: 'setExternalCookies',
    value: function setExternalCookies(response) {
      Object.values(response.data.external_cookies).forEach(function (cookie) {
        var expireDate = new Date(cookie.expiry * 1000);
        var expireMinutes = (expireDate - new Date()) / 1000 / 60;
        setCookieToBrowser(cookie.name, cookie.value, 0, '/', cookieDomain, expireMinutes);
      });
    }
  }, {
    key: 'showStep',
    value: function showStep(step) {
      this.currentStep = step;
    }
  }, {
    key: 'showSignupForm',
    value: function showSignupForm($event) {
      $event.preventDefault();
      this.loginSignupConfig.switchToSignup();
    }
  }]);

  return flArrowLogin;
}();

flArrowLogin.$inject = ['$http', '$window', 'Auth', 'LoginSignupConfig', 'UsersService'];

var flArrowLogin$1 = flComponent$1(flArrowLogin, {
  selector: 'fl-arrow-login',
  template: arrowLoginTemplate,
  providers: [flArrowLoginForm$1, flArrowLoginSuccess$1, flArrowLoginUsernameInput$1, flArrowResetPasswordForm$1, AuthModule, LoginSignupConfigProvider, UsersProvider$1],
  bindings: {
    showAsModal: '=',
    closeModal: '&'
  }
});

var USER_TYPE_EMPLOYER = 'employer';
var USER_TYPE_FREELANCER = 'freelancer';
var SIGNUP_STEPS = {
  BASE_STEP: 1,
  USERNAME_STEP: 2,
  ACCOUNT_TYPE_STEP: 3,
  PRIVACY_CONSENT_STEP: 4,
  CAPTCHA_STEP: 5,
  SUCCESS_STEP: 10 };
var REFERRAL_SIGNUP_COOKIE_KEY = 'referral_signup';
var IS_FROM_EU_COOKIE_KEY = 'is_from_eu';
var PRIVACY_CONSENT_KEY = 'privacy_consent';
var BUSINESS_USER_KEY = 'business_user';
var PROJECT_COLLABORATION_INVITATION_KEY = 'project_collaboration_invitation';
var CONTEST_COLLABORATION_INVITATION_KEY = 'contest_collaboration_invitation';

var arrowAccountTypeTemplate = "<div class=\"Modal-header\">\n  <div class=\"ModalLoginSignup-header\">\n    <div class=\"ModalLoginSignup-header-previousStep\"\n      ng-click=\"ArrowAccountType.showStep({step: ArrowAccountType.steps.USERNAME_INPUT})\">\n      <fl-icon name=\"ui-chevron-left\"\n        class=\"ModalLoginSignup-header-previousStep-icon\">\n      </fl-icon>\n    </div>\n    <button class=\"Modal-close\"\n      ng-click=\"ArrowAccountType.closeModal()\"\n      type=\"button\"\n      data-modal-hide aria-label=\"Close this modal window\"\n      ng-if=\"ArrowAccountType.showAsModal\">\n      <span class=\"Icon Icon--small\">\n        <fl-icon name=\"ui-close\"></fl-icon>\n      </span>\n    </button>\n    <div id=\"fl-logo\"\n      class=\"ModalLoginSignup-header-logo\">\n      <fl-icon name=\"fl-arrow-logo\"></fl-icon>\n    </div>\n  </div>\n</div>\n<div class=\"Modal-body\">\n  <h2 class=\"ModalLoginSignup-body-title\">\n    Select account type\n  </h2>\n  <p class=\"ModalLoginSignup-body-subtitle\">\n    Don’t worry, this can be changed later.\n  </p>\n  <aside ng-class=\"{'is-hidden': !ArrowAccountType.showErrorMessage}\"\n    class=\"alert alert-error\">\n    <span ng-if=\"ArrowAccountType.errorCode === 'EXTERNAL_AW_LINK_EXISTING_FLN'\">\n      Sorry we were unable to create your account, there was a Freelancer account under the same email address. Please contact <a href=\"/support\">support</a>.\n    </span>\n    <span ng-if=\"ArrowAccountType.errorCode === 'EXTERNAL_AW_USER_EXISTS'\">\n      An account with this email already exists on Arrow.com. Please login with your account details.\n    </span>\n    <span ng-if=\"ArrowAccountType.errorStatus === 429\">\n      You are performing too many requests. Please try again later.\n    </span>\n    <span ng-if=\"ArrowAccountType.errorStatus !== 429 &&\n      ArrowAccountType.errorCode !== 'EXTERNAL_AW_LINK_EXISTING_FLN' &&\n      ArrowAccountType.errorCode !== 'EXTERNAL_AW_USER_EXISTS'\">\n      There was a problem signing up. Please contact <a href=\"/support\">support</a> for assistance.\n    </span>\n  </aside>\n  <div class=\"form-feedback-success login-success alert alert-success\"\n    ng-if=\"ArrowAccountType.signupSuccess\">\n    Signup Success!\n    <div class=\"Loader Loader--small\"></div>\n  </div>\n  <div ng-click=\"ArrowAccountType.selectFreelancer()\"\n    class=\"Card ModalLoginSignup-signupAccountType-card\">\n    <div class=\"ModalLoginSignup-signupAccountType-card-content\">\n      <div class=\"ModalLoginSignup-signupAccountType-card-image\">\n        <img ng-src=\"{[{ArrowAccountType.workImageUrl}]}\" alt=\"Work Image\"/>\n      </div>\n      <div class=\"ModalLoginSignup-signupAccountType-card-title\">\n        I want to work\n      </div>\n    </div>\n    <div class=\"ModalLoginSignup-signupAccountType-card-next\">\n      <div ng-if=\"!ArrowAccountType.isSubmitting || ArrowAccountType.selectedEmployer\">\n        <fl-icon name=\"ui-arrow-right\" class=\"ModalLoginSignup-signupAccountType-card-next-icon\">\n        </fl-icon>\n      </div>\n      <div ng-if=\"ArrowAccountType.isSubmitting && ArrowAccountType.selectedFreelancer\" class=\"Loader Loader--small\">\n      </div>\n    </div>\n  </div>\n  <div ng-click=\"ArrowAccountType.selectEmployer()\"\n    class=\"Card ModalLoginSignup-signupAccountType-card\">\n    <div class=\"ModalLoginSignup-signupAccountType-card-content\">\n      <div class=\"ModalLoginSignup-signupAccountType-card-image\">\n        <img ng-src=\"{[{ArrowAccountType.hireImageUrl}]}\" alt=\"Hire Image\"/>\n      </div>\n      <div class=\"ModalLoginSignup-signupAccountType-card-title\">\n        I want to hire\n      </div>\n    </div>\n    <div class=\"ModalLoginSignup-signupAccountType-card-next\">\n      <div ng-if=\"!ArrowAccountType.isSubmitting || ArrowAccountType.selectedFreelancer\">\n        <fl-icon name=\"ui-arrow-right\" class=\"ModalLoginSignup-signupAccountType-card-next-icon\">\n        </fl-icon>\n      </div>\n      <div ng-if=\"ArrowAccountType.isSubmitting && ArrowAccountType.selectedEmployer\" class=\"Loader Loader--small\">\n      </div>\n    </div>\n  </div>\n</div>\n";

var flArrowAccountType = function () {
  function flArrowAccountType($http, Cdn, UserData, UsersService) {
    _classCallCheck(this, flArrowAccountType);

    this.$http = $http;
    this.UserData = UserData;
    this.UsersService = UsersService;

    this.hireImageUrl = Cdn.getCdnUrl('/static/img/login-signup/fln-icon-hire-black.svg');
    this.workImageUrl = Cdn.getCdnUrl('/static/img/login-signup/fln-icon-work-black.svg');

    this.signupSuccess = false;
    this.showErrorMessage = false;
    this.isSubmitting = false;

    // States
    this.selectedEmployer = false;
    this.selectedFreelancer = false;
  }

  _createClass(flArrowAccountType, [{
    key: 'selectEmployer',
    value: function selectEmployer() {
      this.UserData.user.role = 'Employer';
      this.selectedEmployer = true;
      this.selectedFreelancer = false;
      this.signup();
    }
  }, {
    key: 'selectFreelancer',
    value: function selectFreelancer() {
      this.UserData.user.role = 'Worker';
      this.selectedFreelancer = true;
      this.selectedEmployer = false;
      this.signup();
    }
  }, {
    key: 'signup',
    value: function signup() {
      var _this = this;

      // Check if user is from the EU. If they are, we show the consent form,
      // otherwise we attempt to sign up.
      if (this.UserData.user.isFromEU) {
        this.showStep({ step: this.steps.CONSENT_FORM });
        return;
      }

      // Attempt to signup
      if (this.signupSuccess || this.isSubmitting) {
        return;
      }

      this.isSubmitting = true;

      return this.$http({
        method: 'POST',
        url: '/ajax/auth/arrow/signup.php',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Accept: 'application/json'
        },
        data: this.UsersService.serializeData({
          email: this.UserData.user.email,
          password: this.UserData.user.password,
          username: this.UserData.user.username,
          fullname: this.UserData.user.fullName,
          country: this.UserData.user.country,
          privacyConsent: this.UserData.user.privacyConsent,
          businessUser: !this.UserData.user.privateUser,
          userType: this.UserData.user.role
        })
      }).then(function (response) {
        if (response.status === 200 && response.data && response.data.token) {
          _this.signupSuccess = true;
          _this.onSignupSuccess({ response: response });
          return;
        }
        return Promise.reject(response);
      }).catch(function (response) {
        _this.showErrorMessage = true;
        _this.isSubmitting = false;
        _this.errorStatus = response.status;
        _this.errorCode = response.data.error;
      });
    }
  }]);

  return flArrowAccountType;
}();

flArrowAccountType.$inject = ['$http', 'Cdn', 'UserData', 'UsersService'];

var flArrowAccountType$1 = flComponent$1(flArrowAccountType, {
  selector: 'fl-arrow-account-type',
  template: arrowAccountTypeTemplate,
  bindings: {
    steps: '=',
    signupAgreements: '=',
    showAsModal: '=',
    closeModal: '&',
    showStep: '&',
    onSignupSuccess: '&'
  },
  providers: [CdnProvider, UserData$1, UsersProvider$1]
});

var arrowConsentFormTemplate = "<div class=\"Modal-header\">\n  <div class=\"ModalLoginSignup-header\">\n    <div class=\"ModalLoginSignup-header-previousStep\"\n      ng-click=\"ArrowConsentForm.goBack()\">\n      <fl-icon class=\"ModalLoginSignup-header-previousStep-icon\"\n        name=\"ui-chevron-left\">\n      </fl-icon>\n    </div>\n    <button class=\"Modal-close\"\n      ng-if=\"ArrowConsentForm.showAsModal\"\n      ng-click=\"ArrowConsentForm.closeModal()\"\n      type=\"button\"\n      data-modal-hide aria-label=\"Close this modal window\">\n      <span class=\"Icon Icon--small\">\n        <fl-icon name=\"ui-close\"></fl-icon>\n      </span>\n    </button>\n    <div id=\"fl-logo\" class=\"ModalLoginSignup-header-logo\">\n      <fl-icon name=\"fl-arrow-logo\"></fl-icon>\n    </div>\n  </div>\n</div>\n\n<div class=\"Modal-body ModalLoginSignup-body ModalLoginSignup-body--arrow\">\n  <form name=\"ArrowConsentForm.form\"\n    class=\"recover-password-form fl-form large-form ModalLoginSignup-resetPassword-form\">\n    <aside ng-class=\"{'is-hidden': !ArrowConsentForm.showErrorMessage}\"\n      class=\"alert alert-error\">\n      <span >\n        There was a problem signing up. Please contact <a href=\"/support\">support</a> for assistance.\n      </span>\n    </aside>\n    <div class=\"form-feedback-success login-success alert alert-success\"\n      ng-if=\"ArrowConsentForm.signupSuccess\">\n      Signup Success!\n      <div class=\"Loader Loader--small\"></div>\n    </div>\n    <ol>\n      <li class=\"form-step has-label login-form-options\">\n        <h4 class=\"ModalLoginSignup-body-subheading\">\n          Email Opt-In\n        </h4>\n        <p class=\"ModalLoginSignup-body-tag\">\n          Would you like to receive marketing promotions, special offers,\n          inspirations, and updates to Freelancer’s product and policies? You can unsubscribe at any time.\n        </p>\n        <div class=\"Checkbox\">\n          <input id=\"email\"\n            class=\"Checkbox-input\"\n            type=\"checkbox\"\n            name=\"\"\n            ng-model=\"ArrowConsentForm.UserData.user.privacyConsent\"\n          />\n          <label class=\"ModalLoginSignup-body-label Checkbox-label checkbox\"\n            for=\"email\">\n            <small class=\"ModalLoginSignup-signupBaseForm-signupTerms\">\n              Yes, I want to receive emails.\n            </small>\n          </label>\n        </div>\n      </li>\n      <li class=\"form-step has-label login-form-options\">\n        <h4 class=\"ModalLoginSignup-body-subheading\">\n          Account Type\n        </h4>\n        <p class=\"ModalLoginSignup-body-tag\">\n          Do you intend to use Freelancer for personal use? Using\n          Freelancer for cases other than business may be subject to additional VAT.\n        </p>\n        <div class=\"Checkbox\">\n          <input id=\"account\"\n            class=\"Checkbox-input\"\n            type=\"checkbox\"\n            name=\"\"\n            ng-model=\"ArrowConsentForm.UserData.user.privateUser\"\n          />\n          <label class=\"Checkbox-label checkbox\"\n            for=\"account\">\n            <small class=\"ModalLoginSignup-signupBaseForm-signupTerms\">\n              Yes, I am using Freelancer for personal use.\n            </small>\n          </label>\n        </div>\n      </li>\n      <li class=\"form-step\">\n        <button id=\"signup_btn\"\n          class=\"btn btn-black btn-large btn-submit ModalLoginSignup-signupBaseForm-submitBtn\"\n          type=\"submit\"\n          ng-click=\"ArrowConsentForm.signup($event)\">\n          Sign up\n        </button>\n      </li>\n    </ol>\n  </form>\n</div>\n";

var flArrowConsentForm = function () {
  function flArrowConsentForm($http, UserData, UsersService) {
    _classCallCheck(this, flArrowConsentForm);

    this.$http = $http;
    this.UserData = UserData;
    this.UsersService = UsersService;

    this.isSubmitting = false;
    this.signupSuccess = false;
    this.showErrorMessage = false;
  }

  _createClass(flArrowConsentForm, [{
    key: 'signup',
    value: function signup($event) {
      var _this = this;

      $event.preventDefault();

      // Attempt to signup
      if (this.signupSuccess || this.isSubmitting) {
        return;
      }

      this.showErrorMessage = false;
      this.isSubmitting = true;

      return this.$http({
        method: 'POST',
        url: '/ajax/auth/arrow/signup.php',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Accept: 'application/json'
        },
        data: this.UsersService.serializeData({
          email: this.UserData.user.email,
          password: this.UserData.user.password,
          username: this.UserData.user.username,
          fullname: this.UserData.user.fullName,
          country: this.UserData.user.country,
          privacyConsent: this.UserData.user.privacyConsent,
          businessUser: !this.UserData.user.privateUser,
          userType: this.UserData.user.role
        })
      }).then(function (response) {
        if (response.status === 200 && response.data && response.data.token) {
          _this.signupSuccess = true;
          _this.onSignupSuccess({ response: response });
          return;
        }
        return Promise.reject(response);
      }).catch(function () {
        _this.showErrorMessage = true;
        _this.isSubmitting = false;
      });
    }
  }, {
    key: 'goBack',
    value: function goBack() {
      if (this.postProjectOnLogin) {
        // Account type select was skipped, so go to username input
        this.showStep(this.steps.USERNAME_INPUT);
      } else {
        this.showStep(this.steps.ACCOUNT_TYPE);
      }
    }
  }]);

  return flArrowConsentForm;
}();

flArrowConsentForm.$inject = ['$http', 'UserData', 'UsersService'];

var flArrowConsentForm$1 = flComponent$1(flArrowConsentForm, {
  selector: 'fl-arrow-consent-form',
  template: arrowConsentFormTemplate,
  providers: [UserData$1, UsersProvider$1],
  bindings: {
    steps: '=',
    signupAgreements: '=',
    showAsModal: '=',
    postProjectOnLogin: '=',
    closeModal: '&',
    showStep: '&',
    onSignupSuccess: '&'
  }
});

var arrowSignupFormTemplate = "<div class=\"Modal-header\">\n  <button class=\"Modal-close\"\n    ng-if=\"ArrowSignupForm.showAsModal\"\n    ng-click=\"ArrowSignupForm.closeModal()\"\n    type=\"button\"\n    data-modal-hide aria-label=\"Close this modal window\">\n    <span class=\"Icon Icon--small\">\n      <fl-icon name=\"ui-close\"></fl-icon>\n    </span>\n  </button>\n  <div class=\"ModalLoginSignup-header-logo\">\n    <fl-icon name=\"fl-arrow-logo\"></fl-icon>\n  </div>\n</div>\n\n<div class=\"Modal-body ModalLoginSignup-body ModalLoginSignup-body--arrow\"\n  fl-analytics-section=\"Signup\">\n  <div class=\"ModalLoginSignup-body-heading\">\n    <span>\n      Sign Up\n    </span>\n  </div>\n\n  <form id=\"signup_form\"\n    class=\"user-signup-form fl-form responsive-form\"\n    name=\"ArrowSignupForm.form\">\n    <ol>\n      <li class=\"form-step name-step\"\n        ng-class=\"{'is-invalid': ArrowSignupForm.form.fullName.$invalid && ArrowSignupForm.form.fullName.$dirty,\n                    'is-valid': ArrowSignupForm.form.fullName.$valid}\">\n        <label class=\"is-accessibly-hidden\"\n          for=\"fullName\">\n          Full Name\n        </label>\n        <input id=\"name\"\n          type=\"text\"\n          name=\"fullName\"\n          rel=\"popover\"\n          placeholder=\"Full Name\"\n          class=\"large-input\"\n          fl-focus-on=\"ArrowSignupForm.focusFullNameInput\"\n          ng-model=\"ArrowSignupForm.UserData.user.fullName\"\n          ng-required=\"true\"\n        />\n        <div ng-messages=\"ArrowSignupForm.form.fullName.$error\" tabindex=\"-1\">\n          <div class=\"form-error\" ng-message=\"required\">\n            Please provide your full name.\n          </div>\n        </div>\n      </li>\n\n      <li class=\"form-step email-step\"\n        ng-class=\"{'is-invalid': ArrowSignupForm.form.email.$invalid && ArrowSignupForm.form.email.$dirty,\n                    'is-valid': ArrowSignupForm.form.email.$valid}\">\n        <label class=\"is-accessibly-hidden\"\n          for=\"new-email\">\n          Email Address\n        </label>\n        <input id=\"new-email\"\n          class=\"large-input\"\n          type=\"text\"\n          name=\"email\"\n          rel=\"popover\"\n          placeholder=\"Email\"\n          ng-model=\"ArrowSignupForm.UserData.user.email\"\n          ng-model-options=\"{ debounce: {'default': 300, 'blur': 0}, allowInvalid: true }\"\n          ng-required=\"true\"\n          fl-email-username-valid-check=\"email\"\n          fl-blocked-email-check\n          fl-unique-email-username-check\n          fl-unique-arrow-email-check\n        />\n        <div class=\"Loader Loader--small ModalLoginSignup-inputLoader\"\n          ng-if=\"ArrowSignupForm.form.email.$pending\">\n        </div>\n        <div ng-messages=\"ArrowSignupForm.form.email.$error\" tabindex=\"-1\">\n          <div class=\"form-error\" ng-message=\"required\">\n            Please enter an email address.\n          </div>\n          <div class=\"form-error\" ng-message=\"validEmail\">\n            Please enter a valid email address.\n          </div>\n          <div class=\"form-error\" ng-message=\"unblockedEmail\">\n            This email domain is blocked. Please use a different email address.\n          </div>\n          <div class=\"form-error\" ng-message=\"uniqueEmail\">\n            This email address is already in use on the Freelancer platform.\n          </div>\n          <div class=\"form-error\" ng-message=\"uniqueArrowEmail\">\n            This email address is already in use on Arrow.com.\n          </div>\n        </div>\n      </li>\n\n      <li class=\"form-step password-step\"\n        ng-class=\"{'is-invalid': ArrowSignupForm.form.password.$invalid && ArrowSignupForm.form.password.$dirty,\n                    'is-valid': ArrowSignupForm.form.password.$valid}\">\n        <label class=\"is-accessibly-hidden\"\n          for=\"new-password\">\n          Password\n        </label>\n        <input id=\"new-password\"\n          class=\"large-input\"\n          type=\"password\"\n          name=\"password\"\n          placeholder=\"Password\"\n          ng-model=\"ArrowSignupForm.UserData.user.password\"\n          ng-required=\"true\"\n          ng-minlength=\"8\"\n          ng-maxlength=\"25\"\n          fl-arrow-password-check\n        />\n        <div ng-if=\"ArrowSignupForm.form.password.$pending\"\n          class=\"Loader Loader--small ModalLoginSignup-inputLoader\">\n        </div>\n        <div ng-messages=\"ArrowSignupForm.form.password.$error\" tabindex=\"-1\">\n          <div class=\"form-error\" ng-message=\"required\">\n            Please enter a password.\n          </div>\n          <div class=\"form-error\" ng-message=\"minlength\">\n            Password must be at least 8 characters.\n          </div>\n          <div class=\"form-error\" ng-message=\"maxlength\">\n            Password must be at most 25 characters.\n          </div>\n          <div class=\"form-error\" ng-message=\"strongArrowPassword\">\n            Password must contain a lowercase letter, an uppercase letter, and a number.\n          </div>\n          <div class=\"form-error\" ng-message=\"arrowPasswordAllowedCharacters\">\n            Password can only contain capital and lowercase letters, numbers, and the following special characters !@#$%^*()-_=+[]|;:,.&lt;&gt;/?.\n          </div>\n        </div>\n      </li>\n\n      <li class=\"form-step country-step\"\n        ng-class=\"{'is-invalid': ArrowSignupForm.form.country.$invalid && ArrowSignupForm.form.country.$dirty,\n                    'is-valid': ArrowSignupForm.form.country.$valid}\">\n        <label class=\"is-accessibly-hidden\"\n          for=\"country\">\n          Country\n        </label>\n        <select id=\"country\"\n          class=\"large-input\"\n          name=\"country\"\n          ng-options=\"country.code as country.name for country in ArrowSignupForm.countryOptions\"\n          ng-model=\"ArrowSignupForm.UserData.user.country\"\n          ng-required=\"true\"\n        >\n          <option value=\"\" selected disabled>Select a country</option>\n        </select>\n        <div ng-messages=\"ArrowSignupForm.form.country.$error\" tabindex=\"-1\">\n          <div class=\"form-error\" ng-message=\"required\">\n            Please select a country.\n          </div>\n        </div>\n      </li>\n\n      <input id=\"signup_skip_captcha\"\n        type=\"hidden\"\n        name=\"signup_skip_captcha\"\n        value=\"{{ArrowSignupForm.loginSignupConfig.getSkipCaptchaHash()}}\"\n      />\n\n      <li class=\"form-step has-label login-form-options\"\n        ng-class=\"{'is-invalid': ArrowSignupForm.form.termsAgreement.$invalid && ArrowSignupForm.form.termsAgreement.$dirty}\">\n        <div class=\"Checkbox\">\n          <input id=\"termsAgreement\"\n            class=\"Checkbox-input\"\n            type=\"checkbox\"\n            name=\"termsAgreement\"\n            ng-required=\"true\"\n            ng-model=\"ArrowSignupForm.signupAgreements.terms\"\n          />\n          <label class=\"ModalLoginSignup-body-label Checkbox-label checkbox\"\n            for=\"termsAgreement\">\n            <small class=\"ModalLoginSignup-signupBaseForm-signupTerms\">\n              By creating an account you agree to the use of your personal information in accordance with Arrow Electronics and Freelancer.com,\n              through the platform's\n              <a href='javascript: void()'\n                onclick='window.open(\n                \"/about/privacy?popup=true\",\"\",\"width=700, height=550, left=100,top=100,menu=no, toolbar=no,scrollbars=yes,resizable=yes\"\n                );return false;'>\n                Privacy Policy\n              </a>\n              and\n              <a href='#' onclick='window.open(\n                \"/info/plainterms.html\",\"\",\"width=500, height=450, left=100,top=100,menu=no, toolbar=no,scrollbars=yes,resizable=yes\"\n                );return false;'>\n                Terms of Use.\n              </a>\n            </small>\n          </label>\n        </div>\n      </li>\n\n      <li class=\"form-step has-label login-form-options\">\n        <div class=\"Checkbox\">\n          <input id=\"promotionalAgreement\"\n            class=\"Checkbox-input\"\n            type=\"checkbox\"\n            name=\"promotionalAgreement\"\n            ng-model=\"ArrowSignupForm.signupAgreements.arrowMarketing\"\n          />\n          <label class=\"Checkbox-label checkbox\"\n            for=\"promotionalAgreement\">\n            <small class=\"ModalLoginSignup-signupBaseForm-signupTerms\">\n              I would like to receive promotional email communication from Arrow.\n            </small>\n          </label>\n        </div>\n      </li>\n\n      <li class=\"form-step\">\n        <button id=\"signup_btn\"\n          type=\"submit\"\n          class=\"btn btn-black btn-large btn-submit ModalLoginSignup-signupBaseForm-submitBtn\"\n          ng-click=\"ArrowSignupForm.signup($event)\"\n          fl-analytics=\"NormalSignupEmailPassword\">\n            Sign up with Arrow\n        </button>\n      </li>\n    </ol>\n  </form>\n</div>\n";

var flArrowSignupForm = function () {
  function flArrowSignupForm($timeout, UserData) {
    var _this = this;

    _classCallCheck(this, flArrowSignupForm);

    this.$timeout = $timeout;
    this.UserData = UserData;
    this.form = {};

    // Focus on the full name input after timeout
    this.$timeout(function () {
      _this.focusFullNameInput = true;
    }, 50);
  }

  _createClass(flArrowSignupForm, [{
    key: 'signup',
    value: function signup($event) {
      $event.preventDefault();
      // Set form fields as dirty if it has any errors.
      angular.forEach(this.form.$error, function (type) {
        angular.forEach(type, function (field) {
          field.$setDirty();
        });
      });
      if (!this.form.$valid) {
        return;
      }
      this.showStep({ step: this.steps.USERNAME_INPUT });
    }
  }]);

  return flArrowSignupForm;
}();

flArrowSignupForm.$inject = ['$timeout', 'UserData'];

var flArrowSignupForm$1 = flComponent$1(flArrowSignupForm, {
  selector: 'fl-arrow-signup-form',
  template: arrowSignupFormTemplate,
  providers: [flFocusOnProvider, flArrowPasswordCheck, flBlockedEmailCheck, flEmailUsernameValidCheck$1, flUniqueEmailUsernameCheck, flUniqueArrowEmailCheck, UserData$1],
  bindings: {
    countryOptions: '=',
    signupAgreements: '=',
    steps: '=',
    showAsModal: '=',
    closeModal: '&',
    showStep: '&'
  }
});

var arrowSignupUsernameInputTemplate = "<div class=\"Modal-header\">\n  <div class=\"ModalLoginSignup-header\">\n    <div class=\"ModalLoginSignup-header-previousStep\"\n      ng-click=\"ArrowSignupUsernameInput.showStep({step: ArrowSignupUsernameInput.steps.SIGNUP_FORM})\">\n      <fl-icon class=\"ModalLoginSignup-header-previousStep-icon\"\n        name=\"ui-chevron-left\">\n      </fl-icon>\n    </div>\n    <button class=\"Modal-close\"\n      ng-if=\"ArrowSignupUsernameInput.showAsModal\"\n      ng-click=\"ArrowSignupUsernameInput.closeModal()\"\n      type=\"button\"\n      data-modal-hide aria-label=\"Close this modal window\">\n      <span class=\"Icon Icon--small\">\n        <fl-icon name=\"ui-close\"></fl-icon>\n      </span>\n    </button>\n    <div id=\"fl-logo\" class=\"ModalLoginSignup-header-logo\">\n      <fl-icon name=\"fl-arrow-logo\"></fl-icon>\n    </div>\n  </div>\n</div>\n\n<div class=\"Modal-body\"\n  fl-analytics-section=\"Signup\">\n  <h2 class=\"ModalLoginSignup-body-title ModalLoginSignup-body-title--center\">\n    Choose a username\n  </h2>\n    <aside ng-class=\"{'is-hidden': !ArrowSignupUsernameInput.showErrorMessage}\"\n      class=\"alert alert-error\">\n      <span ng-if=\"ArrowSignupUsernameInput.errorCode === 'EXTERNAL_AW_LINK_EXISTING_FLN'\">\n        Sorry we were unable to create your account, there was a Freelancer account under the same email address. Please contact <a href=\"/support\">support</a>.\n      </span>\n      <span ng-if=\"ArrowSignupUsernameInput.errorCode === 'EXTERNAL_AW_USER_EXISTS'\">\n        An account with this email already exists on Arrow.com. Please login with your account details.\n      </span>\n      <span ng-if=\"ArrowSignupUsernameInput.errorStatus === 429\">\n        You are performing too many requests. Please try again later.\n      </span>\n      <span ng-if=\"ArrowSignupUsernameInput.errorStatus !== 429 &&\n        ArrowSignupUsernameInput.errorCode !== 'EXTERNAL_AW_LINK_EXISTING_FLN' &&\n        ArrowSignupUsernameInput.errorCode !== 'EXTERNAL_AW_USER_EXISTS'\">\n        There was a problem signing up. Please contact <a href=\"/support\">support</a> for assistance.\n      </span>\n    </aside>\n    <div class=\"form-feedback-success login-success alert alert-success\"\n      ng-if=\"ArrowSignupUsernameInput.signupSuccess\">\n      Signup Success!\n      <div class=\"Loader Loader--small\"></div>\n    </div>\n  <p class=\"ModalLoginSignup-body-subtitle\">\n    Please note that a username cannot be changed, once chosen.\n  </p>\n  <form class=\"user-signup-form fl-form responsive-form\"\n    name=\"ArrowSignupUsernameInput.form\">\n    <div class=\"form-step email-step\"\n      ng-class=\"{'is-invalid': ArrowSignupUsernameInput.form.username.$invalid && ArrowSignupUsernameInput.form.username.$dirty,\n                  'is-valid': ArrowSignupUsernameInput.form.username.$valid}\">\n      <label class=\"is-accessibly-hidden\"\n        for=\"new-username\">\n        Username\n      </label>\n      <input id=\"new-username\"\n        class=\"large-input\"\n        type=\"text\"\n        name=\"username\"\n        rel=\"popover\"\n        placeholder=\"Username\"\n        ng-model=\"ArrowSignupUsernameInput.UserData.user.username\"\n        ng-model-options=\"{ debounce: {'default': 300, 'blur': 0} }\"\n        ng-required=\"true\"\n        ng-minlength=\"3\"\n        ng-maxlength=\"16\"\n        fl-email-username-valid-check=\"username\"\n        fl-unique-email-username-check=\"username\"\n        fl-focus-on=\"ArrowSignupUsernameInput.focusUsernameInput\">\n      <div class=\"Loader Loader--small ModalLoginSignup-inputLoader\"\n        ng-if=\"ArrowSignupUsernameInput.form.username.$pending\">\n      </div>\n      <div ng-messages=\"ArrowSignupUsernameInput.form.username.$error\" tabindex=\"-1\">\n        <div class=\"form-error\" ng-message=\"required\">\n          Please enter a username.\n        </div>\n        <div class=\"form-error\" ng-message=\"minlength\">\n          Please enter at least 3 characters.\n        </div>\n        <div class=\"form-error\" ng-message=\"maxlength\">\n          Please enter at most 16 characters.\n        </div>\n        <div class=\"form-error\" ng-message=\"validUsername\">\n          Username must be alphanumeric starting with a letter.\n        </div>\n        <div class=\"form-error\" ng-message=\"uniqueUsername\">\n          This username already exists, please choose another.\n        </div>\n        <div class=\"form-error\" ng-message=\"uniqueFromPassword\">\n          Username must be different to password.\n        </div>\n      </div>\n      <div id=\"new-username-suggestion\"\n        class=\"ModalLoginSignup-signupUsernameInput-suggestions\"\n        ng-if=\"ArrowSignupUsernameInput.usernameSuggestions\">\n        <span class=\"ModalLoginSignup-signupUsernameInput-suggestionTitle\">\n          Suggestions:\n        </span>\n        <span ng-repeat=\"name in ArrowSignupUsernameInput.usernameSuggestions\">\n          <a ng-click=\"ArrowSignupUsernameInput.updateUsername(name)\">\n            {{name}}\n          </a>\n          <span class=\"ModalLoginSignup-signupUsernameInput-suggestions-separator\"\n            ng-show=\"!$last\">\n            /\n          </span>\n        </span>\n      </div>\n    </div>\n    <button class=\"btn btn-black btn-large ModalLoginSignup-signupUsernameInput-submitBtn\"\n      ng-disabled=\"ArrowSignupUsernameInput.isSubmitting\"\n      ng-click=\"ArrowSignupUsernameInput.signup($event)\"\n      fl-analytics=\"NormalSignupUsername\">\n      Next\n      <span class=\"Loader Loader--small\"\n        ng-if=\"ArrowSignupUsernameInput.isSubmitting\">\n      </span>\n    </button>\n  </form>\n</div>\n";

var flArrowSignupUsernameInput = function () {
  function flArrowSignupUsernameInput($http, $timeout, Users, UserData, UsersService) {
    var _this = this;

    _classCallCheck(this, flArrowSignupUsernameInput);

    this.$http = $http;
    this.$timeout = $timeout;
    this.Users = Users;
    this.UserData = UserData;
    this.UsersService = UsersService;

    this.isSubmitting = false;
    this.signupSuccess = false;
    this.showErrorMessage = false;

    this.generateSuggestedUsernames();

    this.$timeout(function () {
      _this.focusUsernameInput = true;
    }, 50);
  }

  _createClass(flArrowSignupUsernameInput, [{
    key: 'signup',
    value: function signup($event) {
      var _this2 = this;

      $event.preventDefault();

      if (!this.form.$valid || this.signupSuccess || this.isSubmitting) {
        return;
      }

      // If posting a project, skip account type step and set to 'Employer'
      if (this.postProjectOnLogin) {
        this.UserData.user.role = 'Employer';
      } else {
        this.showStep({ step: this.steps.ACCOUNT_TYPE });
        return;
      }

      // Check if user is from the EU. If they are, we show the consent form,
      // otherwise we attempt to sign up.
      if (this.UserData.user.isFromEU) {
        this.showStep({ step: this.steps.CONSENT_FORM });
        return;
      }

      this.isSubmitting = true;

      return this.$http({
        method: 'POST',
        url: '/ajax/auth/arrow/signup.php',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Accept: 'application/json'
        },
        data: this.UsersService.serializeData({
          email: this.UserData.user.email,
          password: this.UserData.user.password,
          username: this.UserData.user.username,
          fullname: this.UserData.user.fullName,
          country: this.UserData.user.country,
          privacyConsent: this.UserData.user.privacyConsent,
          businessUser: !this.UserData.user.privateUser,
          userType: this.UserData.user.role
        })
      }).then(function (response) {
        if (response.status === 200 && response.data && response.data.token) {
          _this2.signupSuccess = true;
          _this2.onSignupSuccess({ response: response });
          return;
        }
        return Promise.reject(response);
      }).catch(function (response) {
        _this2.showErrorMessage = true;
        _this2.isSubmitting = false;
        _this2.errorStatus = response.status;
        _this2.errorCode = response.data.error;
      });
    }
  }, {
    key: 'generateSuggestedUsernames',
    value: function generateSuggestedUsernames() {
      var _this3 = this;

      this.Users.check({ email: this.UserData.user.email }, { recommend_name: true }).then(function (result) {
        _this3.usernameSuggestions = [];
        _this3.usernameSuggestions.push(result.recommended_name);
        _this3.usernameSuggestions = _this3.usernameSuggestions.concat(result.alternate_names);
      });
    }
  }, {
    key: 'updateUsername',
    value: function updateUsername(name) {
      this.form.username.$setDirty();
      this.UserData.user.username = name;
    }
  }]);

  return flArrowSignupUsernameInput;
}();

flArrowSignupUsernameInput.$inject = ['$http', '$timeout', 'Users', 'UserData', 'UsersService'];

var flArrowSignupUsernameInput$1 = flComponent$1(flArrowSignupUsernameInput, {
  selector: 'fl-arrow-signup-username-input',
  template: arrowSignupUsernameInputTemplate,
  provider: [flFocusOnProvider, flEmailUsernameValidCheck$1, flUniqueEmailUsernameCheck, UserData$1, UsersProvider, UsersProvider$1],
  bindings: {
    steps: '=',
    signupAgreements: '=',
    showAsModal: '=',
    postProjectOnLogin: '=',
    closeModal: '&',
    showStep: '&',
    onSignupSuccess: '&'
  }
});

var arrowSignupSuccessTemplate = "<div class=\"Modal-header\">\n  <div class=\"ModalLoginSignup-header\">\n    <button class=\"Modal-close\"\n      ng-click=\"ArrowSignupSuccess.closeModal($event)\"\n      type=\"button\"\n      data-modal-hide aria-label=\"Close this modal window\"\n      ng-if=\"ArrowSignupSuccess.showAsModal\">\n      <span class=\"Icon Icon--small\">\n        <fl-icon name=\"ui-close\"></fl-icon>\n      </span>\n    </button>\n    <div id=\"fl-logo\" class=\"ModalLoginSignup-header-logo\">\n      <fl-icon name=\"fl-arrow-logo\"></fl-icon>\n    </div>\n  </div>\n</div>\n\n<div class=\"Modal-body\"\n  fl-analytics-section=\"ArrowLogin\">\n  <div class=\"ModalLoginSignup-loginSuccess\">\n    <h2 class=\"ModalLoginSignup-body-title\">Signup Success!</h2>\n    <p class=\"ModalLoginSignup-body-subtitle\">Please wait while we redirect you...</p>\n    <div class=\"ModalLoginSignup-signupSuccess-spinner\">\n      <div class=\"Loader Loader--large\"></div>\n    </div>\n  </div>\n</div>\n";

var flArrowSignupSuccess = function flArrowSignupSuccess() {
  _classCallCheck(this, flArrowSignupSuccess);
};

var flArrowSignupSuccess$1 = flComponent$1(flArrowSignupSuccess, {
  selector: 'fl-arrow-signup-success',
  template: arrowSignupSuccessTemplate,
  bindings: {
    showAsModal: '=',
    closeModal: '&'
  }
});

var arrowSignupTemplate = "<fl-arrow-signup-form\n  ng-if=\"ArrowSignup.currentStep === ArrowSignup.steps.SIGNUP_FORM\"\n  show-as-modal=\"ArrowSignup.showAsModal\"\n  close-modal=\"ArrowSignup.closeModal()\"\n  steps=\"ArrowSignup.steps\"\n  show-step=\"ArrowSignup.showStep(step)\"\n  signup-agreements=\"ArrowSignup.signupAgreements\"\n  country-options=\"ArrowSignup.countryOptions\"\n></fl-arrow-signup-form>\n<fl-arrow-signup-username-input\n  ng-if=\"ArrowSignup.currentStep === ArrowSignup.steps.USERNAME_INPUT\"\n  show-as-modal=\"ArrowSignup.showAsModal\"\n  close-modal=\"ArrowSignup.closeModal()\"\n  steps=\"ArrowSignup.steps\"\n  show-step=\"ArrowSignup.showStep(step)\"\n  signup-agreements=\"ArrowSignup.signupAgreements\"\n  on-signup-success=\"ArrowSignup.onSignupSuccess(response)\"\n  post-project-on-login=\"ArrowSignup.postProjectOnLogin\"\n></fl-arrow-signup-username-input>\n<fl-arrow-account-type\n  ng-if=\"ArrowSignup.currentStep === ArrowSignup.steps.ACCOUNT_TYPE\"\n  show-as-modal=\"ArrowSignup.showAsModal\"\n  close-modal=\"ArrowSignup.closeModal()\"\n  steps=\"ArrowSignup.steps\"\n  show-step=\"ArrowSignup.showStep(step)\"\n  signup-agreements=\"ArrowSignup.signupAgreements\"\n  on-signup-success=\"ArrowSignup.onSignupSuccess(response)\"\n></fl-arrow-account-type>\n<fl-arrow-consent-form\n  ng-if=\"ArrowSignup.currentStep === ArrowSignup.steps.CONSENT_FORM\"\n  show-as-modal=\"ArrowSignup.showAsModal\"\n  close-modal=\"ArrowSignup.closeModal()\"\n  steps=\"ArrowSignup.steps\"\n  show-step=\"ArrowSignup.showStep(step)\"\n  signup-agreements=\"ArrowSignup.signupAgreements\"\n  on-signup-success=\"ArrowSignup.onSignupSuccess(response)\"\n  post-project-on-login=\"ArrowSignup.postProjectOnLogin\"\n></fl-arrow-consent-form>\n<fl-arrow-signup-success\n  ng-if=\"ArrowSignup.currentStep === ArrowSignup.steps.SIGNUP_SUCCESS\"\n  show-as-modal=\"ArrowSignup.showAsModal\"\n  close-modal=\"ArrowSignup.closeModal()\"\n></fl-arrow-signup-success>\n\n<div class=\"Modal-footer\">\n  <div ng-messages=\"ArrowSignup.error\">\n    <div ng-message=\"accessDenied\" class=\"alert alert-error\">\n      There was a problem logging in with your account. Please contact <a href=\"/support\">support</a>.\n    </div>\n    <div ng-message=\"internalError\" class=\"alert alert-error\">\n      Something went wrong. Please try again.\n    </div>\n  </div>\n  <div class=\"ModalLoginSignup-switchLoginSignupType\"\n    ng-if=\"ArrowSignup.currentStep === ArrowSignup.steps.SIGNUP_FORM\">\n    Already have an account on Arrow.com?\n    <a class=\"ModalLoginSignup--switchToLogin-link\"\n      ng-click=\"ArrowSignup.showLoginForm()\">\n      Log In\n    </a>\n  </div>\n</div>\n";

var flArrowSignup = function () {
  function flArrowSignup($http, $window, Auth, CookieStore, LoginSignupConfig, UserData, UsersService) {
    _classCallCheck(this, flArrowSignup);

    this.$http = $http;
    this.$window = $window;
    this.Auth = Auth;
    this.CookieStore = CookieStore;
    this.loginSignupConfig = LoginSignupConfig;
    this.UserData = UserData;
    this.UsersService = UsersService;
    this.steps = {
      SIGNUP_FORM: 1,
      USERNAME_INPUT: 2,
      ACCOUNT_TYPE: 3,
      CONSENT_FORM: 4,
      SIGNUP_SUCCESS: 5
    };
    this.currentStep = this.steps.SIGNUP_FORM;

    this.signupAgreements = {
      terms: false,
      arrowMarketing: false
    };

    // Check if user is from the EU
    if (this.CookieStore.get(IS_FROM_EU_COOKIE_KEY) === 'true') {
      this.UserData.user.isFromEU = true;
      this.UserData.user.privacyConsent = false;
    } else {
      this.UserData.user.isFromEU = false;
      this.UserData.user.privacyConsent = true;
    }

    this.urlParams = new Map(window.location.search.slice(1).split('&').map(function (kv) {
      return kv.split('=');
    }));

    // Check if the user is posting a project on signup
    this.postProjectOnLoginObject = JSON.parse(window.localStorage.getItem('postProjectObject'));
    this.postProjectOnLogin = this.urlParams.get('postProjectOnLogin') === 'true' && this.postProjectOnLoginObject && this.postProjectOnLoginObject['logged-out'];

    this.getCountryOptions();
  }

  _createClass(flArrowSignup, [{
    key: 'onSignupSuccessRedirect',
    value: function onSignupSuccessRedirect() {
      var _this = this;

      this.UsersService.getSignupRedirectUrl(this.loginSignupConfig.isRedirectDisabled(), this.loginSignupConfig.isModal(), this.loginSignupConfig.getRedirectUrl(), this.loginSignupConfig.getProjectCollaborationInvitation(), this.loginSignupConfig.getContestCollaborationInvitation()).then(function (response) {
        if (response.data) {
          var redirectUrl = response.data.redirect_url;

          if (redirectUrl === 'reload') {
            _this.$window.location.reload();
          } else if (redirectUrl !== '') {
            if (!redirectUrl.includes('?')) {
              redirectUrl = redirectUrl + '?';
            }

            _this.$window.location.href = redirectUrl + '&new_signup=true';
          }
        }
      }).catch(function () {
        _this.$window.location.href = '/dashboard';
      });

      // Close the modal only if there is no redirects
      if (this.loginSignupConfig.isRedirectDisabled()) {
        this.closeModal();
      }
    }
  }, {
    key: 'onSignupSuccess',
    value: function onSignupSuccess(response) {
      var _this2 = this;

      this.showStep(this.steps.SIGNUP_SUCCESS);

      return new Promise(function (resolve) {
        _this2.setCookiesOnSignup(response);
        resolve();
      }).then(function () {
        return _this2.UsersService.crossDomainSSO({
          data: {
            token: _this2.Auth.getAccessToken(),
            user: _this2.Auth.getUserId()
          }
        }, true);
      }).then(function () {
        return new Promise(function (resolve) {
          _this2.loginSignupConfig.resolveAuth(_this2.loginSignupConfig.authMessages.LOGIN_SUCCESS);
          resolve();
        });
      }).then(function () {
        return new Promise(function (resolve) {
          if (_this2.postProjectOnLogin) {
            // Post a project
            _this2.postProject(_this2.postProjectOnLoginObject['logged-out'].item).then(function (response) {
              var project = response.data.result;

              // Clear draft of the just posted project if it is in localStorage
              var draftProject = JSON.parse(window.localStorage.getItem('arrowPostProjectDraft'));
              if (draftProject) {
                delete draftProject['logged-out'];
                window.localStorage.setItem('arrowPostProjectDraft', JSON.stringify(draftProject));
              }

              // Clear localStorage entry of object that was just posted
              delete _this2.postProjectOnLoginObject['logged-out'];
              window.localStorage.setItem('postProjectObject', JSON.stringify(_this2.postProjectOnLoginObject));
              // Redirect to PVP
              _this2.$window.location.href = '/projects/' + project.id;
              resolve();
            }).catch(function () {
              // TODO: Redirect to PJP, populate with draft data, and then show
              // error message. If funds are required for upgrades, do something else

              // Clear localStorage entry of project so it doesn't randomly get posted later
              delete _this2.postProjectOnLoginObject['logged-out'];
              window.localStorage.setItem('postProjectObject', JSON.stringify(_this2.postProjectOnLoginObject));
              _this2.$window.location.href = '/dashboard';
            });
          } else {
            resolve();
          }
        });
      }).then(function () {
        _this2.onSignupSuccessRedirect();
      });
    }
  }, {
    key: 'postProject',
    value: function postProject(project) {
      var _this3 = this;

      var projectData = {
        title: project.title,
        description: project.description,
        currency: { id: project.currency.id },
        budget: {
          minimum: project.budget.minimum,
          maximum: project.budget.maximum,
          currency_id: project.currency.id,
          project_type: project.type
        },
        jobs: project.jobs,
        type: project.type,
        hourly_project_info: project.type === 'hourly' ? project.hourlyProjectInfo : undefined,
        hireme: project.hireme,
        location: project.local ? project.location : undefined,
        upgrades: _extends({}, project.upgrades, {
          recruiter: project.upgrades.assisted,
          project_management: project.upgrades.projectManagement,
          ip_contract: project.upgrades.ipContract
        }),
        nda_details: {
          hidden_description: project.ndaDetails.hiddenDescription
        },
        files: project.files
      };

      return new Promise(function (resolve, reject) {
        _this3.$http({
          method: 'POST',
          url: '/api/projects/0.1/projects/',
          data: projectData,
          headers: {
            'Content-type': 'application/json'
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    }
  }, {
    key: 'setCookiesOnSignup',
    value: function setCookiesOnSignup(response) {
      this.Auth.set(response.data.token, response.data.user, true);
      this.UsersService.setExtraCookies();
      // TODO: Set any other AFLN specific cookies (ARROW_FED_AUTH_TOKEN)
      this.setExternalCookies(response);
    }
  }, {
    key: 'setExternalCookies',
    value: function setExternalCookies(response) {
      Object.values(response.data.external_cookies).forEach(function (cookie) {
        var expireDate = new Date(cookie.expiry * 1000);
        var expireMinutes = (expireDate - new Date()) / 1000 / 60;
        setCookieToBrowser(cookie.name, cookie.value, 0, '/', cookieDomain, expireMinutes);
      });
    }

    // Get a list of countries to show on the dropdown in the signup form

  }, {
    key: 'getCountryOptions',
    value: function getCountryOptions() {
      var _this4 = this;

      this.$http.get('/ajax/user/getCountries.php').then(function (response) {
        var countryMap = response.data.data;
        _this4.countryOptions = Object.keys(countryMap).map(function (key) {
          return {
            name: key,
            code: countryMap[key]
          };
        });
      });
    }
  }, {
    key: 'showStep',
    value: function showStep(step) {
      this.currentStep = step;
    }
  }, {
    key: 'showLoginForm',
    value: function showLoginForm() {
      this.loginSignupConfig.switchToLogin();
    }
  }]);

  return flArrowSignup;
}();

flArrowSignup.$inject = ['$http', '$window', 'Auth', 'CookieStore', 'LoginSignupConfig', 'UserData', 'UsersService'];

var flArrowSignup$1 = flComponent$1(flArrowSignup, {
  selector: 'fl-arrow-signup',
  template: arrowSignupTemplate,
  providers: [flArrowAccountType$1, flArrowConsentForm$1, flArrowSignupForm$1, flArrowSignupUsernameInput$1, flArrowSignupSuccess$1, AuthModule, CookieStoreProvider$1, LoginSignupConfigProvider, UserData$1, UsersProvider$1],
  bindings: {
    showAsModal: '=',
    closeModal: '&'
  }
});

/**
* @ngdoc service
* @name flFacebook.FacebookSDK
*
* @description
* Angular wrapper around the Facebook API, providing access to all the
* Facebook JS SDK APIs within the Angular context & returning Promises instead
* of callbacks. This service is currently implemented using "ezfb". Please
* prefer the use of the higher level Facebook service over that one.
*/

var FacebookSDK = function FacebookSDK(ezfb) {
  _classCallCheck(this, FacebookSDK);

  return ezfb;
};

FacebookSDK.$inject = ['ezfb'];

var FacebookSDKModule = flService('FacebookSDK', ['ezfb', OPAQUE_MODULE_NAME], FacebookSDK);

angular.module(FacebookSDKModule).config(['ezfbProvider', 'FACEBOOK_APP_ID', function (ezfbProvider, FACEBOOK_APP_ID) {
  ezfbProvider.setInitParams({
    appId: FACEBOOK_APP_ID,
    xfbml: false,
    version: 'v3.2'
  });
}]);

var _templateObject$10 = _taggedTemplateLiteral(['\n        ', '://\n        ', '\n        ', '\n        ', '', ''], ['\n        ', '://\n        ', '\n        ', '\n        ', '', '']),
    _templateObject2$4 = _taggedTemplateLiteral(['\n        https://www.facebook.com/dialog/oauth?client_id=\n        ', '\n        &redirect_uri=', '\n        &scope=', ''], ['\n        https://www.facebook.com/dialog/oauth?client_id=\n        ', '\n        &redirect_uri=', '\n        &scope=', '']);

/**
  * @ngdoc service
  * @name flFacebook.Facebook
  *
  * @description
  * Provides high level Facebook functionality. Your controllers should prefer
  * using this service instead of Facebook SDK as it abstracts Facebook SDK's
  * internal complexity.
  */

var FacebookProvider = function () {
  function FacebookProvider($q, $window, $location, FacebookSDK, FACEBOOK_APP_ID) {
    _classCallCheck(this, FacebookProvider);

    this.$q = $q;
    this.$window = $window;
    this.$location = $location;
    this.FacebookSDK = FacebookSDK;
    this.FACEBOOK_APP_ID = FACEBOOK_APP_ID;
  }
  /**
  * @ngdoc method
  * @name flFacebook.Facebook#getLoginStatus
  * @methodOf flFacebook.Facebook
  *
  * @description
  * Check if the user is currently connected with Facebook.
  *
  * @returns {Object} a Promise object that will be resolved with an
  * AuthResponse object from the Facebook API. This object can then be
  * passed to the Auth Service's loginWithFacebook API to login the
  * user into Freelancer or the Users Service's createWithFacebook to
  * create a new user account. On failure, an error object with a "code"
  * key of 'NOT_AUTHORISED' or 'NOT_CONNECTED' will be returned.
  */


  _createClass(FacebookProvider, [{
    key: 'checkConnected',
    value: function checkConnected() {
      var _this = this;

      return this.FacebookSDK.getLoginStatus().then(function (response) {
        // Ask user to login if they are not signed into facebook
        if (response.status === 'connected') {
          return _this.$q.when(response.authResponse);
        } else if (response.status === 'not_authorized') {
          return _this.$q.reject({ code: 'NOT_AUTHORISED' });
        }

        return _this.$q.reject({ code: 'NOT_CONNECTED' });
      });
    }
    /**
    * @ngdoc method
    * @name flFacebook.Facebook#login
    * @methodOf flFacebook.Facebook
    *
    * @description
    * Prompt the user, if required, to login to his Facebook account &
    * authorize Freelancer to access his profile.
    *
    * @param {Array} scope Array of permission strings. Calling this
    * function with new permissions will prompt the user to accept them.
    * These permissions will be added to the default ones (user_location,
    * user_website, email, user_birthday).
    *
    * @returns {Object} a Promise object that will be resolved with an
    * AuthResponse object from the Facebook API. This object can then be
    * passed to the Auth Service's loginWithFacebook API to login the
    * user into Freelancer or the Users Service's createWithFacebook to
    * create a new user account. On failure, an error object with a "code"
    * key of 'NOT_AUTHORISED' or 'NOT_CONNECTED' will be returned.
    * WARNING: For Chrome on iOS (userAgent detected), the user would be
    * redirect to Facebook & redirected back to the current page with the
    * "facebook_redirect" appended to it. This is needed to fix
    * http://stackoverflow.com/questions/16843116/
    * facebook-oauth-unsupported-in-chrome-on-ios
    */

  }, {
    key: 'login',
    value: function login(permissions) {
      var _this2 = this;

      var s = ['email', 'public_profile'];
      var scope = s.concat(permissions);
      // The redirect method is needed to fix
      // http://stackoverflow.com/questions/16843116/
      // facebook-oauth-unsupported-in-chrome-on-ios
      // Also for the installable web app when launched specifically on iOS
      if (this.$window.navigator.userAgent.match('CriOS') || this.$window.navigator.standalone) {
        // Exclusive to iOS
        // Add the "facebook_redirect" search param to the current query
        // string to allow the app to identify the redirect
        var queryString = this.$window.location.search;
        // TODO: a proper URL lib would probably be nicer
        var redirectQueryString = queryString ? queryString + '&facebook_redirect' : '?facebook_redirect';
        var redirectUrl = oneLineTrim(_templateObject$10, this.$location.protocol(), this.$location.host(), this.$location.path(), redirectQueryString, this.$location.hash());
        // Do redirect the user.
        this.$window.location.href = oneLineTrim(_templateObject2$4, this.FACEBOOK_APP_ID, encodeURIComponent(redirectUrl), scope.join(','));
        // Do not return a state as user is going to be redirected
        return this.$q.defer().promise;
      }
      return this.FacebookSDK.login(null, {
        scope: scope.join(', ')
      }).then(function (response) {
        // Make sure the user has authorised Facebook
        if (response.status === 'connected') {
          return _this2.$q.when(response.authResponse);
        } else if (response.status === 'not_authorized') {
          return _this2.$q.reject({ code: 'NOT_AUTHORISED' });
        }
        return _this2.$q.reject({ code: 'NOT_CONNECTED' });
      });
    }
    /**
    * @ngdoc method
    * @name flFacebook.Facebook#getUser
    * @methodOf flFacebook.Facebook
    *
    * @description
    * Get the Facebook Graph API user object of the currently connected
    * user, or an error object with a "code" key of 'NOT_AUTHORISED' or
    * 'NOT_CONNECTED' on error.
    *
    * @returns {Object} a Promise object that will be resolved with an
    * Faceook Graph API User Object. The exact fields of the user object
    * are determined by the requested permissions on login.
    */

  }, {
    key: 'getUser',
    value: function getUser() {
      var _this3 = this;

      var fields = ['first_name', 'email'];
      return this.checkConnected().then(function () {
        return _this3.FacebookSDK.api('/me', { fields: fields.join(', ') });
      });
    }
    /**
    * @ngdoc method
    * @name flFacebook.Facebook#getUserPictureUrl
    * @methodOf flFacebook.Facebook
    *
    * @description
    * Get the profile picture URL on the currently connected user, or an error
    * object with a "code" key of 'NOT_AUTHORISED' or 'NOT_CONNECTED' on error
    *
    * @param {int} height Request a profile picture with a specific height
    * @param {int} width Request a profile picture with a specific width
     * @returns {String} a Promise object that will be resolved with the URL
    * of the user's profile picture. The dimession of the picture are
    * determined by the height & width paramaters and default to Facebook
    * default size if unspecified.
    */

  }, {
    key: 'getUserPictureUrl',
    value: function getUserPictureUrl(height, width) {
      var _this4 = this;

      var params = height ? '&height=' + height : '';
      params += width ? '&width=' + width : '';
      return this.checkConnected().then(function () {
        return _this4.FacebookSDK.api('/me/picture?redirect=false' + params);
      }).then(function (response) {
        return response.data.url;
      });
    }
  }]);

  return FacebookProvider;
}();

FacebookProvider.$inject = ['$q', '$window', '$location', 'FacebookSDK', 'FACEBOOK_APP_ID'];


var FacebookProvider$1 = flService('Facebook', [FacebookSDKModule, OPAQUE_MODULE_NAME], FacebookProvider);

var template$3 = "<div class=\"Modal-header\">\n  <button class=\"Modal-close\" ng-click=\"LoginForm.closeModal()\" type=\"button\" data-modal-hide aria-label=\"Close this modal window\"\n      ng-if=\"LoginForm.showAsModal\">\n      <span class=\"Icon Icon--small\">\n        <fl-icon name=\"ui-close\"></fl-icon>\n      </span>\n  </button>\n  <div class=\"ModalLoginSignup-header-logo\">\n      <fl-icon name=\"fl-logo\"></fl-icon>\n  </div>\n</div>\n<div class=\"Modal-body\" fl-analytics-section=\"Login\">\n    <div class=\"ModalLoginSignup-body-heading\">\n      <span ng-if=\"!LoginForm.loginSignupConfig.getLoginTitle()\">\n        Welcome Back\n      </span>\n      <span ng-if=\"LoginForm.loginSignupConfig.getLoginTitle()\">\n        {{LoginForm.loginSignupConfig.getLoginTitle()}}\n      </span>\n    </div>\n    <form class=\"user-login-form fl-form large-form responsive-form\">\n        <div ng-messages=\"LoginForm.fbError\">\n            <div ng-message=\"facebookNotAuthorized\" class=\"alert alert-error\">\n                Please authorize Freelancer to access your Facebook account in order to login with Facebook\n            </div>\n            <div ng-message=\"facebookNotConnected\" class=\"alert alert-error\">\n                Please connect with your Facebook account or login below\n            </div>\n            <div ng-message=\"facebookRateLimit\" class=\"alert alert-error\">\n              You are performing too many requests. Please try again later.\n            </div>\n            <div ng-message=\"facebookClosed\" class=\"alert alert-error\">\n              This account has been closed. Please contact <a href=\"/support\">support</a> for more assistance.\n            </div>\n            <div ng-message=\"facebookAccessDenied\" class=\"alert alert-error\">\n                There was a problem logging in with your account. Please contact <a href=\"/support\">support</a>.\n            </div>\n            <div ng-message=\"facebookUnknownError\" class=\"alert alert-error\">\n                Failed to connect with Facebook. Please try again.\n            </div>\n        </div>\n        <button ng-if=\"!LoginForm.loginSignupConfig.isHideFb()\"\n            ng-click=\"LoginForm.fbLogin()\"\n            class=\"btn-facebook btn btn-large ModalLoginSignup-facebook-connect\"\n            data-uitest-target=\"facebook-login-button\"\n            fl-analytics=\"FBLogin\">\n            <div class=\"ModalLoginSignup-facebook-container\">\n                <span class=\"ModalLoginSignup-facebook-icon btn-facebook-icon Icon Icon--large Icon--light\">\n                    <fl-icon name=\"ui-facebook\"></fl-icon>\n                </span>\n                <div>Login with Facebook</div>\n            </div>\n        </button>\n    </form>\n    <div class=\"hr-divider\" ng-if=\"!LoginForm.loginSignupConfig.isHideFb()\"><span class=\"hr-divider-text\">OR</span></div>\n    <form name=\"LoginForm.form\" class=\"user-login-form fl-form large-form responsive-form\">\n        <aside ng-class=\"{'is-hidden': !LoginForm.showErrorMessage}\"\n            class=\"alert alert-error\">\n            <span ng-if=\"LoginForm.errorStatus === 401 && LoginForm.errorCode === 'ExceptionCodes.MISSING_USER'\">Incorrect username or password provided.</span>\n            <span ng-if=\"LoginForm.errorStatus === 401 && LoginForm.errorCode === 'Closed'\">This account has been closed. Please contact <a href=\"/support\">support</a> for more assistance.</span>\n            <span ng-if=\"LoginForm.errorStatus === 401 && LoginForm.errorCode === 'ExceptionCodes.BLOCKED_TWO_FACTOR'\">\n                We have detected your log in from a new device. Please check your email to continue.\n            </span>\n            <span ng-if=\"(\n                    LoginForm.errorStatus === 401\n                    && LoginForm.errorCode !== 'ExceptionCodes.MISSING_USER'\n                    && LoginForm.errorCode !== 'Closed'\n                    && LoginForm.errorCode !== 'ExceptionCodes.BLOCKED_TWO_FACTOR'\n                )\n                || LoginForm.errorStatus === 500\">\n                There was a problem logging in with your account. Please contact <a href=\"/support\">support</a>.<br/>Request ID: {{LoginForm.requestId}}\n            </span>\n            <span ng-if=\"LoginForm.errorStatus === 429\">You are performing too many requests. Please try again later.</span>\n        </aside>\n        <div ng-if=\"LoginForm.loginSuccess\"\n          class=\"form-feedback-success login-success alert alert-success\">\n          Login Success!\n          <div class=\"Loader Loader--small\"></div>\n        </div>\n        <fieldset>\n            <ol>\n                <li ng-class=\"{'is-invalid': LoginForm.form.username.$invalid && LoginForm.form.username.$dirty}\"\n                    class=\"form-step username-step\">\n                    <label for=\"username\" class=\"is-accessibly-hidden\">Username</label>\n                    <input id=\"username\" name=\"username\" type=\"text\"\n                      placeholder=\"Email or Username\" maxlength=\"150\" class=\"large-input\"\n                      ng-model=\"LoginForm.UserData.user.username\"\n                      ng-model-options=\"{ debounce: {'default': 300, 'blur': 0}, allowInvalid: true }\"\n                      ng-required=\"true\"\n                      ng-change=\"LoginForm.hideErrorMessage()\"\n                      fl-email-username-valid-check\n                      fl-focus-on=\"LoginForm.focusEmailInput\" />\n                    <div ng-messages=\"LoginForm.form.username.$error\" tabindex=\"-1\">\n                        <div class=\"form-error\" ng-message=\"required\">\n                            Please enter your username or email address.\n                        </div>\n                        <div class=\"form-error\" ng-message=\"validEmailUsername\">\n                            Please enter a valid username or email address.\n                        </div>\n                    </div>\n                </li>\n                <li ng-class=\"{'is-invalid': LoginForm.form.password.$invalid && LoginForm.form.password.$dirty}\"\n                  class=\"form-step password-step\">\n                    <label for=\"password\" class=\"is-accessibly-hidden\">Password</label>\n                    <input id=\"password\" name=\"password\" type=\"password\"\n                      placeholder=\"Password\" maxlength=\"150\" class=\"large-input\"\n                      ng-model=\"LoginForm.UserData.user.password\"\n                      ng-required=\"true\"/>\n                    <div ng-messages=\"LoginForm.form.password.$error\" tabindex=\"-1\">\n                        <div class=\"form-error\" ng-message=\"required\">\n                            Please enter your password.\n                        </div>\n                    </div>\n                </li>\n                <li class=\"form-step has-label login-form-options\">\n                    <a ng-click=\"LoginForm.showResetPasswordForm()\" class=\"login-form-forgot forgot-password\" fl-analytics=\"ForgotPassword\">\n                        Forgot Password?\n                    </a>\n                    <div class=\"Checkbox\">\n                        <input ng-model=\"LoginForm.rememberLogin\" id=\"loginpermanent\" class=\"Checkbox-input\" type=\"checkbox\" name=\"remember\" />\n                        <label class=\"Checkbox-label checkbox\" for=\"loginpermanent\">\n                            Remember me\n                        </label>\n                    </div>\n                </li>\n                <li class=\"form-step\">\n                    <button ng-click=\"LoginForm.login($event)\"\n                        id=\"login_btn\"\n                        ng-disabled=\"LoginForm.isSubmitting\"\n                        type=\"submit\"\n                        class=\"btn btn-info btn-large btn-submit ModalLoginSignup-loginForm-submitBtn\"\n                        fl-analytics=\"NormalLogin\">\n                        Log In\n                    </button>\n                </li>\n            </ol>\n        </fieldset>\n    </form>\n    <span class=\"ModalLoginSignup-switchLoginSignupType\" ng-if=\"LoginForm.loginSignupConfig.showSignupOption()\">\n        Don't have an account?\n        <a ng-click=\"LoginForm.goToSignup($event)\" fl-analytics=\"SignupLink\">Sign Up</a>\n    </span>\n</div>\n";

var twoFAOptionsWhitelist = [9603891, // nyl10
24461021, // rchoapeck
26277993];

var flLoginForm = function () {
  function flLoginForm($window, $timeout, $rootScope, UsersService, Users, UserData, Facebook, Analytics, Auth, LoginSignupConfig) {
    var _this = this;

    _classCallCheck(this, flLoginForm);

    this.$window = $window;
    this.$timeout = $timeout;
    this.$rootScope = $rootScope;
    this.UsersService = UsersService;
    this.Users = Users;
    this.UserData = UserData;
    this.Analytics = Analytics;
    this.Facebook = Facebook;
    this.Auth = Auth;
    this.UsersService.getDeviceToken(this.UserData.user);
    this.isSubmitting = false;
    this.showErrorMessage = false;
    this.rememberLogin = false;
    this.loginSuccess = false;
    this.form = {};
    this.fbError = {};

    this.loginSignupConfig = LoginSignupConfig;

    this.watchShowSignup = $rootScope.$watch(function () {
      return _this.loginSignupConfig.options.showSignup;
    }, function (newValue) {
      // If Show Signup was set to false (on login), try auto connect facebook
      if (newValue === false && _this.UserData.isFacebookConnected()) {
        _this.fbLogin(true);
      }
    });

    // Focus on Email Input after timeout. (Triggers flFocusOn)
    this.$timeout(function () {
      _this.focusEmailInput = true;
    }, 50);
  }

  _createClass(flLoginForm, [{
    key: 'login',
    value: function login(event) {
      var _this2 = this;

      event.preventDefault();
      this.showErrorMessage = false;

      // Set form fields as dirty if it has any errors.
      angular.forEach(this.form.$error, function (type) {
        angular.forEach(type, function (field) {
          field.$setDirty();
        });
      });

      if (!this.form.$valid || this.isSubmitting || this.loginSuccess) {
        return;
      }

      this.isSubmitting = true;
      this.fbError = {};
      return this.UsersService.login(this.UserData.user, this.rememberLogin, this.loginSignupConfig.getOld2FAToken()).then(function (response) {
        if (response.data && response.data.pre_login_token) {
          var _ret = function () {
            var token = response.data.pre_login_token.split('.');
            var twoFATokenDecoded = atob(token[1]);
            var userId = JSON.parse(twoFATokenDecoded).user_id;

            return {
              v: ABTest.getUserExperimentVariation('TS-T69187-show-more-2fa-options', userId).then(function (variant) {
                _this2.onNeedTotp({
                  twoFAMethod: _this2.retrieveTwoFAMethod(response.data.pre_login_token),
                  userId: userId,
                  showTwoFAOptions: variant === 'test' || twoFAOptionsWhitelist.includes(userId)
                });
              })
            };
          }();

          if (typeof _ret === "object") return _ret.v;
        } else if (response.data && response.data.token) {
          _this2.loginSuccess = true;
          _this2.$window.requestAnimationFrame(function () {
            _this2.onLoginSuccess({
              rememberLogin: _this2.rememberLogin
            });
          });
        } else {
          _this2.isSubmitting = false;
        }
      }).catch(function (response) {
        if (response.data && response.data.error_code === 'Suspended') {
          _this2.$window.requestAnimationFrame(function () {
            _this2.onLoginSuccess({
              rememberLogin: _this2.rememberLogin,
              forceRedirectUrl: '/users/usersuspended.php'
            });
          });
        }
        _this2.showErrorMessage = true;
        _this2.errorStatus = response.status;
        _this2.errorCode = response.data.error_code;
        _this2.requestId = response.data.request_id;
        _this2.errorMessage = response.data.message;
        _this2.isSubmitting = false;
      });
    }
  }, {
    key: 'retrieveTwoFAMethod',
    value: function retrieveTwoFAMethod(preLoginToken) {
      var token = preLoginToken.split('.');
      var twoFATokenDecoded = atob(token[1]);
      return JSON.parse(twoFATokenDecoded)['2fa_methods'][0];
    }

    /**
     * Login through Facebook.
     * Automatically Triggers FB Link or Switch to Signup on new account.
     */

  }, {
    key: 'fbLogin',
    value: function fbLogin(skipLogin) {
      var _this3 = this;

      if (this.loginSuccess || this.isSubmitting) {
        return;
      }

      this.isSubmitting = true;
      this.showErrorMessage = false;
      this.fbError = {};
      var facebookAuthParams = void 0;
      var authParamsPromise = void 0;
      // 1. Get Facebook auth params
      // If we come from Facebook signup, we need to skip the login
      // step overwise the popup will be blocked!
      if (!skipLogin) {
        authParamsPromise = this.Facebook.login();
      } else {
        authParamsPromise = this.Facebook.checkConnected();
      }

      // 2. Log into the Freelancer account
      return authParamsPromise.then(function (authParams) {
        facebookAuthParams = authParams;
        _this3.UserData.user.facebookAccessToken = authParams.accessToken;
        _this3.UserData.user.facebookSignedRequest = authParams.signedRequest;

        return _this3.UsersService.loginWithFacebook(_this3.UserData.user)
        // 3. Redirect the user
        .then(function (response) {
          if (response.data) {
            _this3.loginSuccess = true;
            _this3.Analytics.trackAction('facebook', 'login', 'SUCCESS');
            _this3.$window.requestAnimationFrame(function () {
              _this3.onLoginSuccess({
                rememberLogin: false
              });
            });
            return;
          }
          _this3.isSubmitting = false;
        }).catch(function (error) {
          // Get Error Contents
          var errorStatus = error.status;
          error = error.data || null;

          // No Error Data
          if (!error) {
            _this3.Analytics.trackError('facebook', 'login', errorStatus, 'EmptyError');
            _this3.fbError.facebookUnknownError = true;
            _this3.isSubmitting = false;
            return;
          }

          if (error.error_code === 'FacebookEmailMatch') {
            // Facebook email matches an existing Freelancer's email.
            _this3.Analytics.trackAction('facebook', 'login', error.error_code);
            _this3.fbLink(facebookAuthParams);
            return;
          } else if (error.error_code === 'ExceptionCodes.MISSING_USER') {
            // New User, Redirect to Signup
            _this3.Analytics.trackAction('facebook', 'login', error.error_code);
            _this3.fbRedirectToSignup();
            return;
          }

          _this3.isSubmitting = false;
          if (errorStatus === 429) {
            _this3.fbError.facebookRateLimit = true;
          } else if (error.error_code === 'Closed') {
            _this3.fbError.facebookClosed = true;
          } else if (error.error_code === 'Suspended') {
            _this3.$window.requestAnimationFrame(function () {
              _this3.onLoginSuccess({
                rememberLogin: _this3.rememberLogin,
                forceRedirectUrl: '/users/usersuspended.php'
              });
            });
          } else if (errorStatus === 401) {
            _this3.fbError.facebookAccessDenied = true;
          } else {
            _this3.Analytics.trackError('facebook', 'login', error.error_code, error.message);
            _this3.fbError.facebookUnknownError = true;
          }
        });
      }).catch(function () {
        _this3.isSubmitting = false;
      });
    }

    /**
     * Get Facebook Details for current user then Redirect to /signup
     * Used from fbLogin()
     */

  }, {
    key: 'fbRedirectToSignup',
    value: function fbRedirectToSignup() {
      var _this4 = this;

      return this.Facebook.getUser().then(function (facebookUser) {
        _this4.UserData.setFacebookConnected(true);
        // Clear username and set Email
        _this4.UserData.username = '';
        _this4.UserData.user.email = facebookUser.email;
        // Set Facebook Data
        _this4.UserData.setFacebookEmail(facebookUser.email);
        _this4.UserData.setFacebookName(facebookUser.first_name);
        // Switch to Signup Form
        _this4.isSubmitting = false;
        _this4.showSignupForm();
      }).catch(function (error) {
        _this4.isSubmitting = false;
        if (error.code === 'NOT_AUTHORISED') {
          _this4.fbError.facebookNotAuthorized = true;
        } else if (error.code === 'NOT_CONNECTED') {
          _this4.fbError.facebookNotConnected = true;
        } else {
          _this4.Analytics.trackError('facebook', 'loginRedirectToSignup', error.code);
          _this4.fbError.facebookUnknownError = true;
        }
      });
    }

    /**
     * Links User to their Freelancer Account.
     * Used from fbLogin()
     */

  }, {
    key: 'fbLink',
    value: function fbLink(facebookAuthParams) {
      var _this5 = this;

      this.fbError = {};
      this.Facebook.getUser().then(function (facebookUser) {
        _this5.UserData.setFacebookConnected(true);
        _this5.UserData.setFacebookEmail(facebookUser.email);
        _this5.UserData.setFacebookName(facebookUser.first_name);
        _this5.UserData.user.facebookAccessToken = facebookAuthParams.accessToken;
        _this5.UserData.user.facebookSignedRequest = facebookAuthParams.signedRequest;

        // Try Get Profile Picture then Show Facebook Link Form
        _this5.Facebook.getUserPictureUrl(60, 60).then(function (pictureUrl) {
          _this5.UserData.setFacebookPictureUrl(pictureUrl);
        }).finally(function () {
          _this5.isSubmitting = false;
          _this5.showFacebookLinkForm();
        });
      }).catch(function (error) {
        _this5.isSubmitting = false;
        if (error.code === 'NOT_AUTHORISED') {
          _this5.Analytics.trackAction('facebook', 'link accounts', error.code);
          _this5.fbError.facebookNotAuthorized = true;
        } else if (error.code === 'NOT_CONNECTED') {
          _this5.Analytics.trackAction('facebook', 'link accounts', error.code);
          _this5.fbError.facebookNotConnected = true;
        } else {
          _this5.fbError.facebookUnknownError = error.code;
        }
      });
    }
  }, {
    key: 'goToSignup',
    value: function goToSignup($event) {
      $event.preventDefault();
      this.showSignupForm();
    }
  }, {
    key: 'hideErrorMessage',
    value: function hideErrorMessage() {
      this.showErrorMessage = false;
    }
  }]);

  return flLoginForm;
}();

flLoginForm.$inject = ['$window', '$timeout', '$rootScope', 'UsersService', 'Users', 'UserData', 'Facebook', 'Analytics', 'Auth', 'LoginSignupConfig'];

var flLoginForm$1 = flComponent$1(flLoginForm, {
  selector: 'fl-login-form',
  template: template$3,
  providers: [flIconProvider, flFocusOnProvider, flEmailUsernameValidCheck$1, UsersProvider$1, FacebookProvider$1, AnalyticsModule, AuthModule, UserData$1, UsersProvider, LoginSignupConfigProvider],
  bindings: {
    showSignupForm: '&',
    showResetPasswordForm: '&',
    showFacebookLinkForm: '&',
    onNeedTotp: '&',
    rememberLogin: '=',
    onLoginSuccess: '&',
    showAsModal: '=',
    closeModal: '&'
  }
});

var template$4 = "<div class=\"Modal-header\">\n  <div class=\"ModalLoginSignup-header-logo\">\n      <fl-icon name=\"fl-logo\"></fl-icon>\n  </div>\n</div>\n<div class=\"Modal-body ModalLoginSignup-body ModalLoginSignup-totp\">\n    <h4 class=\"ModalLoginSignup-body-heading\">2-Step Verification</h4>\n    <div ng-if=\"!TotpForm.showOptions\">\n        <div class=\"ModalLoginSignup-totp-message\">\n            A verification code has been sent to you via\n            <span ng-switch=\"TotpForm.twoFaMethod\">\n                <span ng-switch-when=\"1\">Email.</span>\n                <span ng-switch-when=\"2\">SMS.</span>\n                <span ng-switch-when=\"3\">Generator App.</span>\n                <span ng-switch-when=\"4\">Freelancer App.</span>\n                <span ng-switch-default>Email, SMS or App.</span>\n            </span>\n            Please verify that 6 digit code below to continue.\n        </div>\n        <form class=\"user-login-form fl-form large-form responsive-form\">\n            <div ng-if=\"TotpForm.loginSuccess\"\n              class=\"form-feedback-success login-success alert alert-success\">\n              Login Success\n            </div>\n            <fieldset>\n                <ol>\n                    <li class=\"form-step has-label login-form-options\">\n                        <a ng-if=\"TotpForm.showTwoFAOptions\"\n                          ng-click=\"TotpForm.showOtherOptions()\"\n                          class=\"login-form-forgot recover-login-switch-bt\">\n                          Having problems?\n                        </a>\n                        <a ng-if=\"!TotpForm.showTwoFAOptions\"\n                          ng-click=\"TotpForm.login()\"\n                          class=\"login-form-forgot recover-login-switch-bt\">\n                          Resend code\n                        </a>\n                    </li>\n                    <aside ng-class=\"{'is-hidden': !TotpForm.showResendSuccessMessage}\"\n                        class=\"alert alert-info\">\n                        Code has been resent. Please check your\n                        <span ng-switch=\"TotpForm.twoFaMethod\">\n                            <span ng-switch-when=\"1\">Email.</span>\n                            <span ng-switch-when=\"2\">SMS.</span>\n                            <span ng-switch-when=\"3\">Generator App.</span>\n                            <span ng-switch-when=\"4\">Freelancer App.</span>\n                            <span ng-switch-default>Email, SMS or App.</span>\n                        </span>\n                    </aside>\n                    <aside ng-class=\"{'is-hidden': !TotpForm.showErrorMessage}\"\n                        class=\"alert alert-error\">\n                        <span ng-if=\"TotpForm.errorStatus === 401 && TotpForm.errorCode === 'ExceptionCodes.INVALID_TOTP'\">Wrong code. Please try again.</span>\n                        <span ng-if=\"TotpForm.errorStatus === 401 && TotpForm.errorCode !== 'ExceptionCodes.INVALID_TOTP'\">There was a problem logging in with your account. Please contact <a href=\"/support\">support</a>.<br/>Error: {{TotpForm.errorCode}}</span>\n                        <span ng-if=\"TotpForm.errorStatus === 429\">You are performing too many requests. Please try again later.</span>\n                        <span ng-if=\"TotpForm.errorStatus === 500\">{{TotpForm.errorMessage}}<br/>Error: {{TotpForm.errorCode}}</span>\n                        <span ng-if=\"TotpForm.errorStatus === 'error'\" ng-bind-html=\"TotpForm.errorMessage\"></span>\n                    </aside>\n                    <li class=\"form-step totp-step\">\n                        <label for=\"totp\" class=\"is-accessibly-hidden\">One Time Password</label>\n                        <input type=\"text\" placeholder=\"6 digit code\" name=\"totp\"\n                            class=\"large-input\"\n                            ng-model=\"TotpForm.UserData.user.TOTP\"\n                            ng-keypress=\"TotpForm.totpOnKeyPress($event)\"\n                            ng-change=\"TotpForm.totpOnChange()\"\n                            fl-focus-on=\"TotpForm.focusTotpInput\" />\n                    </li>\n                </ol>\n            </fieldset>\n        </form>\n    </div>\n    <div ng-if=\"TotpForm.showOptions\">\n      <h6 class=\"ModalLoginSignup-totp-message\">\n          Choose another method to sign-in\n      </h6>\n      <aside ng-class=\"{'is-hidden': !TotpForm.showErrorMessage}\"\n          ng-switch=\"TotpForm.errorStatus\"\n          class=\"alert alert-error\">\n          <span ng-switch-when=\"401\">There was a problem logging in with your account. Please contact <a href=\"/support\">support</a>.<br/>Error: {{TotpForm.errorCode}}</span>\n          <span ng-switch-when=\"429\">You are performing too many requests. Please try again later.</span>\n          <span ng-switch-when=\"500\">{{TotpForm.errorMessage}}<br/>Error: {{TotpForm.errorCode}}</span>\n          <span ng-switch-default>An unexpected error has occured. Please try again later.</span>\n      </aside>\n      <ul class=\"ModalLoginSignup-totp-options\">\n          <li class=\"ModalLoginSignup-totp-item\">\n            <a ng-if=\"TotpForm.totpMethods.indexOf(1) >= 0\" ng-click=\"TotpForm.resendCode(1)\" role=\"button\" class=\"ModalLoginSignup-totp-btn\">\n              <span class=\"Icon ModalLoginSignup-totp-icon\">\n                <fl-icon name=\"ui-mail\"></fl-icon>\n              </span>\n              <span class=\"ModalLoginSignup-totp-details\">Receive the verification code from your email</span>\n            </a>\n          </li>\n          <li class=\"ModalLoginSignup-totp-item\">\n            <a ng-if=\"TotpForm.totpMethods.indexOf(2) >= 0\" ng-click=\"TotpForm.resendCode(2)\" role=\"button\" class=\"ModalLoginSignup-totp-btn\">\n              <span class=\"Icon ModalLoginSignup-totp-icon\">\n                <fl-icon name=\"ui-mobile-phone\"></fl-icon>\n              </span>\n              <span class=\"ModalLoginSignup-totp-details\">Get the verification code at {{TotpForm.smsNumber}}</span>\n            </a>\n          </li>\n          <li class=\"ModalLoginSignup-totp-item\">\n            <a ng-click=\"TotpForm.contactSupport()\" role=\"button\" class=\"ModalLoginSignup-totp-btn\">\n              <span class=\"Icon ModalLoginSignup-totp-icon\">\n                <fl-icon name=\"ui-help\"></fl-icon>\n              </span>\n              <span class=\"ModalLoginSignup-totp-details\">Contact Customer Support. We'll get back to you as soon as we can.</span>\n            </a>\n          </li>\n      </ul>\n    </div>\n</div>\n";

/**
 * @ngdoc component
 * @name LoginSignupApp.flTotpForm
 * @description
 * Handles the code input, and resends for the 2FA form.
 */

var flTotpForm = function () {
  function flTotpForm($window, $timeout, Analytics, UsersService, UserData) {
    var _this = this;

    _classCallCheck(this, flTotpForm);

    this.$window = $window;
    this.$timeout = $timeout;
    this.Analytics = Analytics;
    this.Users = UsersService;
    this.UserData = UserData;

    this.Users.getDeviceToken(this.UserData.user);
    this.showResendSuccessMessage = false;
    this.isResendingCode = false;
    this.isSubmitting = false;
    this.loginSuccess = false;
    this.showOptions = false;
    this.totpMethods = [];
    this.smsNumber = null;
    this.defaultMethod = null;

    // Focus on TOTP Input after timeout. (Triggers flFocusOn)
    this.$timeout(function () {
      _this.focusTotpInput = true;
    }, 50);
  }

  _createClass(flTotpForm, [{
    key: 'tryTotpLogin',
    value: function tryTotpLogin() {
      var _this2 = this;

      if (!this.isSubmitting && !this.loginSuccess && this.UserData.user.TOTP.length > 5) {
        this.isSubmitting = true;
        this.showErrorMessage = false;
        this.Users.totpLogin(this.UserData.user, this.rememberLogin).then(function (response) {
          if (response.data && response.data.token) {
            _this2.loginSuccess = true;
            _this2.$window.requestAnimationFrame(function () {
              _this2.onLoginSuccess({
                rememberLogin: _this2.rememberLogin
              });
            });
          }
          _this2.isSubmitting = false;
        }).catch(function (response) {
          _this2.showErrorMessage = true;
          _this2.errorStatus = response.status;
          _this2.errorCode = response.data.error_code;
          _this2.errorMessage = response.data.message;
          _this2.isSubmitting = false;
        });
      }
    }

    /**
     * Try to login again. This is useful for totp form component to mimic resending code
     */

  }, {
    key: 'login',
    value: function login() {
      var _this3 = this;

      this.Analytics.trackEvent('Login', '2fa', null, 'click', null, 'ResendCode');

      if (!this.isResendingCode) {
        this.isResendingCode = true;

        return this.Users.login(this.UserData.user, this.rememberLogin).then(function (response) {
          if (response.data && response.data.pre_login_token) {
            _this3.showResendSuccessMessage = true;
            _this3.$timeout(function () {
              _this3.showResendSuccessMessage = false;
            }, 10000);
          }

          _this3.isResendingCode = false;
        });
      }
    }

    /**
     * Limit TOTP length to 6 numbers.
     * Disallows input if length is greater or equal to 6 characters.
     */

  }, {
    key: 'totpOnKeyPress',
    value: function totpOnKeyPress(event) {
      var specialKeys = ['Backspace', 'Tab', 'End', 'Home'];
      var specialKeyCodes = [8, 9, 2, 3];
      // Allow Special Keys
      if (event.key && specialKeys.indexOf(event.key) !== -1 || specialKeyCodes.indexOf(event.keyCode) !== -1) {
        return;
      }

      if (this.UserData.user.TOTP.length < 6) {
        return;
      }
      event.preventDefault();
    }

    /**
     * Allow only numeric values and Limit Length
     */

  }, {
    key: 'totpOnChange',
    value: function totpOnChange() {
      var numberOnlyValue = this.UserData.user.TOTP.replace(/[^0-9]/g, '');
      this.UserData.user.TOTP = numberOnlyValue;
      var limitString = this.UserData.user.TOTP.substring(0, 6);
      this.UserData.user.TOTP = limitString;

      this.tryTotpLogin();
    }
  }, {
    key: 'showOtherOptions',
    value: function showOtherOptions() {
      var _this4 = this;

      this.track2FAMethodEvent('HavingProblems');
      this.showErrorMessage = false;

      this.Users.getAvailableTotpMethods(this.userId).then(function (response) {
        _this4.totpMethods = response.methods;
        _this4.smsNumber = response.sms;
        _this4.showOptions = true;
      }).catch(function (response) {
        _this4.showErrorMessage = true;
        _this4.errorStatus = response.data.status;
        _this4.errorMessage = response.data.message;
      });
    }
  }, {
    key: 'resendCode',
    value: function resendCode(method) {
      var _this5 = this;

      var methodName = this.get2FAMethodLabel(method).split(' ').map(function (word) {
        return word[0].toUpperCase() + word.substr(1);
      }).join('');
      this.track2FAMethodEvent('ChangeMethod' + methodName);

      if (!this.isResendingCode) {
        this.isResendingCode = true;
        this.showResendSuccessMessage = false;
        this.showErrorMessage = false;

        if (!this.defaultMethod) {
          this.defaultMethod = this.twoFaMethod;
        }

        return this.Users.deliverToken(this.UserData.user, method).then(function () {
          if (_this5.defaultMethod === method) {
            _this5.showResendSuccessMessage = true;
            _this5.$timeout(function () {
              _this5.showResendSuccessMessage = false;
            }, 10000);
          }

          _this5.twoFaMethod = method;
          _this5.showOptions = false;
          _this5.isResendingCode = false;
        }).catch(function (response) {
          _this5.showErrorMessage = true;
          _this5.errorStatus = response.status;
          _this5.errorCode = response.data.error_code;
          _this5.errorMessage = response.data.message;
          _this5.isResendingCode = false;
        });
      }
    }
  }, {
    key: 'contactSupport',
    value: function contactSupport() {
      this.track2FAMethodEvent('ContactSupport');
      this.$window.location.href = '/contact';
    }
  }, {
    key: 'get2FAMethodLabel',
    value: function get2FAMethodLabel(methodId) {
      switch (methodId) {
        case 2:
          return 'sms';

        case 3:
          return 'authenticator app';

        case 4:
          return 'freelancer app';

        default:
          return 'email';
      }
    }
  }, {
    key: 'track2FAMethodEvent',
    value: function track2FAMethodEvent(label) {
      this.Analytics.trackEvent('Login', '2fa', 'current method', null, this.get2FAMethodLabel(this.twoFaMethod), label);
    }
  }]);

  return flTotpForm;
}();

flTotpForm.$inject = ['$window', '$timeout', 'Analytics', 'UsersService', 'UserData'];

var flTotpForm$1 = flComponent$1(flTotpForm, {
  selector: 'fl-totp-form',
  template: template$4,
  providers: [flIconProvider, flFocusOnProvider, AnalyticsModule, UsersProvider$1, UserData$1],
  bindings: {
    twoFaMethod: '=',
    userId: '=',
    showTwoFAOptions: '=',
    rememberLogin: '=',
    onLoginSuccess: '&'
  }
});

var facebookLinkFormTemplate = "<div class=\"Modal-header\">\n  <div class=\"ModalLoginSignup-header\">\n    <div ng-click=\"FacebookLinkForm.cancelLink()\" class=\"ModalLoginSignup-header-previousStep\">\n      <fl-icon name=\"ui-chevron-left\" class=\"ModalLoginSignup-header-previousStep-icon\"></fl-icon>\n    </div>\n    <button class=\"Modal-close\" ng-click=\"FacebookLinkForm.closeModal()\" type=\"button\" data-modal-hide aria-label=\"Close this modal window\"\n        ng-if=\"FacebookLinkForm.showAsModal\">\n        <span class=\"Icon Icon--small\">\n          <fl-icon name=\"ui-close\"></fl-icon>\n        </span>\n    </button>\n    <div id=\"fl-logo\" class=\"ModalLoginSignup-header-logo\">\n      <img ng-src=\"{[{FacebookLinkForm.headerImageUrl}]}\" alt=\"Freelancer logo\" />\n    </div>\n  </div>\n</div>\n<div class=\"Modal-body\">\n  <div class=\"ModalLoginSignup-body-heading\">\n    Link to existing Freelancer account\n  </div>\n  <figure class=\"ImageThumbnail ModalLoginSignup-facebook-profileImage\">\n    <img ng-src=\"{{FacebookLinkForm.UserData.getFacebookPictureUrl()}}\" alt=\"Profile Picture\"\n      class=\"ImageThumbnail-image\">\n  </figure>\n  <h2 class=\"ModalLoginSignup-body-heading\">\n    Welcome {{FacebookLinkForm.UserData.getFacebookName()}}!\n  </h2>\n  <div class=\"ModalLoginSignup-facebookLinkForm-info\">\n    Your email address is already associated with a Freelancer account. Enter your password below to link accounts:\n  </div>\n  <form name=\"FacebookLinkForm.form\" class=\"user-login-form fl-form large-form responsive-form\">\n    <div ng-messages=\"FacebookLinkForm.errors\">\n      <div ng-message=\"incorrectPassword\" class=\"alert alert-error\">\n        Incorrect username or password provided.\n      </div>\n      <div ng-message=\"facebookRateLimit\" class=\"alert alert-error\">\n        You are performing too many requests. Please try again later.\n      </div>\n      <div ng-message=\"facebookClosed\" class=\"alert alert-error\">\n        This account has been closed. Please contact <a href=\"/support\">support</a> for more assistance.\n      </div>\n      <div ng-message=\"facebookAccessDenied\" class=\"alert alert-error\">\n        There was a problem logging in with your account. Please contact <a href=\"/support\">support</a>.\n      </div>\n      <div ng-message=\"facebookUnknownError\" class=\"alert alert-error\">\n        Failed to connect with Facebook. Please try again.\n      </div>\n    </div>\n    <div ng-if=\"FacebookLinkForm.loginSuccess\"\n      class=\"form-feedback-success login-success alert alert-success\">\n      Successfully Linked!\n    </div>\n    <fieldset>\n      <ol>\n        <li ng-class=\"{'is-invalid': FacebookLinkForm.form.email.$invalid && FacebookLinkForm.form.email.$dirty}\"\n          class=\"form-step email-step\">\n          <label for=\"email\" class=\"is-accessibly-hidden\">Username</label>\n          <input id=\"email\" name=\"email\" type=\"email\"\n            maxlength=\"150\" class=\"large-input\"\n            ng-model=\"FacebookLinkForm.UserData.user.email\"\n            ng-required=\"true\"\n            ng-disabled=\"true\"/>\n        </li>\n        <li ng-class=\"{'is-invalid': FacebookLinkForm.form.password.$invalid && FacebookLinkForm.form.password.$dirty}\"\n          class=\"form-step password-step\">\n          <label for=\"password\" class=\"is-accessibly-hidden\">Password</label>\n          <input id=\"password\" name=\"password\" type=\"password\"\n            placeholder=\"Password\" class=\"large-input\"\n            maxlength=\"150\"\n            ng-model=\"FacebookLinkForm.UserData.user.password\"\n            ng-required=\"true\"/>\n          <div ng-if=\"FacebookLinkForm.form.password.$pending\"\n            class=\"Loader Loader--small ModalLoginSignup-inputLoader\">\n          </div>\n          <div ng-messages=\"FacebookLinkForm.form.password.$error\" tabindex=\"-1\">\n            <div class=\"form-error\" ng-message=\"required\">\n              Please enter your password.\n            </div>\n          </div>\n        </li>\n        <li class=\"form-step has-label login-form-options\">\n          <a ng-click=\"FacebookLinkForm.showResetPasswordForm()\" class=\"login-form-forgot forgot-password\">Forgot Password?</a>\n        </li>\n        <li class=\"form-step\">\n          <button ng-click=\"FacebookLinkForm.onFormSubmit($event)\" ng-disabled=\"FacebookLinkForm.isSubmitting\" type=\"submit\" class=\"btn btn-info btn-large btn-submit ModalLoginSignup-facebookLinkForm-submitBtn\">\n            Log In\n          </button>\n        </li>\n      </ol>\n    </fieldset>\n  </form>\n</div>\n";

var flFacebookLinkForm = function () {
  function flFacebookLinkForm($http, Cdn, UsersService, UserData, Analytics) {
    _classCallCheck(this, flFacebookLinkForm);

    this.$http = $http;
    this.UserData = UserData;
    this.Analytics = Analytics;
    this.UsersService = UsersService;
    this.headerImageUrl = Cdn.getCdnUrl('/static/img/freelancer-logo.svg');
    this.isSubmitting = false;
    this.errors = {};
  }

  _createClass(flFacebookLinkForm, [{
    key: 'onFormSubmit',
    value: function onFormSubmit(event) {
      var _this = this;

      event.preventDefault();
      this.errors = {};
      // Set form fields as dirty if it has any errors.
      angular.forEach(this.form.$error, function (type) {
        angular.forEach(type, function (field) {
          field.$setDirty();
        });
      });
      if (!this.form.$valid || this.isSubmitting) {
        return;
      }
      this.isSubmitting = true;

      // All Errors should be dealt with in linkFacebookAccount.
      this.linkFacebookAccount().then(function () {
        _this.onComplete();
      }).catch(function () {});
    }

    /**
     * Try to link a user to their facebook account, given their facebook auth
     * params and email and password.
     */

  }, {
    key: 'linkFacebookAccount',
    value: function linkFacebookAccount() {
      var _this2 = this;

      this.errors = {};
      return this.UsersService.linkFacebookAccount(this.UserData.user).then(function (response) {
        if (response.data && response.data.token) {
          _this2.loginSuccess = true;
          _this2.onLoginSuccess();
          return;
        }
        _this2.isSubmitting = false;
      }).catch(function (error) {
        // Get Error Contents
        var errorStatus = error.status;
        error = error.data || null;

        // No Error Data
        if (!error) {
          _this2.Analytics.trackError('facebook', 'login', errorStatus, 'EmptyError');
          _this2.errors.facebookUnknownError = true;
          return;
        }

        // Redirect on Suspended
        if (error.error_code === 'Suspended') {
          _this2.onLoginSuccess({
            rememberLogin: _this2.rememberLogin,
            forceRedirectUrl: '/users/usersuspended.php'
          });
          return;
        }

        _this2.isSubmitting = false;
        if (errorStatus === 429) {
          _this2.errors.facebookRateLimit = true;
        } else if (errorStatus === 401 && error.error_code === 'None') {
          _this2.errors.incorrectPassword = true;
        } else if (errorStatus === 401 && error.error_code === 'Closed') {
          _this2.errors.facebookClosed = true;
        } else if (errorStatus === 401) {
          _this2.errors.facebookAccessDenied = true;
        } else {
          _this2.Analytics.trackError('facebook', 'login', error.error_code, error.message);
          _this2.errors.facebookUnknownError = true;
        }
      });
    }

    /**
     * Cancel Facebook Link
     */

  }, {
    key: 'cancelLink',
    value: function cancelLink() {
      // Clear User Data
      this.UserData.user.facebookConnected = false;
      this.UserData.user.facebookName = '';
      this.UserData.user.facebookEmail = '';
      this.UserData.user.facebookPictureUrl = '';
      this.UserData.user.facebookAccessToken = '';
      this.UserData.user.facebookSignedRequest = '';
      this.UserData.user.password = '';
      // Use Callback.
      this.onCancel();
    }
  }]);

  return flFacebookLinkForm;
}();

flFacebookLinkForm.$inject = ['$http', 'Cdn', 'UsersService', 'UserData', 'Analytics'];

var flFacebookLinkForm$1 = flComponent$1(flFacebookLinkForm, {
  selector: 'fl-facebook-link-form',
  template: facebookLinkFormTemplate,
  bindings: {
    onComplete: '&',
    onCancel: '&',
    onLoginSuccess: '&',
    showResetPasswordForm: '&',
    showAsModal: '=',
    closeModal: '&'
  },
  providers: [ngMessages, UserData$1, UsersProvider$1, AnalyticsModule, CdnProvider, flIconProvider]
});

var template$5 = "<div class=\"Modal-header\">\n  <div class=\"ModalLoginSignup-header\">\n    <div ng-click=\"ResetPasswordForm.onCancel()\" class=\"ModalLoginSignup-header-previousStep\">\n      <fl-icon name=\"ui-chevron-left\" class=\"ModalLoginSignup-header-previousStep-icon\"></fl-icon>\n    </div>\n    <div class=\"ModalLoginSignup-header-logo\">\n      <fl-icon name=\"fl-logo\"></fl-icon>\n    </div>\n  </div>\n</div>\n<div class=\"Modal-body ModalLoginSignup-body\">\n  <h4 class=\"ModalLoginSignup-body-heading\">Reset your password</h4>\n  <p ng-class=\"{'is-hidden': !ResetPasswordForm.showSuccessMessage}\"\n      class=\"alert alert-info\">\n      Email sent. If the email address you entered is registered at Freelancer.com, you'll receive an email with instructions on how to set a new password.\n  </p>\n  <p ng-class=\"{'is-hidden': !ResetPasswordForm.showErrorMessage}\" class=\"alert alert-danger\">\n    {{ ResetPasswordForm.errorMessage }}\n  </p>\n  <form name=\"ResetPasswordForm.form\" class=\"recover-password-form fl-form large-form ModalLoginSignup-resetPassword-form\">\n    <fieldset>\n      <ol>\n        <li class=\"form-step recover-email-step\"\n          ng-class=\"{'is-invalid': ResetPasswordForm.form.email.$invalid && ResetPasswordForm.form.email.$dirty,\n          'is-valid': ResetPasswordForm.form.email.$valid}\">\n          <label for=\"forgotten-email\" class=\"is-accessibly-hidden\">Email Address</label>\n          <input id=\"forgotten-email\" name=\"email\" maxlength=\"100\" type=\"text\"\n            class=\"large-input\"\n            placeholder=\"Enter your email address\"\n            ng-model=\"ResetPasswordForm.UserData.user.email\"\n            ng-model-options=\"{ debounce: {'default': 300, 'blur': 0} }\"\n            ng-required=\"true\"\n            fl-email-username-valid-check=\"email\"\n            fl-focus-on=\"ResetPasswordForm.focusEmailInput\" />\n          <div ng-messages=\"ResetPasswordForm.form.email.$error\" tabindex=\"-1\">\n            <div class=\"form-error\" ng-message=\"required\">\n                Please enter your email address.\n            </div>\n            <div class=\"form-error\" ng-message=\"validEmail\">\n                Please enter a valid email address.\n            </div>\n          </div>\n        </li>\n        <li class=\"form-step\">\n          <button class=\"btn btn-info btn-large btn-primary btn-submit ModalLoginSignup-resetPassword-submitBtn\"\n            ng-disabled=\"ResetPasswordForm.isSubmitting\"\n            ng-click=\"ResetPasswordForm.resetPassword($event)\"\n            type=\"submit\">\n            Reset Password\n          </button>\n        </li>\n      </ol>\n    </fieldset>\n  </form>\n  <span class=\"login-form-signup-link\" ng-if=\"ResetPasswordForm.loginSignupConfig.showSignupOption()\">\n      Don't have an account?\n      <a ng-click=\"ResetPasswordForm.goToSignup($event)\">Sign Up</a>\n  </span>\n</div>\n";

var flResetPasswordForm = function () {
  function flResetPasswordForm($timeout, UsersService, UserData, LoginSignupConfig) {
    var _this = this;

    _classCallCheck(this, flResetPasswordForm);

    this.$timeout = $timeout;
    this.UserData = UserData;
    this.Users = UsersService;
    this.isSubmitting = false;
    this.showSuccessMessage = false;
    this.showErrorMessage = false;
    this.errorMessage = '';
    this.loginSignupConfig = LoginSignupConfig;

    // Set User Email to Username if it's a valid email
    // Reset Password is accessed from Login, which uses ng mdoel on username,
    // so we check to see if we can prefill this value first instead.
    if (this.UserData.user.username && isValidEmail(this.UserData.user.username)) {
      this.UserData.user.email = this.UserData.user.username;
    }

    // Focus on Email Input after timeout. (Triggers flFocusOn)
    this.$timeout(function () {
      _this.focusEmailInput = true;
    }, 50);
  }

  _createClass(flResetPasswordForm, [{
    key: 'resetPassword',
    value: function resetPassword(event) {
      var _this2 = this;

      event.preventDefault();
      this.showErrorMessage = false;
      // Set form fields as dirty for each form input type with any errors.
      angular.forEach(this.form.$error, function (type) {
        angular.forEach(type, function (field) {
          field.$setDirty();
        });
      });
      if (!this.form.$valid || this.isSubmitting) {
        return;
      }
      this.isSubmitting = true;
      this.Users.forgotPassword(this.UserData.user.email).then(function (response) {
        if (response.data && response.data.status === 'success') {
          _this2.showSuccessMessage = true;
          _this2.$timeout(function () {
            _this2.showSuccessMessage = false;
          }, 10000);
        } else if (response.data && response.data.msg) {
          _this2.errorMessage = response.data.msg;
          _this2.showErrorMessage = true;

          if (response.data.redirectUrl) {
            window.location.href = response.data.redirectUrl;
          }
        }
        _this2.isSubmitting = false;
      });
    }
  }, {
    key: 'goToSignup',
    value: function goToSignup($event) {
      $event.preventDefault();
      this.showSignupForm();
    }
  }]);

  return flResetPasswordForm;
}();

flResetPasswordForm.$inject = ['$timeout', 'UsersService', 'UserData', 'LoginSignupConfig'];

var flResetPasswordForm$1 = flComponent$1(flResetPasswordForm, {
  selector: 'fl-reset-password-form',
  template: template$5,
  providers: [flIconProvider, flFocusOnProvider, flEmailUsernameValidCheck$1, UserData$1, UsersProvider$1, LoginSignupConfigProvider],
  bindings: {
    showSignupForm: '&',
    onCancel: '&',
    showLoginForm: '&'
  }
});

var loginSuccessTemplate = "<div class=\"Modal-header\">\n  <div class=\"ModalLoginSignup-header\">\n    <button class=\"Modal-close\" ng-click=\"LoginSuccess.closeModal($event)\" type=\"button\" data-modal-hide aria-label=\"Close this modal window\"\n      ng-if=\"LoginSuccess.loginSignupConfig.isModal()\">\n      <span class=\"Icon Icon--small\">\n        <fl-icon name=\"ui-close\"></fl-icon>\n      </span>\n    </button>\n    <div id=\"fl-logo\" class=\"ModalLoginSignup-header-logo\">\n      <img ng-src=\"{[{LoginSuccess.headerImageUrl}]}\" alt=\"Freelancer logo\" />\n    </div>\n  </div>\n</div>\n<div class=\"Modal-body\" fl-analytics-section=\"Login\">\n  <div class=\"ModalLoginSignup-loginSuccess\">\n    <h2 class=\"ModalLoginSignup-body-title\">Login Success!</h2>\n    <div ng-if=\"LoginSuccess.loginSignupConfig.getLoginSuccessMessage()\">\n      <p class=\"ModalLoginSignup-body-subtitle\">{{LoginSuccess.loginSignupConfig.getLoginSuccessMessage()}}</p>\n    </div>\n    <div ng-if=\"!LoginSuccess.loginSignupConfig.getLoginSuccessMessage()\">\n      <p class=\"ModalLoginSignup-body-subtitle\">Please wait while we redirect you...</p>\n    </div>\n    <div class=\"ModalLoginSignup-signupSuccess-spinner\">\n      <div class=\"Loader Loader--large\"></div>\n    </div>\n  </div>\n</div>\n";

var flLoginSuccess = function () {
  function flLoginSuccess(Cdn, UserData, LoginSignupConfig) {
    _classCallCheck(this, flLoginSuccess);

    this.headerImageUrl = Cdn.getCdnUrl('/static/img/freelancer-logo.svg');
    this.UserData = UserData;
    this.loginSignupConfig = LoginSignupConfig;
  }

  _createClass(flLoginSuccess, [{
    key: 'closeModal',
    value: function closeModal($event) {
      this.closeModal({ $event: $event });
    }
  }]);

  return flLoginSuccess;
}();

flLoginSuccess.$inject = ['Cdn', 'UserData', 'LoginSignupConfig'];

var flLoginSuccess$1 = flComponent$1(flLoginSuccess, {
  selector: 'fl-login-success',
  template: loginSuccessTemplate,
  bindings: { closeModal: '&' },
  providers: [CdnProvider, UserData$1, LoginSignupConfigProvider]
});

var LOGIN_STEPS = {
  LOGIN_FORM: 1,
  TOTP_FORM: 2,
  FB_LINK_FORM: 3,
  RESET_PASSWORD_FORM: 4,
  LOGIN_SUCCESS: 10
};

var loginTemplate = "<fl-login-form\n  ng-if=\"Login.currentStep === Login.steps.LOGIN_FORM\"\n  show-signup-form=\"Login.goToSignup()\"\n  show-reset-password-form=\"Login.showResetPasswordForm()\"\n  show-facebook-link-form=\"Login.showFacebookLinkForm()\"\n  on-need-totp=\"Login.showTOTPForm(twoFAMethod, userId, showTwoFAOptions)\"\n  on-login-success=\"Login.onLoginSuccess({rememberLogin: rememberLogin, forceRedirectUrl: forceRedirectUrl})\"\n  remember-login=\"Login.rememberLogin\"\n  show-as-modal=\"Login.showAsModal\"\n  close-modal=\"Login.closeModal()\">\n</fl-login-form>\n<fl-totp-form\n  ng-if=\"Login.currentStep === Login.steps.TOTP_FORM\"\n  two-fa-method=\"Login.twoFAMethod\"\n  user-id=\"Login.userId\"\n  show-two-f-a-options=\"Login.showTwoFAOptions\"\n  on-login-success=\"Login.onLoginSuccess({rememberLogin: rememberLogin, forceRedirectUrl: forceRedirectUrl})\"\n  remember-login=\"Login.rememberLogin\"\n  show-as-modal=\"Login.showAsModal\">\n</fl-totp-form>\n<fl-reset-password-form\n  ng-if=\"Login.currentStep === Login.steps.RESET_PASSWORD_FORM\"\n  show-signup-form=\"Login.goToSignup()\"\n  on-cancel=\"Login.currentStep = Login.steps.LOGIN_FORM\"\n  show-login-form=\"Login.showLoginForm()\"\n  show-as-modal=\"Login.showAsModal\">\n</fl-reset-password-form>\n<fl-facebook-link-form\n  ng-if=\"Login.currentStep === Login.steps.FB_LINK_FORM\"\n  on-cancel=\"Login.currentStep = Login.steps.LOGIN_FORM\"\n  on-login-success=\"Login.onLoginSuccess({rememberLogin: rememberLogin, forceRedirectUrl: forceRedirectUrl})\"\n  show-reset-password-form=\"Login.showResetPasswordForm()\"\n  show-as-modal=\"Login.showAsModal\"\n  close-modal=\"Login.closeModal()\">\n</fl-facebook-link-form>\n<fl-login-success\n  ng-if=\"Login.currentStep === Login.steps.LOGIN_SUCCESS\"\n  close-modal=\"Login.closeModal($event)\">\n</fl-login-success>\n";

var flLogin = function () {
  function flLogin($window, $rootScope, UserData, LoginSignupConfig) {
    _classCallCheck(this, flLogin);

    this.$window = $window;
    this.$rootScope = $rootScope;
    this.UserData = UserData;
    this.steps = LOGIN_STEPS;
    this.loginSignupConfig = LoginSignupConfig;
  }

  _createClass(flLogin, [{
    key: 'goToSignup',
    value: function goToSignup() {
      this.loginSignupConfig.switchToSignup();
    }
  }, {
    key: 'showLoginForm',
    value: function showLoginForm() {
      this.currentStep = this.steps.LOGIN_FORM;
    }
  }, {
    key: 'showTOTPForm',
    value: function showTOTPForm(twoFAMethod, userId, showTwoFAOptions) {
      this.twoFAMethod = twoFAMethod;
      this.userId = userId;
      this.showTwoFAOptions = showTwoFAOptions;
      this.currentStep = this.steps.TOTP_FORM;
    }
  }, {
    key: 'showResetPasswordForm',
    value: function showResetPasswordForm() {
      this.currentStep = this.steps.RESET_PASSWORD_FORM;
    }
  }, {
    key: 'showFacebookLinkForm',
    value: function showFacebookLinkForm() {
      if (this.UserData.isFacebookConnected()) {
        this.UserData.user.password = '';
        this.UserData.user.email = this.UserData.getFacebookEmail();
        this.currentStep = this.steps.FB_LINK_FORM;
        return;
      }
      this.currentStep = this.steps.LOGIN_FORM;
    }
  }]);

  return flLogin;
}();

flLogin.$inject = ['$window', '$rootScope', 'UserData', 'LoginSignupConfig'];

var flLogin$1 = flComponent$1(flLogin, {
  selector: 'fl-login',
  template: loginTemplate,
  bindings: {
    showAsModal: '=',
    closeModal: '&',
    onLoginSuccess: '&',
    currentStep: '='
  },
  providers: [UserData$1, flLoginForm$1, flTotpForm$1, flLoginSuccess$1, flFacebookLinkForm$1, flResetPasswordForm$1, LoginSignupConfigProvider]
});

var _defineProperty = (function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
});

var webappTrackingServiceReady = new Promise(function (resolve) {
  if (window.webappCompatTracking) {
    resolve();
  } else {
    window.webappCompatTrackingReadyCallback = function () {
      return resolve();
    };
  }
});

var Tracking = {
  trackCustomEvent: function trackCustomEvent(name, section, extraParams) {
    return webappTrackingServiceReady.then(function () {
      return window.webappCompatTracking.trackCustomEvent(name, section, extraParams);
    });
  }
};

var usernameInputTemplate = "<div class=\"Modal-header\">\n  <div class=\"ModalLoginSignup-header\">\n    <div ng-click=\"UsernameInput.onCancel()\" class=\"ModalLoginSignup-header-previousStep\">\n      <fl-icon name=\"ui-chevron-left\" class=\"ModalLoginSignup-header-previousStep-icon\"></fl-icon>\n    </div>\n\n    <button class=\"Modal-close\" ng-click=\"UsernameInput.closeModal($event)\" type=\"button\" data-modal-hide aria-label=\"Close this modal window\"\n      ng-if=\"UsernameInput.showAsModal\">\n      <span class=\"Icon Icon--small\">\n        <fl-icon name=\"ui-close\"></fl-icon>\n      </span>\n    </button>\n    <div id=\"fl-logo\" class=\"ModalLoginSignup-header-logo\">\n      <img ng-src=\"{[{UsernameInput.headerImageUrl}]}\" alt=\"Freelancer logo\" />\n    </div>\n  </div>\n</div>\n<div class=\"Modal-body\" fl-analytics-section=\"Signup\">\n  <h2 class=\"ModalLoginSignup-body-title\">Choose a username</h2>\n  <p class=\"ModalLoginSignup-body-subtitle\">Please note that a username cannot be changed, once chosen.</p>\n  <form class=\"user-signup-form fl-form responsive-form\" name=\"UsernameInput.form\">\n    <div class=\"form-step email-step\"\n      ng-class=\"{'is-invalid': UsernameInput.form.username.$invalid && UsernameInput.form.username.$dirty,\n                 'is-valid': UsernameInput.form.username.$valid}\">\n      <label for=\"new-username\" class=\"is-accessibly-hidden\">Username</label>\n      <input type=\"text\" name=\"username\" id=\"new-username\"\n        rel=\"popover\" placeholder=\"Username\" class=\"large-input\"\n        ng-model=\"UsernameInput.UserData.user.username\"\n        ng-model-options=\"{ debounce: {'default': 300, 'blur': 0} }\"\n        ng-required=\"true\"\n        ng-minlength=\"3\"\n        ng-maxlength=\"16\"\n        fl-email-username-valid-check=\"username\"\n        fl-unique-email-username-check=\"username\"\n        fl-focus-on=\"UsernameInput.focusUsernameInput\">\n      <div ng-if=\"UsernameInput.form.username.$pending\"\n        class=\"Loader Loader--small ModalLoginSignup-inputLoader\">\n      </div>\n      <div ng-messages=\"UsernameInput.form.username.$error\" tabindex=\"-1\">\n        <div class=\"form-error\" ng-message=\"required\">\n          Please enter a username.\n        </div>\n        <div class=\"form-error\" ng-message=\"minlength\">\n          Please enter at least 3 characters.\n        </div>\n        <div class=\"form-error\" ng-message=\"maxlength\">\n          Please enter at most 16 characters.\n        </div>\n        <div class=\"form-error\" ng-message=\"validUsername\">\n          Username must be alphanumeric starting with a letter.\n        </div>\n        <div class=\"form-error\" ng-message=\"uniqueUsername\">\n          This username already exists, please choose another.\n        </div>\n        <div class=\"form-error\" ng-message=\"uniqueFromPassword\">\n          Username must be different to password.\n        </div>\n      </div>\n      <div id=\"new-username-suggestion\" class=\"ModalLoginSignup-signupUsernameInput-suggestions\">\n        <span class=\"ModalLoginSignup-signupUsernameInput-suggestionTitle\">Suggestions:</span>\n        <span ng-repeat=\"name in UsernameInput.usernameSuggestions\">\n          <a ng-click=\"UsernameInput.updateUsername(name)\">\n          {{name}}\n          </a>\n          <span ng-show=\"!$last\" class=\"ModalLoginSignup-signupUsernameInput-suggestions-separator\">/</span>\n        </span>\n      </div>\n    </div>\n    <button class=\"btn btn-info btn-large ModalLoginSignup-signupUsernameInput-submitBtn\"\n      ng-disabled=\"UsernameInput.isSubmitting\"\n      ng-click=\"UsernameInput.onFormSubmit($event)\"\n      fl-analytics=\"NormalSignupUsername\">\n      Next\n      <span ng-if=\"UsernameInput.isSubmitting\" class=\"Loader Loader--small\">\n      </span>\n    </button>\n  </form>\n</div>\n";

var flUsernameInput = function () {
  function flUsernameInput($scope, $timeout, Cdn, UsersService, UserData, Facebook) {
    var _this = this;

    _classCallCheck(this, flUsernameInput);

    this.$scope = $scope;
    this.$timeout = $timeout;
    this.headerImageUrl = Cdn.getCdnUrl('/static/img/freelancer-logo.svg');
    this.UserData = UserData;
    this.Users = UsersService;
    this.Facebook = Facebook;

    // Focus on Username Input after timeout. (Triggers flFocusOn)
    this.$timeout(function () {
      _this.focusUsernameInput = true;
    }, 50);
  }

  _createClass(flUsernameInput, [{
    key: 'updateUsername',
    value: function updateUsername(name) {
      var _this2 = this;

      this.form.username.$setDirty();
      this.UserData.user.username = name;
      var usernameValidWatch = this.$scope.$watch(function () {
        return _this2.form.$valid;
      }, function (newValue) {
        if (newValue === true) {
          _this2.onComplete();
          usernameValidWatch();
        }
      });
    }
  }, {
    key: 'onFormSubmit',
    value: function onFormSubmit(event) {
      event.preventDefault();
      // Set form fields as dirty if it has any errors.
      angular.forEach(this.form.$error, function (type) {
        angular.forEach(type, function (field) {
          field.$setDirty();
        });
      });
      if (!this.form.$valid) {
        return;
      }
      this.onComplete();
    }
  }]);

  return flUsernameInput;
}();

flUsernameInput.$inject = ['$scope', '$timeout', 'Cdn', 'UsersService', 'UserData', 'Facebook'];

var flUsernameInput$1 = flComponent$1(flUsernameInput, {
  selector: 'fl-username-input',
  template: usernameInputTemplate,
  bindings: {
    onCancel: '&',
    onComplete: '&',
    usernameSuggestions: '=',
    showAsModal: '=',
    closeModal: '&',
    isSubmitting: '='
  },
  providers: [CdnProvider, UserData$1, UsersProvider$1, flFocusOnProvider, flIconProvider, FacebookProvider$1, flEmailUsernameValidCheck$1, flUniqueEmailUsernameCheck]
});

var signupBaseFormTemplate = "<div class=\"Modal-header\">\n  <button class=\"Modal-close\" ng-click=\"SignupBaseForm.closeModal($event)\" type=\"button\" data-modal-hide aria-label=\"Close this modal window\"\n    ng-if=\"SignupBaseForm.showAsModal\">\n    <span class=\"Icon Icon--small\">\n      <fl-icon name=\"ui-close\"></fl-icon>\n    </span>\n  </button>\n  <div class=\"ModalLoginSignup-header-logo\">\n    <fl-icon name=\"fl-logo\"></fl-icon>\n  </div>\n</div>\n<div class=\"Modal-body\" fl-analytics-section=\"Signup\">\n  <div class=\"ModalLoginSignup-body-heading\">\n    <span ng-if=\"!SignupBaseForm.loginSignupConfig.getSignupTitle()\">\n      Sign Up\n    </span>\n    <span ng-if=\"SignupBaseForm.loginSignupConfig.getSignupTitle()\">\n      {{SignupBaseForm.loginSignupConfig.getSignupTitle()}}\n    </span>\n  </div>\n  <div ng-if=\"!SignupBaseForm.UserData.isFacebookConnected()\">\n    <button ng-if=\"!SignupBaseForm.loginSignupConfig.isHideFb()\"\n      ng-click=\"SignupBaseForm.facebookConnect()\"\n      class=\"btn-facebook btn btn-large ModalLoginSignup-facebook-connect\"\n      data-uitest-target=\"facebook-signup-button\"\n      fl-analytics=\"FBSignup\">\n      <div class=\"ModalLoginSignup-facebook-container\">\n        <span class=\"ModalLoginSignup-facebook-icon btn-facebook-icon Icon Icon--large Icon--light\">\n            <fl-icon name=\"ui-facebook\"></fl-icon>\n        </span>\n        <div>Continue with Facebook</div>\n      </div>\n    </button>\n    <div ng-messages=\"SignupBaseForm.facebookErrors\" class=\"ModalLoginSignup-signupBaseForm-facebookErrors\">\n      <div ng-message=\"facebookLinked\" class=\"alert alert-success ModalLoginSignup-signupBaseForm-loginSuccess\">\n        <div class=\"ModalLoginSignup-signupBaseForm-loginSuccess-text\">Welcome {{SignupBaseForm.UserData.getFacebookName()}}! Logging you in.</div>\n        <div class=\"Loader Loader--small\"></div>\n      </div>\n      <div ng-message=\"emailTaken\" class=\"alert alert-info\">\n        Your Facebook email is already associated with a Freelancer account.\n        Click <a ng-click=\"SignupBaseForm.showLoginForm()\">here</a> to login.\n      </div>\n      <div ng-message=\"emailBlocked\" class=\"alert alert-error\">\n        The email domain associated with your Facebook Account is blocked. Please use a different email address.\n      </div>\n      <div ng-message=\"notAuthorized\" class=\"alert alert-error\">\n        Please authorise Freelancer to access your Facebook account in order to sign up with Facebook.\n      </div>\n      <div ng-message=\"accessDenied\" class=\"alert alert-error\">\n        There was a problem logging in with your account. Please contact <a href=\"https://www.freelancer.com/support\">support</a>.\n      </div>\n      <div ng-message=\"unknownError\" class=\"alert alert-error\">\n        Failed to connect with Facebook. Please try again.\n      </div>\n    </div>\n    <div ng-if=\"!SignupBaseForm.loginSignupConfig.isHideFb()\" class=\"hr-divider\">\n      <span class=\"hr-divider-text\">OR</span>\n    </div>\n  </div>\n  <div ng-if=\"SignupBaseForm.UserData.isFacebookConnected()\">\n    <figure class=\"ImageThumbnail ModalLoginSignup-facebook-profileImage\">\n      <img ng-src=\"{{SignupBaseForm.UserData.user.facebookPictureUrl}}\" class=\"ImageThumbnail-image\">\n    </figure>\n    <h2 class=\"ModalLoginSignup-body-heading\">\n      Welcome {{SignupBaseForm.UserData.getFacebookName()}}!\n    </h2>\n  </div>\n  <form id=\"signup_form\" class=\"user-signup-form fl-form responsive-form ModalLoginSignup-form\"\n    name=\"SignupBaseForm.form\">\n    <fieldset class=\"ModalLoginSignup-form-fieldset\">\n      <ol>\n        <li class=\"form-step email-step\"\n          ng-class=\"{'is-invalid': SignupBaseForm.form.email.$invalid && SignupBaseForm.form.email.$dirty,\n                     'is-valid': SignupBaseForm.form.email.$valid}\">\n          <label for=\"new-email\" class=\"is-accessibly-hidden\">Email Address</label>\n          <input type=\"text\" name=\"email\" id=\"new-email\"\n            rel=\"popover\" placeholder=\"Email Address\" class=\"large-input\"\n            ng-model=\"SignupBaseForm.UserData.user.email\"\n            ng-model-options=\"{ debounce: {'default': 300, 'blur': 0}, allowInvalid: true }\"\n            ng-disabled=\"SignupBaseForm.UserData.isFacebookConnected()\n              && (SignupBaseForm.form.email.$valid || SignupBaseForm.form.email.$pending)\n              && SignupBaseForm.UserData.user.email === SignupBaseForm.UserData.getFacebookEmail()\"\n            ng-required=\"true\"\n            fl-email-username-valid-check=\"email\"\n            fl-blocked-email-check\n            fl-unique-email-username-check\n            fl-focus-on=\"SignupBaseForm.focusEmailInput\">\n          <div ng-if=\"SignupBaseForm.form.email.$pending\"\n            class=\"Loader Loader--small ModalLoginSignup-inputLoader\">\n          </div>\n          <div class=\"form-help\" id=\"new-email-suggestion\" style=\"display: none;\">\n            Did you mean <a id=\"new-email-suggestion-content\"></a>?\n          </div>\n          <div ng-messages=\"SignupBaseForm.form.email.$error\" tabindex=\"-1\">\n            <div class=\"form-error\" ng-message=\"required\">\n              Please enter an email address.\n            </div>\n            <div class=\"form-error\" ng-message=\"validEmail\">\n              Please enter a valid email address.\n            </div>\n            <div class=\"form-error\" ng-message=\"unblockedEmail\">\n              This email domain is blocked. Please use a different email address.\n            </div>\n            <div class=\"form-error\" ng-message=\"uniqueEmail\">\n              This email address is already in use.\n            </div>\n          </div>\n        </li>\n\n        <li class=\"form-step password-step\"\n          ng-if=\"!SignupBaseForm.UserData.isFacebookConnected()\"\n          ng-class=\"{'is-invalid': SignupBaseForm.form.password.$invalid && SignupBaseForm.form.password.$dirty,\n                     'is-valid': SignupBaseForm.form.password.$valid}\">\n          <label for=\"new-password\" class=\"is-accessibly-hidden\">Password</label>\n          <input type=\"password\" id=\"new-password\" name=\"password\"\n            placeholder=\"Password\" class=\"large-input\"\n            ng-model=\"SignupBaseForm.UserData.user.password\"\n            ng-required=\"true\"\n            ng-minlength=\"6\"\n            ng-maxlength=\"150\"\n            fl-password-check>\n          <div ng-if=\"SignupBaseForm.form.password.$pending\"\n            class=\"Loader Loader--small ModalLoginSignup-inputLoader\">\n          </div>\n          <div ng-messages=\"SignupBaseForm.form.password.$error\" tabindex=\"-1\">\n            <div class=\"form-error\" ng-message=\"required\">\n              Please enter a password.\n            </div>\n            <div class=\"form-error\" ng-message=\"minlength\">\n              Password must be at least 6 characters.\n            </div>\n            <div class=\"form-error\" ng-message=\"maxlength\">\n              Password must be at most 150 characters.\n            </div>\n            <div class=\"form-error\" ng-message=\"uniqueFromUsername\">\n              Password must be different to username.\n            </div>\n            <div class=\"form-error\" ng-message=\"strongPassword\">\n              Password must contain lowercase and uppercase letters or a number.\n            </div>\n          </div>\n        </li>\n\n        <li id=\"coupon-step\" class=\"form-step coupon-step\" ng-if=\"SignupBaseForm.showCouponInput\">\n            <button type=\"button\" id=\"redeem_coupon\" class=\"coupon-step-toggle btn btn-plain\">\n              I have a coupon code I would like to use\n            </button>\n            <div class=\"coupon-step-inner\">\n              <label for=\"coupon\">\n                Coupon Code (Optional)\n              </label>\n              <input type=\"text\" name=\"coupon\" id=\"coupon\" value=\"{{SignupBaseForm.coupon}}\" class=\"default-input\">\n              <span class=\"help-inline\"></span>\n              <div class=\"form-error\"></div>\n            </div>\n        </li>\n\n        <input type=\"hidden\" name=\"signup_skip_captcha\" id=\"signup_skip_captcha\" value=\"{{SignupBaseForm.loginSignupConfig.getSkipCaptchaHash()}}\">\n\n        <li class=\"form-step\">\n            <button type=\"submit\" id=\"signup_btn\"\n              class=\"btn btn-info btn-large btn-submit ModalLoginSignup-signupBaseForm-submitBtn\"\n              ng-click=\"SignupBaseForm.onFormSubmit($event)\"\n              fl-analytics=\"NormalSignupEmailPassword\">\n              Join Freelancer\n            </button>\n        </li>\n        <small class=\"ModalLoginSignup-signupBaseForm-signupTerms\">\n          By registering you confirm that you accept the\n          <a href='/about/terms' onclick='window.open(\n            \"/info/plainterms.html\",\"\",\"width=500, height=450, left=100,top=100,menu=no, toolbar=no,scrollbars=yes,resizable=yes\"\n            );return false;'>\n            Terms and Conditions\n          </a>\n          and\n          <a href='/about/privacy' onclick='window.open(\n            \"/about/privacy?popup=true\",\"\",\"width=700, height=550, left=100,top=100,menu=no, toolbar=no,scrollbars=yes,resizable=yes\"\n           );return false;'>\n            Privacy Policy\n          </a>\n        </small>\n      </ol>\n    </fieldset>\n  </form>\n</div>\n";

var flSignupBaseForm = function () {
  function flSignupBaseForm($log, $timeout, UsersService, UserData, LoginSignupConfig) {
    var _this = this;

    _classCallCheck(this, flSignupBaseForm);

    this.$log = $log;
    this.$timeout = $timeout;
    this.UserData = UserData;
    this.Users = UsersService;
    this.loginSignupConfig = LoginSignupConfig;

    if (this.loginSignupConfig.getEmailPrefill()) {
      this.UserData.user.email = this.loginSignupConfig.getEmailPrefill();
    }

    // Focus on Email Input after timeout. (Triggers flFocusOn)
    this.$timeout(function () {
      _this.focusEmailInput = true;
    }, 50);
  }

  _createClass(flSignupBaseForm, [{
    key: 'onFormSubmit',
    value: function onFormSubmit(event) {
      event.preventDefault();
      // Set form fields as dirty if it has any errors.
      angular.forEach(this.form.$error, function (type) {
        angular.forEach(type, function (field) {
          field.$setDirty();
        });
      });
      if (!this.form.$valid) {
        return;
      }
      this.onComplete();
    }
  }, {
    key: 'closeModal',
    value: function closeModal($event) {
      this.closeModal({ $event: $event });
    }
  }]);

  return flSignupBaseForm;
}();

flSignupBaseForm.$inject = ['$log', '$timeout', 'UsersService', 'UserData', 'LoginSignupConfig'];

var flSignupBaseForm$1 = flComponent$1(flSignupBaseForm, {
  selector: 'fl-signup-base-form',
  template: signupBaseFormTemplate,
  bindings: {
    onComplete: '&',
    showLoginForm: '&',
    facebookConnect: '&',
    facebookErrors: '=',
    showAsModal: '=',
    closeModal: '&'
  },
  providers: [ngMessages, UserData$1, UsersProvider$1, flIconProvider, flFocusOnProvider, flPasswordCheck, flBlockedEmailCheck, flEmailUsernameValidCheck$1, LoginSignupConfigProvider, flUniqueEmailUsernameCheck]
});

var accountTypeSelectorTemplate = "<div class=\"Modal-header\">\n  <div class=\"ModalLoginSignup-header\">\n    <div ng-click=\"AccountTypeSelector.onCancel()\" class=\"ModalLoginSignup-header-previousStep\">\n      <fl-icon name=\"ui-chevron-left\" class=\"ModalLoginSignup-header-previousStep-icon\"></fl-icon>\n    </div>\n    <button class=\"Modal-close\" ng-click=\"AccountTypeSelector.closeModal($event)\" type=\"button\" data-modal-hide aria-label=\"Close this modal window\"\n      ng-if=\"AccountTypeSelector.showAsModal\">\n      <span class=\"Icon Icon--small\">\n        <fl-icon name=\"ui-close\"></fl-icon>\n      </span>\n    </button>\n    <div id=\"fl-logo\" class=\"ModalLoginSignup-header-logo\">\n      <img ng-src=\"{[{AccountTypeSelector.headerImageUrl}]}\" alt=\"Freelancer logo\" />\n    </div>\n  </div>\n</div>\n<div class=\"Modal-body\" fl-analytics-section=\"Signup\">\n  <h2 class=\"ModalLoginSignup-body-title\">Select account type</h2>\n  <p class=\"ModalLoginSignup-body-subtitle\">Don’t worry, this can be changed later.</p>\n  <div ng-click=\"AccountTypeSelector.selectFreelancer()\" class=\"Card ModalLoginSignup-signupAccountType-card\" fl-analytics=\"NormalSignupFreelancer\">\n    <div class=\"ModalLoginSignup-signupAccountType-card-content\">\n      <div class=\"ModalLoginSignup-signupAccountType-card-image\">\n        <img ng-src=\"{[{AccountTypeSelector.workImageUrl}]}\" alt=\"Work Image\" />\n      </div>\n      <div class=\"ModalLoginSignup-signupAccountType-card-title\">\n        I want to work\n      </div>\n    </div>\n    <div class=\"ModalLoginSignup-signupAccountType-card-next\">\n      <div ng-if=\"!AccountTypeSelector.submittingSignup || AccountTypeSelector.selectedEmployer\">\n        <fl-icon name=\"ui-arrow-right\" class=\"ModalLoginSignup-signupAccountType-card-next-icon\">\n        </fl-icon>\n      </div>\n      <div ng-if=\"AccountTypeSelector.submittingSignup && AccountTypeSelector.selectedFreelancer\" class=\"Loader Loader--small\">\n      </div>\n    </div>\n  </div>\n  <div ng-click=\"AccountTypeSelector.selectEmployer()\" class=\"Card ModalLoginSignup-signupAccountType-card\" fl-analytics=\"NormalSignupEmployer\">\n    <div class=\"ModalLoginSignup-signupAccountType-card-content\">\n      <div class=\"ModalLoginSignup-signupAccountType-card-image\">\n        <img ng-src=\"{[{AccountTypeSelector.hireImageUrl}]}\" alt=\"Hire Image\" />\n      </div>\n      <div class=\"ModalLoginSignup-signupAccountType-card-title\">\n        I want to hire\n      </div>\n    </div>\n    <div class=\"ModalLoginSignup-signupAccountType-card-next\">\n      <div ng-if=\"!AccountTypeSelector.submittingSignup || AccountTypeSelector.selectedFreelancer\">\n        <fl-icon name=\"ui-arrow-right\" class=\"ModalLoginSignup-signupAccountType-card-next-icon\">\n        </fl-icon>\n      </div>\n      <div ng-if=\"AccountTypeSelector.submittingSignup && AccountTypeSelector.selectedEmployer\" class=\"Loader Loader--small\">\n      </div>\n    </div>\n  </div>\n</div>\n";

var flAccountTypeSelector = function () {
  function flAccountTypeSelector(Cdn, UserData, UsersService) {
    _classCallCheck(this, flAccountTypeSelector);

    this.headerImageUrl = Cdn.getCdnUrl('/static/img/freelancer-logo.svg');
    this.hireImageUrl = Cdn.getCdnUrl('/static/img/login-signup/fln-icon-hire.svg');
    this.workImageUrl = Cdn.getCdnUrl('/static/img/login-signup/fln-icon-work.svg');
    this.UserData = UserData;
    this.Users = UsersService;

    // States
    this.selectedEmployer = false;
    this.selectedFreelancer = false;
  }

  _createClass(flAccountTypeSelector, [{
    key: 'selectEmployer',
    value: function selectEmployer() {
      this.UserData.user.role = USER_TYPE_EMPLOYER;
      this.selectedEmployer = true;
      this.selectedFreelancer = false;
      this.onComplete();
    }
  }, {
    key: 'selectFreelancer',
    value: function selectFreelancer() {
      this.UserData.user.role = USER_TYPE_FREELANCER;
      this.selectedFreelancer = true;
      this.selectedEmployer = false;
      this.onComplete();
    }
  }]);

  return flAccountTypeSelector;
}();

flAccountTypeSelector.$inject = ['Cdn', 'UserData', 'UsersService'];

var flAccountTypeSelector$1 = flComponent$1(flAccountTypeSelector, {
  selector: 'fl-account-type-selector',
  template: accountTypeSelectorTemplate,
  bindings: {
    onCancel: '&',
    onComplete: '&',
    submittingSignup: '=',
    showAsModal: '=',
    closeModal: '&'
  },
  providers: [CdnProvider, UserData$1, UsersProvider$1, flIconProvider]
});

var privacyConsentFormTemplate = "<div class=\"Modal-header\">\n  <div class=\"ModalLoginSignup-header\">\n    <div ng-click=\"PrivacyConsentForm.onCancel()\" class=\"ModalLoginSignup-header-previousStep\">\n      <fl-icon name=\"ui-chevron-left\" class=\"ModalLoginSignup-header-previousStep-icon\"></fl-icon>\n    </div>\n    <button class=\"Modal-close\" ng-click=\"PrivacyConsentForm.loginSignupConfig.hide()\" type=\"button\" data-modal-hide aria-label=\"Close this modal window\"\n      ng-if=\"PrivacyConsentForm.loginSignupConfig.isModal()\">\n      <span class=\"Icon Icon--small\">\n        <fl-icon name=\"ui-close\"></fl-icon>\n      </span>\n    </button>\n    <div id=\"fl-logo\" class=\"ModalLoginSignup-header-logo\">\n      <img ng-src=\"{[{PrivacyConsentForm.headerImageUrl}]}\" alt=\"Freelancer logo\" />\n    </div>\n  </div>\n</div>\n<div class=\"Modal-body\" fl-analytics-section=\"Signup\">\n <form name=\"PrivacyConsentForm.form\">\n    <h2 class=\"ModalLoginSignup-body-title\">Email Opt-In</h2>\n    <p class=\"ModalLoginSignup-body-subtitle\">Would you like to receive marketing promotions, special offers, inspirations, and updates to Freelancer's product and policies? You can unsubscribe at any time.</p>\n    <div class=\"fl-form Checkbox ModalLoginSignup-privacyConsentForm-input\">\n      <input id=\"privacy-consent\" name=\"privacy-consent\"\n        class=\"Checkbox-input\" type=\"checkbox\"\n        ng-model=\"PrivacyConsentForm.UserData.user.privacyConsent\">\n      <label class=\"Checkbox-label\" for=\"privacy-consent\">\n        Yes, I want to receive emails.\n      </label>\n    </div>\n\n    <h2 class=\"ModalLoginSignup-body-title\">Account Type</h2>\n    <p class=\"ModalLoginSignup-body-subtitle\">Do you intend to use Freelancer for personal use? Using Freelancer for cases other than business may be subject to additional VAT.</p>\n    <div class=\"fl-form Checkbox ModalLoginSignup-privacyConsentForm-input\">\n      <input id=\"business-user\" name=\"business-user\"\n        class=\"Checkbox-input\" type=\"checkbox\"\n        ng-model=\"PrivacyConsentForm.UserData.user.privateUser\">\n      <label class=\"Checkbox-label\" for=\"business-user\">\n        Yes, I am using Freelancer for personal use.\n      </label>\n    </div>\n\n    <button type=\"submit\"\n      class=\"btn btn-info btn-large btn-submit ModalLoginSignup-privacyConsentForm-submitBtn\"\n      ng-click=\"PrivacyConsentForm.onFormSubmit($event)\"\n      fl-analytics=\"NormalSignupPrivacyConsent\"\n      ng-disabled=\"PrivacyConsentForm.submittingSignup\">\n      <span ng-if=\"!PrivacyConsentForm.submittingSignup\">\n        Sign Up\n      </span>\n      <span ng-if=\"PrivacyConsentForm.submittingSignup\">\n        <div class=\"Loader Loader--small\"></div>\n      </span>\n    </button>\n  </form>\n</div>\n";

var flPrivacyConsentForm = function () {
  function flPrivacyConsentForm(Cdn, UserData, LoginSignupConfig) {
    _classCallCheck(this, flPrivacyConsentForm);

    this.headerImageUrl = Cdn.getCdnUrl('/static/img/freelancer-logo.svg');
    this.UserData = UserData;
    this.loginSignupConfig = LoginSignupConfig;
    this.UserData.user.privateUser = false;
  }

  _createClass(flPrivacyConsentForm, [{
    key: 'onFormSubmit',
    value: function onFormSubmit(event) {
      event.preventDefault();
      // Set form fields as dirty if it has any errors.
      angular.forEach(this.form.$error, function (type) {
        angular.forEach(type, function (field) {
          field.$setDirty();
        });
      });
      if (!this.form.$valid) {
        return;
      }
      this.onComplete();
    }
  }]);

  return flPrivacyConsentForm;
}();

flPrivacyConsentForm.$inject = ['Cdn', 'UserData', 'LoginSignupConfig'];

var flPrivacyConsentForm$1 = flComponent$1(flPrivacyConsentForm, {
  selector: 'fl-privacy-consent-form',
  template: privacyConsentFormTemplate,
  bindings: {
    onCancel: '&',
    onComplete: '&',
    submittingSignup: '='
  },
  providers: [CdnProvider, UserData$1, flIconProvider, LoginSignupConfigProvider]
});

/**
 * @ngdoc service
 * @name Captcha
 * @description
 * Captcha Service
 * TODO: Move to replace captcha.js in flAngular
 * (also need to move flRecaptcha.js which contains the directive)
 */

var Captcha = function () {
  function Captcha($q, $window, $interval, RECAPTCHA_PUBLIC_KEY) {
    _classCallCheck(this, Captcha);

    this.$q = $q;
    this.$window = $window;
    this.$interval = $interval;
    this.RECAPTCHA_PUBLIC_KEY = RECAPTCHA_PUBLIC_KEY;
    this.recaptchaLibraryLoaded = false;
  }

  _createClass(Captcha, [{
    key: 'create',
    value: function create(element, params) {
      var _this = this;

      // Assign Site Key
      params.sitekey = this.RECAPTCHA_PUBLIC_KEY;
      // Create Promise
      var deferred = this.$q.defer();
      if (this.recaptchaLibraryLoaded) {
        (function () {
          var waitForLoad = _this.$interval(function () {
            if (angular.isDefined(_this.$window.grecaptcha)) {
              _this.$interval.cancel(waitForLoad);
              var widgetId = _this._render(element, params);
              deferred.resolve(widgetId);
            }
          }, 100);
        })();
      } else if (!this._existsRecaptchaScript()) {
        // If recaptcha script does not exist, create it and call back to render
        this.recaptchaLibraryLoaded = true;
        // Create callback function to onRecaptchaLoad
        this.$window.onRecaptchaLoad = function () {
          var widgetId = _this._render(element, params);
          deferred.resolve(widgetId);
        };
        this._injectRecaptchaScript(element);
      } else {
        // Otherwise, call render
        var widgetId = this._render(element, params);
        deferred.resolve(widgetId);
      }
      return deferred.promise;
    }
  }, {
    key: '_render',
    value: function _render(element, params) {
      return this.$window.grecaptcha.render(element, params);
    }
  }, {
    key: '_existsRecaptchaScript',
    value: function _existsRecaptchaScript() {
      return angular.isDefined(this.$window.grecaptcha);
    }
  }, {
    key: '_injectRecaptchaScript',
    value: function _injectRecaptchaScript() {
      var script = angular.element(document.createElement('script'));
      script.attr('src', 'https://www.google.com/recaptcha/api.js?onload=onRecaptchaLoad&render=explicit');
      script.attr('async', true);
      angular.element(document.body).append(script);
    }
  }]);

  return Captcha;
}();

Captcha.$inject = ['$q', '$window', '$interval', 'RECAPTCHA_PUBLIC_KEY'];

var CaptchaProvider = flService$1('Captcha', [OPAQUE_MODULE_NAME], Captcha);

/**
 * @ngdoc directive
 * @name Captcha.directive:flRecaptcha
 * @restrict E
 * @description
 * Injects Google No Captcha Recaptcha
 * TODO: Move to replace this with flRecaptcha in flAngular
 * (also need to move captcha.js which contains the service)
 */

var flRecaptcha = function () {
  function flRecaptcha($window, Captcha) {
    _classCallCheck(this, flRecaptcha);

    this.$window = $window;
    this.Captcha = Captcha;
  }

  _createClass(flRecaptcha, [{
    key: 'link',
    value: function link() {
      var _this = this;

      this.widgetId = null;
      this.captchaRendered = false;
      this.Captcha.create(this.elementId, this.getParams()).then(function (widgetId) {
        _this.widgetId = widgetId;
        _this.captchaRendered = true;
      }).catch(function () {});
    }
  }, {
    key: 'getParams',
    value: function getParams() {
      return {
        callback: this._successCallback.bind(this),
        'expired-callback': this._expiredCallback.bind(this),
        'error-callback': this._errorCallback.bind(this),
        theme: this.theme,
        type: this.type,
        size: this.size
      };
    }
  }, {
    key: '_successCallback',
    value: function _successCallback(response) {
      this.onSuccess({ response: response });
    }
  }, {
    key: '_expiredCallback',
    value: function _expiredCallback() {
      this.onExpired();
    }
  }, {
    key: '_errorCallback',
    value: function _errorCallback() {
      this.onError();
    }
  }]);

  return flRecaptcha;
}();

flRecaptcha.$inject = ['$window', 'Captcha'];

var flRecaptcha$1 = flDirective$1(flRecaptcha, {
  selector: 'fl-recaptcha',
  template: '<div id="{{Recaptcha.elementId}}"></div><div class="Loader" ng-if="!Recaptcha.captchaRendered"></div>',
  restrict: 'E',
  scope: {
    elementId: '@',
    theme: '@',
    type: '@',
    size: '@',
    onSuccess: '&',
    onExpired: '&',
    onError: '&'
  },
  providers: [CaptchaProvider]
});

var captchaFormTemplate = "<div class=\"Modal-header\">\n  <button type=\"button\" class=\"Modal-close\" type=\"button\"\n    aria-label=\"Close this modal window\" ng-click=\"CaptchaForm.closeModal($event)\">\n    <span class=\"Icon Icon--small\">\n      <fl-icon name=\"ui-close\"></fl-icon>\n    </span>\n  </button>\n  <div id=\"fl-logo\" class=\"ModalLoginSignup-header-logo\">\n    <img ng-src=\"{[{CaptchaForm.headerImageUrl}]}\" alt=\"Freelancer logo\" />\n  </div>\n</div>\n<div class=\"Modal-body\">\n  <h2 class=\"ModalLoginSignup-body-heading\">You're almost there!</h2>\n  <div class=\"ModalLoginSignup-captchaForm-recaptcha\">\n    <fl-recaptcha element-id=\"SignupCaptcha\"\n      on-success=\"CaptchaForm.onVerifyCaptcha(response)\"\n      on-expired=\"CaptchaForm.onExpiredCaptcha()\">\n    </fl-recaptcha>\n  </div>\n  <div ng-if=\"CaptchaForm.showError\" class=\"alert alert-error ModalLoginSignup-captchaForm-error\">\n    You must click the I'm not a robot checkbox.\n  </div>\n  <button class=\"btn btn-large btn-info ModalLoginSignup-captchaForm-submit\"\n    ng-click=\"CaptchaForm.onSubmit()\"\n    ng-disabled=\"CaptchaForm.submittingSignup\">\n    <span ng-if=\"!CaptchaForm.submittingSignup\">\n      Join Freelancer\n    </span>\n    <span ng-if=\"CaptchaForm.submittingSignup\">\n      <div class=\"Loader Loader--small\"></div>\n    </span>\n  </button>\n</div>\n";

var flCaptchaForm = function () {
  function flCaptchaForm(Cdn, UserData) {
    _classCallCheck(this, flCaptchaForm);

    this.UserData = UserData;
    this.headerImageUrl = Cdn.getCdnUrl('/static/img/freelancer-logo.svg');
    this.showError = false;
    this.isSubmitting = false;
    this.verifiedCaptcha = false;
  }

  _createClass(flCaptchaForm, [{
    key: 'onExpiredCaptcha',
    value: function onExpiredCaptcha() {
      this.verifiedCaptcha = false;
      this.UserData.user.captcha.response = '';
    }
  }, {
    key: 'onVerifyCaptcha',
    value: function onVerifyCaptcha(response) {
      if (!response) {
        return;
      }
      this.verifiedCaptcha = true;
      this.showError = false;
      this.UserData.user.captcha.response = response;
    }
  }, {
    key: 'onSubmit',
    value: function onSubmit() {
      this.isSubmitting = true;
      if (this.verifiedCaptcha !== true) {
        this.showError = true;
        this.isSubmitting = false;
        return;
      }
      this.showError = false;
      this.onComplete();
    }
  }, {
    key: 'closeModal',
    value: function closeModal($event) {
      this.closeModal({ $event: $event });
    }
  }]);

  return flCaptchaForm;
}();

flCaptchaForm.$inject = ['Cdn', 'UserData'];

var flCaptchaForm$1 = flComponent$1(flCaptchaForm, {
  selector: 'fl-captcha-form',
  template: captchaFormTemplate,
  bindings: {
    onCancel: '&',
    onComplete: '&',
    submittingSignup: '=',
    showAsModal: '=',
    closeModal: '&'
  },
  providers: [UserData$1, CdnProvider, flIconProvider, flRecaptcha$1]
});

var signupSuccessTemplate = "<div class=\"Modal-header\">\n  <div class=\"ModalLoginSignup-header\">\n    <button class=\"Modal-close\" ng-click=\"SignupSuccess.closeModal($event)\" type=\"button\" data-modal-hide aria-label=\"Close this modal window\"\n      ng-if=\"SignupSuccess.loginSignupConfig.isModal()\">\n      <span class=\"Icon Icon--small\">\n        <fl-icon name=\"ui-close\"></fl-icon>\n      </span>\n    </button>\n    <div id=\"fl-logo\" class=\"ModalLoginSignup-header-logo\">\n      <img ng-src=\"{[{SignupSuccess.headerImageUrl}]}\" alt=\"Freelancer logo\" />\n    </div>\n  </div>\n</div>\n<div class=\"Modal-body\" fl-analytics-section=\"Signup\">\n  <div class=\"ModalLoginSignup-signupSuccess\">\n    <h2 class=\"ModalLoginSignup-body-title\">Signup Success!</h2>\n    <div ng-if=\"SignupSuccess.loginSignupConfig.getSignupSuccessMessage()\">\n      <p class=\"ModalLoginSignup-body-subtitle\">{{SignupSuccess.loginSignupConfig.getSignupSuccessMessage()}}</p>\n    </div>\n    <div ng-if=\"!SignupSuccess.loginSignupConfig.getSignupSuccessMessage()\">\n      <p class=\"ModalLoginSignup-body-subtitle\">Please wait while we redirect you...</p>\n    </div>\n    <div class=\"ModalLoginSignup-signupSuccess-spinner\">\n      <div class=\"Loader Loader--large\"></div>\n    </div>\n  </div>\n</div>\n";

var flSignupSuccess = function () {
  function flSignupSuccess(Cdn, UserData, LoginSignupConfig) {
    _classCallCheck(this, flSignupSuccess);

    this.headerImageUrl = Cdn.getCdnUrl('/static/img/freelancer-logo.svg');
    this.UserData = UserData;
    this.loginSignupConfig = LoginSignupConfig;
  }

  _createClass(flSignupSuccess, [{
    key: 'closeModal',
    value: function closeModal($event) {
      this.closeModal({ $event: $event });
    }
  }]);

  return flSignupSuccess;
}();

flSignupSuccess.$inject = ['Cdn', 'UserData', 'LoginSignupConfig'];

var flSignupSuccess$1 = flComponent$1(flSignupSuccess, {
  selector: 'fl-signup-success',
  template: signupSuccessTemplate,
  bindings: { closeModal: '&' },
  providers: [CdnProvider, UserData$1, LoginSignupConfigProvider]
});

var signupTemplate = "<fl-signup-base-form\n  ng-if=\"Signup.currentStep === Signup.steps.BASE_STEP\"\n  on-complete=\"Signup.onCompleteBaseForm()\"\n  facebook-connect=\"Signup.facebookConnect()\"\n  facebook-errors=\"Signup.error.facebook\"\n  show-login-form=\"Signup.gotoLogin()\"\n  show-as-modal=\"Signup.showAsModal\"\n  close-modal=\"Signup.closeModal($event)\">\n</fl-signup-base-form>\n<fl-username-input\n  ng-if=\"Signup.currentStep === Signup.steps.USERNAME_STEP\"\n  username-suggestions=\"Signup.usernameSuggestions\"\n  on-cancel=\"Signup.currentStep = Signup.steps.BASE_STEP\"\n  on-complete=\"Signup.onCompleteUsernameStep()\"\n  show-as-modal=\"Signup.showAsModal\"\n  is-submitting=Signup.isSubmitting\n  close-modal=\"Signup.closeModal($event)\">\n</fl-username-input>\n<fl-account-type-selector\n  ng-if=\"Signup.currentStep === Signup.steps.ACCOUNT_TYPE_STEP\"\n  on-cancel=\"Signup.currentStep = Signup.steps.USERNAME_STEP\"\n  on-complete=\"Signup.onCompleteAccountTypeStep()\"\n  submitting-signup=\"Signup.isSubmitting\"\n  show-as-modal=\"Signup.showAsModal\"\n  close-modal=\"Signup.closeModal($event)\">\n</fl-account-type-selector>\n<fl-privacy-consent-form\n  ng-if=\"Signup.currentStep === Signup.steps.PRIVACY_CONSENT_STEP\"\n  on-cancel=\"Signup.currentStep = Signup.steps.ACCOUNT_TYPE_STEP\"\n  on-complete=\"Signup.onCompletePrivacyStep()\"\n  submitting-signup=\"Signup.isSubmitting\">\n</fl-privacy-consent-form>\n<fl-captcha-form\n  ng-if=\"Signup.currentStep === Signup.steps.CAPTCHA_STEP\"\n  on-complete=\"Signup.onCompleteCaptchaStep(response)\"\n  submitting-signup=\"Signup.isSubmitting\"\n  show-as-modal=\"Signup.showAsModal\"\n  close-modal=\"Signup.closeModal($event)\">\n</fl-captcha-form>\n<fl-signup-success\n  ng-if=\"Signup.currentStep === Signup.steps.SUCCESS_STEP\"\n  close-modal=\"Signup.closeModal($event)\">\n</fl-signup-success>\n<div class=\"Modal-footer\">\n  <div ng-messages=\"Signup.error\">\n    <div ng-message=\"accessDenied\" class=\"alert alert-error\">\n      There was a problem logging in with your account. Please contact <a href=\"https://www.freelancer.com/support\">support</a>.\n    </div>\n    <div ng-message=\"internalError\" class=\"alert alert-error\">\n      Something went wrong. Please try again.\n    </div>\n  </div>\n  <div ng-if=\"Signup.loginSignupConfig.showLoginOption() && Signup.currentStep === Signup.steps.BASE_STEP\"\n    class=\"ModalLoginSignup-switchLoginSignupType\">\n    Already have an account?\n    <a ng-click=\"Signup.gotoLogin()\" class=\"ModalLoginSignup--switchToLogin-link\">\n      Log In\n    </a>\n  </div>\n</div>\n";

/**
 * @ngdoc controller
 * @name LoginSignupApp.flSignup
 * @description
 * Handles the Signup Flow which consists of several steps:
 * 1. Email and Password Step (signup-base-form)
 * 2. Username Step (username-input)
 * 3. Account Type Step (account-type-selector)
 */

var flSignup = function () {
  function flSignup($window, $rootScope, Auth, Analytics, Cdn, CookieStore, Facebook, LoginSignupConfig, UserData, Users, UsersService) {
    var _this = this;

    _classCallCheck(this, flSignup);

    this.$window = $window;
    this.$rootScope = $rootScope;
    this.isSubmitting = false;
    this.Auth = Auth;
    this.Users = Users;
    this.UserData = UserData;
    this.UsersService = UsersService;
    this.Facebook = Facebook;
    this.Analytics = Analytics;
    this.Cdn = Cdn;
    this.CookieStore = CookieStore;
    this.loginSignupConfig = LoginSignupConfig;
    // Form
    this.error = {};
    this.steps = SIGNUP_STEPS;
    this.currentStep = this.steps.BASE_STEP;
    this.usernameSuggestions = [];
    this.referralSignupCookieKey = REFERRAL_SIGNUP_COOKIE_KEY;

    // Initialise User Object
    this.UserData.user.isNewUser = true;

    // Watch for Signup/Login switches, and auto connect facebook
    this.watchShowSignup = $rootScope.$watch(function () {
      return _this.loginSignupConfig.options.showSignup;
    }, function (newValue) {
      // If Show Signup was set to true, try auto connect facebook
      if (newValue === true && _this.UserData.isFacebookConnected()) {
        _this.facebookConnect(true, false);
      }
    });
  }

  /**
   * @ngdoc method
   * @name LoginSignupApp.flSignup#gotoLogin
   * @methodOf LoginSignupApp.flSignup
   * @description
   * Switches to Login funnel by:
   * Setting the rootscope variable to false in order for flLogin to be displayed.
   */

  _createClass(flSignup, [{
    key: 'gotoLogin',
    value: function gotoLogin() {
      // Clear Errors
      this.clearErrors();
      // Disconnect Facebook if Connected (stops Login from auto logging same
      // facebook account, and redirecting back to signup if it is a new account)
      this.UserData.setFacebookConnected(false);
      this.loginSignupConfig.switchToLogin();
    }

    /**
     * @ngdoc method
     * @name LoginSignupApp.flSignup#onCompleteBaseForm
     * @methodOf LoginSignupApp.flSignup
     * @description
     * Call back for when the user successfully completes the base form.
     * Generates suggested usernames and activates to step 2, which is username input.
     */

  }, {
    key: 'onCompleteBaseForm',
    value: function onCompleteBaseForm() {
      this.clearErrors();
      this.generateSuggestedUsernames();
      this.currentStep = this.steps.USERNAME_STEP;
    }

    /**
     * @ngdoc method
     * @name LoginSignupApp.flSignup#onCompleteUsernameStep
     * @methodOf LoginSignupApp.flSignup
     * @description
     * Call back for when the user successfully completes the username input step.
     * Activates step 3 which is account type selector.
     */

  }, {
    key: 'onCompleteUsernameStep',
    value: function onCompleteUsernameStep() {
      this.clearErrors();
      // Check whether we can skip the Select Account Type Step.
      if (this.loginSignupConfig.getForcedAccountType() === USER_TYPE_FREELANCER) {
        this.UserData.user.role = USER_TYPE_FREELANCER;
        this.onCompleteAccountTypeStep();
      } else if (this.loginSignupConfig.getForcedAccountType() === USER_TYPE_EMPLOYER) {
        this.UserData.user.role = USER_TYPE_EMPLOYER;
        this.onCompleteAccountTypeStep();
      } else {
        this.currentStep = this.steps.ACCOUNT_TYPE_STEP;
      }
    }

    /**
     * @ngdoc method
     * @name LoginSignupApp.flSignup#onCompleteAccountTypeStep
     * @methodOf LoginSignupApp.flSignup
     * @description
     * Call back for when the user successfully completes the account type selector step.
     *
     * Show Privacy Consent Form as next step for EU Users.
     * Default Privacy Consent to true for Non EU Users.
     */

  }, {
    key: 'onCompleteAccountTypeStep',
    value: function onCompleteAccountTypeStep() {
      this.clearErrors();

      var fromEU = this.CookieStore.get(IS_FROM_EU_COOKIE_KEY);
      if (fromEU === 'true') {
        this.UserData.user.isFromEU = true;
        this.UserData.user.privacyConsent = false;
      } else {
        this.UserData.user.isFromEU = false;
        this.UserData.user.privacyConsent = true;
      }
      // If User is from EU, show Privacy Step.
      if (this.UserData.user.isFromEU) {
        this.currentStep = this.steps.PRIVACY_CONSENT_STEP;
        return;
      }

      // Otherwise: Normal Signup Flow (default Privacy Consent to true)
      this.UserData.user.privacyConsent = true;
      if (this.UserData.isFacebookConnected()) {
        this.tryFacebookSignup();
        return;
      }
      this.tryUserSignup();
    }

    /**
     * @ngdoc method
     * @name LoginSignupApp.flSignup#onCompletePrivacyStep
     * @description
     * Call back for when user successfully completes the privacy step.
     */

  }, {
    key: 'onCompletePrivacyStep',
    value: function onCompletePrivacyStep() {
      this.clearErrors();
      if (this.UserData.isFacebookConnected()) {
        this.tryFacebookSignup();
        return;
      }
      this.tryUserSignup();
    }

    /**
     * @ngdoc method
     * @name LoginSignupApp.flSignup#onCompleteCaptchaStep
     * @methodOf LoginSignupApp.flSignup
     * @description
     * Call back for when the user successfully completes the captcha step.
     */

  }, {
    key: 'onCompleteCaptchaStep',
    value: function onCompleteCaptchaStep() {
      this.clearErrors();
      if (this.UserData.isFacebookConnected()) {
        this.tryFacebookSignup();
        return;
      }
      this.tryUserSignup();
    }

    /**
     * @ngdoc method
     * @name LoginSignupApp.flSignup#onSignupSuccessStep
     * @methodOf LoginSignupApp.flSignup
     * @description
     * Show Message whilst satisfying any redirects and callbacks.
     */

  }, {
    key: 'onSignupSuccessStep',
    value: function onSignupSuccessStep() {
      var source = this.UserData.isFacebookConnected() ? 'facebook' : 'normal';
      qtsp.push({
        section: this.loginSignupConfig.getPageName(),
        sub_section: 'LoginSignup',
        label: 'OnSignup',
        name: 'success',
        value: source
      });

      this.clearErrors();
      // If Redirect is not disabled, show success step while user is being
      // redirected. Otherwise, keep window open until signup is successful.
      if (!this.loginSignupConfig.isRedirectDisabled()) {
        this.currentStep = this.steps.SUCCESS_STEP;
      }
    }

    /**
     * @ngdoc method
     * @name LoginSignupApp.flSignup#facebookConnect
     * @methodOf LoginSignupApp.flSignup
     * @description
     * Connects to the User's Facebook Account, and stores the user's facebook profile
     * information in UserData.
     */

  }, {
    key: 'facebookConnect',
    value: function facebookConnect(skipLogin, retry) {
      var _this2 = this;

      // Clear Errors and define facebook error
      this.clearErrors();
      this.error.facebook = {};
      var authParamsPromise = void 0;
      // 1. Get Facebook auth params
      // If we come from Facebook login, we need to skip the login
      // step otherwise the popup will be blocked!
      if (!skipLogin) {
        authParamsPromise = this.Facebook.login();
      } else {
        authParamsPromise = this.Facebook.checkConnected().catch(function () {});
      }
      authParamsPromise.then(function (facebookAuthParams) {
        // 2. Get Facebook user infos
        _this2.UserData.setFacebookUserId(facebookAuthParams.userID);
        _this2.UserData.setFacebookAccessToken(facebookAuthParams.accessToken);
        _this2.UserData.user.facebookSignedRequest = facebookAuthParams.signedRequest;
        return _this2.Facebook.getUser();
      }).then(function (facebookUser) {
        _this2.UserData.setFacebookEmail(facebookUser.email);
        _this2.UserData.setFacebookName(facebookUser.first_name);

        // 3. Try to login to see if the facebook account is linked
        _this2.UsersService.loginWithFacebook(_this2.UserData.user).then(function (response) {
          if (response.data) {
            _this2.error.facebook.facebookLinked = true;
            _this2.Analytics.trackAction('facebook', 'login', 'SUCCESS');
            _this2.loginSuccess = true;
            _this2.$window.requestAnimationFrame(function () {
              _this2.onLoginSuccess({
                rememberLogin: false
              });
            });
          }
        }).catch(function () {
          if (_this2.loginSuccess) {
            return;
          }
          // 3. Check if user is registered
          _this2.Users.check({ email: _this2.UserData.user.facebookEmail }).then(function () {
            // User's Email is not taken. Must be new user.
            _this2.UserData.user.isNewUser = false;
            var url = _this2.Facebook.getUserPictureUrl(60, 60);
            if (url) {
              return url;
            }
            return _this2.Cdn.getCdnUrl('/img/unknown.png');
          }).then(function (facebookPictureUrl) {
            // 5. Display relevant form to continue facebook signup
            _this2.UserData.user.email = _this2.UserData.getFacebookEmail();
            _this2.UserData.setFacebookPictureUrl(facebookPictureUrl);
            _this2.UserData.setFacebookConnected(true);
            // Show Base Step
            _this2.currentStep = _this2.steps.BASE_STEP;
          }).catch(function (error) {
            if (error.code === 'EMAIL_TAKEN') {
              _this2.Analytics.trackAction('facebook', 'signup', error.code);
              _this2.error.facebook.emailTaken = true;
            } else if (error.code === 'EMAIL_BLOCKED') {
              _this2.Analytics.trackAction('facebook', 'signup', error.code);
              _this2.error.facebook.emailBlocked = true;
            } else if (error.code === 'NOT_AUTHORISED') {
              _this2.Analytics.trackAction('facebook', 'signup', error.code);
              _this2.error.facebook.notAuthorized = true;
            } else if (error.code === 'ACCESS_DENIED') {
              _this2.Analytics.trackAction('facebook', 'signup', error.code);
              _this2.error.facebook.accessDenied = true;
            } else if (error.code === 'NOT_CONNECTED') {
              _this2.Analytics.trackAction('facebook', 'signup', error.code);
              if (retry) {
                _this2.facebookConnect();
              } else {
                _this2.error.facebook.notConnected = true;
              }
            } else {
              _this2.Analytics.trackError('facebook', 'signup', error.code, error.data);
              _this2.error.facebook.unknownError = true;
            }
          });
        });
      });
    }

    /**
     * @ngdoc method
     * @name LoginSignupApp.flSignup#tryFacebookSignup
     * @methodOf LoginSignupApp.flSignup
     * @description
     * Attempts to Signup User through Facebook, using info stored in UserData.user
     */

  }, {
    key: 'tryFacebookSignup',
    value: function tryFacebookSignup() {
      var _this3 = this;

      if (this.isSubmitting === true) {
        return;
      }
      this.error = {};
      this.isSubmitting = true;
      this.Users.createWithFacebook(this.UserData.user, {
        userID: this.UserData.getFacebookUserId(),
        accessToken: this.UserData.getFacebookAccessToken()
      }, this.getAllExtraData()).then(function () {
        _this3.Analytics.trackAction('facebook', 'signup', 'SUCCESS');
        Tracking.trackCustomEvent('User Sign Up', 'Sign Up Form', {
          account_type: _this3.UserData.user.role
        });
        _this3.onSignupSuccessStep();
        _this3.removeExtraDataFromCookie();
        _this3.UsersService.setExtraCookies();
      }).then(function () {
        return _this3.UsersService.crossDomainSSO({
          data: {
            token: _this3.Auth.getAccessToken(),
            user: _this3.Auth.getUserId()
          }
        }, true);
      }).then(function () {
        return new Promise(function (resolve) {
          // Resolve LoginSignupConfig Callback first, before resolving then
          // going through any redirects.
          if (_this3.UserData.user.role === USER_TYPE_FREELANCER) {
            _this3.loginSignupConfig.resolveAuth(_this3.loginSignupConfig.authMessages.SIGNUP_FREELANCER);
          } else {
            _this3.loginSignupConfig.resolveAuth(_this3.loginSignupConfig.authMessages.SIGNUP_EMPLOYER);
          }
          resolve();
        }).then(function () {
          _this3.onSignupSuccessRedirect();
        });
      }).catch(function (error) {
        if (error.code === 'ACCESS_DENIED') {
          _this3.error.accessDenied = true;
        } else {
          _this3.error.internalError = true;
        }
        qtsp.push({
          section: _this3.loginSignupConfig.getPageName(),
          sub_section: 'LoginSignup',
          label: 'OnSignup',
          name: 'facebook_failure',
          value: error.code
        });

        _this3.isSubmitting = false;
      });
    }
  }, {
    key: 'removeExtraDataFromCookie',
    value: function removeExtraDataFromCookie() {
      this.CookieStore.remove(this.referralSignupCookieKey);
    }
  }, {
    key: 'getAllExtraData',
    value: function getAllExtraData() {
      var extraData = {};

      // Referral Signup
      var cookieData = this.CookieStore.get(REFERRAL_SIGNUP_COOKIE_KEY);
      if (cookieData) {
        extraData[REFERRAL_SIGNUP_COOKIE_KEY] = cookieData;
      }

      // VAT Business/Individual User, only set the business_user if the option
      // is shown to the user.
      if (this.UserData.user.privateUser !== null) {
        extraData[BUSINESS_USER_KEY] = !this.UserData.user.privateUser ? 'true' : 'false';
      }

      if (this.loginSignupConfig.getProjectCollaborationInvitation() !== '') {
        extraData[PROJECT_COLLABORATION_INVITATION_KEY] = this.loginSignupConfig.getProjectCollaborationInvitation();
      }

      if (this.loginSignupConfig.getContestCollaborationInvitation() !== '') {
        extraData[CONTEST_COLLABORATION_INVITATION_KEY] = this.loginSignupConfig.getContestCollaborationInvitation();
      }

      return extraData;
    }
  }, {
    key: 'getSignupMetaData',
    value: function getSignupMetaData() {
      return _defineProperty({}, PRIVACY_CONSENT_KEY, !!this.UserData.user.privacyConsent);
    }

    /**
     * @ngdoc method
     * @name LoginSignupApp.flSignup#tryUserSignup
     * @methodOf LoginSignupApp.flSignup
     * @description
     * Attempts to Signup the user, using info stored in UserData.user
     */

  }, {
    key: 'tryUserSignup',
    value: function tryUserSignup() {
      var _this4 = this;

      if (this.isSubmitting === true) {
        return;
      }
      this.isSubmitting = true;
      this.error = {};
      this.Users.create(this.UserData.user, this.UserData.user.password, this.UserData.user.captcha, this.getAllExtraData(), this.getSignupMetaData()).then(function () {
        _this4.Analytics.trackAction('user', 'signup', 'SUCCESS');
        Tracking.trackCustomEvent('User Sign Up', 'Sign Up Form', {
          account_type: _this4.UserData.user.role
        });
        _this4.onSignupSuccessStep();
        _this4.removeExtraDataFromCookie();
        _this4.UsersService.setExtraCookies();
      }).then(function () {
        return _this4.UsersService.crossDomainSSO({
          data: {
            token: _this4.Auth.getAccessToken(),
            user: _this4.Auth.getUserId()
          }
        }, true);
      }).then(function () {
        return new Promise(function (resolve) {
          // Resolve LoginSignupConfig Callback first, before resolving then
          // going through any redirects.
          if (_this4.UserData.user.role === USER_TYPE_FREELANCER) {
            _this4.loginSignupConfig.resolveAuth(_this4.loginSignupConfig.authMessages.SIGNUP_FREELANCER);
          } else {
            _this4.loginSignupConfig.resolveAuth(_this4.loginSignupConfig.authMessages.SIGNUP_EMPLOYER);
          }
          resolve();
        }).then(function () {
          _this4.onSignupSuccessRedirect();

          // Close the modal only if there is no redirects
          if (_this4.loginSignupConfig.isRedirectDisabled()) {
            _this4.closeModal();
          }
        });
      }).catch(function (error) {
        if (error.code === 'CAPTCHA_REQUIRED') {
          _this4.UserData.user.captcha.challenge = error.data.request_id;
          _this4.currentStep = _this4.steps.CAPTCHA_STEP;
          _this4.Analytics.trackAction('user', 'signup', error.code);
        } else if (error.code === 'ACCESS_DENIED') {
          _this4.error.accessDenied = true;
          _this4.Analytics.trackAction('user', 'signup', error.code);
        } else {
          _this4.error.internalError = true;
          _this4.Analytics.trackAction('user', 'signup', error.code);
        }
        qtsp.push({
          section: _this4.loginSignupConfig.getPageName(),
          sub_section: 'LoginSignup',
          label: 'OnSignup',
          name: 'failure',
          value: error.code
        });

        _this4.isSubmitting = false;
      });
    }

    /**
     * @ngdoc method
     * @name LoginSignupApp.flSignup#onSignupSuccessRedirect
     * @methodOf LoginSignupApp.flSignup
     * @description
     * Handles redirects on signup success (for both normal and facebook)
     * Currently happens after the Auth Promise has been resolved, and any call
     * backs related to Auth Promise (LoginSignupConfig) has been called.
     */

  }, {
    key: 'onSignupSuccessRedirect',
    value: function onSignupSuccessRedirect() {
      var _this5 = this;

      this.UsersService.getSignupRedirectUrl(this.loginSignupConfig.isRedirectDisabled(), this.loginSignupConfig.isModal(), this.loginSignupConfig.getRedirectUrl(), this.loginSignupConfig.getProjectCollaborationInvitation(), this.loginSignupConfig.getContestCollaborationInvitation()).then(function (response) {
        if (response.data) {
          var redirectUrl = response.data.redirect_url;

          if (redirectUrl === 'reload') {
            _this5.$window.location.reload();
          } else if (redirectUrl !== '') {
            if (!redirectUrl.includes('?')) {
              redirectUrl = redirectUrl + '?';
            }

            _this5.$window.location.href = redirectUrl + '&new_signup=true';
          }
        }
      }).catch(function () {
        if (_this5.UserData.user.role === USER_TYPE_FREELANCER) {
          _this5.$window.location.href = '/new-freelancer';
        } else {
          _this5.$window.location.href = '/post-project?onboard=true';
        }
      });
    }

    /**
     * @ngdoc method
     * @name LoginSignupApp.flSignup#generateSuggestedUsernames
     * @methodOf LoginSignupApp.flSignup
     * @description
     * Gets suggested usernames for the current email stored in UserData.
     * Is linked to the username-input component where it is then displayed.
     */

  }, {
    key: 'generateSuggestedUsernames',
    value: function generateSuggestedUsernames() {
      var _this6 = this;

      this.Users.check({ email: this.UserData.user.email }, { recommend_name: true }).then(function (result) {
        _this6.usernameSuggestions = [];
        _this6.usernameSuggestions.push(result.recommended_name);
        _this6.usernameSuggestions = _this6.usernameSuggestions.concat(result.alternate_names);
      }).catch(function (error) {
        _this6.Analytics.trackError('suggestUsernames', 'signup', error.error_code);
      });
    }

    /**
     * @ngdoc method
     * @name LoginSignupApp.flSignup#clearErrors
     * @methodOf LoginSignupApp
     * @description
     * Clears all errors.
     */

  }, {
    key: 'clearErrors',
    value: function clearErrors() {
      this.error = {};
    }

    /**
     * @ngdoc method
     * @name LoginSignupApp.flSignup#clearErrors
     * @methodOf LoginSignupApp.flSignup
     * @description
     * Gets any errors currently set.
     */

  }, {
    key: 'getErrors',
    value: function getErrors() {
      return this.error;
    }
  }]);

  return flSignup;
}();

flSignup.$inject = ['$window', '$rootScope', 'Auth', 'Analytics', 'Cdn', 'CookieStore', 'Facebook', 'LoginSignupConfig', 'UserData', 'Users', 'UsersService'];

var flSignup$1 = flComponent$1(flSignup, {
  selector: 'fl-signup',
  template: signupTemplate,
  bindings: {
    showAsModal: '=',
    closeModal: '&',
    onLoginSuccess: '&'
  },
  providers: [AuthModule, UserData$1, UsersProvider$1, UsersProvider, CookieStoreProvider$1, FacebookProvider$1, AnalyticsModule, flCaptchaForm$1, flSignupSuccess$1, flUsernameInput$1, flSignupBaseForm$1, flPrivacyConsentForm$1, flAccountTypeSelector$1, flIconProvider, flPasswordCheck, flBlockedEmailCheck, CdnProvider, LoginSignupConfigProvider]
});

var template$6 = "<div ng-if=\"!LoginSignupModal.loginSignupConfig.isModal()\" class=\"Modal Modal--small\">\n  <div class=\"Modal-inner ModalLoginSignup-inner ModalLoginSignup--asPage\"\n    aria-hidden=\"false\" data-keyboard=\"false\" data-backdrop=\"static\">\n    <div class=\"Modal-dialog\"\n      ng-if=\"!LoginSignupModal.enterprise\"\n      role=\"dialog\">\n      <div class=\"Modal-content Card\" role=\"document\">\n          <fl-signup ng-if=\"LoginSignupModal.loginSignupConfig.options.showSignup\" show-as-modal=\"LoginSignupModal.loginSignupConfig.isModal()\"\n            on-login-success=\"LoginSignupModal.onLoginSuccess(rememberLogin, forceRedirectUrl)\">\n          </fl-signup>\n          <fl-login ng-if=\"!LoginSignupModal.loginSignupConfig.options.showSignup\" show-as-modal=\"LoginSignupModal.loginSignupConfig.isModal()\"\n            on-login-success=\"LoginSignupModal.onLoginSuccess(rememberLogin, forceRedirectUrl)\"\n            current-step=\"LoginSignupModal.currentLoginStep\">\n          </fl-login>\n      </div>\n      <fl-app-links\n        ng-if=\"LoginSignupModal.loginSignupConfig.showAppLinks() && !LoginSignupModal.loginSignupConfig.options.showSignup\">\n      </fl-app-links>\n    </div>\n    <div class=\"Modal-dialog\"\n      ng-if=\"LoginSignupModal.enterprise === 'arrow'\"\n      role=\"dialog\">\n      <div class=\"Modal-content Card\" role=\"document\">\n        <fl-arrow-signup ng-if=\"LoginSignupModal.loginSignupConfig.options.showSignup\"\n        ></fl-arrow-signup>\n        <fl-arrow-login ng-if=\"!LoginSignupModal.loginSignupConfig.options.showSignup\"\n        ></fl-arrow-login>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div ng-if=\"LoginSignupModal.loginSignupConfig.isModal()\">\n  <div ng-if=\"!LoginSignupModal.enterprise\">\n    <fl-signup ng-if=\"LoginSignupModal.loginSignupConfig.options.showSignup\"\n      show-as-modal=\"LoginSignupModal.loginSignupConfig.isModal()\"\n      close-modal=\"LoginSignupModal.closeModal()\" on-login-success=\"LoginSignupModal.onLoginSuccess(rememberLogin, forceRedirectUrl)\">\n    </fl-signup>\n    <fl-login ng-if=\"!LoginSignupModal.loginSignupConfig.options.showSignup\"\n      show-as-modal=\"LoginSignupModal.loginSignupConfig.isModal()\"\n      close-modal=\"LoginSignupModal.closeModal()\" on-login-success=\"LoginSignupModal.onLoginSuccess(rememberLogin, forceRedirectUrl)\"\n      current-step=\"LoginSignupModal.currentLoginStep\">\n    </fl-login>\n  </div>\n  <div ng-if=\"LoginSignupModal.enterprise === 'arrow'\">\n    <fl-arrow-signup ng-if=\"LoginSignupModal.loginSignupConfig.options.showSignup\"\n      show-as-modal=\"LoginSignupModal.loginSignupConfig.isModal()\"\n      close-modal=\"LoginSignupModal.closeModal()\"\n    ></fl-arrow-signup>\n    <fl-arrow-login ng-if=\"!LoginSignupModal.loginSignupConfig.options.showSignup\"\n      show-as-modal=\"LoginSignupModal.loginSignupConfig.isModal()\"\n      close-modal=\"LoginSignupModal.closeModal()\"\n    ></fl-arrow-login>\n  </div>\n</div>\n";

var LoginSignupModal = function () {
  function LoginSignupModal($rootScope, $window, CorporateService, LoginSignupConfig, UsersService) {
    _classCallCheck(this, LoginSignupModal);

    this.$rootScope = $rootScope;
    this.$window = $window;
    this.Corporate = CorporateService;
    this.UsersService = UsersService;
    this.loginSignupConfig = LoginSignupConfig;
    this.loginSteps = LOGIN_STEPS;
    this.currentLoginStep = LOGIN_STEPS.LOGIN_FORM;
    this.enterprise = enterprise;
  }

  _createClass(LoginSignupModal, [{
    key: 'loginUrlRedirect',
    value: function loginUrlRedirect(forceRedirectUrl) {
      var _this = this;

      if (forceRedirectUrl) {
        this.$window.location.href = forceRedirectUrl;
        return;
      }

      this.UsersService.getLoginRedirectUrl(this.loginSignupConfig.isRedirectDisabled(), this.loginSignupConfig.isModal(), this.loginSignupConfig.getRedirectUrl()).then(function (response) {
        if (response.data) {
          var redirectUrl = response.data.redirect_url;
          if (redirectUrl === 'reload') {
            _this.$window.location.reload();
          } else if (redirectUrl !== '') {
            _this.$window.location.href = redirectUrl;
          }
        }
      }).catch(function () {
        _this.$window.location.href = '/dashboard/';
      });
    }

    /**
     * @ngdoc method
     * @description
     * Resolves the Auth Promise in LoginSignupConfig, waits for any code linked
     * to that to complete, then resolves and deals with redirects.
     *
     * Not placed in flLogin.js because flSignup.js also needs access to this,
     * as it is possible to login via facebook on the Signup module.
     */

  }, {
    key: 'onLoginSuccess',
    value: function onLoginSuccess(rememberLogin, forceRedirectUrl) {
      var _this2 = this;

      qtsp.push({
        section: this.loginSignupConfig.getPageName(),
        sub_section: 'LoginSignup',
        label: 'OnLogin',
        name: 'success'
      });

      // Set Login Step as Success Step
      // This is done here instead of flLogin because flSignup can call this too.
      if (this.loginSignupConfig.isRedirectDisabled()) {
        this.loginSignupConfig.hide();
      } else {
        this.currentLoginStep = this.loginSteps.LOGIN_SUCCESS;
      }

      return new Promise(function (resolve) {
        // Login Signup Config Callbacks
        _this2.loginSignupConfig.resolveAuth(_this2.loginSignupConfig.authMessages.LOGIN_SUCCESS);
        resolve();
      }).then(function () {
        if (!_this2.Corporate.checkCorporate()) {
          _this2.loginUrlRedirect(forceRedirectUrl);
          return;
        }
        _this2.Corporate.swapAccount(rememberLogin).then(_this2.loginUrlRedirect(forceRedirectUrl));
      });
    }
  }, {
    key: 'closeModal',
    value: function closeModal() {
      this.loginSignupConfig.hide();
    }
  }]);

  return LoginSignupModal;
}();

LoginSignupModal.$inject = ['$rootScope', '$window', 'CorporateService', 'LoginSignupConfig', 'UsersService'];

var flLoginSignupModal = flComponent$1(LoginSignupModal, {
  selector: 'fl-login-signup-modal',
  template: template$6,
  providers: [ngRoute, flArrowLogin$1, flArrowSignup$1, flLogin$1, flSignup$1, flAppLinks$1, flIconProvider, UsersProvider$1, UsersProvider$1, CorporateProvider, UserData$1, LoginSignupConfigProvider]
});

var template$7 = "<fl-login-signup-modal ng-if=\"!LoginSignupAngular.loginSignupConfig.isModal()\"\n></fl-login-signup-modal>\n\n<fl-ui-modal ng-if=\"LoginSignupAngular.loginSignupConfig.options.showAppLinks && LoginSignupAngular.loginSignupConfig.isModal() && LoginSignupAngular.loginSignupConfig.options.visible\"\n    modal-selector=\"'fl-login-signup-modal'\"\n    modal-visible=\"LoginSignupAngular.loginSignupConfig.options.visible\"\n    modal-props=\"{ classes: 'Modal--small', disableBackdropClose: LoginSignupAngular.loginSignupConfig.isDisableBackdropClose() }\"\n    modal-shadow-footer-selector=\"LoginSignupAngular.enterprise ? undefined : 'fl-app-links'\"\n    class=\"pinky-template\"\n></fl-ui-modal>\n\n<fl-ui-modal ng-if=\"!LoginSignupAngular.loginSignupConfig.options.showAppLinks && LoginSignupAngular.loginSignupConfig.isModal() && LoginSignupAngular.loginSignupConfig.options.visible\"\n    modal-selector=\"'fl-login-signup-modal'\"\n    modal-visible=\"LoginSignupAngular.loginSignupConfig.options.visible\"\n    modal-props=\"{ classes: 'Modal--small', disableBackdropClose: LoginSignupAngular.loginSignupConfig.isDisableBackdropClose() }\"\n    class=\"pinky-template\"\n></fl-ui-modal>\n\n\n<a ng-if=\"LoginSignupAngular.showLoginButton\"\n    ng-click=\"LoginSignupAngular.showLoginModal($event)\"\n    class=\"LoginSection-btn\" href=\"/login\" rel=\"nofollow\"\n    ng-class=\"{'LoginSection-btn--arrow' : LoginSignupAngular.enterprise === 'arrow'}\"\n    data-uitest-target=\"login-button\"\n    data-qtsb-section=\"NavBar\"\n    data-qtsb-label=\"ShowLoginSplash\">Log In</a>\n\n<a ng-if=\"LoginSignupAngular.showSignupButton\"\n    ng-click=\"LoginSignupAngular.showSignupModal($event)\"\n    class=\"LoginSection-btn\" href=\"/signup\" rel=\"nofollow\"\n    ng-class=\"{'LoginSection-btn--arrow' : LoginSignupAngular.enterprise === 'arrow'}\"\n    data-uitest-target=\"signup-button\"\n    data-qtsb-section=\"NavBar\"\n    data-qtsb-label=\"ShowHireSignupSplash\">Sign Up</a>\n";

var LoginSignupApp = function () {
  function LoginSignupApp(LoginSignupConfig) {
    _classCallCheck(this, LoginSignupApp);

    this.loginSignupConfig = LoginSignupConfig;
    this.enterprise = enterprise;
    this.modalProps = {
      classes: 'Modal--small',
      disableBackdropClose: this.loginSignupConfig.isDisableBackdropClose()
    };
  }

  _createClass(LoginSignupApp, [{
    key: 'showArrowLoginSignUpModal',
    value: function showArrowLoginSignUpModal(formName) {
      var afterCloseCallback = function afterCloseCallback(authUid) {
        // Login signup modal will return the user id of the authenticated user
        // as the result if successful
        if (authUid) {
          window.location.reload();
        }
      };
      webappModals.open('ArrowLoginSignupModalComponent', {
        inputs: {
          form: formName
        },
        size: 'xsmall',
        edgeToEdge: true,
        closeable: true
      }, afterCloseCallback);
    }
  }, {
    key: 'showSignupModal',
    value: function showSignupModal($event) {
      $event.preventDefault();
      if (this.enterprise === 'arrow') {
        this.showArrowLoginSignUpModal('signup');
      } else {
        this.loginSignupConfig.showSignup().catch(function () {});
      }
    }
  }, {
    key: 'showLoginModal',
    value: function showLoginModal($event) {
      $event.preventDefault();
      if (this.enterprise === 'arrow') {
        this.showArrowLoginSignUpModal('login');
      } else {
        this.loginSignupConfig.showLogin().catch(function () {});
      }
    }
  }]);

  return LoginSignupApp;
}();

LoginSignupApp.$inject = ['LoginSignupConfig'];
LoginSignupApp.$inject = ['LoginSignupConfig'];

function getUrlParameter(param) {
  var pageURL = decodeURIComponent(window.location.search.substring(1));
  var urlVariables = pageURL.split('&');
  var parameterName = void 0;
  var i = void 0;
  for (i = 0; i < urlVariables.length; i++) {
    parameterName = urlVariables[i].split('=');

    if (parameterName[0] === param) {
      return parameterName[1];
    }
  }
}

var skipCaptchaHash = typeof getUrlParameter('secured_connection') !== 'undefined' ? getUrlParameter('secured_connection') : '';

/**
 * Component for Angular Apps
 * Import with LoginSignupConfigProvider, for example usage see flWizardForm
 */
var LoginSignupComponent = flComponent$1(LoginSignupApp, {
  selector: 'fl-login-signup-angular',
  template: template$7,
  bindings: {
    showLoginButton: '=',
    showSignupButton: '='
  },
  providers: [
  // Component
  flLoginSignupModal, flIconProvider, flUiModalProvider, flAppLinks$1,

  // Service
  UsersProvider$1, UserData$1, AuthModule, LoginSignupConfigProvider]
});

/**
 * Initialise Login Signup Angular for non Angular code
 */
function init$2() {
  return new Promise(function (resolve) {
    var app = flApp('fl-login-signup-angular', [LoginSignupComponent, ngSanitize], LoginSignupApp);

    // If app has already been initialised:
    var el = angular.element(document.querySelector('fl-login-signup-angular'));
    if (el.injector()) {
      var config = el.injector().get('LoginSignupConfig');
      config.options.skipCaptchaHash = skipCaptchaHash;
      resolve(config);
    }

    // Else wait on app.run
    app.run(function () {
      setTimeout(function () {
        var el = angular.element(document.querySelector('fl-login-signup-angular'));
        if (el.injector()) {
          var _config = el.injector().get('LoginSignupConfig');
          _config.options.skipCaptchaHash = skipCaptchaHash;
          resolve(_config);
        }
      });
    });
  });
}

var DeloitteProjectType = {
  client_billable: 'Client Billable',
  firm_initiative: 'Firm Initiative',
  PRD: 'PRD',
  other_investment: 'Other Investment'
};

var DeloittePractice = {
  commercial_core: 'Commercial Core',
  commercial_usdc_onsite: 'Commercial USDC OnSite',
  commercial_usdc_incenter: 'Commercial USDC InCenter',
  gps_core: 'GPS Core',
  gps_usdc_onsite: 'GPS USDC Onsite',
  gps_usdc_incenter: 'GPS USDC In-Center',
  usi_onsite: 'USI Onsite',
  usi_offshore: 'USI Offshore'
};

var DeloitteIndustry = {
  automotive: 'Automative',
  banking_and_capital_markets: 'Banking & Capital Markets',
  civil_government: 'Civil Government',
  consumer_products: 'Consumer Products',
  cross_sector_c: 'Cross Sector (C)',
  cross_sector_ci: 'Cross Sector (CI)',
  cross_sector_eri: 'Cross Sector (ERI)',
  cross_sector_fs: 'Cross Sector (FS)',
  cross_sector_gps: 'Cross Sector (GPS)',
  cross_sector_lshc: 'Cross Sector (LSHC)',
  cross_sector_tmt: 'Cross Sector (TMT)',
  defense_security_and_justice: 'Defense Security & Justice',
  federal_health: 'Federal Health',
  health_care: 'Health Care',
  industrial_products_and_construction: 'Industrial Products & Construction',
  insurance: 'Insurance',
  investment_management: 'Investment Management',
  media_and_entertainment: 'Media & Entertainment',
  oil_gas_and_chemicals: 'Oil, Gas, & Chemicals',
  power_and_utilities: 'Power & Utilities',
  real_estate: 'Real Estate',
  retail_wholesale_and_distribution: 'Retail, Wholesale, & Distribution',
  state_local_and_higher_education: 'State, Local, & Higher Education',
  technology: 'Technology',
  transportation_hospitality_and_services: 'Transportation, Hospitality, & Services'
};

var DeloitteOffering = {
  cbo: {
    cbo_cloud_engineering: 'Cloud Engineering',
    cbo_core_industry_solutions: 'Core Industry Solutions',
    cbo_cross_consulting_group: 'Cross Consulting Group',
    cbo_health_technology: 'Health Technology',
    cbo_operations_transformation: 'Operations Transformation',
    cbo_systems_engineering: 'Systems Engineering'
  },
  cnm: {
    cnm_advertising_marketing_and_commerce: 'Advertising, Marketing, & Commerce',
    cnm_cross_consulting_group: 'Cross Consulting Group',
    cnm_customer_strategy_and_applied_design: 'Customer Strategy & Applied Design',
    cnm_digital_customer: 'Digital Customer',
    cnm_digital_government: 'Digital Government',
    cnm_human_services_transformation: 'Human Services Transformation'
  },
  eo: {
    eo_cross_consulting_group: 'Cross Consulting Group',
    eo_erp_saas: 'ERP SaaS',
    eo_finance_and_enterprise_performance: 'Finance & Enterprise Performance',
    eo_oracle: 'Oracle',
    eo_sap: 'SAP',
    eo_supply_chain_and_network_operations: 'Supply Chain & Network Operations',
    eo_technology_services_optimization: 'Technology Services Optimization'
  },
  hc: {
    hc_cross_consulting_group: 'Cross Consulting Group',
    hc_hc_as_a_service: 'HC as a Service',
    hc_hr_transformation: 'HR Transformation',
    hc_organization_transformation: 'Organization Transformation',
    hc_workforce_transformation: 'Workforce Transformation'
  },
  mna: {
    mna_mergers_and_acquisitions: 'Mergers & Acquisitions'
  },
  sna: {
    sna_analytics_and_cognitive: 'Analytics & Cognitive',
    sna_cross_consulting_group: 'Cross Consulting Group',
    sna_hybrid_solutions_and_incubation: 'Hybrid Solutions & Incubation',
    sna_strategy: 'Strategy'
  }
};

var DeloitteOfferingPortfolio = {
  cbo: 'Core Business Operations',
  cnm: 'Customer & Marketing',
  eo: 'Enterprise Operations',
  hc: 'Human Capital',
  mna: 'Mergers & Acquisitions',
  sna: 'Strategy & Analytics'
};

var LOCALSTORAGE_KEY = 'HIREME_DRAFT_';

var HireMeDraft = function () {
  function HireMeDraft() {
    _classCallCheck(this, HireMeDraft);
  }

  _createClass(HireMeDraft, [{
    key: 'get',
    value: function get(employerId, freelancerId) {
      if (!Modernizr.localstorage) {
        return;
      }

      var data = JSON.parse(localStorage.getItem('' + LOCALSTORAGE_KEY + employerId));

      if (!(data && data.freelancerId === parseInt(freelancerId, 10))) {
        return;
      }

      return data;
    }
  }, {
    key: 'save',
    value: function save(employerId, freelancerId, data) {
      if (!Modernizr.localstorage) {
        return;
      }

      data.freelancerId = parseInt(freelancerId, 10);
      localStorage.setItem('' + LOCALSTORAGE_KEY + employerId, JSON.stringify(data));
    }
  }, {
    key: 'remove',
    value: function remove(employerId, freelancerId) {
      if (!Modernizr.localstorage) {
        return;
      }

      if (this.get(employerId, freelancerId)) {
        localStorage.removeItem('' + LOCALSTORAGE_KEY + employerId);
      }
    }
  }]);

  return HireMeDraft;
}();

function hireMeDraft () {
  return new HireMeDraft();
}

var initialDataFiles = [];

function init$3(initFiles, params) {
  var fileUrl = '/buyers/postproject-upload.php?fileset=';

  params = jq.extend({
    // default template names, to not break existing pages
    uploadTemplate: 'template-upload',
    downloadTemplate: 'template-download',
    domID: 'fileupload', // id of the fileupload element to use
    domEl: document // container the fileupload element will be found in
  }, params);

  if (Object.prototype.toString.call(initFiles) === '[object Array]') {
    initialDataFiles = initFiles;
  }

  // falls back to document > #fileupload, as per default
  var domEl = jq(params.domEl);
  var fileuploadDom = domEl.find('#' + params.domID);

  // Initialize the jQuery File Upload widget:
  fileuploadDom.fileupload({
    maxFileSize: 20000000, // 20 MB
    dataType: 'json',
    dropZone: fileuploadDom,
    url: fileUrl,
    singleFileUploads: false,
    autoUpload: true,
    paramName: 'upload[]',
    uploadTemplateId: params.uploadTemplate,
    downloadTemplateId: params.downloadTemplate,
    add: function add(e, data) {
      var isUploaded = false;
      var uploadedFileNames = [];
      for (var i = 0; i < data.files.length; i++) {
        if (jq('#project_files [value=\'' + data.files[i].name + '\']').length > 0 || initialDataFiles.length > 0 && initialFileExists(data.files[i].name) === true) {
          uploadedFileNames.push(data.files[i].name);
          isUploaded = true;
        }
      }
      if (isUploaded) {
        domEl.find('.fileUploadError').text(translate('Você já enviou <%= filenames %>', {
          filenames: uploadedFileNames.join(', ') })).fadeIn().delay(2000).fadeOut('slow');
        return false;
      }
      var that = jq(this).data('fileupload');
      var options = that.options;
      var files = data.files;
      jq(this).fileupload('process', data).done(function () {
        that._adjustMaxNumberOfFiles(-files.length);
        data.isAdjusted = true;
        data.isValidated = that._validate(files);
        data.files.valid = data.isValidated;
        data.context = that._renderUpload(files).data('data', data);
        options.filesContainer[options.prependFiles ? 'prepend' : 'append'](data.context);

        that._renderPreviews(files, data.context);
        that._forceReflow(data.context);
        that._transition(data.context).done(function () {
          if (that._trigger('added', e, data) !== false && (options.autoUpload || data.autoUpload) && data.autoUpload !== false && data.isValidated) {
            data.submit();
          }
        });
      });
    },
    destroy: function destroy(e, data) {
      var fileName = jq(data.context.context).closest('.delete').siblings('.name').find('p').text().trim();
      if (fileName == '') {
        fileName = jq(data.context.context).closest('.delete').siblings('.name').text().trim();
      }
      var that = jq(this).data('fileupload');
      if (data.url) {
        jq.ajax(data);
        that._adjustMaxNumberOfFiles(1);
      }
      that._transition(data.context).done(function () {
        jq(this).remove();
        that._trigger('destroyed', e, data);
      });

      domEl.find('#project_files [value=\'' + fileName + '\']').remove();

      var driveFileElem = domEl.find('[data-upload-field="drive_files"] [data-filename="' + fileName + '"]');

      var driveFileId = driveFileElem.data('file-id');

      driveFileElem.remove();
      if (driveFileId && getUserIdfromCookie()) {
        fetch('/ajax/files/deleteFile.php?id=' + driveFileId, {
          credentials: 'same-origin',
          headers: new Headers({
            'X-XSRF-TOKEN': getCSRFToken() }),

          method: 'DELETE' });
      }
    }
  });

  // override to get DND to work for IE
  fileuploadDom.unbind('dragover').bind('dragover', function (e) {
    var that = fileuploadDom.data('fileupload');
    var dataTransfer = e.originalEvent.dataTransfer;
    e.dataTransfer = dataTransfer;
    if (that._trigger('dragover', e) === false) {
      return false;
    }
    if (dataTransfer) {
      try {
        // workaround for IE
        dataTransfer.effectAllowed = 'copy';
      } catch (_error) {
        // do nothing
      }
      dataTransfer.dropEffect = 'copy';
    }
    e.preventDefault();
  });

  fileuploadDom.bind('fileuploadadd', function (e, data) {
    data.url = fileUrl + domEl.find('#proj_upload_fileset').val();
  }).bind('fileuploaddone', function (e, data) {
    jq.each(data.result, function (index, file) {
      domEl.find('#proj_upload_fileset').val(file.fileset);

      domEl.find('#project_files').append(jq('<option/>', {
        value: file.name,
        text: file.name,
        selected: true }));

      if (file.isDriveFile) {
        domEl.find('[data-upload-field="drive_files"]').append(jq('<option/>', {
          value: file.id,
          text: file.name,
          selected: true,
          'data-file-id': file.id,
          'data-filename': file.name }));
      }
    });
  });

  fileuploadDom.find('input').attr('title', translate('Sem arquivos selecionados.'));
}

function initialFileExists(filename) {
  if (initialDataFiles.indexOf(filename) >= 0) {
    return true;
  }

  return false;
}

var fileupload = {
  init: init$3 };

var url = '/api/users/0.1/users/check/?recommend_name=true';
var dfd = jq.Deferred();
var isAsync = true;

function init$4(asyncParam) {
  if (typeof asyncParam !== 'undefined') {
    isAsync = !!asyncParam;
  }
}

function suggestUsername(emailInput) {
  var emailData = {
    user: {
      email: emailInput
    }
  };

  jq.ajax({
    url: url,
    contentType: 'application/json; charset=utf-8',
    type: 'POST',
    data: JSON.stringify(emailData),
    dataType: 'json',
    async: isAsync
  }).success(function (response) {
    if (response.status === 'success') {
      dfd.resolve(response);
    } else {
      dfd.reject(response);
    }
  });

  return dfd.promise();
}

var usernameSuggester = {
  suggestUsername: suggestUsername,
  init: init$4
};

var _templateObject$11 = _taggedTemplateLiteral(['Este dom\xEDnio de e-mail est\xE1 bloqueado. Por favor, use um endere\xE7o de e-mail diferente.'], ['Este dom\xEDnio de e-mail est\xE1 bloqueado. Por favor, use um endere\xE7o de e-mail diferente.']);

var usernamePattern = /^[a-z][a-z0-9]{2,15}$/i;
var usernameMin = 3;
var usernameMax = 16;
var isUserReturned = false;
var loginAjax = false;
var loginCallback = false;
var domClass = {
  authFormAlert: '.auth-form-alert',
  authFormError: '.auth-form-error',
  formStep: 'control-group',
  formStepSelector: '.control-group',
  success: 'success',
  successSelector: '.success',
  error: 'error',
  errorSelector: '.error',
  warning: 'warning',
  warningSelector: '.warning',
  formError: 'help-inline',
  formErrorSelector: '.help-inline',
  formHelp: 'help-inline',
  formHelpSelector: '.help-inline' };

var signupModalRequired = void 0;
var previousEmailValidated = void 0;

var isPPP = window.isPPP;

function init$5(params) {
  signupModalRequired = params.signupModalRequired;

  jq(document).ready(function () {
    // Auth window
    jq('.authTypeBtn').click(function () {
      jq(this).siblings('.authTypeBtn').find('input').attr('checked', false);
      jq(this).find('input').attr('checked', true);
      jq('.authTypeBtn').removeClass('bold');
      jq(this).addClass('bold');

      if (jq(this).find('input').val() == 'userTypeNew') {
        jq('#userTypeReturningDiv').hide();
        jq('#projectLoginUserCreate').show();
      } else {
        jq('#projectLoginUserCreate').hide();
        jq('#userTypeReturningDiv').show();
      }

      // Clear Authform Errors
      clearAuthFormMessages();
    });

    // Occurs only in PPP
    if (typeof isPPP !== 'undefined' && isPPP) {
      jq('#nonAuthForm').on('click', '#loginLinkPrefill', function () {
        showPrefilledLoginForm();
      });
    }

    jq('#nonAuthForm input').focus(function (event) {
      var element = event.currentTarget;
      var controlGroupDom = jq(element).closest(domClass.formStepSelector);
      // Occurs only in PPP
      if (controlGroupDom.length > 0) {
        if (typeof isPPP !== 'undefined' && isPPP) {
          controlGroupDom.removeClass(domClass.successSelector + ' ' + (domClass.errorSelector + ' ' + domClass.error + ' ') + 'is-warning').find(domClass.formErrorText).html('');
        } else {
          controlGroupDom.removeClass(domClass.successSelector + ' ' + domClass.errorSelector).find(domClass.formErrorSelector).html('');
        }
      }
    });

    // Occurs only in PPP
    if (typeof isPPP !== 'undefined' && isPPP) {
      jq('#nonAuthForm').on('keyup', '#passwd', function (event) {
        if (!jq('.password-suggestion-widget').hasClass('hide')) {
          var element = event.target;
          if (jq(element).valid()) {
            var controlGroupDom = jq(element).closest(domClass.formStepSelector);

            controlGroupDom.removeClass(domClass.successSelector + ' ' + (domClass.errorSelector + ' is-warning')).find(domClass.formErrorText).html('');
          }
          if (jq(element).val() === '') {
            updatePasswordHelp({}, false);
          }
        }
      });
    }

    var validateRules = {
      // Returning user
      username: {
        required: '#userTypeReturning:checked' },

      passwd: {
        required: '#userTypeReturning:checked',
        verifyUser: true },

      // New User
      newusername: {
        required: '#userTypeNew:checked',
        rangelength: [usernameMin, usernameMax],
        checkNewUsernamePattern: true },

      email: {
        required: '#userTypeNew:checked',
        email: true },

      newuserpasswd: {
        required: '#userTypeNew:checked',
        usernamePasswordEqualCheck: '#new-username',
        checkPasswordPattern: true },

      newuserpasswd1: {
        required: '#userTypeNew:checked',
        equalTo: '#nonAuthForm #passwd' } };

    // Only occurs in PPP
    if (typeof isPPP !== 'undefined' && isPPP) {
      validateRules.newuserpasswd1 = {
        required: '#userTypeNew:checked #passwd',
        equalTo: '#nonAuthForm #passwd' };
    }

    if (typeof params === 'object') {
      if (params.noConfirmPassword) {
        delete validateRules.newuserpasswd1;
      }
      if (params.useFLStyle) {
        domClass = {
          authFormAlert: '.auth-form-alert',
          authFormError: '.auth-form-error',
          formStep: 'form-step',
          formStepSelector: '.form-step',
          success: 'is-valid',
          successSelector: '.is-valid',
          error: 'is-invalid',
          warningOrange: 'is-warning',
          errorSelector: '.is-invalid',
          warning: 'is-help',
          warningSelector: '.is-help',
          formError: 'form-error',
          formErrorSelector: '.form-error',
          formErrorText: '.error-text',
          formHelp: 'form-help',
          formHelpSelector: '.form-help' };
      }

      if (params.isReturningUser) {
        jq('#userTypeReturning').attr('checked', 'true');
        jq('#userTypeReturningDiv').show();
        jq('#projectLoginUserCreate').hide();
      }

      if (params.trackNewEmail) {
        jq('#new-email').on('emailValid', function () {
          var previousEmailBuffer = typeof previousEmailValidated === 'object' ? previousEmailValidated : [];

          var validNewEmail = jq(this).val();

          if (previousEmailBuffer.indexOf(validNewEmail) === -1) {
            _lt.push(['emails_captured', {
              email: validNewEmail }]);

            previousEmailBuffer.push(validNewEmail);
          }

          previousEmailValidated = previousEmailBuffer;
        });
      }

      if (typeof params.loginCallback === 'function') {
        loginCallback = params.loginCallback;
      }
    }

    var form = jq('#nonAuthForm');
    form.on('submit', function (e) {
      e.preventDefault();
    });

    form.validate({
      errorElement: 'span',
      onsubmit: false,
      onkeyup: false,
      onfocusout: function onfocusout(element) {
        // Only occurs in PPP
        if (typeof isPPP !== 'undefined' && isPPP) {
          jq(element).parent('li').removeClass(domClass.error + ' ' + (domClass.warningOrange + ' ') + ('' + domClass.success));

          if (jq(element).val() === '') {
            if (jq(element).attr('id') === 'passwd1' && jq('#passwd').val() !== '') {
              jq(element).valid();
            }
            return;
          }
          // Only trigger the authentication if the password is not empty.
        } else if (element.id === 'post-proj-username' && jq('#post-proj-pwd').val() === '') {
          return;
        }
        // End of AB Test
        // Validate first the patterns before submitting it to the server.
        if (jq(element).valid()) {
          if (element.id === 'new-username') {
            verifyNewUsername();
          } else if (element.id === 'new-email') {
            verifyNewEmail();
          }
        }
      },
      errorPlacement: function errorPlacement(error, element) {
        // AB Test UX Improvements 2
        if (typeof isPPP !== 'undefined' && isPPP) {
          var errorText = element.siblings(domClass.formErrorSelector).find(domClass.formErrorText);
          error.appendTo(errorText);
        } else {
          error.appendTo(element.siblings(domClass.formErrorSelector));
        }
        // End of AB Test
      },

      rules: validateRules,
      messages: {
        newusername: {
          rangelength: translate('O nome de usuário deve ter 3-16 caracteres.') },

        newuserpasswd: {
          rangelength: translate('A senha deve ter 6-16 caracteres.') } },

      highlight: function highlight(label) {
        var controlGroupDom = jq(label).closest(domClass.formStepSelector);
        controlGroupDom.removeClass(domClass.success);
        // Only occurs in PPP
        if (typeof isPPP !== 'undefined' && isPPP) {
          controlGroupDom.addClass(domClass.warningOrange);
        } else {
          controlGroupDom.addClass(domClass.error);
        }
      },
      unhighlight: function unhighlight(element, errorClass) {
        if (element.type === 'radio') {
          this.findByName(element.name).removeClass(errorClass + ' ' + domClass.warningOrange);
        } else {
          jq(element).closest(domClass.formStepSelector).removeClass(errorClass + ' ' + domClass.warningOrange);
        }
      },
      success: function success(label) {
        // Only occurs in PPP
        jq(label).closest(domClass.formStepSelector).removeClass(domClass.warning + ' ' + domClass.error);
      }
    });

    jq.validator.addMethod('verifyUser', function () {
      verifyuser();
      return true;
    });

    jq.validator.addMethod('checkNewUsernamePattern', function (value, element) {
      var pattern = usernamePattern;

      if (pattern.test(jq(element).val())) {
        return true;
      }
    }, translate('O nome de usuário deve ser alfanumérico começando com uma letra.'));

    jq.validator.addMethod('checkPasswordPattern', function (value, element) {
      var val = jq(element).val();

      var nums = val.match(/\d/g);
      var lowers = val.match(/[a-z]/g);
      var uppers = val.match(/[A-Z]/g);
      var pattern = /^.{6,}$/i;

      var patternResult = pattern.test(val);

      if (patternResult) {
        var strengthLevel = 0;
        if (nums) {
          strengthLevel += 2;
        }
        if (lowers) {
          strengthLevel += uppers ? 4 : 3;
        }
        if (uppers) {
          strengthLevel += lowers ? 4 : 3;
        }
        if (strengthLevel > 4) {
          // Occurs only in PPP
          if (typeof isPPP !== 'undefined' && isPPP) {
            updatePasswordHelp({
              'help-text-num': nums,
              'help-text-upper': uppers,
              'help-text-six': patternResult }, false);
          }
          // Password Valid: Show Success
          jq('#passwd').closest(domClass.formStepSelector).removeClass(domClass.warning).removeClass(domClass.error).addClass(domClass.success);
          return true;
        }
      }

      // Occurs only in PPP
      if (typeof isPPP !== 'undefined' && isPPP) {
        updatePasswordHelp({
          'help-text-num': nums,
          'help-text-upper': uppers,
          'help-text-six': patternResult }, true);
      }
    }, translate('Por favor, digite uma senha mais forte.'));

    jq.validator.addMethod('usernamePasswordEqualCheck', function (value, element, params) {
      var $checkElement = jq(params);

      if ($checkElement.length === 0 || $checkElement.val() == '') {
        return true;
      }

      if (value === $checkElement.val()) {
        return false;
      }

      return true;
    }, translate('A senha não deve ser igual ao nome de usuário'));

    jq('#post-proj-pwd').keypress(function (e) {
      if (e.which == 13) {
        jq('#nonAuthForm').valid();
      }
    });

    if (signupModalRequired) {
      jq('#normalLoginBtn').click(function () {
        jq('#nonAuthForm').valid();
      });
    }

    jq('#nonAuthForm').bind('validateForm', validateForm);

    var userTypeIdChecked = jq('[name=userType]:checked');
    if (userTypeIdChecked.length > 0) {
      userTypeIdChecked.click();
    }
  });
}

function updatePasswordHelp(params, showHelpBox) {
  jq.each(params, function (id, value) {
    if (value) {
      jq('#' + id).removeClass('is-invalid').addClass('is-valid');
    } else {
      jq('#' + id).removeClass('is-valid').addClass('is-invalid');
    }
  });

  if (showHelpBox) {
    jq('.password-suggestion-widget').removeClass('is-widget-hidden hide').addClass('is-visible');
    jq('.is-visible').fadeIn(function () {
      jq(this).css('display', '');
    });
  } else {
    setTimeout(function () {
      jq('.password-suggestion-widget').removeClass('is-visible').addClass('is-widget-hidden');
      jq('.is-widget-hidden').fadeOut();
    }, 400);
  }
}

function autofillUsername() {
  usernameSuggester.init();
  var emailInput = jq('#new-email').val();
  var suggestUsername = '';

  usernameSuggester.suggestUsername(emailInput).done(function (resp) {
    suggestUsername = resp.result.recommended_name;
    // Occurs only in PPP
    if (typeof isPPP !== 'undefined' && isPPP) {
      jq(domClass.formErrorSelector).find(domClass.formErrorText).html('');
    } else {
      jq(domClass.formErrorSelector).html('');
    }
    jq('.username').removeClass('error');
    jq('#new-username').val(suggestUsername);
    jq('#new-username').focus();
  });
}

function verifyNewEmail() {
  jq.ajax({
    dataType: 'json',
    url: '/ajax/check-email-exist.php?' + ('json=true&email=' + encodeURIComponent(jq('#new-email').val())),
    success: function success(response) {
      if (response.result == 'success') {
        (function () {
          autofillUsername();
          var suggestedEmailId = 'suggested-email';
          jq('#new-email').mailcheck({
            suggested: function suggested(element, suggestion) {
              jq('#new-email').closest(domClass.formStepSelector).removeClass(domClass.warning).removeClass(domClass.error).addClass(domClass.success);
              var emailSuggestionLink = '<a id="' + suggestedEmailId + '" class="suggestedEmail" href="#">' + (suggestion.address + '@' + suggestion.domain + '</a>');
              var emailSuggestionText = translate('Você quis dizer <%=emailSuggestion%> ?', {
                emailSuggestion: emailSuggestionLink });

              jq('#new-email').siblings(domClass.formHelpSelector).html(emailSuggestionText);

              // Add Event Listener to User Clicking on the Suggested Email
              document.getElementById(suggestedEmailId).addEventListener('click', function (event) {
                var newEmailEl = document.getElementById('new-email');
                newEmailEl.value = event.srcElement.textContent;
                newEmailEl.focus();
              });
            },
            empty: function empty() {
              // Only occurs in PPP
              if (typeof isPPP !== 'undefined' && isPPP) {
                jq('#new-email').closest(domClass.formStepSelector).removeClass(domClass.warning).removeClass(domClass.error);
              } else {
                // Email is Valid. Now also check whether Email is Blocked
                isBlockedEmail(jq('#new-email').val()).then(function (result) {
                  if (result == false) {
                    jq('#new-email').closest(domClass.formStepSelector).removeClass(domClass.warning).removeClass(domClass.error).addClass(domClass.success);
                    jq('#new-email').trigger('emailValid');
                    return;
                  }
                  jq('#new-email').closest(domClass.formStepSelector).removeClass(domClass.success).removeClass(domClass.warning).addClass(domClass.error);
                  jq('#new-email').siblings(domClass.formErrorSelector).html(translate(_templateObject$11));
                }).catch(function () {
                  jq('#new-email').trigger('emailValid');
                });
              }
              jq('#new-email').siblings(domClass.formHelpSelector).html('');
            }
          });

          jq('#new-email').trigger('emailValid');
        })();
      } else {
        // Only occurs in PPP
        if (typeof isPPP !== 'undefined' && isPPP) {
          jq('#new-email').closest(domClass.formStepSelector).removeClass(domClass.success).addClass(domClass.warningOrange);
        } else {
          jq('#new-email').closest(domClass.formStepSelector).removeClass(domClass.success).addClass(domClass.error);
        }
        // Occurs only in PPP
        if (typeof isPPP !== 'undefined' && isPPP) {
          if (response.msg === 'This email already exists, please choose another') {
            jq('#new-email').siblings(domClass.formErrorSelector).find(domClass.formErrorText).html(translate('O E-mail já existe. <a id=\'loginLinkPrefill\'>Em vez disso, quer fazer login?</a>'));
          }
        } else {
          jq('#new-email').siblings(domClass.formErrorSelector).html(translate('Este endereço de e-mail já está em uso.'));
        }
      }
    }
  });
}

function showPrefilledLoginForm() {
  jq('#userTypeReturning').attr('checked', 'true');
  jq('#post-proj-username').val(jq('#new-email').val());
  jq('.authTypeBtn').trigger('click');
  jq('#post-proj-pwd').focus();
}

function verifyNewUsername() {
  jq.ajax({
    dataType: 'json',
    url: '/ajax/check-username-exist.php?json=true&' + ('username=' + jq('#new-username').val()),
    success: function success(response) {
      var controlGroupDom = jq('#new-username').closest(domClass.formStepSelector);

      // Only occurs in PPP
      if (typeof isPPP !== 'undefined' && isPPP) {
        controlGroupDom.removeClass(domClass.error + ' ' + domClass.warningOrange).removeClass(domClass.success);
      } else {
        controlGroupDom.removeClass(domClass.error).removeClass(domClass.success);
      }

      if (response.result == 'success') {
        // does not occur in PPP
        if (typeof isPPP === 'undefined' || !isPPP) {
          controlGroupDom.addClass(domClass.success);
        }
        // Occurs only in PPP
        if (typeof isPPP !== 'undefined' && isPPP) {
          jq('#new-username').siblings(domClass.formErrorSelector).find(domClass.formErrorText).html('');
        } else {
          jq('#post-proj-username').siblings(domClass.formErrorSelector).html(translate('Por favor, verifique seus detalhes de login.'));
        }
        // Only occurs in PPP
      } else if (typeof isPPP !== 'undefined' && isPPP) {
        controlGroupDom.addClass(domClass.warningOrange);
        jq('#new-username').siblings(domClass.formErrorSelector).find(domClass.formErrorText).html(translate('Esse nome de usuário já existe.'));
      } else {
        controlGroupDom.addClass(domClass.error);
        jq('#new-username').siblings(domClass.formErrorSelector).html(translate('Esse nome de usuário já existe.'));
      }
    }
  });
}

function getUserDetails() {
  jq(document).ready(function () {
    jq.ajax({
      type: 'get',
      dataType: 'json',
      url: sslBaseUrl + '/ajax/postproject/userdetails.php',
      success: function success(response) {
        if (response.status === 'success') {
          if (signupModalRequired) {
            jq('#signup-modal').trigger('initialBid');
            return true;
          }
          isUserReturned = true;
          if (response.user_location !== false && typeof window.userLocation !== 'undefined' && window.userLocation === false) {
            window.userLocation = response.user_location;
          }
          var logoHTML = '<img src="' + response.logo_url + '" ' + ('alt="' + response.logoname + '" ') + 'border=0 width=80 height=80 style="margin-right: 20px;">';
          jq('#loggedinLogo').html(logoHTML);
          jq('#loggedinFullname').html(response.name);
          jq('#nonAuthForm').fadeOut('slow', function () {
            jq('#headerTopLoggedIn').fadeIn('slow');
          });
          jq('#createform').removeClass('faded');
        }
      }
    });
  });
}

function verifyuser(callback) {
  clearAuthFormMessages();

  var username = jq('#post-proj-username').val();
  var password = jq('#post-proj-pwd').val();

  if (username == '' || password == '') {
    return false;
  }

  if (!signupModalRequired) {
    jq('#returningForm').hide();
    jq('#returningAjax').show();
  } else {
    jq('#normalLoginBtn').hide();
    jq('#normal-login-spiner').show();
  }
  if (loginAjax) {
    loginAjax.abort();
  }
  loginAjax = jq.ajax({
    type: 'post',
    data: {
      username: username,
      passwd: password,
      csrf_token: getCSRFToken() },

    dataType: 'json',
    url: sslBaseUrl + '/ajax/login.php',
    cache: false,
    success: function success(response) {
      if (jq('#headerTopLoggedIn').is(':visible')) {
        return;
      }

      if (response.status == 'success') {
        if (response.redirect) {
          window.location.href = response.redirect;
        }
        jq('.terms-text, .contest_terms, .hireme-terms').hide();

        if (loginCallback && typeof loginCallback === 'function') {
          isUserReturned = true;
          loginCallback();
        } else {
          getUserDetails();
        }
        if (typeof isPPP !== 'undefined' && isPPP) {
          jq(document).trigger('userLogin', response);
        }
      } else {
        jq('#post-proj-username, #post-proj-pwd').closest(domClass.formStepSelector).removeClass(domClass.success).addClass(domClass.error);
        var errorMsg = void 0;
        var errorAnchor = void 0;
        if (response.code === 5) {
          errorMsg = response.msg;
          errorAnchor = domClass.authFormAlert;
        } else {
          errorMsg = translate('Por favor, verifique seus detalhes de login.');
          errorAnchor = jq('#post-proj-pwd').siblings('.help-inline');
        }

        jq(errorAnchor).html(errorMsg).show();

        if (!signupModalRequired) {
          jq('#returningForm').show();
          jq('#returningAjax').hide();
        } else {
          jq('#normalLoginBtn').show();
          jq('#normal-login-spiner').hide();
        }
      }

      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    }
  });
}

function validateForm() {
  jq(this).data('isValid', jq('#nonAuthForm').valid());
  return jq(this).data('isValid');
}

function userReturned() {
  return isUserReturned;
}

function clearAuthFormMessages() {
  jq('#post-proj-username, #post-proj-pwd').closest(domClass.formStepSelector).removeClass(domClass.success + ' ' + domClass.error);
  // Occurs only in PPP
  if (typeof isPPP !== 'undefined' && isPPP) {
    jq('#post-proj-username').siblings(domClass.formErrorSelector).find(domClass.formErrorText).html('');
  } else {
    jq('#post-proj-username').siblings(domClass.formErrorSelector).html('');
    jq('#post-proj-pwd').siblings(domClass.formErrorSelector).html('');
  }
  jq(domClass.authFormAlert).html('').hide();
  jq(domClass.authFormError).html('').hide();
}

var userAuthForm = {
  init: init$5,
  getUserDetails: getUserDetails,
  validateForm: validateForm,
  userReturned: userReturned,
  verifyUser: verifyuser,
  isSignUp: function isSignUp() {
    return jq('#userTypeNew').is(':checked');
  },

  dom: {
    getForm: function getForm() {
      return jq('#nonAuthForm');
    },
    isFormVisible: function isFormVisible() {
      return jq('#nonAuthForm:visible').length > 0;
    },
    getNewEmail: function getNewEmail() {
      return jq('#new-email');
    },
    getNewUsername: function getNewUsername() {
      return jq('#new-username');
    },
    getPassword: function getPassword() {
      return jq('#passwd');
    },
    getConfirmPassword: function getConfirmPassword() {
      return jq('#passwd1');
    }
  } };

var hiremeModalContainerTemplate = "<div class=\"pinky-template\">\n  <div class=\"quickhire-legacy\">\n    <div id=\"modal-hire-me\" class=\"quick-hire-form-container modal hide absolute\">\n    </div>\n  </div>\n</div>\n";

var quickHireFormTemplate = "<div id=\"quick-hire-form\" class=\"ModalHireMe quick-hire-form quick-hire-form-slim\">\n  <div id=\"headerTopLoggedIn\" class=\"ModalHireMe-loginGreeting\">\n    <div class=\"Card\">\n      <div class=\"Card-body\">\n        <div id=\"loggedinLogo\" class=\"ModalHireMe-loginGreeting-profilePicture\"></div>\n        <div id=\"loggedinWelcome\">\n          <h1 class=\"ModalHireMe-loginGreeting-title\">\n            <%= T_('Bem-vindo de volta <span id=\"loggedinFullname\"></span>!') %>\n          </h1>\n          <p><%- T_('descreva seu projeto abaixo.') %></p>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <%  if (typeof show_hireme_promotion_copy !== 'undefined' && show_hireme_promotion_copy) {  %>\n    <div class=\"alert alert-info quick-hire-form-alert\">\n      <%- T_('Odeia taxas subindo? Contrate <[- username ]> agora, com 0% de comissões do projeto para sempre!', { 'username': username }) %>\n    </div>\n  <%  }  %>\n\n  <%  if (!thisUser)  {  %>\n    <form id='nonAuthForm' novalidate='novalidate' class=\"is-hidden\">\n      <fieldset >\n        <div id='returningForm'>\n\n\n            <legend><span class=\"fl-icon-user\"></span> <%- T_('Sobre Você') %> </legend>\n\n          <div class=\"control-group account-wrapper\">\n\n            <label class=\"radio-label\"> <%- T_('Sou um(a):') %> </label>\n\n            <label class=\"radio authTypeBtn <%  if (isNewUser) {  %> bold <%  }  %>\">\n              <input\n                type=\"radio\"\n                id=\"userTypeNew\"\n                value=\"userTypeNew\"\n                name=\"userType\"\n                <%  if (isNewUser || email != undefined) {  %> checked='checked' <%  }  %>>\n\n                <%- T_('Novo usuário') %>\n            </label>\n\n            <label class=\"radio authTypeBtn <%  if (!isNewUser) {  %> bold <%  }  %>\">\n              <input\n                type=\"radio\"\n                id=\"userTypeReturning\"\n                value=\"userTypeReturning\"\n                name=\"userType\"\n                <%  if (!isNewUser) {  %> checked='checked' <%  }  %>>\n\n                <%- T_('Usuário retornando') %>\n            </label>\n\n          </div>\n\n          <aside class=\"auth-form-alert alert alert-warning hide\"></aside>\n          <aside class=\"auth-form-error alert alert-error hide\"></aside>\n\n          <!-- FACEBOOK OAUTH SECTION -->\n          <div id='fb_place_holder'></div>\n\n          <!-- SIGN-UP SECTION -->\n          <div id='projectLoginUserCreate' <%  if (!isNewUser) {  %> class='hide' <%  }  %>>\n            <div class=\"control-group\">\n              <div class=\"controls\">\n               <input type=\"text\" id='new-email' name='email' placeholder=\"<%- T_('E-mail') %> \" value=\"<%-  email  %>\">\n               <span class=\"help-inline form-error\"></span>\n              </div>\n            </div>\n            <div class=\"control-group\">\n              <div class=\"controls\">\n                <input\n                  type=\"text\"\n                  name=\"newusername\"\n                  maxlength=\"16\"\n                  id=\"new-username\"\n                  class=\"valid\"\n                  placeholder=\"<%- T_('Usuário') %> \"\n                >\n               <span class=\"help-inline form-error\"></span>\n              </div>\n            </div>\n            <div class=\"control-group\">\n              <div class=\"controls\">\n               <input type=\"password\" id='passwd' name='newuserpasswd' placeholder=\"<%- T_('Senha') %> \">\n               <span class=\"help-inline form-error\"></span>\n              </div>\n            </div>\n          </div>\n\n          <!-- LOGIN SECTION -->\n          <div id='userTypeReturningDiv' <%  if (isNewUser) {  %> class='hide' <%  }  %>>\n              <div class=\"control-group\">\n                <div class=\"controls\">\n                 <input\n                  type=\"text\"\n                  id=\"post-proj-username\"\n                  name='username'\n                  value=\"\"\n                  size=\"45\"\n                  placeholder=\"<%- T_('Usuário') %>\">\n                 <span class=\"help-inline\"></span>\n                </div>\n              </div>\n              <div class=\"control-group\">\n                <div class=\"controls\">\n                 <input\n                  type=\"password\"\n                  id=\"post-proj-pwd\"\n                  name='passwd'\n                  value=\"\"\n                  size=\"45\"\n                  placeholder=\"<%- T_('Senha') %>\">\n                 <span class=\"help-inline\"></span>\n                </div>\n              </div>\n          </div>\n        </div>\n      </fieldset>\n\n      <div id=\"returningAjax\">\n         <span>\n           <img src=\"<%=  cdn_url('/img/spinner-black.gif')  %>\">\n        </span>\n      </div>\n\n    </form>\n  <%  }  %>\n\n  <form class='quick-hire-post-form' data-seller-id=\"<%-  userID  %>\" data-seller-username=\"<%-  username  %>\"\n    data-source-type=\"<%-  sourceType  %>\" data-source-id=\"<%-  sourceId  %>\">\n    <fieldset>\n\n        <legend><span class=\"fl-icon-comment\"></span> <%- T_('Enviar uma Mensagem Privada') %> </legend>\n\n      <div class=\"control-group\">\n        <div class=\"controls\">\n            <textarea\n              rows=\"3\"\n              name=\"pmb\"\n              placeholder=\"<%-  T_('Tell them a bit about yourself and your project, and include details of what you need done.')  %>\"\n              data-draft=\"pmb\"\n              id=\"pmb\"\n            ><%  if (!abTests.inForceHMDescriptionTest) {  %><%- T_('Oi <[- username ]>, reparei no seu perfil e gostaria de oferecer a você meu projeto. Podemos discutir quaisquer detalhes no chat.', { 'username': username }) %><%  }  %></textarea>\n        <span class=\"help-block\"></span>\n        </div>\n      </div>\n    </fieldset>\n    <%  if (!isDeloitteUser)  {  %>\n    <fieldset class=\"ModalHireMe-budgetForm\">\n      <div class=\"ModalHireMe-budgetForm-row control-group\">\n        <div class=\"ModalHireMe-budgetForm-inputs\">\n          <select id='project-type' class=\"ModalHireMe-budgetForm-type budget-type budget-period project-type\" data-draft=\"project_type\">\n            <option value='fixed'> <%- T_('Preço Fixo') %> </option>\n            <option value='hourly'> <%- T_('Por Hora') %> </option>\n          </select>\n          <div class=\"controls fixed-detail\" style=\"display: inline-block\">\n            <div class=\"ModalHireMe-budgetForm-rateDuration input-append\">\n              <%=  T_(\"<input type='number' name='fixedPeriod' class='ModalHireMe-budgetForm-rateDuration-input project-period' min='1' data-draft='period' value=<[-days_duration]>><span class='ModalHireMe-budgetForm-rateDuration-addOn add-on'>Days</span>\",{days_duration:days_duration})  %>\n            </div>\n          </div>\n          <div class=\"controls hourly-detail\" style=\"display: none\">\n            <div class=\"ModalHireMe-budgetForm-rateDuration input-append\">\n              <%=  T_(\"<span>in</span> <input type='number' name='commitment' class='ModalHireMe-budgetForm-rateDuration-input project-workload' min='1' value='10' data-draft='commitment'/> <span class='ModalHireMe-budgetForm-rateDuration-addOn add-on'>Hrs/Week</span>\")  %>\n            </div>\n          </div>\n        </div>\n        <div class=\"ModalHireMe-budgetForm-helper help-block\"></div>\n      </div>\n\n      <div class=\"control-group project-type-detail fixed-detail hourly-detail\">\n        <label class=\"control-label\">\n          <%- T_('Orçamento') %>\n          <span class=\"normal\">\n            (<%-  T_('Min')  %>: <span class=\"min-budget-currency-sign\">$</span><span class=\"min-budget-amount\">10</span><span id=\"min-budget-per-hour\" hidden><%- T_('/h') %></span>)\n          </span>\n        </label>\n        <div class=\"ModalHireMe-budgetForm-row\">\n          <input type='hidden' class='project-duration' value='6'>\n          <div class=\"ModalHireMe-budgetForm-inputs controls\">\n            <div class=\"input-prepend\">\n              <span class=\"add-on budget-currency-sign\">$</span><input\n                type=\"number\"\n                name='budget'\n                class=\"ModalHireMe-budgetForm-amount budget-amount\"\n                min=\"<%-  default_min  %>\"\n                fixed-value=\"<%-  min_fixed_budget  %>\"\n                hourly-value=\"<%-  hourlyrate  %>\"\n                value=\"<%-  min_fixed_budget  %>\"\n                data-draft=\"budget\">\n            </div>\n            <select id=\"modalhireme-fixed-multifield-currency\" name='currency'\n              class=\"ModalHireMe-budgetForm-currency project-currency\" data-draft=\"currency\">\n              <%  _.each(budgets, function(budget, index) {  %>\n                <%  if (!isEscrowComRequired || (isEscrowComRequired && budget.vars.is_escrow)) {  %>\n                  <option\n                    value=\"<%-  budget.vars.currency.id  %>\"\n                    title=\"<%=  budget.vars.currency.sign  %>\"\n                    min-fixed-budget=\"<%-  budget.vars.budgets.fixed[0].min_sum  %>\"\n                    min-hourly-budget=\"<%-  budget.vars.budgets.hourly[0].min_sum  %>\"\n                    exchange-rate=\"<%-  budget.vars.currency.exchangerate  %>\"\n                    <%  if (index == 0) {  %> selected=\"selected\" <%  }  %>>\n                    <%-  budget.vars.currency.code  %>\n                  </option>\n                <%  }  %>\n              <%  })  %>\n            </select>\n          </div>\n          <div class=\"ModalHireMe-budgetForm-helper help-block\"></div>\n        </div>\n      </div>\n    </fieldset>\n    <%  }  %>\n    <%  if (isDeloitteUser)  {  %>\n     <!-- Show these fieldset just for Deloitte users -->\n    <fieldset class=\"ModalHireMe-budgetForm\">\n      <div class=\"ModalHireMe-Deloitte\">\n        <div class=\"ModalHireMe-Deloitte-item control-group\">\n          <label for=\"deloitteBillingCode\">\n              <%-  T_('Project Billing code')  %>\n            <span class=\"Tooltip--top\" data-tooltip=\"Billing code will not be shared with resource until they accept the project\">\n              <span class=\"ModalHireMe-Deloitte-icon fl-icon-info-sign\"></span>\n            </span>\n          </label>\n          <input id=\"deloitteBillingCode\" name=\"deloitteBillingCode\" type=\"text\" class=\"default-input\" placeholder=\"ABC12345-12-12-AB-1234\">\n          <div class=\"ModalHireMe-budgetForm-helper help-block\"></div>\n        </div>\n        <div class=\"ModalHireMe-Deloitte-item control-group\">\n          <label for=\"deloitteBillableHours\"><%-  T_('Expected Billable Hours')  %></label>\n          <span class=\"input-group input-append ModalHireMe-Deloitte-inputWrapper\">\n              <input id=\"deloitteBillableHours\" name=\"deloitteBillableHours\" type=\"number\" class=\"default-input\" placeholder=\"1\" min=\"1\" max=\"1000\">\n              <span class=\"add-on\"><%-  T_('Hrs')  %></span>\n          </span>\n          <div class=\"ModalHireMe-budgetForm-helper help-block\"></div>\n        </div>\n        <div class=\"ModalHireMe-Deloitte-item control-group\">\n            <label for=\"startDate\"><%-  T_('Expected start date')  %></label>\n            <input type=\"date\" name=\"startDate\" id=\"startDate\" class=\"default-input\">\n            <div class=\"ModalHireMe-budgetForm-helper help-block\"></div>\n        </div>\n        <div class=\"ModalHireMe-Deloitte-item control-group\">\n            <label for=\"endDate\"><%-  T_('Expected end date')  %></label>\n            <input type=\"date\" name=\"endDate\" id=\"endDate\" class=\"default-input\">\n            <div class=\"ModalHireMe-budgetForm-helper help-block\"></div>\n\n        </div>\n      </div>\n      <div>\n        <h3 class=\"ModalHireMe-Deloitte-subtitle \"><%-  T_('Project Details')  %></h3>\n        <div class=\"ModalHireMe-Deloitte\">\n          <div class=\"ModalHireMe-Deloitte-item control-group\">\n              <label for=\"deloitteProjectType\"><%-  T_('Project type')  %></label>\n              <select class=\"small-select\" name=\"deloitteProjectType\" id=\"deloitteProjectType\">\n                <option value=\"\"><%-  T_('Please select project type')  %></option>\n                <%  for (var key in deloitteAdditionalFieldsData.DeloitteProjectType) {  %>\n                  <option value=\"<%-  key  %>\"\n                    title=<%-  deloitteAdditionalFieldsData.DeloitteProjectType[key]  %>\">\n                    <%-  deloitteAdditionalFieldsData.DeloitteProjectType[key]  %>\n                  </option>\n                <%  };  %>\n              </select>\n              <div class=\"ModalHireMe-budgetForm-helper help-block\"></div>\n          </div>\n          <div class=\"ModalHireMe-Deloitte-item control-group\">\n              <label for=\"deloittePractice\"><%-  T_('Practice')  %></label>\n              <select class=\"small-select\" name=\"deloittePractice\" id=\"deloittePractice\">\n                <option value=\"\"><%-  T_('Please select project practice')  %></option>\n                <%  for (var key in deloitteAdditionalFieldsData.DeloittePractice) {  %>\n                  <option value=\"<%-  key  %>\"\n                    title=<%-  deloitteAdditionalFieldsData.DeloittePractice[key]  %>\">\n                    <%-  deloitteAdditionalFieldsData.DeloittePractice[key]  %>\n                  </option>\n                <%  };  %>\n              </select>\n              <div class=\"ModalHireMe-budgetForm-helper help-block\"></div>\n          </div>\n          <div class=\"ModalHireMe-Deloitte-item control-group\">\n              <label for=\"deloitteIndustry\"><%-  T_('Industry')  %></label>\n              <select class=\"small-select\" name=\"deloitteIndustry\" id=\"deloitteIndustry\">\n                <option value=\"\"><%-  T_('Please select project industry')  %></option>\n                <%  for (var key in deloitteAdditionalFieldsData.DeloitteIndustry) {  %>\n                  <option value=\"<%-  key  %>\"\n                    title=<%-  deloitteAdditionalFieldsData.DeloitteIndustry[key]  %>\">\n                    <%-  deloitteAdditionalFieldsData.DeloitteIndustry[key]  %>\n                  </option>\n                <%  };  %>\n              </select>\n              <div class=\"ModalHireMe-budgetForm-helper help-block\"></div>\n          </div>\n          <div class=\"ModalHireMe-Deloitte-item control-group\">\n              <label class=\"ModalHireMe-Deloitte-portfolioWrapper\" for=\"deloitteOffering\">\n                <%-  T_('Offering')  %>\n                <span data-offering-category></span>\n              </label>\n              <select class=\"small-select\" name=\"deloitteOffering\" id=\"deloitteOffering\">\n                <option value=\"\"><%-  T_('Please select project offering')  %></option>\n                <%  for (var portfolio in deloitteAdditionalFieldsData.DeloitteOffering) {  %>\n                  <optgroup label=\"<%-  deloitteAdditionalFieldsData.DeloitteOfferingPortfolio[portfolio]  %>\">\n                    <%  var portfolioObj = deloitteAdditionalFieldsData.DeloitteOffering[portfolio];  %>\n                    <%  for (var offering in portfolioObj) {  %>\n                      <option value=\"<%-  offering  %>\"\n                        title=<%-  portfolioObj[offering]  %>\">\n                        <%-  portfolioObj[offering]  %>\n                      </option>\n                    <%  };  %>\n                  </optgroup>\n                <%  };  %>\n              </select>\n              <div class=\"ModalHireMe-budgetForm-helper help-block\"></div>\n          </div>\n          <div class=\"control-group\">\n            <div class=\"Checkbox\">\n              <input id=\"isClearanceRequired\" name=\"isClearanceRequired\" class=\"Checkbox-input\" type=\"checkbox\" >\n              <label class=\"Checkbox-label\" for=\"isClearanceRequired\"><%-  T_('Is clearance required for this project?')  %></label>\n            </div>\n            <input id=\"deloitteClearance\" disabled name=\"deloitteClearance\" type=\"text\" class=\"default-input\" placeholder=\"Specify clearance\">\n            <div class=\"ModalHireMe-budgetForm-helper help-block\"></div>\n          </div>\n          <div class=\"control-group\">\n            <div class=\"Checkbox\">\n              <input id=\"deloitteItar\" class=\"Checkbox-input\" type=\"checkbox\" name=\"deloitteItar\">\n              <label class=\"Checkbox-label\" for=\"deloitteItar\"><%-  T_('Is this project subject to the International Traffic in Arms Regulations (ITAR)?')  %></label>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class=\"control-group\">\n        <div class=\"Checkbox\">\n          <input id=\"deloitteUserAgreement\" class=\"Checkbox-input\" type=\"checkbox\" name=\"deloitteUserAgreement\" required>\n          <label class=\"Checkbox-label checkbox ModalHireMe-checkbox\" for=\"deloitteUserAgreement\">\n            <span>\n              I have reviewed my project and affirm that no\n              <a href=\"/media/deloitte/confidential-information.pdf\" target=\"_blank\">confidential information</a>\n              has been shared in this project posting in compliance with Deloitte's\n              <a href=\"//deloittenet.deloitte.com/About/Policies/Admin/Pages/223_ConfidentialInformationOtherVitalBusinessInterests_US.aspx\" target=\"_blank\">Confidentiality Policy</a>\n              and\n              <a href=\"//deloittenet.deloitte.com/About/Policies/Admin/Pages/910_Privacy_Policy_US.aspx\" target=\"_blank\">Privacy Policy</a>\n            </span>\n          </label>\n        </div>\n      </div>\n    </fieldset>\n    <%  }  %>\n    <p class=\"hireme-terms\">\n      <%= T_('Ao clicar em ”Contratar Agora”, você está indicando que leu e aceita os <a href=\"/about/terms\" class=\"site_plainterms\">Termos e Condições</a> e <a href=\"/about/privacy\" class=\"site_privacy\">Política de Privacidade</a>') %>\n    </p>\n  </form>\n  <div id=\"quickhire-modal-generic-error\" class=\"quickhire-modal-generic-error alert alert-error\">\n  </div>\n  <a class=\"btn btn-info btn-block btn-quickhire\"\n    hireme-label=\"Success\"><%- T_('Contratar Agora!') %></a>\n  <div class=\"Loader loading-img\" style=\"display:none\"></div>\n</div>\n<!-- The template to display files available for upload -->\n<script id=\"quickhire-template-upload\" type=\"text/x-tmpl\">\n{% for (var i=0, file; file=o.files[i]; i++) { %}\n  {% var errors = <%=  JSON.stringify(locale.fileupload.errors)  %>; %}\n  <tr class=\"template-upload fade\">\n    <td class=\"preview\"><span class=\"fade\"></span></td>\n    <td class=\"name\" title=\"{%=file.name%}\">\n      <span class=\"filename-span\">{%=file.name%}</span>\n    </td>\n    <td class=\"size\"><span>{%=o.formatFileSize(file.size)%}</span></td>\n    {% if (file.error) { %}\n      <td class=\"error\" colspan=\"2\">\n        <span class=\"label label-important\"><%-  locale.fileupload.error  %></span>\n        {%=errors[file.error] || file.error%}</td>\n      <td class=\"cancel\">\n        <button class=\"btn btn-danger\">\n          <i class=\"icon-trash icon-white\"></i>\n          <span><%-  locale.fileupload.destroy  %></span>\n        </button>\n      </td>\n    {% } else if (o.files.valid && !i) { %}\n      <td>\n        <div class=\"progress progress-success progress-striped active\"\n        role=\"progressbar\" aria-valuemin=\"0\" aria-valuemax=\"100\"\n        aria-valuenow=\"0\">\n          <div class=\"bar fileupload-progress-bar\"></div>\n        </div>\n      </td>\n      <td class=\"start\">{% if (!o.options.autoUpload) { %}\n        <button class=\"btn btn-primary\">\n          <i class=\"icon-upload icon-white\"></i>\n          <span><%-  locale.fileupload.start  %></span>\n        </button>\n      {% } %}</td>\n      <td class=\"cancel\">{% if (!i) { %}\n        <button class=\"btn btn-primary\">\n          <i class=\"icon-ban-circle icon-white\"></i>\n          <span><%-  locale.fileupload.cancel  %></span>\n        </button>\n      {% } %}</td>\n    {% } else { %}\n      <td colspan=\"2\"></td>\n      <td class=\"cancel\">{% if (!i) { %}\n        <button class=\"btn btn-primary\">\n          <i class=\"icon-ban-circle icon-white\"></i>\n          <span><%-  locale.fileupload.cancel  %></span>\n        </button>\n      {% } %}</td>\n    {% } %}\n  </tr>\n{% } %}\n</script>\n<!-- The template to display files available for download -->\n<script id=\"quickhire-template-download\" type=\"text/x-tmpl\">\n{% for (var i=0, file; file=o.files[i]; i++) { %}\n  {% var errors = <%=  JSON.stringify(locale.fileupload.errors)  %>; %}\n  <tr class=\"template-download fade\">\n    {% if (file.error) { %}\n      <td></td>\n      <td class=\"name\" title=\"{%=file.name%}\">\n        <span class=\"filename-span\">{%=file.name%}</span>\n      </td>\n      <td class=\"size\"><span>{%=o.formatFileSize(file.size)%}</span></td>\n      <td class=\"error\" colspan=\"2\">\n        <span class=\"label label-important\"><%-  locale.fileupload.error  %></span>\n        {%=errors[file.error] || file.error%}\n      </td>\n    {% } else { %}\n      <td class=\"preview\">{% if (file.thumbnail_url) { %}\n        <a href=\"{%=file.url%}\" title=\"{%=file.name%}\" rel=\"gallery\" download=\"{%=file.name%}\"><img src=\"{%=file.thumbnail_url%}\"></a>\n      {% } %}</td>\n      <td class=\"name\">\n        <p href=\"{%=file.url%}\" title=\"{%=file.name%}\"\n        rel=\"{%=file.thumbnail_url&&'gallery'%}\"\n        download=\"{%=file.name%}\">\n          <span class=\"filename-span\">{%=file.name%}</span>\n        </p>\n      </td>\n      <td class=\"size\"><span>{%=o.formatFileSize(file.size)%}</span></td>\n      <td colspan=\"2\"></td>\n    {% } %}\n    <td class=\"delete\">\n      <button class=\"btn btn-danger\" data-type=\"{%=file.delete_type%}\" data-url=\"{%=file.delete_url%}\">\n        <i class=\"icon-trash icon-white\"></i>\n        <%-  locale.fileupload.destroy  %>\n      </button>\n    </td>\n  </tr>\n{% } %}\n</script>\n";

var quickHireFormTemplateHeader = "<h3 class=\"quick-hire-form-title\"><%- T_('Ofereça seu projeto para <[- username ]>', { 'username': username }) %></h3>\n";

var quickHireMilestoneFormTemplate = "<div class=\"milestone-modal-wrapper pinky-template\">\n  <div class=\"milestone-modal is-milestone-hireme\">\n    <h3 class=\"milestone-modal-title\"><%- T_('Criar um Pré-pagamento em Espera') %></h3>\n    <span class=\"project-descr-tip quick-hire-post-form-tip\" data-title=\"<%- T_('Pré-Pagamento em Espera') %>\" id=\"milestones-popover\"\n      data-content=\"<%- T_('O Sistema de Pré-Pagamento em Espera é o nosso recurso de pagamentos protegidos. Ele permite que <[- username]> comece a trabalhar, sabendo que os fundos estão no sistema e lhe dão tranquilidade porque você somente vai liberar os fundos quando estiver 100% satisfeito. Recomendamos que você divida seu projeto em tarefas menores (pré-pagamentos) e pague o <[- username]> em parcelas, conforme cada pré-pagamento for concluído. No caso improvável de um problema ocorrer no seu projeto, quaisquer pré-pagamentos em espera são protegidos pelo nosso Sistema de Resolução de Disputas.', { 'username': username }) %>\">\n      <img src=\"<%=  cdn_url('/build/css/images/pages/post-project/question.png')  %>\">\n    </span>\n    <div class=\"milestone-modal-description\">\n      <p class=\"milestone-modal-description-content\">\n        <%= T_('Os freelancers têm <strong>150% mais probabilidades de aceitar</strong> seu projeto quando um Pré-pagamento em Espera for criado. Seu Pré-pagamento em Espera será automaticamente reembolsado caso <[- username ]> não aceitar o projeto.', { 'username': username }) %>\n      </p>\n    </div>\n    <form class=\"quick-hire-milestone-form milestone-modal-form fl-form\">\n      <fieldset class=\"milestone-modal-form-fieldset\">\n        <ol>\n          <li class=\"milestone-modal-form-amount control-group form-step\">\n            <label><%- T_('Quantia do Pré-pagamento') %></label>\n            <span class=\"input-group\">\n              <span class=\"milestone-currency-sign add-on\">\n                <%  if (typeof abTestPrehire !== 'undefined' && abTestPrehire && currency) {  %>\n                  <%=  currency.sign  %>\n                <%  } else {  %>\n                  <%=  quickHireReturnData.currency_sign  %>\n                <%  }  %>\n              </span>\n              <input name=\"milestoneAmount\"\n                class=\"milestone-modal-form-amount-input milestone-amount default-input\"\n                type=\"text\"\n                placeholder=\"\"\n                value=\"<%-  budget  %>\"\n                maxlength=\"8\">\n            </span>\n            <div class=\"form-error help-block\"></div>\n          </li>\n          <li class=\"milestone-modal-form-description control-group form-step\">\n            <label><%- T_('Descrição do Pré-pagamento') %></label>\n            <input type=\"text\" name=\"milestoneDescr\" class=\"milestone-descr default-input\"\n              placeholder=\"<%- T_('Insira descrição do seu pré-pagamento aqui') %>\" value=\"<%- T_('Pré-pagamento inicial') %>\">\n            <div class=\"form-error help-block\"></div>\n          </li>\n        </ol>\n      </fieldset>\n    </form>\n    <div id=\"milestone-modal-upgrade-section\" class=\"milestone-modal-upgrade-section is-hidden\"></div>\n    <div class=\"milestone-request-total milestone-modal-total\">\n      <%-  T_('Total:')  %>\n      <%  if (typeof abTestPrehire !== 'undefined' && abTestPrehire && currency) {  %>\n        <%=  currency.sign  %>\n      <%  } else {  %>\n        <%=  quickHireReturnData.currency_sign  %>\n      <%  }  %>\n      <span class='total-amount'>\n      </span>\n      <%  if (typeof abTestPrehire !== 'undefined' && abTestPrehire && currency) {  %>\n        <%=  currency.code  %>\n      <%  }  %>\n    </div>\n    <div class=\"milestone-modal-payment milestone-modal-summary\">\n      <div id=\"payment-sources-container\">\n      </div>\n    </div>\n    <div id=\"prehire-created\" class=\"alert alert-success hide\">\n      <%= T_('Você contratou com sucesso <strong><[- username ]></strong>.', { 'username': username }) %>\n    </div>\n    <div id=\"milestone-error\" class=\"milestone-modal-alert alert alert-error\"></div>\n    <div class=\"quickhire-modal-generic-warning milestone-modal-alert alert alert-warning\"></div>\n    <%  if (typeof abTestSkipMilestone !== 'undefined' && abTestSkipMilestone) {  %>\n      <button type=\"button\" class=\"btn\" id=\"milestone-not-now\"\n        data-qtsb-section=\"HireMe\"\n        data-qtsb-subsection=\"CreateMilestoneModal\"\n        data-qtsb-label=\"NotNow\">\n        <%- T_('Agora Não') %>\n      </button>\n    <%  }  %>\n    <button type=\"button\" class=\"btn btn-info btn-quickhire-create-milestone\"\n      data-qtsb-section=\"HireMe\"\n      data-qtsb-subsection=\"CreateMilestoneModal\"\n      data-qtsb-label=\"Proceed\">\n      <%- T_('Prosseguir para Pagamento') %>\n    </button>\n    <img src=\"<%=  cdn_url('/img/ajax-loader.gif')  %>\" class=\"loading-img margin-r20\" style=\"display:none\"/>\n    <a type=\"button\" class=\"btn btn-quickhire-no-milestone is-hidden\"\n      href=\"<%  if (typeof abTestPrehire === 'undefined' || !abTestPrehire) {  %> <%-  quickHireReturnData.url  %> <%  } else {  %> <%  }  %>\" >\n      <%- T_('Não Obrigado') %>\n    </a>\n  </div>\n</div>\n";

var paymentVerificationTemplate = "<figure class=\"ModalPaymentVerification-figure\">\n    <img src=\"/build/img/payment-verification.svg\"\n      alt=\"Keep our community safe: Verify your payment method to hire freelancers\">\n</figure>\n<h3 class=\"ModalPaymentVerification-heading\">Keep our community safe</h3>\n<p class=\"ModalPaymentVerification-copy\">Verify your payment method to hire freelancers</p>\n<div class=\"ModalPaymentVerification-cta\">\n  <a id=\"verify-now\" \n    type=\"button\"\n    href=\"<%-  paymentVerifyUrl  %>\" \n    class=\"btn btn-info btn-large ModalPaymentVerification-button\">Verify Now</a>\n</div>\n<p>\n  <a id=\"verify-later\" \n    href=\"<%-  pppRedirectUrl  %>\">Or post a project and verify later</a>\n</p>\n";

var errorMessageTemplate = "<div>\n  <%  if (code === ErrorCode.EMAIL_VERIFICATION_REQUIRED) {  %>\n    <p>\n      <strong><%-  T_('Email verification required')  %></strong>\n    </p>\n    <p>\n      <%-  T_('You need to verify your email before hiring this user.')  %>\n    </p>\n    <a href=\"/users/verify.php?id=<%-  userId  %>&sellerId=<%-  sellerId  %>\" target=\"_blank\">\n      <%-  T_('Verify your email')  %>\n    </a>\n  <%  } else if (code === ErrorCode.NEGATIVE_BALANCE_SUSPENSION) {  %>\n    <%=  message  %>\n  <%  } else {  %>\n    <%-  message  %>\n  <%  }  %>\n</div>\n";

var _templateObject$12 = _taggedTemplateLiteral(['#modalhireme-fixed-multifield-currency\n      option[value="', '"]'], ['#modalhireme-fixed-multifield-currency\n      option[value="', '"]']),
    _templateObject2$5 = _taggedTemplateLiteral(['.hourly-detail #modalhireme-fixed-multifield-currency\n            option:selected'], ['.hourly-detail #modalhireme-fixed-multifield-currency\n            option:selected']),
    _templateObject3$2 = _taggedTemplateLiteral(['You need to verify your email to hire another freelancer.\n            We\'ve just sent you another verification email.\n            Please verify your email and try again.'], ['You need to verify your email to hire another freelancer.\n            We\'ve just sent you another verification email.\n            Please verify your email and try again.']),
    _templateObject4 = _taggedTemplateLiteral(['Milestone creation failed, please try again.\n       Please contact support at support@freelancer.com if this error persists.'], ['Milestone creation failed, please try again.\n       Please contact support at support@freelancer.com if this error persists.']);

/**
                                                          * Warning: This module is used on ALL bootstrap pages across the site.
                                                          * Please be considerate when adding selectors, and use the
                                                          * quickhireFormContainerDom variable, private to this module, which refers to
                                                          * the container element for this modal to find the elements you are looking
                                                          * for. Otherwise this module may misbehave on other pages.
                                                          */

// The module must have a container with class 'quick-hire-form-container'
var budgetsCache = [];
var durationsCache = [];
var feeNotes = false;
var quickHireReturnData = {};
var thisUser = getUserIdfromCookie();
var quickhireFormContainerDom = {};
var selectedCurrencyDom = false;
var projectTypeDom = false;
// Entrypoint to be sent with TTREF events.
var entryPoint = 'directoryInline4';
var abTests = {};
var abTestSkipMilestone = false;
var isOnMilestoneCreation = false;
var milestoneCreationCancelRedirectUrl = null;
var hireMeModal = void 0;
var previousCurrency = void 0;
var freelancerUserId = void 0;
var experiments = {};
var hireMeLoadCallback = void 0;
var isDeloitteUser = false;
var isEscrowComRequired = false;

var ErrorCode = {
  EMAIL_VERIFICATION_REQUIRED: 20153,
  NEGATIVE_BALANCE_SUSPENSION: 20003,
  UNVERIFIED_PAYMENT_RESPONSE: 20001 };

var selectors = {
  draft: {
    budget: '[data-draft="budget"]',
    commitment: '[data-draft="commitment"]',
    currency: '[data-draft="currency"]',
    period: '[data-draft="period"]',
    pmb: '[data-draft="pmb"]',
    projectType: '[data-draft="project_type"]' } };

var HIREME_DRAFT_EXPERIMENT_NAME = 'TS-T123810-hireme-pending-state-ux';
var HireMeDraft$1 = hireMeDraft();

function entryPointToQTS(original) {
  // Some of our ttref entryPoint values have a different QTS mapping. Arg!
  return original === 'directoryInline4' ? 'Directory' : original;
}

var hiremeEvents = {
  /* Tracking events called on form open, successful hire, milestone
                        * award/success
                        * Please use these instead of hacking additional events inline... :(
                        */
  success: function success(data) {
    _ttref.push(['_trackEvent', 'ProjectHireMe', 'Award', 'Success', 'project_id', data.project_id]);

    _lt.push({
      event: 'HireMe Posted' });
  },
  quickHireReturnDataReady: function quickHireReturnDataReady() {
    _lt.push(['user_action', {
      section: entryPointToQTS(entryPoint),
      subsection: 'MilestoneCreate_InitialHireMe',
      label: 'form_open',
      action: 'click',
      project_id: quickHireReturnData.project_id }]);
  },
  milestoneClick: function milestoneClick() {
    _ttref.push(['_trackEventNoCookie', 'HireMe', 'Initial_Milestone', entryPoint, 'click']);

    _lt.push(['user_action', {
      section: entryPointToQTS(entryPoint),
      subsection: 'MilestoneCreate_InitialHireMe',
      label: 'form_submit',
      action: 'click',
      project_id: quickHireReturnData.project_id }]);
  },
  milestoneSuccess: function milestoneSuccess() {}
};

function findErrorEl() {
  var errorEl = quickhireFormContainerDom.find('#quickhire-modal-milestone-generic-error, ' + '#quickhire-modal-generic-error, ' + '#milestone-error');

  return errorEl;
}

function findWarningEl() {
  return quickhireFormContainerDom.find('.quickhire-modal-generic-warning');
}

function displayError(message, code, sellerId) {
  var errorEl = findErrorEl();
  var errorTemplate = _.template(errorMessageTemplate)({
    ErrorCode: ErrorCode,
    T_: translate,
    code: code,
    message: message,
    userId: getUserIdfromCookie(),
    sellerId: sellerId });

  errorEl.html(errorTemplate);
  errorEl.show();
}

function displayWarning(message) {
  var warningEl = findWarningEl();
  warningEl.text(message);
  warningEl.show();
}

function hideError() {
  var errorEl = findErrorEl();
  errorEl.hide();
}

function convertToExchangeRate(amount, prevRate, curRate) {
  /*
                                                            * Exchange rates are all based on USD so convert the previous currency
                                                            * first to USD before changing to user's selected currency
                                                            */
  var convertedAmount = Math.round(amount * prevRate / curRate).toFixed(0);
  var roundingFactor = 1;

  if (convertedAmount > 10000) {
    roundingFactor = 1000;
  } else if (convertedAmount > 1000) {
    roundingFactor = 100;
  } else if (convertedAmount > 100) {
    roundingFactor = 10;
  }

  convertedAmount = Math.round(convertedAmount / roundingFactor) * roundingFactor;

  return convertedAmount;
}

function applyExchangeRate(selectedOption) {
  if (previousCurrency === selectedOption.val()) {
    return;
  }

  // Automatically convert the budget amount based on the selected currency
  var budgetAmountDom = quickhireFormContainerDom.find('.budget-amount');
  var previousValueDom = quickhireFormContainerDom.find(oneLine(_templateObject$12, previousCurrency));

  var prevRate = previousValueDom.attr('exchange-rate');
  var curRate = selectedOption.attr('exchange-rate');
  var budget = budgetAmountDom.val();
  var convertedBudget = convertToExchangeRate(budget, prevRate, curRate);
  budgetAmountDom.val(convertedBudget);
  previousCurrency = selectedOption.val();

  /*
                                            * Update the default exchange rate for hourly/fixed price if
                                            * budget amount field value was not yet modified
                                            */
  var hourlyValue = budgetAmountDom.attr('hourly-value');
  var fixedValue = budgetAmountDom.attr('fixed-value');
  if (hourlyValue !== fixedValue) {
    var convertedFixedValue = convertToExchangeRate(fixedValue, prevRate, curRate);

    var convertedHourlyValue = convertToExchangeRate(hourlyValue, prevRate, curRate);

    budgetAmountDom.attr('fixed-value', convertedFixedValue);
    budgetAmountDom.attr('hourly-value', convertedHourlyValue);
  }
}

// if the currency has higher value than USD set the minimum
// hourly rate equal to 1 otherwise set the minimum hourly rate
// to 1 USD equivalent of the selected currency. (exchange rate is <currency>/USD)
function computeMinimumHourlyBudget(exchangeRate) {
  return exchangeRate >= 1 ? 1 : Math.floor(1 / exchangeRate);
}

function changeMinimumBudget(params) {
  if (selectedCurrencyDom === false) {
    selectedCurrencyDom = quickhireFormContainerDom.find('#modalhireme-fixed-multifield-currency option:selected');
  }
  applyExchangeRate(selectedCurrencyDom);

  var projectTypeDetailDom = params.triggeringElement.closest('.project-type-detail');

  var sign = selectedCurrencyDom.attr('title');

  var minBudget = selectedCurrencyDom.attr('min-' + projectTypeDom.val() + '-budget');

  if (projectTypeDom.val() === 'hourly') {
    minBudget = computeMinimumHourlyBudget(selectedCurrencyDom.attr('exchange-rate'));

    selectedCurrencyDom.attr('min-hourly-budget', minBudget);
  }

  projectTypeDetailDom.find('.budget-currency-sign').html(sign);
  projectTypeDetailDom.find('.min-budget-currency-sign').html(sign);

  quickhireFormContainerDom.find('.min-budget-amount').html(minBudget);
  quickhireFormContainerDom.find('.budget-amount').attr('min', minBudget);
  quickhireFormContainerDom.find('.budget-amount').valid();
}

function formatBillingCode(code) {
  var billingCode = code.toUpperCase().replace(/[^A-Z\d]/g, '').split('');
  var separatorIndexes = [14, 12, 10, 8];
  var separator = '-';
  separatorIndexes.forEach(function (index) {
    if (billingCode.length > index) {
      billingCode.splice(index, 0, separator);
    }
  });
  billingCode = billingCode.join('').substr(0, 22);
  return billingCode;
}

function applyEvents() {
  quickhireFormContainerDom.on('click', '.btn-auth-type', function () {
    var that = jq(this);
    var form = quickhireFormContainerDom.find('.quick-hire-post-form');
    that.find('.user-type').attr('checked', 'checked');
    that.siblings('btn-auth-type').find('.user-type').attr('checked', false);
    if (that.hasClass('returning-user')) {
      form.find('.user-create').hide();
      form.find('.user-return').show();
    } else {
      form.find('.user-return').hide();
      form.find('.user-create').show();
    }
  });

  quickhireFormContainerDom.on('change', '.hoursOption', function () {
    var form = quickhireFormContainerDom.find('.quick-hire-post-form');
    var checkedOption = form.find('.hoursOption:checked');
    if (checkedOption.val() == 'notSure') {
      form.find('.project-workload').attr('disabled', true).val(1);
    } else {
      form.find('.project-workload').removeAttr('disabled');
    }
  });

  quickhireFormContainerDom.on('change', '#isClearanceRequired', function () {
    var checkBox = quickhireFormContainerDom.find('#isClearanceRequired');
    var input = quickhireFormContainerDom.find('#deloitteClearance');
    if (checkBox.is(':checked')) {
      input.prop('disabled', false);
    } else {
      input.prop('disabled', true);
    }
  });
  // deloitteClearance is dependent on checkbox, so have to manually remove errors
  quickhireFormContainerDom.on('keyup', '#deloitteClearance', function () {
    if (quickhireFormContainerDom.find('#deloitteClearance').val()) {
      clearValidationError(quickhireFormContainerDom.find('#deloitteClearance'));
    }
  });

  quickhireFormContainerDom.on('click', '.hours-option-text', function () {
    var forOption = jq(this).attr('for');
    jq(this).find('.hoursOption[value=' + forOption + ']').trigger('click');
  });

  quickhireFormContainerDom.on('click', '.cancel-quickhire', function () {
    quickhireFormContainerDom.find('.close').trigger('click');
  });

  quickhireFormContainerDom.on('click', '.site_plainterms', function () {
    window.open('/info/plainterms.html', '', 'width=1000, height=600, left=100,top=100,menu=no, ' + 'toolbar=no,scrollbars=yes,resizable=yes');

    return false;
  });

  quickhireFormContainerDom.on('click', '.site_privacy', function () {
    window.open('/page.php?p=info/privacy', '', 'width=1000, height=600, left=0,top=0,menu=no, ' + 'toolbar=no,scrollbars=yes,resizable=yes');

    return false;
  });

  projectTypeDom.on('change', function () {
    var formContainer = quickhireFormContainerDom;
    var freelancerId = quickhireFormContainerDom.find('.quick-hire-post-form').data('seller-id');

    if (projectTypeDom.val() === 'hourly') {
      formContainer.find('#min-budget-per-hour').show();
      formContainer.find('.fixed-detail').hide();
      formContainer.find('.hourly-detail').show();
      formContainer.find('#project_fix_fee_note').hide();
      formContainer.find('#project_hourly_fee_note').show();

      _t.push(['user_action', {
        section: 'HireMeModal',
        name: 'ToggleToHourly',
        label: 'Per Hour',
        reference: 'freelancer_id',
        reference_id: freelancerId }]);
    } else {
      formContainer.find('#min-budget-per-hour').hide();
      formContainer.find('.hourly-detail').hide();
      formContainer.find('.fixed-detail').show();
      formContainer.find('#project_fix_fee_note').show();
      formContainer.find('#project_hourly_fee_note').hide();

      _t.push(['user_action', {
        section: 'HireMeModal',
        name: 'ToggleToFixedPrice',
        label: 'Fixed Price',
        reference: 'freelancer_id',
        reference_id: freelancerId }]);
    }

    var budgetAmountDom = formContainer.find('.budget-amount');
    budgetAmountDom.val(budgetAmountDom.attr(projectTypeDom.val() + '-value'));
    budgetAmountDom.focusout();

    changeMinimumBudget({
      triggeringElement: jq(this) });
  });

  quickhireFormContainerDom.on('click', '.btn-quickhire', function () {
    var form = quickhireFormContainerDom.find('.quick-hire-post-form');
    var hasAuthErrors = false;

    if (quickhireFormContainerDom.find('#userTypeReturning').is(':checked') && !userAuthForm.userReturned()) {
      quickhireFormContainerDom.find('#post-proj-username, #post-proj-pwd').closest('.control-group').removeClass('success').addClass('error');
      quickhireFormContainerDom.find('#post-proj-pwd').siblings('.help-inline').html(translate('Por favor, verifique seus detalhes de login.'));
      hasAuthErrors = true;
    }

    if (hasAuthErrors) {
      var errorElement = quickhireFormContainerDom.find('.control-group.error:first').offset().top;
      jq(document).scrollTop(errorElement - 250);
    }
    if (validateForm$1(form) && thisUser) {
      submitForm(form);
    }
  });

  quickhireFormContainerDom.on('click', '.btn-quickhire-create-milestone', function () {
    var milestoneForm = quickhireFormContainerDom.find('.quick-hire-milestone-form');

    if (validateMilestoneForm(milestoneForm)) {
      submitMilestoneForm(milestoneForm);
    }
  });

  quickhireFormContainerDom.on('click', '.btn-quickhire-no-milestone', function () {
    var formContainer = quickhireFormContainerDom;
    formContainer.find('.btn-quickhire-create-milestone').attr('disabled', true);
    formContainer.find('.btn-quickhire-no-milestone').attr('disabled', true);
  });

  quickhireFormContainerDom.on('change', '#modalhireme-fixed-multifield-currency', function () {
    selectedCurrencyDom = jq(this).find('option:selected');
    changeMinimumBudget({
      triggeringElement: jq(this) });
  });

  quickhireFormContainerDom.on('change', '.budget-amount', function () {
    jq(this).attr('fixed-value', jq(this).val());
    jq(this).attr('hourly-value', jq(this).val());
  });

  quickhireFormContainerDom.on('keyup', '#deloitteBillingCode', function () {
    var that = jq(this);
    var code = formatBillingCode(that.val());
    that.val(code);
  });

  quickhireFormContainerDom.on('paste', '#deloitteBillingCode', function () {
    var that = jq(this);
    var code = formatBillingCode(that.val());
    that.val(code);
  });

  if (isDeloitteUser) {
    quickhireFormContainerDom.on('change', '#deloitteOffering', function () {
      var that = jq(this);
      var offering = that.find(':selected').parent().attr('label');
      quickhireFormContainerDom.find('[data-offering-category]').text(offering || '');
    });

    jq.validator.addMethod('checkEndDate', function (value, element) {
      var that = jq(element);
      var inputVal = that.val();
      if (inputVal && quickhireFormContainerDom.find('#startDate').val() && inputVal > quickhireFormContainerDom.find('#startDate').val()) {
        return true;
      }
      return false;
    }, translate('End date should be greater than start date.'));

    jq.validator.addMethod('checkStartDate', function () {
      var form = quickhireFormContainerDom.find('.quick-hire-post-form');
      form.validate().element('#endDate');
      return true;
    }, translate('End date should be greater than start date.'));

    jq.validator.addMethod('checkDeloitteBillingCode', function (value, element) {
      var that = jq(element);
      var inputVal = that.val();
      var billingCodeRegex = new RegExp(/^[A-Z]{3}[\d]{5}-[A-Z\d]{2}-[A-Z\d]{2}-[A-Z\d]{2}-[\d]{4}$/, 'i');

      return billingCodeRegex.test(inputVal);
    }, translate('Please enter a valid billing code.'));

    jq.validator.addMethod('checkGAABillingCode', function (value, element) {
      var that = jq(element);
      var inputVal = that.val();
      var billingCodeRegex = new RegExp(/^(?!GAA).*$/, 'i');
      return billingCodeRegex.test(inputVal);
    }, translate('You may not use a WBS code beginning with GAA to post a gig.'));

    jq.validator.addMethod('checkClearance', function (value, element) {
      var that = jq(element);
      var checked = that[0].checked;
      // deloitteClearance is dependent on checkbox, so have to manually trigger error msgs
      if (checked) {
        if (!quickhireFormContainerDom.find('#deloitteClearance').val()) {
          addValidationError(quickhireFormContainerDom.find('#deloitteClearance'));

          return false;
        }
      }
      clearValidationError(quickhireFormContainerDom.find('#deloitteClearance'));

      return true;
    }, translate('Please provide clearance.'));
  } else {
    jq.validator.addMethod('checkCraigslistViolation', function (value, element) {
      var craigslistTerms = ['craigslist', /(^|\W)cl($|\W)/, 'clist'];
      var violationTerms = ['ghost', 'ghosting', 'flag', 'flagging', 'block', 'blocking', 'pva', 'pvas', 'phone verified accounts', 'auto reply', 'auto respond', 'post', 'poster', 'posting', 'autopost', 'autoposter', 'autoposting', 'anti-flagging', 'captcha', 'captchas'];

      var craigslistCheckResult = false;
      for (var i = craigslistTerms.length - 1; i >= 0; i--) {
        if (jq(element).val().toLowerCase().match(craigslistTerms[i])) {
          craigslistCheckResult = true;
        }
      }
      var violationCheckResult = false;
      for (var j = violationTerms.length - 1; j >= 0; j--) {
        if (jq(element).val().toLowerCase().match(violationTerms[j])) {
          violationCheckResult = true;
        }
      }
      if (craigslistCheckResult && violationCheckResult) {
        jq(this).find('#warning_craigslist_id').show();
        return true;
      }
      quickhireFormContainerDom.find('#warning_craigslist_id').hide();
      return true;
    }, translate('Por favor, certifique-se de não violar os Termos de Uso da Craiglist.'));

    jq.validator.addMethod('checkCopyRightViolation', function (value, element) {
      var copyRightViolationTerms = ['clone', 'exact copy'];

      for (var i = copyRightViolationTerms.length - 1; i >= 0; i--) {
        if (jq(element).val().toLowerCase().match(copyRightViolationTerms[i])) {
          jq(this).find('#warning_copyright_id').show();
          return true;
        }
      }
      quickhireFormContainerDom.find('#warning_copyright_id').hide();
      return true;
    }, translate('Por favor, certifique-se de não violar os Termos de Uso da Craiglist.'));

    jq.validator.addMethod('checkFixedPeriod', function (value, element) {
      var that = jq(element);

      if (projectTypeDom.val() === 'fixed') {
        var inputAmount = parseInt(that.val(), 10);
        if (Number.isNaN(inputAmount) || inputAmount <= 0) {
          return false;
        }
      }
      return true;
    }, translate('Por favor, digite um período válido.'));

    jq.validator.addMethod('checkHourlyWorkload', function (value, element) {
      var that = jq(element);

      if (projectTypeDom.val() === 'hourly') {
        var inputAmount = parseInt(that.val(), 10);
        if (Number.isNaN(inputAmount) || inputAmount <= 0) {
          return false;
        }
      }
      return true;
    }, translate('Por favor, Insira uma carga horária válida'));

    jq.validator.addMethod('checkBudget', function (value, element) {
      var form = quickhireFormContainerDom;
      var that = jq(element);
      var inputAmount = parseInt(that.val(), 10);
      var minBudgetAmount = 0;
      var optionSelected = void 0;

      if (projectTypeDom.val() === 'fixed') {
        optionSelected = form.find('.fixed-detail ' + '#modalhireme-fixed-multifield-currency option:selected');

        minBudgetAmount = parseInt(optionSelected.attr('min-fixed-budget'), 10);
      } else if (projectTypeDom.val() === 'hourly') {
        optionSelected = form.find(oneLine(_templateObject2$5));

        minBudgetAmount = parseInt(optionSelected.attr('min-hourly-budget'), 10);
      }

      if (Number.isNaN(inputAmount) || inputAmount < minBudgetAmount) {
        return false;
      }

      return true;
    }, translate('Por favor, insira um orçamento válido.'));
  }
}

function addValidationError(element) {
  element.closest('.control-group').addClass('error is-invalid').removeClass('is-valid');
}

function clearValidationError(element) {
  element.closest('.control-group').removeClass('error is-invalid').addClass('is-valid');
}

function requirePaymentVerification() {
  hireMeModal.hide();
  return jq.ajax({
    url: '/ajax/hireme/getEncodedUserProfileUrl.php',
    headers: { 'X-XSRF-TOKEN': getCSRFToken() },
    type: 'GET',
    data: { user_id: freelancerUserId },
    success: function success(response) {
      if (response.status == 'success') {
        var params = jq.param({
          successUrl: response.url,
          quickVerify: 'true',
          skipTrial: 'true' });

        showPaymentVerificationModal('/payments/verify.php?' + params);
      }
    }
  });
}

var loadDraft = function loadDraft(employerId, freelancerId) {
  var data = HireMeDraft$1.get(employerId, freelancerId);

  if (!data) {
    return;
  }

  if (data.commitment) {
    quickhireFormContainerDom.find(selectors.draft.commitment).val(data.commitment);
  }

  if (data.period) {
    quickhireFormContainerDom.find(selectors.draft.period).val(data.period);
  }

  quickhireFormContainerDom.find(selectors.draft.pmb).val(data.pmb);
  quickhireFormContainerDom.find(selectors.draft.projectType).val(data.projectType).trigger('change');
  quickhireFormContainerDom.find(selectors.draft.currency).val(data.currency).trigger('change');
  quickhireFormContainerDom.find(selectors.draft.budget).val(data.budget).trigger('change');
};

var saveDraft = function saveDraft(employerId, freelancerId, data) {
  ABTest.getUserExperimentVariation(HIREME_DRAFT_EXPERIMENT_NAME, parseInt(employerId, 10)).then(function (variant) {
    if (variant !== 'test') {
      return;
    }

    var dataToSave = {
      budget: data.budget,
      commitment: data.commitment,
      currency: data.currency,
      period: data.period,
      pmb: data.pmb,
      projectType: data.type };

    HireMeDraft$1.save(employerId, freelancerId, dataToSave);
  });
};

function submitForm(form) {
  var data = {};
  var skills = [];
  var selectedSkills = form.find('.selected_skill');
  var formContainer = quickhireFormContainerDom;
  for (var i = 0; i < selectedSkills.length; i++) {
    skills.push(jq(selectedSkills[i]).attr('value'));
  }
  data.skills = skills;
  data.csrf_token = getCSRFToken();
  data.type = projectTypeDom.val();

  if (data.type == 'fixed') {
    var fixedDetail = form.find('.fixed-detail');
    data.period = fixedDetail.find('.project-period').val();
    data.currency = fixedDetail.find('#modalhireme-fixed-multifield-currency').val();
    data.budget = fixedDetail.find('.budget-amount').val();
  } else if (data.type == 'hourly') {
    var hourlyDetail = form.find('.hourly-detail');
    data.commitment_interval = 'week';
    data.duration = hourlyDetail.find('.project-duration').val();
    data.commitment = hourlyDetail.find('.project-workload').val();
    data.budget = hourlyDetail.find('.budget-amount').val();
    data.currency = hourlyDetail.find('#modalhireme-fixed-multifield-currency').val();
  } else if (isDeloitteUser) {
    var startDate = form.find('#startDate').val();
    startDate = Math.round(new Date(startDate).getTime() / 1000);
    var endDate = form.find('#endDate').val();
    endDate = Math.round(new Date(endDate).getTime() / 1000);
    data.timeframe = {
      start_date: startDate,
      end_date: endDate };

    data.deloitte_details = {
      billing_code: form.find('#deloitteBillingCode').val(),
      industry_offering: {
        industry: form.find('#deloitteIndustry').val(),
        offering: form.find('#deloitteOffering').val(),
        practice: form.find('#deloittePractice').val(),
        project_type: form.find('#deloitteProjectType').val() },

      itar: form.find('#deloitteItar').is(':checked') ? 'Yes' : '',
      clearance: form.find('#deloitteClearance').val() };

    data.commitment_interval = 'week';
    data.commitment = parseInt(form.find('#deloitteBillableHours').val(), 10);
    data.duration = 6; // hard coded in html for non deloitte users
    data.currency = 40; // TKN currency
    data.budget = 1;
    data.type = 'hourly';
  } else {
    return false;
  }

  data.pmb = form.find('#pmb').val();
  data.autoNameAndDescription = true;
  data.sellerId = form.data('seller-id');
  data.sellerUsername = form.data('seller-username');
  data.sourceType = form.data('source-type');
  data.sourceId = form.data('source-id');

  var authform = quickhireFormContainerDom.find('#nonAuthForm');
  if (!thisUser && authform.find('#userTypeNew').is(':checked')) {
    data.username = authform.find('#new-username').val();
    data.email = authform.find('#new-email').val();
    data.passwd = authform.find('#passwd').val();
    data.passwd1 = data.passwd;
    data.email_notify = true;
  }

  jq.ajax({
    url: '/buyers/onquickhire.php',
    type: 'post',
    data: data,
    dataType: 'json',
    beforeSend: function beforeSend() {
      formContainer.find('.loading-img').show();
      formContainer.find('.btn-quickhire').attr('disabled', true).hide();
      formContainer.find('.cancel-quickhire').attr('disabled', true);
      hideError();
    },
    success: function success(response) {
      hiremeEvents.success(response);
      HireMeDraft$1.remove(thisUser, data.sellerId);

      if (response.status == 'success' && !response.ABTestAutomaticPayment) {
        if (response.result && response.result.deloitte_details) {
          window.location.href = '/projects/' + response.result.seo_url;
        } else if (isEscrowComRequired) {
          window.location.href = response.url;
        } else {
          isOnMilestoneCreation = true;
          var popoverPlacement = 'right';
          upsellUpgrades(response);
          quickhireFormContainerDom.removeClass('quick-hire-form-container');
          popoverPlacement = 'bottom';

          quickHireReturnData = response;
          hiremeEvents.quickHireReturnDataReady();

          milestoneCreationCancelRedirectUrl = quickHireReturnData.url;

          var budget = data.budget;
          if (data.type === 'fixed') {
            budget *= 0.5;
          }

          var quickHireMilestoneFormHTML = _.template(quickHireMilestoneFormTemplate)({
            username: data.sellerUsername,
            userID: data.sellerId,
            quickHireReturnData: quickHireReturnData,
            budget: budget,
            type: data.type,
            commitment: data.type == 'hourly' ? data.commitment : false,
            abTestSkipMilestone: abTestSkipMilestone,
            T_: translate,
            cdn_url: cdn_url,
            uiIcon: uiIcon });

          quickhireFormContainerDom.html(quickHireMilestoneFormHTML);
          quickhireFormContainerDom.find('#milestones-popover').popover({
            placement: popoverPlacement,
            trigger: 'hover',
            animation: true,
            template: '<div class="popover"><div class="arrow"></div>' + '<div class="popover-inner">' + '<div class="popover-content"><p></p></div></div></div>' });

          initMilestoneValidator(quickhireFormContainerDom.find('.quick-hire-milestone-form'));

          thisUser = getUserIdfromCookie();

          quickhireFormContainerDom.find('#milestone-not-now').click(function () {
            hireMeModal.hide();
          });

          // Show div to display info about not being able
          // to send the private message
          if (response.pmNotSentMessage) {
            displayWarning(response.pmNotSentMessage);
          }

          quickhireFormContainerDom.find('.btn-quickhire-no-milestone').on('click', function () {
            // Because the href in the button on the template
            // does not redirect in some older browsers
            // (looking at you, IE8)
            window.location.href = quickHireReturnData.url;
          });
        }

        return;
      }

      if (response.status === 'failed') {
        saveDraft(thisUser, data.sellerId, data);

        if (response.code === ErrorCode.UNVERIFIED_PAYMENT_RESPONSE) {
          return requirePaymentVerification();
        }
      }

      if (response.url) {
        window.location.href = response.url;
      } else {
        displayError(response.reason, response.code, data.sellerId);
      }
    },
    error: function error(response) {
      saveDraft(thisUser, freelancerUserId, data);

      if (response.responseJSON.error.code === 'EMAIL_VERIFICATION_REQUIRED') {
        displayError(translate(_templateObject3$2), ErrorCode.EMAIL_VERIFICATION_REQUIRED);
      } else {
        displayError(translate('Erro do Servidor'));
      }
    },
    complete: function complete() {
      formContainer.find('.loading-img').hide();
      formContainer.find('.btn-quickhire').removeAttr('disabled').show();
      formContainer.find('.cancel-quickhire').removeAttr('disabled');
    }
  });
}

function getTotal() {
  var quickhire = quickhireFormContainerDom;
  var total = awardUpgrades.getUpgradeTotal();
  if (parseFloat(quickhire.find('.milestone-amount').val())) {
    total += parseFloat(quickhire.find('.milestone-amount').val());
  }
  return total.toFixed(2);
}

function upsellUpgrades(data) {
  var quickhire = quickhireFormContainerDom;
  var that = this;
  var updateTotal = function updateTotal() {
    quickhire.find('.total-amount').html(getTotal());
  };
  var initPaymentSource = function initPaymentSource(data) {
    var paymentsSourceDetails = {
      currencyDetails: {
        id: data.currency_id,
        sign: data.currency_sign,
        code: data.currency_code } };

    paymentsSourceDetails.amount = getTotal();
    modulePaymentsSource.init(paymentsSourceDetails, quickhire.find('#payment-sources-container'));
  };

  var upgradesPrepared = function upgradesPrepared() {
    awardUpgrades.init();
    initPaymentSource(data);
    updateTotal();
    quickhire.find('.upgrade-checkbox').on('change', updateTotal);
    quickhire.find('.milestone-amount').on('keyup', updateTotal);
  };

  if (typeof data.abTestPrehire !== 'undefined' && data.abTestPrehire) {
    awardUpgrades.prepareUpgradeForPreHireChat(data.currency_id).then(function () {
      upgradesPrepared();
    });
  } else {
    awardUpgrades.prepareUpgradeABTest(data.project_id, true).then(function () {
      upgradesPrepared();
      quickhire.off('click', '.btn-quickhire-create-milestone').on('click', '.btn-quickhire-create-milestone', function () {
        var milestoneForm = quickhire.find('.quick-hire-milestone-form');
        if (validateMilestoneForm(milestoneForm)) {
          awardUpgrades.upgradeAndCreateMilestone(data, milestoneForm, submitMilestoneForm, that);
        }
      });
    });
  }
}

function submitMilestoneForm(milestoneForm) {
  var isPrehireProject = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var formContainer = quickhireFormContainerDom;
  formContainer.find('.loading-img').show();
  hiremeEvents.milestoneClick();
  formContainer.find('.btn-quickhire-create-milestone').attr('disabled', true).hide();
  formContainer.find('.btn-quickhire-no-milestone').attr('disabled', true);
  hideError();
  jq.ajax({
    url: '/ajax/give-and-get/getDelayedPaymentVerifyVars.php',
    type: 'get',
    data: {},
    success: function success(response) {
      if (!response.isChildPaymentVerified && response.inExperiment && response.isTest) {
        redirectToPv(milestoneForm);
      } else {
        submitMilestone(milestoneForm, isPrehireProject);
      }
    },
    error: function error() {
      submitMilestone(milestoneForm, isPrehireProject);
    }
  });
}

function redirectToPv(milestoneForm) {
  var data = {
    csrf_token: getCSRFToken(),
    seller_name: quickHireReturnData.seller_username,
    seller_id: quickHireReturnData.seller_id,
    currency_id: quickHireReturnData.currency_id,
    project_id: quickHireReturnData.project_id,
    milestone_amount: milestoneForm.find('.milestone-amount').val(),
    description: milestoneForm.find('.milestone-descr').val() };

  jq.ajax({
    url: '/ajax/give-and-get/getAutoCreateMilestoneToken.php',
    type: 'get',
    data: data,
    headers: { 'X-XSRF-TOKEN': getCSRFToken() },
    dataType: 'json',
    beforeSend: function beforeSend() {},
    success: function success(response) {
      window.location.href = '/payments/verify.php?referral-program=true\n        &new_signup=true&project_id=' + encodeURIComponent(quickHireReturnData.project_id) + '&data_token=' + response.data_token;
    },
    error: function error() {},
    complete: function complete() {}
  });
}

function submitMilestone(milestoneForm) {
  var isPrehireProject = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  // track user confirm to create milestone
  var data = {};
  var formContainer = quickhireFormContainerDom;
  data.csrf_token = getCSRFToken();
  data.username = quickHireReturnData.seller_username;
  data.amount = milestoneForm.find('.milestone-amount').val();
  data.project = quickHireReturnData.project_id;
  data.reason = 'partly_payment';
  data.other_reason = milestoneForm.find('.milestone-descr').val();
  data.currency = quickHireReturnData.currency_id;
  data.bidId = quickHireReturnData.initial_bid.id;
  data.bidderId = quickHireReturnData.seller_id;

  // m is useMaster
  data.m = true;

  jq.ajax({
    url: '/ajax/payment/onnewescrow.php',
    type: 'post',
    data: data,
    headers: { 'X-XSRF-TOKEN': getCSRFToken() },
    dataType: 'json',
    beforeSend: function beforeSend() {
      formContainer.find('.loading-img').show();
      formContainer.find('.btn-quickhire-create-milestone').attr('disabled', true).hide();
      formContainer.find('.btn-quickhire-no-milestone').attr('disabled', true);
      hideError();
    },
    success: function success(response) {
      if (response.status == 'success') {
        if (!isPrehireProject) {
          quickHireReturnData.url += '&ttref=HireMe_' + entryPoint + '&hireme_initial_milestone_tracking=immediate';
          window.location.href = quickHireReturnData.url;
        } else {
          formContainer.find('.loading-img').hide();
          hireMeModal.hide();
        }
      } else if (response.needDeposit) {
        var r = createMilestoneCartItem(data);
        r.then(function (response) {
          if (response.status === 'success') {
            var uri = '/deposit/?cartId=' + response.result;

            window.location = uri;
          } else {
            displayMilestoneCartError();
          }
        }).fail(function () {
          displayMilestoneCartError();
        });
      } else {
        displayError(response.msg);
        formContainer.find('.btn-quickhire-create-milestone').removeAttr('disabled').show();
        formContainer.find('.btn-quickhire-no-milestone').removeAttr('disabled');
        formContainer.find('.loading-img').hide();
      }
    },
    error: function error() {
      displayError(translate('Erro do Servidor'));
      formContainer.find('.btn-quickhire-create-milestone').removeAttr('disabled').show();
      formContainer.find('.btn-quickhire-no-milestone').removeAttr('disabled');
      formContainer.find('.loading-img').hide();
    },
    complete: function complete() {
      formContainer.find('.loading-img').hide();
    }
  });
}

function displayMilestoneCartError() {
  var formContainer = quickhireFormContainerDom;

  displayError(translate(_templateObject4));

  formContainer.find('.btn-quickhire-create-milestone').removeAttr('disabled').show();
  formContainer.find('.btn-quickhire-no-milestone').removeAttr('disabled');
  formContainer.find('.loading-img').hide();
}

/**
   * 1. Create milestone draft
   * 2. Create cart
   * 3. Create cart item
   */
function createMilestoneCartItem(data) {
  var cartId = null;
  var milestoneDraftId = null;

  var amount = Number(data.amount);
  var projectId = Number(data.project);
  var desc = data.other_reason;
  var currencyId$$1 = Number(data.currency);
  var bidId = Number(data.bidId);
  var bidderId = Number(data.bidderId);
  return jq.ajax({
    url: '/api/projects/0.1/milestone_drafts/',
    type: 'POST',
    dataType: 'json',
    data: JSON.stringify({
      amount: amount,
      bidder_id: bidderId,
      bid_id: bidId,
      currency_id: currencyId$$1,
      description: desc,
      project_id: projectId }),

    contentType: 'application/json',
    headers: getAuthHeader() }).then(function (response) {
    if (response.status !== 'success') {
      return response;
    }
    milestoneDraftId = response.result.id;

    // Create cart
    var returnAction = {
      destination: 'project_view_page',
      payload: projectId.toString() };

    return jq.ajax({
      url: '/api/payments/0.1/carts/',
      type: 'POST',
      data: JSON.stringify({
        description: 'Hire Me Initial Milestone',
        return_action: returnAction }),

      contentType: 'application/json',
      headers: getAuthHeader() });
  }).then(function (response) {
    if (response.status !== 'success') {
      return response;
    }
    cartId = response.result.id;

    return jq.ajax({
      url: '/api/payments/0.1/carts/' + cartId + '/cart_items/',
      type: 'POST',
      data: JSON.stringify({
        context_type: 'milestone',
        context_id: milestoneDraftId.toString(),
        description: desc,
        currency: currencyId$$1,
        amount: amount,
        cart_id: cartId,
        context_sub_type: -1 }),

      contentType: 'application/json',
      headers: getAuthHeader() });
  }).then(function (res) {
    if (res.status === 'success') {
      return { status: 'success', result: cartId };
    }
    return res;
  });
}

function createPrehireProject(params, milestoneForm) {
  var that = jq(this);
  var formContainer = quickhireFormContainerDom;
  var initialMilestoneAmount = parseFloat(jq('.milestone-amount').val());
  var data = {
    currency: params.employer.primary_currency.id,
    sellerUsername: params.freelancer.username,
    sellerId: params.freelancer.id,
    type: 'fixed',
    period: 999,
    budget: initialMilestoneAmount,
    isPrehireProject: true,
    csrf_token: getCSRFToken(),
    autoNameAndDescription: true,
    prehireTotalCharge: getTotal(),
    autoSendPMB: params.autoSendPMB };

  data.drive_files = formContainer.find('[data-upload-field="drive_files"]').val();

  jq.ajax({
    url: '/buyers/onquickhire.php',
    type: 'post',
    data: data,
    dataType: 'json',
    beforeSend: function beforeSend() {
      formContainer.find('.loading-img').show();
      formContainer.find('.btn-quickhire-create-milestone').attr('disabled', true).hide();
      formContainer.find('.btn-quickhire-no-milestone').attr('disabled', true);
      hideError();
    },
    success: function success(response) {
      if (response.status == 'success') {
        params.deferred.resolve(response.project_id);
        milestoneForm.find('#prehire-created').show();

        var upgradeData = {
          project_id: response.project_id,
          currency_id: response.currency_id,
          seller_id: response.seller_id,
          seller_username: response.seller_username,
          abTestPrehire: true };

        quickHireReturnData = response;

        awardUpgrades.upgradeAndCreateMilestone(upgradeData, milestoneForm, submitMilestoneForm, that, true);
      } else {
        params.deferred.reject('Failed to create project');
        if (response.reason) {
          displayError(response.reason, response.code);
        }
        if (response.url) {
          window.location.href = response.url;
        }
      }
    },
    error: function error() {
      params.deferred.reject('Failed to create project');
      displayError(translate('Erro do Servidor'));
    },
    complete: function complete() {
      formContainer.find('.loading-img').hide();
      formContainer.find('.btn-quickhire-no-milestone').removeAttr('disabled');
      formContainer.find('.btn-quickhire-create-milestone').removeAttr('disabled').show();
    }
  });
}

function validateForm$1(form) {
  var detailErrors = false;

  if (projectTypeDom.val() === 'hourly') {
    detailErrors = form.find('.fixed-detail .error');
  } else if (projectTypeDom.val() === 'fixed') {
    detailErrors = form.find('.hourly-detail .error');
  }

  if (detailErrors !== false) {
    detailErrors.removeClass('error');
    detailErrors.find('.help-block').html('');
  }
  return form.valid();
}

function validateMilestoneForm(milestoneForm) {
  return milestoneForm.valid();
}

function initMilestoneValidator(milestoneForm) {
  jq.validator.addMethod('checkMilestoneAmount', function (value, element) {
    var that = jq(element);
    var inputAmount = parseFloat(that.val());
    if (Number.isNaN(inputAmount) || inputAmount <= 0) {
      return false;
    }
    return true;
  }, translate('Por favor, insira uma quantia válida'));

  milestoneForm.validate({
    errorElement: 'span',
    onsubmit: false,
    errorPlacement: function errorPlacement(error, element) {
      error.appendTo(element.closest('.control-group').find('.help-block'));
    },
    onfocusout: function onfocusout(element) {
      if (jq(element).val()) {
        jq(element).valid();
      } else {
        return false;
      }
    },
    highlight: function highlight(label) {
      jq(label).closest('.control-group').addClass('error is-invalid').removeClass('is-valid');
    },
    success: function success(label) {
      jq(label).closest('.control-group').removeClass('error is-invalid').addClass('is-valid');
    },

    rules: {
      milestoneAmount: {
        checkMilestoneAmount: true,
        min: 0.01,
        required: true },

      milestoneDescr: {
        minlength: 1,
        maxlength: 40,
        required: true } } });
}

function initValidator(form) {
  var rules = {};
  if (isDeloitteUser) {
    rules = {
      startDate: {
        required: true,
        checkStartDate: true },

      endDate: {
        required: true,
        checkEndDate: true },

      deloitteBillingCode: {
        checkGAABillingCode: true,
        checkDeloitteBillingCode: true },

      deloitteBillableHours: {
        required: true,
        min: 1,
        max: 1000 },

      deloitteUserAgreement: {
        required: true },

      deloitteIndustry: {
        required: true },

      deloitteOffering: {
        required: true },

      deloittePractice: {
        required: true },

      deloitteProjectType: {
        required: true },

      isClearanceRequired: {
        checkClearance: true } };
  } else {
    var descriptionMinLength = abTests.inForceHMDescriptionTest ? 30 : 10;

    rules = {
      pmb: {
        minlength: descriptionMinLength,
        maxlength: 4000,
        checkCraigslistViolation: true,
        required: true },

      fixedBudget: {
        checkBudget: true },

      fixedPeriod: {
        checkFixedPeriod: true },

      hourlyWorkload: {
        checkHourlyWorkload: true },

      hourlyRate: {
        checkBudget: true },

      budget: {
        checkBudget: true } };
  }
  form.validate({
    errorElement: 'span',
    onsubmit: false,
    errorPlacement: function errorPlacement(error, element) {
      element.closest('.control-group').find('.help-block, .help-inline').eq(0).html(error);
    },
    onfocusout: function onfocusout(element) {
      if (jq(element).val()) {
        jq(element).valid();
      } else {
        return false;
      }
    },
    highlight: function highlight(label) {
      jq(label).closest('.control-group').addClass('error');
    },
    success: function success(label) {
      jq(label).closest('.control-group').removeClass('error');
    },

    rules: rules,
    messages: {} });
}

function initFileUpload(params) {
  // First param was never used in this module. Add in support if you need
  // it.
  fileupload.init(undefined, params, true, true);
}

function initTooltips(form) {
  form.find('#autoOpenToBidding-tip').popover({
    placement: 'top',
    template: '<div class="popover"><div class="arrow"></div>' + '<div class="popover-inner" style="width:400px">' + '<h3 class="popover-title"></h3><div class="popover-content"><p></p>' + '</div></div></div>' });

  form.find('#project-type-tip').popover({
    placement: 'top',
    content: '' + translate('<b>Preço Fixo</b>: Ideal quando você possui um projeto com um escopo bem definido e uma descrição detalhada do projeto.') + (translate('As taxas do projeto são cobradas quando o freelancer aceita o projeto.') + '<br><br>') + ('' + translate('<b>Projetos por Hora</b>: Recomendado para quando quiser contratar um freelancer para um trabalho em andamento.')) + ('' + translate('A descrição do projeto pode estar menos definida. As taxas do projeto são cobradas em cada pagamento feito para o freelancer.')),
    trigger: 'hover',
    html: true });

  form.find('.quick-hire-post-form-tip').each(function () {
    var that = jq(this);
    that.popover({
      content: that.data('content'),
      title: that.data('title'),
      placement: 'top',
      trigger: 'hover',
      html: true });
  });
}

var showHireMeModal = function showHireMeModal(hireMeModal, hireMeParams, fileUploadParams) {
  hireMeModal.show();

  var formContainer = jq('#quick-hire-form');
  projectTypeDom = formContainer.find('#project-type');
  applyEvents();
  var form = formContainer.find('.quick-hire-post-form');
  initValidator(form);
  initTooltips(form, hireMeParams);
  initFileUpload(fileUploadParams);
  showFixedBudgetSuggestion(hireMeParams.userID, hireMeParams.username, form);

  var today = new Date().toISOString().split('T')[0];
  form.find('#startDate').attr('min', today);
  form.find('#endDate').attr('min', today);

  selectBudgetType(hireMeParams, projectTypeDom);

  if (thisUser && hireMeParams.currencyId) {
    quickhireFormContainerDom.find('#modalhireme-fixed-multifield-currency').val(hireMeParams.currencyId).trigger('change');
  }

  loadDraft(thisUser, freelancerUserId);
};

var showHireMeWebappModal = function showHireMeWebappModal() {
  webappModals.open('HireMeWebappModalComponent', {
    inputs: {
      profileUserId: freelancerUserId },

    size: 'small',
    edgeToEdge: true });
};

function initForm(hireMeParams, fileUploadParams, ttSource) {
  if (!document.getElementById('modal-hire-me')) {
    document.body.insertAdjacentHTML('beforeend', hiremeModalContainerTemplate);
  }

  freelancerUserId = hireMeParams.userID;

  if (typeof hireMeParams.abTests === 'object' && hireMeParams.abTests) {
    abTests = hireMeParams.abTests;
  }

  var initCallback = function initCallback() {
    abTests.inForceHMDescriptionTest = experiments.inForceHMDescriptionTest;

    if (typeof window.abTestHiremeMilestone !== 'undefined' && window.abTestHiremeMilestone) {
      abTestSkipMilestone = window.abTestHiremeMilestone;
    }

    if (ttSource) {
      entryPoint = ttSource;
    }

    // Sensible fallback values
    // Consider using
    // /ajax/getProjectSuggestedBudget.php?user_id=...
    hireMeParams = jq.extend({
      fixed_budget: 250,
      hourlyrate: 10,
      default_min: 10,
      daysDuration: 3 }, hireMeParams);

    feeNotes = feeNotes || (thisUser == hireMeParams.userID ? false : hireMeParams.projectFee);
    if (hireMeParams.enterpriseId && hireMeParams.enterpriseId == 1) {
      isDeloitteUser = true;
    } else {
      isDeloitteUser = false;
    }

    var quickHireFormHTML = _.template(quickHireFormTemplate)({
      username: hireMeParams.username.trim(),
      userID: hireMeParams.userID,
      hourlyrate: hireMeParams.hourlyrate,
      is_online: hireMeParams.is_online,
      email: hireMeParams.email || '',
      budgets: budgetsCache,
      min_fixed_budget: hireMeParams.fixed_budget,
      default_min: hireMeParams.default_min,
      durations: durationsCache,
      days_duration: hireMeParams.daysDuration,
      autoProjectName: '',
      thisUser: thisUser,
      feeNotes: feeNotes,
      isNewUser: hireMeParams.isNewUser,
      project_title: hireMeParams.projectTitle || '',
      project_description: hireMeParams.projectDescription || '',
      show_hireme_promotion_copy: hireMeParams.showHireMePromotionCopy,
      sourceType: hireMeParams.sourceType || 'HiremeModal',
      sourceId: hireMeParams.sourceId,
      isDeloitteUser: isDeloitteUser,
      deloitteAdditionalFieldsData: {
        DeloitteProjectType: DeloitteProjectType,
        DeloittePractice: DeloittePractice,
        DeloitteIndustry: DeloitteIndustry,
        DeloitteOffering: DeloitteOffering,
        DeloitteOfferingPortfolio: DeloitteOfferingPortfolio },

      abTests: abTests,
      T_: translate,
      uiIcon: uiIcon,
      cdn_url: cdn_url,
      locale: {
        fileupload: {
          errors: {
            maxFileSize: translate('Seu arquivo é maior que 20 MBs.'),
            minFileSize: translate('Arquivo é demasiado pequeno'),
            acceptFileTypes: translate('Tipo de arquivo não permitido'),
            maxNumberOfFiles: translate('Número máximo de arquivos excedido'),
            uploadedBytes: translate('Os bytes carregados excedem o tamanho do arquivo'),
            emptyResult: translate('Resultado de envio de arquivo vazio') },

          error: translate('Erro'),
          start: translate('Começar'),
          cancel: translate('Cancelar'),
          destroy: translate('Excluir') } },

      isEscrowComRequired: isEscrowComRequired });

    previousCurrency = jq(quickHireFormHTML).find('#modalhireme-fixed-multifield-currency option:selected').val();

    var quickHireFormHeaderHTML = _.template(quickHireFormTemplateHeader)({
      T_: translate,
      username: hireMeParams.username.trim() });

    var quickHireForm = jq('#modal-hire-me-new');

    if (quickHireForm.length) {
      quickHireForm.remove();
    }

    hireMeModal = new Modal('modal-hire-me-new', {
      body: quickHireFormHTML,
      header: quickHireFormHeaderHTML }, {
      extraClass: 'quick-hire-form-container',
      backdropClose: false,
      onHide: function onHide() {
        if (isOnMilestoneCreation) {
          qtsp.push({
            eventName: 'user_action',
            section: 'HireMe',
            subsection: 'CreateMilestoneModal',
            label: 'Close' });

          window.location.href = milestoneCreationCancelRedirectUrl;
        }
      } });

    var formContainer = jq('#quick-hire-form');
    fileUploadParams = jq.extend({
      domEl: formContainer,
      uploadTemplate: 'quickhire-template-upload',
      downloadTemplate: 'quickhire-template-download' }, fileUploadParams);

    quickhireFormContainerDom = formContainer;
    thisUser = getUserIdfromCookie();

    if (!thisUser) {
      var testPromise = ABTest.getSessionExperimentVariation('T59837-show-signup-default-directory-profile').catch(function () {
        return 'control';
      });

      Promise.all([testPromise, init$2()]).then(function (results) {
        var params = {
          disableRedirect: true };

        // ABTest T59837
        if (results[0] === 'test') {
          params.forcedAccountType = 'employer';
          // Test variation: show signup as default.
          return results[1].showSignup(params);
        }
        // Control variation: show login as default.
        return results[1].showLogin(params);
      }).then(function () {
        thisUser = true;
        lazyLoadPostProjectParams(hireMeLoadCallback);
      }).catch(function () {});
    } else if (isDeloitteUser) {
      showHireMeWebappModal();
    } else {
      showHireMeModal(hireMeModal, hireMeParams, fileUploadParams);
    }
  };

  var initPrehireMilestoneFormCallBack = function initPrehireMilestoneFormCallBack() {
    var minBudgetForCurrency = _.find(budgetsCache, function (budget) {
      return budget.vars.currency.id == hireMeParams.employer.primary_currency.id;
    });

    var prehireMilestoneFormHTML = _.template(quickHireMilestoneFormTemplate)({
      abTestPrehire: hireMeParams.abTestPrehire,
      username: hireMeParams.freelancer.username,
      currency: hireMeParams.employer.primary_currency,
      budget: minBudgetForCurrency.vars.budgets.fixed[0].min_sum,
      abTestSkipMilestone: abTestSkipMilestone,
      T_: translate,
      cdn_url: cdn_url });

    if (typeof hireMeModal === 'undefined') {
      hireMeModal = new Modal('modal-chat-project-new', {
        body: prehireMilestoneFormHTML });
    } else {
      jq('#modal-chat-project-new').find('.Modal-body').html(prehireMilestoneFormHTML);
    }

    quickhireFormContainerDom = jq('.milestone-modal-wrapper');

    var milestoneForm = quickhireFormContainerDom.find('.quick-hire-milestone-form');

    initMilestoneValidator(quickhireFormContainerDom.find(milestoneForm));

    quickhireFormContainerDom.on('click', '.btn-quickhire-create-milestone', function () {
      if (validateMilestoneForm(milestoneForm)) {
        createPrehireProject(hireMeParams, milestoneForm);
      }
    });

    var upsellData = {
      abTestPrehire: hireMeParams.abTestPrehire,
      currency_id: hireMeParams.employer.primary_currency.id,
      currency_sign: hireMeParams.employer.primary_currency.sign,
      currency_code: hireMeParams.employer.primary_currency.code };

    upsellUpgrades(upsellData);

    hireMeModal.show();
  };

  if (hireMeParams.abTestPrehire) {
    hireMeLoadCallback = initPrehireMilestoneFormCallBack;
  } else {
    hireMeLoadCallback = initCallback;
  }

  if (!budgetsCache.length || !durationsCache.length) {
    lazyLoadPostProjectParams(hireMeLoadCallback);
  } else {
    hireMeLoadCallback();
  }

  if (hireMeParams.abTestPrehire) {
    return hireMeParams.deferred.promise;
  }
}

function showPaymentVerificationModal(paymentVerifyUrl) {
  var showPaymentVerificationModal = new Modal('modal-payment-verification', {
    body: _.template(paymentVerificationTemplate)({
      paymentVerifyUrl: paymentVerifyUrl,
      pppRedirectUrl: '/post-project' }) }, {
    extraClass: 'ModalPaymentVerification',
    backdropClose: false,
    onShow: function onShow() {
      jq('#verify-now').on('click', function () {
        qtsp.push({
          eventName: 'user_action',
          section: 'force_verify_hm_modal',
          label: 'Verify Now' });
      });

      jq('#verify-later').on('click', function () {
        qtsp.push({
          eventName: 'user_action',
          section: 'force_verify_hm_modal',
          label: 'Or Post a Project and Verify Later' });
      });
    },
    onHide: function onHide() {
      qtsp.push({
        eventName: 'user_action',
        section: 'force_verify_hm_modal',
        name: 'cancel',
        label: 'close' });

      jq('#modal-payment-verification').remove();
    } });

  showPaymentVerificationModal.show();
}

function selectBudgetType(hireMeParams, projectTypeDom) {
  if (typeof hireMeParams === 'undefined' || typeof hireMeParams.budget_period === 'undefined' || typeof projectTypeDom === 'undefined') ; else if (hireMeParams.budget_period === 'hourly') {
    projectTypeDom.val('hourly').trigger('change');
  } // defaults to fixed
}

function showFixedBudgetSuggestion(userId, userName, form) {
  var fixedBudgetSuggestion = void 0;
  var initialFixBudgetSuggetion = function initialFixBudgetSuggetion() {
    if (typeof fixedBudgetSuggestion !== 'undefined') {
      var content = translate('<%= userName %> aceitou projetos semelhantes por $<%= fixedBudgetSuggestion %> Dólares', {
        userName: userName,
        fixedBudgetSuggestion: fixedBudgetSuggestion });

      jq(form).find('#qh_fixed_budget').popover({
        title: translate('Não tem certeza sobre o Orçamento?'),
        content: content,
        trigger: 'manual',
        placement: 'bottom',
        html: true });

      // prefill the budget
      jq(form).find('#qh_fixed_budget').val(fixedBudgetSuggestion);
    }
  };
  var showFixBudgetSuggestion = function showFixBudgetSuggestion() {
    jq(form).find('#qh_fixed_budget').popover('show');
  };
  var hideFixBudgetSuggestion = function hideFixBudgetSuggestion() {
    jq(form).find('#qh_fixed_budget').popover('hide');
  };
  var toggleFixBudgetSuggestion = function toggleFixBudgetSuggestion() {
    jq(form).find('#qh_fixed_budget:visible').popover('toggle');
  };

  jq.ajax({
    url: '/ajax/hireme/getFixedProjectBudgetSuggestion.php?user_id=' + userId,
    dataType: 'json',
    success: function success(resp) {
      if (resp.status == 'success' && resp.result != null && resp.result < 500 && resp.result > 300) {
        fixedBudgetSuggestion = resp.result;
        initialFixBudgetSuggetion();
      }
    }
  });

  jq(form).find('#qh_fixed_budget').focus(showFixBudgetSuggestion);
  jq(form).find('#qh_fixed_budget').blur(hideFixBudgetSuggestion);
  jq(form).find('.fixed').parent().click(toggleFixBudgetSuggestion);
  jq(form).find('.hourly').parent().click(hideFixBudgetSuggestion);
}

function lazyLoadPostProjectParams(callback) {
  jq.ajax({
    url: '/ajax/buyer/load-post-project-params.php?freelancerId=' + freelancerUserId,
    dataType: 'json',
    success: function success(response) {
      budgetsCache = jq.map(response.budgets, function (key) {
        return [key];
      });
      durationsCache = response.durations;
      experiments = response.experiments;
      isEscrowComRequired = response.isEscrowComRequired;

      callback();
    }
  });
}

var moduleQuickHire = {
  initForm: initForm };

var fixedAmountPaymentModalTemplate = "<div class=\"modal-header\">\n    <a class=\"close\" data-dismiss=\"modal\">&times;</a>\n    <h3><%-  customizedModal.title  %></h3>\n</div>\n<div class=\"modal-body\">\n\n    <%  if (customizedModal.description != '') {  %>\n        <p class=\"margin-b20\">\n            <%=  customizedModal.description  %>\n        </p>\n    <%  }  %>\n\n    <%  if (!customizedModal.showDescriptionOnly) {  %>\n        <p class=\"margin-b20\">\n            <strong><%- T_('Quantia a ser paga:') %></strong> <%-  templateData.currencyDetails.sign  %><%-  templateData.amount.toFixed(2)  %> <%-  templateData.currencyDetails.code  %>\n            <span class='muted'> <%-  customizedModal.chargeDetail  %> </span>\n        </p>\n        <div class=\"payment-sources-container\">\n        </div>\n    <%  }  %>\n    <%  if (typeof customizedModal.additionalDetails != 'undefined') {  %>\n        <p class=\"margin-b20 margin-t10\">\n            <%=  customizedModal.additionalDetails  %>\n        </p>\n    <%  }  %>\n\n    <div class=\"alert alert-error modal-milestone-generic-error regular\" style=\"display:none\"></div>\n\n</div>\n<div class=\"modal-footer\">\n    <%  if (customizedConfirm.show) {  %>\n        <button type=\"button\" class=\"btn btn-info btn-small modal-btn-confirm-payment\"><%-  customizedConfirm.buttonText  %></button>\n    <%  }  %>\n    <img src=\"<%=  cdn_url('/img/ajax-loader.gif')  %>\" class=\"loading-img margin-r20\" style=\"display:none\"/>\n    <%  if (customizedCancel.show) {  %>\n        <button type=\"button\" class=\"btn btn-small modal-btn-cancel-payment\"><%-  customizedCancel.buttonText  %></button>\n    <%  }  %>\n</div>\n";

var newFixedAmountPaymentModalTemplate = "<div class=\"responsive-modal\" id=\"expanded-payment-modal\">\n    <div class=\"modal ModalPayment\" aria-label=\"<%- T_('Fechar') %>\" data-backdrop=\"true\">\n        <div class=\"modal-header ModalPayment-header\">\n            <button id=\"paymentModalCloseButton\" type=\"button\" class=\"payment-modal-close close\" data-dismiss=\"modal\" aria-label=\"<%- T_('Fechar') %>\">\n                <span class=\"Icon Icon--small\">\n                    <%=  uiIcon('ui-close-alt')  %>\n                </span>\n            </button>\n        </div>\n        <div class=\"modal-body\">\n            <div class=\"ModalPayment-body\">\n                <figure class=\"ModalPayment-figure\">\n                    <img class=\"ModalPayment-image\" src=\"<%=  cdn_url('/static/img/secure-payment.png')  %>\" alt=\"<%- T_('Pagamento Seguro') %>\" />\n                </figure>\n                <div class=\"ModalPayment-heading\"><%-  heading  %></div>\n                <%  if (headingSubtext) {  %>\n                    <div class=\"ModalPayment-headingSubtext\"><%-  headingSubtext  %></div>\n                <%  }  %>\n                <%  if (subHeading) {  %>\n                    <div class=\"ModalPayment-subHeading\"><%-  subHeading  %></div>\n                <%  }  %>\n                <%  if (showCharges) {  %>\n                    <%  for (i = 0; i < chargeDetails.length; i++) {  %>\n                        <%  if (parseFloat(chargeDetails[i].amount) > 0) {  %>\n                            <div class=\"ModalPayment-paymentDetails\">\n                                <div class=\"ModalPayment-label\">\n                                    <%=  chargeDetails[i].label  %>\n                                </div>\n                                <div class=\"ModalPayment-price\">\n                                    <span class=\"ModalPayment-totalCost-price\">\n                                        <%  if (chargeDetails[i].paid) {  %>\n                                            <span class=\"ModalPayment-totalCost-price-paid\">\n                                                <%- T_('PAGO') %>\n                                            </span>\n                                        <%  } else {  %>\n                                            <%-  currency.sign  %><%-  chargeDetails[i].amount.toFixed(2)  %>\n                                        <%  }  %>\n                                    </span>\n                                </div>\n                            </div>\n                        <%  }  %>\n                    <%  }  %>\n                    <div class=\"ModalPayment-totalCost\">\n                        <span class=\"ModalPayment-totalCost-label\"><%- T_('Total:') %></span>\n                        <span class=\"ModalPayment-totalCost-price\">\n                            <%-  currency.sign  %><%-  chargeTotal.toFixed(2)  %> <%-  currency.code  %>\n                        </span>\n                        <%  if (includesGST) {  %>\n                            <div class=\"ModalPayment-totalCost-detail\"><%- T_('incluindo IPS') %></div>\n                        <%  } else if (taxName) {  %>\n                            <div class=\"ModalPayment-totalCost-detail\"><%- T_('incluindo') %> <%-  taxName  %></div>\n                        <%  }  %>\n                    </div>\n                <%  }  %>\n                <%  if (text) {  %>\n                    <p class=\"ModalPayment-descriptionText\"><%=  text  %></p>\n                <%  }  %>\n            </div>\n            <div class=\"ModalPayment-footer\n                <%  if (!footerText) {  %>\n                    ModalPayment-footer-noText\n                <%  }  %>\n            \">\n                <%  if (footerText) {  %>\n                    <p><%-  footerText  %></p>\n                <%  }  %>\n                <button id=\"paymentModalConfirmButton\" class=\"btn btn-large btn-success ModalPayment-footer-btn\"><%-  buttonLabel  %></button>\n            </div>\n        </div>\n    </div>\n</div>\n";

/**
 * NOTE: This file needs to be kept in sync with the non-SystemJS variant:
 * /public/static/js/payments/module-fixed-amount-payment-modal.js
 * Please replicate all changes to the other file.
 */

/*
                                                                                                  Usage:
                                                                                                  For bootstrap page:
                                                                                                    1. Require the module in your javascript file
                                                                                                    2. Call module.initModal(paymentDetails)
                                                                                                  For non-bootstrap page:
                                                                                                    1. Call initFixedAmountPaymentModalOnNonBSPage(paymentDetails) --
                                                                                                       lack of template, not supported yet
                                                                                                  
                                                                                                  @compulsory params
                                                                                                  paymentDetails is an object contains
                                                                                                    Compulsory:
                                                                                                      amount -- amount for checking payment source
                                                                                                      currencyDetails(id, sign, code) -- object with id, sign, code
                                                                                                  
                                                                                                  @optional params
                                                                                                  callbackFn is a callback function for 'Confirm' button
                                                                                                  callbackFnParams is an object contains params for callbackFn
                                                                                                  cancelCallbackFn is a callback function for 'cancel' button
                                                                                                  cancelCallbackFn is an object contains params for cancelCallbackFn
                                                                                                  customizedConfirmDetails is an object contains customized copies, etc for
                                                                                                  'Confirm' button
                                                                                                  customizedCancelDetails is an object contains customized copies, etc for
                                                                                                  'Cancel' button
                                                                                                  These are optional params, please precheck these params
                                                                                                  (eg. null/undefined/false) in the module/template to avoid unexpected errors
                                                                                                  */

var modalVars = {};

function initModalVars(scope) {
  scope.moduleData = {};
  scope.$el = false;
  scope.callback = false;
  scope.callbackParams = false;
  scope.cancelCallback = false;
  scope.cancelCallbackParams = false;
  scope.closeCallback = false;
  scope.closeCallbackParams = false;
  scope.confirmConfig = {
    buttonText: translate('Confirmar Pagamento'),
    show: true };

  scope.cancelConfig = {
    buttonText: translate('Cancelar'),
    show: true };

  scope.customizedConfirm = scope.confirmConfig;
  scope.customizedCancel = scope.cancelConfig;

  scope.customizedModal = {
    title: translate('Autorizar Pagamento'),
    description: '',
    chargeDetail: '',
    showDescriptionOnly: false };
}

function buildBinds$1() {
  jq(document).ready(function () {
    modalVars.$el.off('click', '.modal-btn-confirm-payment').on('click', '.modal-btn-confirm-payment', function () {
      modalVars.$el.modal('hide');
      if (typeof modalVars.callback === 'function') {
        modalVars.callback(modalVars.callbackParams);
      }
      _t.push(['user_action', {
        section: 'PaymentConfirmationModal',
        label: 'ConfirmPayment',
        action: 'click',
        amount: modalVars.moduleData.amount,
        currency: modalVars.moduleData.currencyDetails.id }]);

      return false;
    });

    modalVars.$el.off('click', '.modal-btn-cancel-payment').on('click', '.modal-btn-cancel-payment', function () {
      modalVars.$el.modal('hide');
      if (typeof modalVars.cancelCallback === 'function') {
        modalVars.cancelCallback(modalVars.cancelCallbackParams);
      }
      _t.push(['user_action', {
        section: 'PaymentConfirmationModal',
        label: 'CancelPayment',
        action: 'click',
        amount: modalVars.moduleData.amount,
        currency: modalVars.moduleData.currencyDetails.id }]);

      return false;
    });

    modalVars.$el.on('click', '.modal-header .close', function () {
      if (typeof modalVars.closeCallback === 'function') {
        modalVars.closeCallback(modalVars.closeCallbackParams);
      }
      _t.push(['user_action', {
        section: 'PaymentConfirmationModal',
        label: 'CloseModal',
        action: 'click',
        amount: modalVars.moduleData.amount,
        currency: modalVars.moduleData.currencyDetails.id }]);

      return false;
    });
  });
}

function buildBindsForExpandedModal() {
  jq(document).ready(function () {
    modalVars.$el.off('click', '#paymentModalConfirmButton').on('click', '#paymentModalConfirmButton', function () {
      modalVars.$el.modal('hide');
      if (typeof modalVars.callback === 'function') {
        modalVars.callback(modalVars.callbackParams);
      }
      _t.push(['user_action', {
        section: 'ExpandedPaymentConfirmationModal',
        label: 'ConfirmPayment',
        action: 'click',
        amount: modalVars.moduleData.amount,
        currency: modalVars.moduleData.currencyDetails.id }]);

      return false;
    });

    modalVars.$el.on('click', '#paymentModalCloseButton', function () {
      if (typeof modalVars.closeCallback === 'function') {
        modalVars.closeCallback(modalVars.closeCallbackParams);
      }
      _t.push(['user_action', {
        section: 'ExpandedPaymentConfirmationModal',
        label: 'CloseModal',
        action: 'click',
        amount: modalVars.moduleData.amount,
        currency: modalVars.moduleData.currencyDetails.id }]);

      return false;
    });
  });
}

function initModal(paymentDetails, callbackFn, callbackFnParams, cancelCallbackFn, cancelCallbackFnParams, customizedConfirmDetails, customizedCancelDetails, customizedModalDialog, closeCallbackFn, closeCallbackFnParams, useExpandedModal) {
  initModalVars(modalVars);

  if (typeof callbackFn === 'function') {
    modalVars.callback = callbackFn;
  }
  if (typeof callbackFnParams === 'object') {
    modalVars.callbackParams = callbackFnParams;
  }
  if (typeof cancelCallbackFn === 'function') {
    modalVars.cancelCallback = cancelCallbackFn;
  }
  if (typeof cancelCallbackFnParams === 'object') {
    modalVars.cancelCallbackParams = cancelCallbackFnParams;
  }
  if (typeof closeCallbackFn === 'function') {
    modalVars.closeCallback = closeCallbackFn;
  }
  if (typeof closeCallbackFnParams === 'object') {
    modalVars.closeCallbackParams = closeCallbackFnParams;
  }
  if (typeof customizedConfirmDetails === 'object') {
    modalVars.customizedConfirm = customizedConfirmDetails;
    if (typeof modalVars.customizedConfirm.buttonText === 'undefined') {
      modalVars.customizedConfirm.buttonText = modalVars.confirmConfig.buttonText;
    }
    if (typeof modalVars.customizedConfirm.show === 'undefined') {
      modalVars.customizedConfirm.show = modalVars.confirmConfig.show;
    }
  }
  if (typeof customizedCancelDetails === 'object') {
    modalVars.customizedCancel = customizedCancelDetails;
    if (typeof modalVars.customizedCancel.buttonText === 'undefined') {
      modalVars.customizedCancel.buttonText = modalVars.cancelConfig.buttonText;
    }
    if (typeof modalVars.customizedCancel.show === 'undefined') {
      modalVars.customizedCancel.show = modalVars.cancelConfig.show;
    }
  }
  if (typeof customizedModalDialog === 'object') {
    modalVars.customizedModal = jq.extend(modalVars.customizedModal, customizedModalDialog);
  }
  if (typeof paymentDetails === 'object') {
    modalVars.moduleData = paymentDetails;
  } else {
    return;
  }
  if (validateAndPrepareData$1()) {
    if (modalVars.moduleData.amount > 0) {
      if (typeof useExpandedModal !== 'undefined' && useExpandedModal) {
        renderExpandedModal();
      } else {
        renderModal();
      }
    } else if (typeof modalVars.callback === 'function') {
      modalVars.callback(modalVars.callbackParams);
    }
  }
}

function validateAndPrepareData$1() {
  if (typeof modalVars.moduleData.amount === 'undefined' || typeof modalVars.moduleData.currencyDetails === 'undefined' || modalVars.customizedModal.showDescriptionOnly && modalVars.customizedModal.description === '') {
    return false;
  }
  modalVars.moduleData.amount = parseFloat(modalVars.moduleData.amount);
  if (Number.isNaN(modalVars.moduleData.amount) || modalVars.moduleData.amount < 0) {
    return false;
  }
  return true;
}

function renderModal() {
  var mainContainer = void 0;
  if (jq('.gaf-container').length > 0) {
    mainContainer = '.gaf-container:first';
  } else {
    mainContainer = '.pinky-template:first';
  }

  /**
     * When you have a page that has both `.gaf-container` and `.pinky-template`,
     * but want to force this payment modal to be appended
     * inside a `.pinky-template` container,
     * just set `usePinkyTemplateContainer` to `true`
     * in the first object argument of `initModal`.
     */
  if (typeof modalVars.moduleData.usePinkyTemplateContainer !== 'undefined' && modalVars.moduleData.usePinkyTemplateContainer === true) {
    mainContainer = '.pinky-template:first';
  }
  modalVars.$el = jq('.fixed-amount-payment-modal');
  modalVars.$el.modal('hide').remove();
  modalVars.$el = jq('<div class="fixed-amount-payment-modal modal hide"></div>').appendTo(mainContainer);
  modalVars.$el.html(_.template(fixedAmountPaymentModalTemplate)({
    templateData: modalVars.moduleData,
    customizedConfirm: modalVars.customizedConfirm,
    customizedCancel: modalVars.customizedCancel,
    customizedModal: modalVars.customizedModal,
    T_: translate,
    cdn_url: cdn_url }));

  modulePaymentsSource.init(modalVars.moduleData, modalVars.$el.find('.payment-sources-container'));

  buildBinds$1();
  modalVars.$el.modal({
    backdrop: 'static',
    keyboard: true });
}

function renderExpandedModal() {
  var mainContainer = void 0;
  if (jq('.gaf-container').length > 0) {
    mainContainer = '.gaf-container:first';
  } else {
    mainContainer = '.pinky-template:first';
  }

  if (typeof modalVars.moduleData.usePinkyTemplateContainer !== 'undefined' && modalVars.moduleData.usePinkyTemplateContainer === true) {
    mainContainer = '.pinky-template:first';
  }
  modalVars.$el = jq('.fixed-amount-payment-modal');
  modalVars.$el.modal('hide').remove();
  modalVars.$el = jq('<div class="fixed-amount-payment-modal hide"></div>').appendTo(mainContainer);
  modalVars.$el.html(_.template(newFixedAmountPaymentModalTemplate)({
    heading: translate('Confirmar Pagamento'),
    headingSubtext: modalVars.moduleData.headingSubtext,
    subHeading: translate('Melhorias'),
    buttonLabel: translate('Confirmar Pagamento'),
    showCharges: true,
    chargeDetails: modalVars.moduleData.chargeDetails,
    chargeTotal: modalVars.moduleData.amount,
    currency: modalVars.moduleData.currencyDetails,
    includesGST: modalVars.moduleData.includesGST,
    taxName: modalVars.moduleData.taxName,
    text: null,
    footerText: translate('Isso será debitado do seus saldos disponíveis, então se necessário, tentaremos processar esse pagamento dos seus métodos de pagamento verificados.'),

    templateData: modalVars.moduleData,
    customizedConfirm: modalVars.customizedConfirm,
    customizedCancel: modalVars.customizedCancel,
    customizedModal: modalVars.customizedModal,
    T_: translate,
    uiIcon: uiIcon,
    cdn_url: cdn_url }));

  buildBindsForExpandedModal();
  modalVars.$el.modal({
    backdrop: 'static',
    keyboard: true });
}

function getModal() {
  return modalVars.$el;
}

var fixedAmountPaymentModalModule = {
  initModal: initModal,
  getModal: getModal };

/**
 * This jQuery plugin displays pagination links inside the selected elements.
 * When moving to systemJS we figured out that it's been changed since it was
 * copied from:
 * https://github.com/gbirke/jquery_pagination
 *
 */

/**
 * @class Class for calculating pagination values
 * @param {int} maxentries Number of entries to paginate.
 * @param {Object} opts Several options (see README for documentation).
 * @return {Object} jQuery Object.
 */
jq.PaginationCalculator = function (maxentries, opts) {
  this.maxentries = maxentries;
  this.opts = opts;
};

jq.extend(jq.PaginationCalculator.prototype, {
  /**
   * Calculate the maximum number of pages
   * -@method
   * @return {Number} max number of pages.
   */
  numPages: function numPages() {
    return Math.ceil(this.maxentries / this.opts.items_per_page);
  },

  /**
   * Calculate start and end point of pagination links depending on
   * current_page and num_display_entries.
   * @return {Array} start and end pagination points.
   */
  getInterval: function getInterval(currentPage) {
    var neHalf = Math.floor(this.opts.num_display_entries / 2);
    var np = this.numPages();
    var upperLimit = np - this.opts.num_display_entries;
    var start = currentPage > neHalf ? Math.max(Math.min(currentPage - neHalf, upperLimit), 0) : 0;
    var end = currentPage > neHalf ? Math.min(currentPage + neHalf + this.opts.num_display_entries % 2, np) : Math.min(this.opts.num_display_entries, np);
    return { start: start, end: end };
  }
});

// Initialize jQuery object container for pagination renderers
jq.PaginationRenderers = {};

/**
 * @class Default renderer for rendering pagination links
 */
jq.PaginationRenderers.defaultRenderer = function (maxentries, opts) {
  this.maxentries = maxentries;
  this.opts = opts;
  this.pc = new jq.PaginationCalculator(maxentries, opts);
};
jq.extend(jq.PaginationRenderers.defaultRenderer.prototype, {
  /**
   * Helper function for generating a single link
   * (or a span tag if it's the current page)
   * @param {Number} page_id The page id for the new item.
   * @param {Number} current_page Current page.
   * @param {Object} appendopts Options for the new item:
   *        text andappendopts classes.
   * @return {jQuery} jQuery object containing the link.
   */
  createLink: function createLink(pageId, currentPage, appendopts) {
    var lnk = void 0;
    var np = this.pc.numPages();
    var liClass = 'Pagination-item PageFreelancersDirectory-pagination-item';
    var activeClass = 'active is-active';
    var disabledClass = 'disabled is-disabled';

    // Normalize page id to sane value
    if (pageId < 0) {
      pageId = 0;
    } else if (pageId >= np) {
      pageId = np - 1;
    }

    appendopts = jq.extend({ text: pageId + 1, classes: '', linkClasses: '' }, appendopts || {});
    if (pageId === currentPage) {
      lnk = jq('<li class="' + liClass + '">' + ('<a class="' + activeClass + '" data-target="pagination">') + (appendopts.text + '</a></li>'));
    } else {
      lnk = jq('<li class="' + liClass + '"><a data-target="pagination">' + (appendopts.text + '</a></li>'));
      lnk.children().first().data('page_id', pageId);
    }
    if (appendopts.classes) {
      lnk.addClass(appendopts.classes);
    }
    if (appendopts.linkClasses) {
      lnk.children('a').addClass(appendopts.linkClasses);
    }

    // If next or previous link points to the current page then it is
    // either the first or last page, add disabled class to the button.
    if (pageId === currentPage && appendopts.isPrevOrNext) {
      lnk.children('a').removeClass(activeClass).addClass(disabledClass);
    }
    return lnk;
  },

  // Generate a range of numeric links
  appendRange: function appendRange(container, currentPage, start, end, opts) {
    var i = void 0;
    for (i = start; i < end; i++) {
      this.createLink(i, currentPage, opts).appendTo(container);
    }
  },
  getLinks: function getLinks(currentPage, eventHandler) {
    var begin = void 0;
    var end = void 0;
    var interval = this.pc.getInterval(currentPage);
    var np = this.pc.numPages();
    var ulClass = 'Pagination';
    var fragment = jq('<ul class="' + ulClass + '"></ul>');

    // Generate "Previous"-Link
    if (this.opts.prev_text && (currentPage > 0 || this.opts.prev_show_always)) {
      fragment.append(this.createLink(currentPage - 1, currentPage, {
        isPrevOrNext: true,
        text: this.opts.prev_text,
        linkClasses: 'btn Pagination-link'
      }));
    }
    // Generate starting points
    if (interval.start > 0 && this.opts.num_edge_entries > 0) {
      end = Math.min(this.opts.num_edge_entries, interval.start);
      this.appendRange(fragment, currentPage, 0, end, { classes: 'sp' });
      if (this.opts.num_edge_entries < interval.start && this.opts.ellipse_text) {
        jq('<li><a data-target="pagination">' + this.opts.ellipse_text + '</a></li>').appendTo(fragment);
      }
    }
    // Generate interval links
    this.appendRange(fragment, currentPage, interval.start, interval.end, {
      linkClasses: 'btn Pagination-link'
    });
    // Generate ending points
    if (interval.end < np && this.opts.num_edge_entries > 0) {
      if (np - this.opts.num_edge_entries > interval.end && this.opts.ellipse_text) {
        jq('<li><a data-target="pagination">' + this.opts.ellipse_text + '</a></li>').appendTo(fragment);
      }
      begin = Math.max(np - this.opts.num_edge_entries, interval.end);
      this.appendRange(fragment, currentPage, begin, np, { classes: 'ep' });
    }
    // Generate "Next"-Link
    if (this.opts.next_text && (currentPage < np - 1 || this.opts.next_show_always)) {
      fragment.append(this.createLink(currentPage + 1, currentPage, {
        isPrevOrNext: true,
        text: this.opts.next_text,
        linkClasses: 'btn Pagination-link'
      }));
    }

    jq(fragment).click(function (e) {
      if (jq(e.target).attr('data-target') === 'pagination') {
        if (jq(e.target).hasClass('is-disabled') || jq(e.target).hasClass('is-active')) {
          e.preventDefault();
          e.stopPropagation();
        } else {
          eventHandler(e);
        }
      }
    });
    return fragment;
  }
});

// Extend jQuery
jq.fn.pagination = function (maxentries, opts) {
  // Initialize options with default values
  opts = jq.extend({
    items_per_page: 10,
    num_display_entries: 5,
    current_page: 0,
    num_edge_entries: 0,
    link_to: '#',
    prev_text: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12"' + 'class="flicon-pagination-prev"><title>Previous</title>' + '<path d="M8 11L3 6l5-5v10z"></path></svg>',
    next_text: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" ' + 'class="flicon-pagination-next"><title>Next</title>' + '<path d="M4 1l5 5-5 5"></path></svg>',
    ellipse_text: '...',
    prev_show_always: true,
    next_show_always: true,
    renderer: 'defaultRenderer',
    callback: function callback() {
      return false;
    }
  }, opts || {});

  var containers = this;
  var renderer = void 0;
  var links = void 0;

  /**
   * This is the event handling function for the pagination links.
   * @param {int} page_id The new page number.
   */
  function paginationClickHandler(evt) {
    var newCurrentPage = jq(evt.target).data('page_id');
    var continuePropagation = selectPage(newCurrentPage);
    if (!continuePropagation) {
      evt.stopPropagation();
    }
    return continuePropagation;
  }

  /**
   * This is a utility function for the internal event handlers.
   * It sets the new current page on the pagination container objects,
   * generates a new HTMl fragment for the pagination links and calls
   * the callback function.
   */
  function selectPage(newCurrentPage) {
    // update the link display of a all containers
    containers.data('current_page', newCurrentPage);
    links = renderer.getLinks(newCurrentPage, paginationClickHandler);
    containers.empty();
    links.appendTo(containers);
    // call the callback and propagate the event if it does not return false
    var continuePropagation = opts.callback(newCurrentPage, containers);
    return continuePropagation;
  }

  // -----------------------------------
  // Initialize containers
  // -----------------------------------
  var currentPage = opts.current_page;
  containers.data('current_page', currentPage);
  // Create a sane value for maxentries and items_per_page
  maxentries = !maxentries || maxentries < 0 ? 1 : maxentries;
  opts.items_per_page = !opts.items_per_page || opts.items_per_page < 0 ? 1 : opts.items_per_page;

  if (!jq.PaginationRenderers[opts.renderer]) {
    throw new ReferenceError('Pagination renderer "' + opts.renderer + '" ' + 'was not found in jQuery.PaginationRenderers object.');
  }
  renderer = new jq.PaginationRenderers[opts.renderer](maxentries, opts);

  // Attach control events to the DOM elements
  var pc = new jq.PaginationCalculator(maxentries, opts);
  var np = pc.numPages();
  containers.bind('setPage', { numPages: np }, function (evt, pageId) {
    if (pageId >= 0 && pageId < evt.data.numPages) {
      selectPage(pageId);
      return false;
    }
  });
  containers.bind('prevPage', function () {
    var currentPage = jq(this).data('current_page');
    if (currentPage > 0) {
      selectPage(currentPage - 1);
    }
    return false;
  });
  containers.bind('nextPage', { numPages: np }, function (evt) {
    var currentPage = jq(this).data('current_page');
    if (currentPage < evt.data.numPages - 1) {
      selectPage(currentPage + 1);
    }
    return false;
  });

  // When all initialisation is done, draw the links
  links = renderer.getLinks(currentPage, paginationClickHandler);
  containers.empty();
  links.appendTo(containers);
}; // End of jq.fn.pagination block

var EXPERIMENT_TYPE_SESSION_BASED = 1;
var EXPERIMENT_TYPE_USER_BASED = 2;
var EXPERIMENT_TYPE_PROJECT_BASED = 3;

var ABTestApi = {
  testSubjectEnrol: function testSubjectEnrol(experimentName, identifier, experimentType) {
    var authHeader = getAuthHeader();

    return jq.ajax({
      url: '/api/abtest/0.1/enrollments/',
      method: 'POST',
      data: JSON.stringify({
        id_type: experimentType,
        id: identifier,
        experiment_name: experimentName
      }),
      contentType: 'application/json',
      headers: authHeader
    });
  },
  testSubjectActivate: function testSubjectActivate(experimentName, variation) {
    var authHeader = getAuthHeader();
    var userId = getUserIdfromCookie();

    return jq.ajax({
      url: '/api/abtest/0.1/enrollments/',
      method: 'PUT',
      data: JSON.stringify({
        id_type: EXPERIMENT_TYPE_USER_BASED,
        id: parseInt(userId, 10),
        experiment_name: experimentName,
        variation: variation
      }),
      contentType: 'application/json',
      headers: authHeader
    });
  },
  activateSessionBasedTestSubject: function activateSessionBasedTestSubject(experimentName, variation) {
    var userId = getUserIdfromCookie();
    var authHeader = void 0;
    if (userId) {
      authHeader = getAuthHeader();
    }
    var sessionId = getCookie('_tracking_session');
    return jq.ajax({
      url: '/api/abtest/0.1/enrollments/',
      method: 'PUT',
      data: JSON.stringify({
        id_type: EXPERIMENT_TYPE_SESSION_BASED,
        id: sessionId,
        experiment_name: experimentName,
        variation: variation
      }),
      contentType: 'application/json',
      headers: authHeader
    });
  },

  EXPERIMENT_TYPE_USER_BASED: EXPERIMENT_TYPE_USER_BASED,
  EXPERIMENT_TYPE_SESSION_BASED: EXPERIMENT_TYPE_SESSION_BASED,
  EXPERIMENT_TYPE_PROJECT_BASED: EXPERIMENT_TYPE_PROJECT_BASED
};

var negotiatedProjectLoadingTemplate = "<div class='quick-hire-form quick-hire-form-slim'>\n      <figure class=\"ChatLoader-profileImage\">\n          <div class=\"loading-overlay is-loading\"></div>\n          <img src=\"<%-  logo_url  %>\"\n              alt=\"<%-  username  %>'s Profile Image\">\n      </figure>\n\n      <span class=\"ChatLoader-description\">\n          <%= T_('Por favor, aguarde enquanto iniciamos um chat com <[- username ]>...', { 'username': username }) %>\n      </span>\n</div>\n";

var $container = void 0;
var $button = void 0;

function init$6(loadingContainer, button) {
  $container = loadingContainer;
  $button = button;
  create();
}

function show() {
  var userRow = $button.parents('li');
  var params = {
    logo_url: userRow.find('.freelancer-profile-image').attr('src'),
    username: userRow.find('.find-freelancer-username').text()
  };
  var loadingHTML = _.template(negotiatedProjectLoadingTemplate)(params);

  $container.removeClass('absolute').html(loadingHTML).modal({
    backdrop: 'static',
    keyboard: false,
    T_: translate
  });

  $button.addClass('processing').prop('disabled', true);
}

function hide() {
  $button.hide();
  $container.modal('hide');
}

function create() {
  var sellerId = $button.attr('data-user_id');
  show();

  jq.post('/ajax/negotiated-project/onCreate.php', {
    seller_id: sellerId
  }, handleResponse, 'json');
}

function initiateChat(projectId, sellerId) {
  window.liveChat.startChat([sellerId], 'private_chat', 'NegProjDirectory', {
    type: 'project',
    id: projectId
  });
}

function handleResponse(response) {
  if (response.status === 'success') {
    setTimeout(function () {
      initiateChat(response.project_id, response.seller_id);
      hide();
    }, 2000);
  } else {
    $button.removeClass('processing').prop('disabled', false);
  }
}

var moduleNegotiatedProject = {
  init: init$6
};

var KEY = {
  ENTER: 13,
  UP: 38,
  DOWN: 40,
  ESC: 27,
  TAB: 9,
  isFunctionKey: function isFunctionKey(k) {
    k = k.which ? k.which : k;
    switch (k) {
      case KEY.UP:
      case KEY.DOWN:
      case KEY.ENTER:
      case KEY.ESC:
      case KEY.TAB:
        return true;
      default:
        return false;
    }
  }
};

/**
 list name is whether 'country' or 'skill'
 */
function navigation(direction, itemName) {
  var listName = '';
  var inputName = '';
  var slimName = '';
  switch (itemName) {
    case 'skill':
      listName = 'job';
      inputName = 'skill';
      slimName = '#job_select_div';
      break;
    case 'country':
      inputName = 'country';
      listName = 'country';
      slimName = '#country_select_div';
      break;
    case 'exam':
      inputName = 'exam';
      listName = 'exam';
      slimName = '#exam_select_div';
      break;
    default:
    // do nothing
  }
  var curSelection = void 0;
  var hoveredItem = jq(slimName + ' .itemHover');
  if (hoveredItem.length === 0) {
    curSelection = -1;
  } else {
    curSelection = hoveredItem.parents('ul').find('li').index(hoveredItem.parent('li'));
  }

  if (direction == KEY.UP) {
    if (curSelection > 0) {
      curSelection--;
      hoveredItem = setSelected(curSelection, listName);
      makeSelectedItemAppear(hoveredItem, slimName, 'top');
    }
  } else if (direction == KEY.DOWN) {
    if (curSelection != jq('#' + listName + '_select_div ul li').size() - 1) {
      curSelection++;
      hoveredItem = setSelected(curSelection, listName);
      makeSelectedItemAppear(hoveredItem, slimName, 'bottom');
    }
  } else if (direction == KEY.ENTER) {
    // select this skill
    var item = jq('#' + listName + '_select_div ul li').eq(curSelection);
    if (!item.hasClass('disabled')) {
      // can be selectable
      item.click();
      jq('#input-' + inputName).val('');
      jq('#input-' + inputName).trigger('blur');
    }
  }
}

/**
 * @param {jquery Object} hoveredItem, jquery li object.
 * @param {String} slimName, name of which dropdown.
 * @param {String} position, top or bottom.
 */
function makeSelectedItemAppear(hoveredItem, slimName, position) {
  var currentHoverItemPostition = hoveredItem.position().top;
  var parentHeight = jq(slimName).height();

  switch (position) {
    case 'top':
      if (currentHoverItemPostition < 0) {
        jq(slimName).slimScroll({
          scrollBy: '-' + currentHoverItemPostition * -1 + 'px'
        });
      }
      break;
    case 'bottom':
      if (parentHeight - currentHoverItemPostition <= hoveredItem.height()) {
        var amount = hoveredItem.height() - parentHeight + currentHoverItemPostition;
        jq(slimName).slimScroll({ scrollBy: amount + 'px' });
      }
      break;
    default:
    // do nothing
  }
}

function setSelected(menuitem, listName) {
  jq('#' + listName + '_select_div ul li a.itemHover').removeClass('itemHover');
  return jq('#' + listName + '_select_div ul li').eq(menuitem).find('a').addClass('itemHover');
}

function bindSelected() {
  var bindFunction = function bindFunction() {
    jq(this).parents('ul').find('a').removeClass('itemHover');
    jq(this).addClass('itemHover');
  };
  jq('body').on('hover', '.select_div li a', bindFunction);
  jq('body').on('mousedown', '.select_div li a', function (e) {
    // mouse left click
    if (e.which == 1) {
      jq(this).parent('li').click();
    }
  });
}

function setFirstSelected(listName) {
  var slim = typeof listName !== 'undefined' ? '#' + listName + '_select_div' : '.select_div';
  if (jq(slim + ' li a.itemHover').length === 0) {
    jq(slim + ' li a').removeClass('itemHover').first().addClass('itemHover');
  }
}

var instance = false;
function getInstance() {
  if (!instance) {
    instance = {
      KEY: KEY,
      navigation: navigation,
      makeSelectedItemAppear: makeSelectedItemAppear,
      setSelected: setSelected,
      setFirstSelected: setFirstSelected,
      bindSelected: bindSelected
    };
  }
  return instance;
}

var DirKeyControl = getInstance();

var skillSuggestionListPage = "<li class=\"suggested-skill\" id=\"input_skill_<%-  job.id  %>\" style=\"cursor:pointer;\" value=\"<%-  job.id  %>\" data-job_name=\"<%- job.name  %>\">\n  <a> <%-  job.name  %> </a>\n  <div class=\"clear\"></div>\n</li>\n";

/**
 * This file is only used for directory page,
 * it is included by skill-selector.js
 * However, the skill-selector file is also used in post project page
 */

var skillSuggestionListTemplate = _.template(skillSuggestionListPage);
var haveSuggestion = false;
var skillsBasedOn = []; // skills already selected
var skillMap = void 0; // passed from skill-selector.js
var skillSuggestion = []; // suggest skills based on selected skills
var mouseHover = false; // add this flag, because jquery blur fire before click
var initialed = false; // flag, bind jquery event only once

/**
 * every time show 5 skills to display in the suggestion box
 */
var renderSkills = function renderSkills() {
  jq('#predict_skills.on_directory .jobs_list').empty();
  var count = 0;
  var job = void 0;

  // if has skill suggestion
  // shuffle the skill suggestion and pick the first five skills
  if (skillSuggestion.length !== 0) {
    skillSuggestion = _.shuffle(skillSuggestion);
    jq(skillSuggestion).each(function (key, value) {
      job = skillMap[value];
      if (typeof job !== 'undefined') {
        jq('#predict_skills.on_directory .jobs_list').append(skillSuggestionListTemplate({
          job: job
        }));
        count++;
      }
      if (count == 5) {
        return false;
      }
    });
  }
  if (count == 0) {
    haveSuggestion = false;
  }
};

/**
 * bind jq event,
 * bind button 'more'
 * also bind hover event of suggestion box, becasue jq blur fire before click
 */
var init$7 = function init() {
  if (initialed) {
    return;
  }
  jq('#moreSuggestions_directory').click(renderSkills);
  jq('#predict_skills.on_directory').hover(function () {
    mouseHover = true;
  }, function () {
    mouseHover = false;
  });
  initialed = true;
};

var showSuggestion = function showSuggestion() {
  if (haveSuggestion) {
    jq('#predict_skills.on_directory').show();
  }
};

var hideSuggestion = function hideSuggestion(forceHide) {
  if (forceHide) {
    mouseHover = false;
    jq('#predict_skills.on_directory').hide();
  } else if (!mouseHover) {
    jq('#predict_skills.on_directory').hide();
  }
};

/**
 * do ajax call, update skill suggestion
 *
 * @param {Object} selectedSkills,  skills already selected.
 * @param {Object} skillDropdownList,  a skill map, passed from
 *        skill-selector.js key=>value.
 * @param {Object} show, optional, if set to true, the call back
 *        of ajax will force show the suggestion box.
 */
var getSuggestionSkills = function getSuggestionSkills(selectedSkills, skillDropdownList, show) {
  // not directory page, then ingore
  if (jq('#predict_skills.on_directory').length === 0) {
    return;
  }
  init$7();
  if (JSON.stringify(skillsBasedOn.sort()) === JSON.stringify(selectedSkills.sort()) && haveSuggestion) {
    if (show) {
      showSuggestion();
    }
    return;
  }

  skillMap = skillDropdownList;
  if (selectedSkills.length === 0) {
    skillsBasedOn = _.clone(selectedSkills);
    haveSuggestion = false;
    hideSuggestion();
  } else {
    jq.getJSON('/buyers/predict.php', {
      jobs: selectedSkills.sort().join(',')
    }, function (msg) {
      if (msg.retval == 'success') {
        skillsBasedOn = _.clone(selectedSkills);
        haveSuggestion = true;
        skillSuggestion = msg.predicts;
        renderSkills();
        if (show) {
          showSuggestion();
        }
      }
    });
  }
};

/**
 * singleton class
 */
var instance$1 = false;
function getInstance$1() {
  if (!instance$1) {
    instance$1 = {
      getSuggestionSkills: getSuggestionSkills,
      showSuggestion: showSuggestion,
      hideSuggestion: hideSuggestion
    };
  }
  return instance$1;
}

var SkillSuggestionOnDirectory = getInstance$1();

var skillDropListTmpl = "<li id=\"input_skill_<%-  job.id  %>\" <%  if (is_disabled) {  %>class=\"disabled\"<%  }  %> style=\"cursor:pointer;\" value=\"<%-  job.id  %>\" data-job_name=\"<%- job.name  %>\">\n    <a class=\"pad\" style=\"color:#333;\">\n        <%-  job.name  %>\n    </a>\n</li>\n";

var skillCategoryMapTmpl = "<%  for (category_id in skillCategoryMap) {\n    var category = skillCategoryMap[category_id]; %>\n        <div class=\"filter-slider-folding advanced-filter\" data-toggle=\"collapse\" data-parent=\"#category_group\" href=\"#category_<%-  category_id  %>\">\n            <span class=\"Icon Icon--small\">\n              <%=  uiIcon('ui-plus')  %>\n            </span>\n            <p class=\"category_jobs_name\"><%-  category.name  %></p>\n        </div>\n        <div id=\"category_<%-  category_id  %>\" class=\"accordion-body collapse\">\n            <div class=\"category_jobs_div\" >\n            <ul style=\"list-style:none!important; font-size:12px\" class=\"nav nav-list\">\n            <%  var jobs = category.jobs;\n            for(var i = 0;i < jobs.length; i++) {\n                var job=jobs[i];  %>\n                <li id=\"skill_<%-  job.id %>\" class=\"category_jobs <%  if (jq('#selected_skill_'+job.id).length == 1) { %>disabled<% } %>\" value=\"<%-  job.id  %>\" style=\"cursor:pointer;\" data-job_name=\"<%-  job.name  %>\"><a class=\"pad\" style=\"color:#333; padding-bottom:0px\"><%-  job.name  %></a></li>\n            <%  }  %>\n            </ul>\n            </div>\n        </div>\n<%  }  %>\n";

var directoryPageTemplate = "<h4><%- T_(\"De que trabalho você precisa?\") %></h4>\n<div class=\"clear\"></div>\n<!--category input -->\n<div>\n    <label class=\"is-accessibly-hidden\" for=\"skill_category\"><%- T_(\"Categoria da Habilidade\") %></label>\n    <select class=\"default-input\" id=\"skill_category\"></select>\n</div>\n<!--subcategory input -->\n<div>\n    <label class=\"is-accessibly-hidden\" for=\"skill_subcategory\"><%- T_(\"Sub-categoria da Habilidade\") %></label>\n    <select class=\"default-input\" id=\"skill_subcategory\"></select>\n</div>\n<div class=\"clear border-bottom\"></div>\n<h4><%- T_(\"Habilidades\") %></h4>\n<div class=\"clear\"></div>\n<!--search box of skills -->\n<div id=\"job_div\">\n    <div class='bucket-search-wrapper'>\n        <label class=\"is-accessibly-hidden\" for=\"input-skill\"><%- T_(\"Buscar habilidade\") %></label>\n        <input id=\"input-skill\" class=\"default-input\" placeholder=\"<%- T_('Procurar habilidade...') %>\"><i class=\"search-icon\"></i>\n    </div>\n    <div id='job_select_wrap' class=\"select_wrap\" style=\"display:none;\">\n        <div id=\"job_select_div\">\n            <ul class=\"nav nav-list\" id=\"job_select\">\n            </ul>\n        </div>\n    </div>\n</div>\n<!-- category with skills -->\n<div class=\"in collapse span4 margin-l0\" id=\"category_group\"></div>\n<!-- toggle Browse skills -->\n<div id=\"browseskills_toggle_div\" class=\"PageFreelancersDirectory-filters-moreSkills\">\n    <a href=\"javascript:void(0)\" role=\"button\" id=\"browseskills_toggle_lnk\" class=\"small pull-right\" data-collapsed=\"false\"></a>\n</div>\n";

var postProjectTemplate = "<!-- Skills Selection - Basic Form Only-->\n<div class=\"control-group\">\n    <label class=\"control-label\" for=\"skill_category\">\n        <%- T_(\"De que trabalho você precisa?\") %>\n    </label>\n    <div class=\"controls\">\n        <label class=\"is-accessibly-hidden\" for=\"skill_category\"><%- T_(\"Categoria da Habilidade\") %></label>\n        <select id=\"skill_category\" name=\"skill_category\" class=\"span6\">\n        </select>\n        <div class=\"bubble contest-upsell\" style=\"display:none\">\n        </div>\n    </div>\n</div>\n<div class=\"control-group margin-b20\">\n    <div class=\"controls\">\n        <label class=\"is-accessibly-hidden\" for=\"skill_subcategory\"><%- T_(\"Sub-categoria da Habilidade\") %></label>\n        <select id=\"skill_subcategory\" name=\"skill_subcategory\" class=\"margin-l20\" style=\"width:420px;display:none;\">\n        </select>\n    </div>\n</div>\n";

var postContestTemplate = "<ol>\n    <li class=\"form-step primary-category\">\n        <label class=\"is-accessibly-hidden\" for=\"skill_category\"><%- T_(\"Categoria da Habilidade\") %></label>\n        <select name='skill_category' id=\"skill_category\">\n            <option><%- T_(\"Selecione uma categoria de trabalho (opcional)\") %></option>\n        </select>\n    </li>\n    <li class=\"form-step secondary-category\">\n        <label class=\"is-accessibly-hidden\" for=\"skill_subcategory\"><%- T_(\"Sub-categoria da Habilidade\") %></label>\n        <select name='skill_subcategory' id=\"skill_subcategory\">\n            <option><%- T_(\"Selecionar um trabalho\") %></option>\n        </select>\n    </li>\n</ol>\n";

var serviceWelcomeTemplate = "<div class=\"row\">\n    <div class=\"skill-category-container control-group span4\">\n        <label class=\"is-accessibly-hidden\" for=\"skill_category\"><%- T_(\"Categoria da Habilidade\") %></label>\n        <select id=\"skill_category\" name=\"category\">\n        </select>\n        <span class=\"help-inline\"></span>\n    </div>\n    <div class=\"control-group span4\">\n        <label class=\"is-accessibly-hidden\" for=\"skill_subcategory\"><%- T_(\"Sub-categoria da Habilidade\") %></label>\n        <select id=\"skill_subcategory\" name=\"subcategory\">\n        </select>\n        <span class=\"help-inline\"></span>\n    </div>\n</div>\n";

var contestLandingPage = "<li class=\"form-step skill-selector\">\n    <label class=\"is-accessibly-hidden\" for=\"skill_category\"><%- T_(\"Categoria da Habilidade\") %></label>\n    <select id=\"skill_category\" name=\"skill_category\"></select>\n    <div class=\"form-error\"></div>\n</li>\n<li class=\"form-step\">\n    <label class=\"is-accessibly-hidden\" for=\"skill_subcategory\"><%- T_(\"Sub-categoria da Habilidade\") %></label>\n    <select id=\"skill_subcategory\" name=\"skill_subcategory\"></select>\n    <div class=\"form-error\"></div>\n</li>\n";

var selectedSkills = [];
var alreadySelectedSkills = jq('#selected_skills_div').find('li a');
if (alreadySelectedSkills.length !== 0) {
  alreadySelectedSkills.each(function () {
    selectedSkills.push(parseInt(jq(this).attr('value'), 10));
  });
}

var chosenCategoryId = -1;
var chosenSubcategoryId = -1;

var skillCategoryBundle = [];
var skillDropdownList = [];
var skillCategoryMap = void 0;

var templateMapping = {
  directory: directoryPageTemplate,
  postproject: postProjectTemplate,
  postcontest: postContestTemplate,
  service_welcome: serviceWelcomeTemplate,
  contestlandingpage: contestLandingPage };

var skillTemplate = _.template(skillDropListTmpl);
var jobsByCategoryTmpl = _.template(skillCategoryMapTmpl);

var getAllSkillBundles = function getAllSkillBundles() {
  return [];
};
var getJobs = function getJobs() {
  return [];
};

var browseSkillsToggleLink = void 0;
var browseSkillsToggleDiv = void 0;
var basicCategoryInput = void 0;
var basicSubcategoryInput = void 0;
var advancedCategoryGroup = void 0;
var advancedDropdownList = void 0;

var selectorObject = void 0;
var toggleLinkNeeded = true;

function isFunction$1(object) {
  if (typeof object === 'function') {
    return true;
  }
  return false;
}

function createSelector(selectorObjectProvider) {
  selectorObject = selectorObjectProvider;
  // Basic Form bundles
  jq.getJSON('/ajax/skill-bundle.php?get_all_bundles=1', function (r) {
    getAllSkillBundles = function getAllSkillBundles() {
      return r;
    };
    // setTimeout(triggerSkillUpdate, 500);
  });
  // Jobs information
  jq.getJSON('/api/projects/0.1/jobs/', function (r) {
    getJobs = function getJobs() {
      return r.result;
    };
  });

  // Display the Skill selector template
  if (typeof selectorObject.template !== 'undefined') {
    selectorObject.parent.html(_.template(templateMapping[selectorObject.template])({
      jq: jq,
      T_: translate }));
  }
  setElements();

  // Events on Toggle
  browseSkillsToggleDiv.on('click', '#browseskills_toggle_lnk', function () {
    toggleBrowseSkills();
  });

  // Events on the Basic Form
  basicCategoryInput.change(function (e) {
    pickBasicCategory(e);
  });
  basicSubcategoryInput.change(function (e) {
    pickBasicSubcategory(e);
  });

  var selectSkill = function selectSkill(id) {
    if (id == 0) {
      // 'All Skills'
      // enable to click all other skills in drop down
      jq('#job_select .disabled').each(function () {
        jq(this).removeClass('disabled');
      });
      jq('.category_jobs_div .disabled').each(function () {
        jq(this).removeClass('disabled');
      });
      selectedSkills = [];

      // Callback function
      if (isFunction$1(selectorObject.onAllSkillsSelectedCallback)) {
        selectorObject.onAllSkillsSelectedCallback();
      }
    } else {
      // enable 'All skills'
      jq('#input_skill_0').removeClass('disabled');

      if (jq('#selected_skill_0').length === 1) {
        jq('#selected_skill_0').parent().remove();
      }

      if (jq('#selected_skill_' + id).length === 1) {
        // if the skill has been selected, remove it
        jq('#selected_skill_' + id).parent().remove();
      }

      selectedSkills.push(id);
    }

    SkillSuggestionOnDirectory.getSuggestionSkills(selectedSkills, skillDropdownList);

    disableAdvJobInSelection(id);

    // Callback function
    if (isFunction$1(selectorObject.onSkillSelectedCallback)) {
      selectorObject.onSkillSelectedCallback({
        subCategoryId: chosenSubcategoryId,
        selectedSkills: getSelectedSkills() });
    }
  };

  advancedDropdownList.on('click', 'li:not(.disabled)', function () {
    var id = jq(this).attr('value');
    selectSkill(id);
  });

  jq('#predict_skills.on_directory .jobs_list').on('click', 'li', function () {
    var id = jq(this).attr('value');
    selectSkill(id);
    SkillSuggestionOnDirectory.hideSuggestion(true);
  });

  // Events on the Advanced Form - Dropdown List
  jq('#input-skill').on('focusin', function () {
    jq('#job_select_wrap').show();
    DirKeyControl.setFirstSelected('job');
    SkillSuggestionOnDirectory.getSuggestionSkills(selectedSkills, skillDropdownList, true);
  }).on('keyup', function (e) {
    var _this = this;

    if (!DirKeyControl.KEY.isFunctionKey(e)) {
      (function () {
        var input = jq(_this).val().toLowerCase();
        advancedDropdownList.html('');
        if (input === '') {
          appendAllSkills();
        } else if (skillDropdownList) {
          Object.keys(skillDropdownList).forEach(function (i) {
            var job = skillDropdownList[i];
            if (job.name.toLowerCase().indexOf(input) !== -1) {
              appendSkillItem(job);
            }
          });
        }
        DirKeyControl.setFirstSelected('job');
      })();
    }
  }).on('keydown', function (e) {
    if (DirKeyControl.KEY.isFunctionKey(e)) {
      DirKeyControl.navigation(e.which, 'skill');
    }
  }).on('clickoutside', function () {
    if (jq(this).val() === '') {
      // nothing selected, list all jobs
      appendAllSkills();
    }
    jq('#job_select_wrap').hide();
    SkillSuggestionOnDirectory.hideSuggestion();
  });

  // Events on the Advanced Form - Jobs Categories
  advancedCategoryGroup.on('click', '.category_jobs:not(.disabled)', function () {
    var job = jq(this);
    var id = job.attr('value');

    if (jq('#selected_skill_0').length === 1) {
      jq('#selected_skill_0').parent().remove();
    }
    if (jq('#selected_skill_' + id).length === 1) {
      // if the skill has been selected, remove it
      jq('#selected_skill_' + id).parent().remove();
    }

    selectedSkills.push(id);
    disableAdvJobInSelection(id);

    // Callback function
    if (isFunction$1(selectorObject.onSkillSelectedCallback)) {
      selectorObject.onSkillSelectedCallback({
        subCategoryId: chosenSubcategoryId,
        selectedSkills: getSelectedSkills() });
    }
  });

  if (selectorObject.skillCategoryBundle) {
    skillCategoryBundle = selectorObject.skillCategoryBundle;
  }
  if (selectorObject.skillDropdownList) {
    skillDropdownList = selectorObject.skillDropdownList;
  }
  if (selectorObject.skillCategoryMap) {
    skillCategoryMap = selectorObject.skillCategoryMap;
  }

  // Check if toggle not needed
  if (skillCategoryBundle.length === 0 || skillDropdownList.length === 0 || skillCategoryMap.length === 0) {
    browseSkillsToggleDiv.hide();
    toggleLinkNeeded = false;
  }

  generateBasicForm();
  generateAdvancedForm();

  // Apply slimScroll on Dropdown List and Jobs Categories
  jq('#job_select_div').slimScroll({
    height: '200px' });

  jq('.filter-slider-folding').each(function () {
    var categoryId = jq(this).next('div').attr('id');
    var skillListSize = jq('#' + categoryId + ' li').size();
    var skillListHeight = 17.85;
    var listHeight = Math.round(skillListSize * skillListHeight).toString() + 'px';

    // check if list is should be less than default size
    if (skillListSize < 14) {
      jq('#' + categoryId + ' .category_jobs_div').slimScroll({
        height: listHeight,
        width: '220px' });
    } else {
      jq('#' + categoryId + ' .category_jobs_div').slimScroll({
        height: '200px',
        width: '220px' });
    }
  });
  // Initial Data
  if (selectorObject.initialData) {
    var initObj = void 0;

    if (selectorObject.initialData.is_service) {
      initObj = selectorObject.initialData.service;
    } else if (selectorObject.initialData.is_contest) {
      initObj = selectorObject.initialData.contest;
    } else {
      initObj = selectorObject.initialData.project;
    }
    var selectedCategory = initObj.category;
    if (selectedCategory != null && selectedCategory >= -2) {
      chosenCategoryId = selectedCategory;
      jq('#skill_category').val(chosenCategoryId).change();
      chosenSubcategoryId = initObj.sub_category;

      jq('#skill_subcategory').val(chosenSubcategoryId);

      if (typeof selectorObject.initialData.is_edit_draft === 'undefined') {
        selectorObject.initialData.is_edit_draft = false;
      }
      if (!selectorObject.initialData.is_repost && !selectorObject.initialData.is_edit_draft) {
        jq('#skill_subcategory').change();
      }

      if (!selectorObject.initialData.is_service && !selectorObject.initialData.is_contest && !selectorObject.initialData.is_edit_draft) {
        pickBasicSubcategoryLater();
      }

      if ((selectorObject.initialData.is_service || selectorObject.initialData.is_contest || selectorObject.initialData.is_edit_draft) && initObj.selected_jobs) {
        // pre-select skills

        pickFromRepostData();
      }
      // For repost projects, get selected skills.
    } else if (initObj.selected_jobs) {
      pickFromRepostData();
    }
  }

  // Initial toggle
  toggleBrowseSkills();

  // Callback function
  if (isFunction$1(selectorObject.onCreateSelectorCallback)) {
    selectorObject.onCreateSelectorCallback(selectedSkills);
  }
}

function setElements() {
  browseSkillsToggleLink = jq('#browseskills_toggle_lnk');
  browseSkillsToggleDiv = jq('#browseskills_toggle_div');
  basicCategoryInput = jq('#skill_category');
  basicSubcategoryInput = jq('#skill_subcategory');
  advancedCategoryGroup = jq('#category_group');
  advancedDropdownList = jq('#job_select');
}

function toggleBrowseSkills() {
  var dataIndex = 'collapsed';
  if (browseSkillsToggleLink.data(dataIndex)) {
    // Display Advanced form
    advancedCategoryGroup.show();
    browseSkillsToggleLink.html(translate('Ocultar')).data(dataIndex, false);
  } else {
    // Display Basic form
    advancedCategoryGroup.hide();
    browseSkillsToggleLink.html(translate('Navegar Habilidades')).data(dataIndex, true);
  }
}

function resetWorkCategory() {
  var reset = false;

  if (chosenCategoryId == -2) {
    // If Customized was previously selected, change to default.
    reset = true;
  } else if (chosenCategoryId != -1) {
    // If a bundle was previously selected, check if skills changed.
    reset = skillsChanged();
  }

  if (reset) {
    chosenCategoryId = -1;
    chosenSubcategoryId = -1;
    basicCategoryInput.val(chosenCategoryId).change();
  }
}

function skillsChanged() {
  var bundles = getAllSkillBundles();

  if (chosenSubcategoryId == null || chosenSubcategoryId == -1) {
    return;
  }
  if (bundles.length === 0) {
    setTimeout(skillsChanged, 200);
    return;
  }

  // If length not equal, skills changed.
  if (selectedSkills.length != bundles[chosenSubcategoryId].length) {
    return true;
  }
  if (bundles[chosenSubcategoryId]) {
    Object.keys(bundles[chosenSubcategoryId]).forEach(function (i) {
      // If bundle skill not found, skills changed.
      if (jq.inArray(parseInt(bundles[chosenSubcategoryId][i], 10), selectedSkills) == -1) {
        return true;
      }
    });
  }
  return false;
}

function getSelectedSkills() {
  var retArray = [];
  for (var i = 0; i < selectedSkills.length; ++i) {
    retArray.push({
      id: selectedSkills[i],
      name: getJobNameFromId(selectedSkills[i]) });
  }
  return retArray;
}

function removeSelectedSkill(jobId) {
  var idx = selectedSkills.indexOf(jobId.toString());
  if (idx != -1) {
    selectedSkills.splice(idx, 1);
  }
  enableAdvJobInSelection(jobId);
  resetWorkCategory();
  SkillSuggestionOnDirectory.getSuggestionSkills(selectedSkills, skillDropdownList);
}

function generateBasicForm() {
  basicCategoryInput.html('');

  var strCustomized = translate('Personalizado');
  var strSelectCategory = translate('Selecione uma categoria de trabalho');

  if (!toggleLinkNeeded) {
    strCustomized += translate('(Selecionar habilidades manualmente)');
    if (!selectorObject.requireField) {
      strSelectCategory += translate('(Opcional)');
    }
  }

  basicCategoryInput.append('<option selected value="-1">' + strSelectCategory + '</option>');

  jq.each(skillCategoryBundle, function (index, data) {
    basicCategoryInput.append('<option value="' + index + '">' + data.name + '</option>');
  });

  basicCategoryInput.append('<option value="-2">' + strCustomized + '</option>');

  basicCategoryInput.trigger('change');
}

function pickBasicCategory(e) {
  chosenCategoryId = jq(e.currentTarget).val();
  if (chosenCategoryId == -1 || chosenCategoryId === null) {
    basicSubcategoryInput.hide();
    return;
  } else if (chosenCategoryId == -2) {
    basicSubcategoryInput.hide();
    if (toggleLinkNeeded) {
      toggleBrowseSkills();
    }
    return;
  }

  basicSubcategoryInput.show();

  // Clear sub category
  basicSubcategoryInput.html('');

  // Add necessary sub category
  var strSelectProject = translate('Selecionar um trabalho');
  if (!toggleLinkNeeded && !selectorObject.requireField) {
    strSelectProject += translate('(Opcional)');
  }
  basicSubcategoryInput.append('<option value="-1" selected="selected">' + strSelectProject + '</option>');

  for (var i = 0; i < skillCategoryBundle[chosenCategoryId].sub_categories.length; i++) {
    basicSubcategoryInput.append('<option value="' + ('' + skillCategoryBundle[chosenCategoryId].sub_categories[i].id) + '">' + ('' + skillCategoryBundle[chosenCategoryId].sub_categories[i].name) + '</option>');
  }

  // Callback function
  if (isFunction$1(selectorObject.onSkillCategoryPickedCallback)) {
    selectorObject.onSkillCategoryPickedCallback(e);
  }
}

function pickBasicSubcategory(e) {
  chosenSubcategoryId = jq(e.currentTarget).val();

  // -1 is the initial "select a job" option
  // null is for -1 and -2 categories which are manual skill selections
  if (chosenSubcategoryId == null || chosenSubcategoryId == -1) {
    return;
  }

  pickBasicSubcategoryLater();

  // Callback function
  if (isFunction$1(selectorObject.onSkillSubcategoryPickedCallback)) {
    selectorObject.onSkillSubcategoryPickedCallback(e);
  }
}

function getJobNameFromId(id) {
  var jobs = getJobs();

  for (var i = jobs.length - 1; i >= 0; i--) {
    if (jobs[i].id == id) {
      return jobs[i].name;
    }
  }
}

function pickBasicSubcategoryLater() {
  var bundles = getAllSkillBundles();

  if (chosenSubcategoryId == null || chosenSubcategoryId == -1) {
    return;
  }
  if (bundles.length === 0) {
    setTimeout(pickBasicSubcategoryLater, 2000);
    return;
  }

  // Reset selectedSkills
  if (selectedSkills.length) {
    for (var i = 0; i < selectedSkills.length; ++i) {
      enableAdvJobInSelection(selectedSkills[i]);
    }
    selectedSkills = [];
  }

  // Repopulate selectedSkills with new choices
  for (var _i = 0; _i < bundles[chosenSubcategoryId].length; ++_i) {
    selectedSkills.push(parseInt(bundles[chosenSubcategoryId][_i], 10));
    disableAdvJobInSelection(bundles[chosenSubcategoryId][_i]);
  }
  // Callback function
  if (isFunction$1(selectorObject.onSkillSelectedCallback)) {
    selectorObject.onSkillSelectedCallback({
      subCategoryId: chosenSubcategoryId,
      selectedSkills: getSelectedSkills() });
  }
}

function pickFromRepostData() {
  var bundles = getAllSkillBundles();
  if (bundles.length === 0) {
    setTimeout(pickFromRepostData, 2000);
    return;
  }

  // Reset selectedSkills
  if (selectedSkills.length) {
    for (var i = 0; i < selectedSkills.length; ++i) {
      enableAdvJobInSelection(selectedSkills[i]);
    }
    selectedSkills = [];
  }

  // Repopulate selectedSkills with new choices
  var initObj = null;
  if (selectorObject.initialData.is_service) {
    initObj = selectorObject.initialData.service;
  } else if (selectorObject.initialData.is_contest) {
    initObj = selectorObject.initialData.contest;
  } else {
    initObj = selectorObject.initialData.project;
  }
  var selectedJobs = initObj.selected_jobs;

  if (selectedJobs) {
    Object.keys(selectedJobs).forEach(function (i) {
      selectedSkills.push(parseInt(selectedJobs[i].id, 10));
      disableAdvJobInSelection(parseInt(selectedJobs[i].id, 10));
    });
  }

  // Callback function
  if (isFunction$1(selectorObject.onSkillSelectedCallback)) {
    selectorObject.onSkillSelectedCallback({
      subCategoryId: chosenSubcategoryId,
      selectedSkills: getSelectedSkills() });
  }
}

function generateAdvancedForm() {
  appendAllSkills();
  advancedCategoryGroup.append(jobsByCategoryTmpl({ jq: jq, skillCategoryMap: skillCategoryMap, uiIcon: uiIcon }));
}

function appendSkillItem(job) {
  advancedDropdownList.append(skillTemplate({ job: job, is_disabled: false }));
  if (jq('#selected_skill_' + job.id).length === 1) {
    disableAdvJobInSelection(job.id);
  }
}

function getAllSkillsHTML() {
  var skillItems = '';
  var lskillDropdownList = skillDropdownList;
  var isDisabled = false;

  // generate all skills HTML
  var allSkill = {};
  allSkill.id = 0;
  allSkill.name = 'All skills';
  skillItems += skillTemplate({ job: allSkill, is_disabled: false });

  if (lskillDropdownList) {
    Object.keys(lskillDropdownList).forEach(function (i) {
      isDisabled = false;
      if (jq('#selected_skill_' + skillDropdownList[i].id).length === 1) {
        disableAdvJobInSelection(skillDropdownList[i].id);
        isDisabled = true;
      }
      skillItems += skillTemplate({
        job: skillDropdownList[i],
        is_disabled: isDisabled });
    });
  }
  return skillItems;
}

function appendAllSkills() {
  var element = document.getElementById(advancedDropdownList.attr('id'));
  if (typeof element !== 'undefined' && element != null) {
    element.innerHTML = '';
    var skillsHtml = getAllSkillsHTML();
    element.innerHTML = skillsHtml;
  }
}

function enableAdvJobInSelection(jobId) {
  jq('#skill_' + jobId).removeClass('disabled');
  jq('#input_skill_' + jobId).removeClass('disabled');
}

function disableAdvJobInSelection(jobId) {
  jq('#skill_' + jobId).addClass('disabled');
  jq('#input_skill_' + jobId).addClass('disabled');
}

var skillSelectorForm = {
  createSelector: createSelector,
  removeSelectedSkill: removeSelectedSkill };

GoogleMapsLoader.KEY = 'AIzaSyAWB_zZMjdwNlu8-9xZ8RyNRbCERQTWSR8';
GoogleMapsLoader.LIBRARIES = ['places'];
GoogleMapsLoader.LANGUAGE = 'en';

var gmapPromise = new Promise(function (resolve) {
  GoogleMapsLoader.load(function (google) {
    resolve(google);
  });
});

var module$1 = {
  config: {}
};
var autoComplete = void 0;
var gmap = void 0;

module$1.init = function (config) {
  module$1.config = config;
  gmapPromise.then(function (google) {
    gmap = google.maps;
    autoComplete = new gmap.places.Autocomplete(
    /* @type {HTMLInputElement} */
    document.getElementById(module$1.config.autoCompleteElement), {
      // WARNING: don't put anything in fields that isn't "Basic Data"
      // https://developers.google.com/maps/billing/gmp-billing#data-skus
      // or it could incur significant extra costs to our google maps usage
      fields: ['address_components', 'formatted_address', 'geometry.location', 'vicinity']
    });
    gmap.event.addListener(autoComplete, 'place_changed', function () {
      if (typeof module$1.config.autoCompleteCallback === 'function') {
        module$1.config.autoCompleteCallback(module$1.getSelectedAddressGeoInfo());
      }
    });
  });

  if (typeof module$1.config.reverseGeocodingElement !== 'undefined') {
    // autocomplete element must be an id without #, since not passing to
    // a jquery selector.  So, we'll assume we're getting the same here, to be
    // consistent in init().
    jq('#' + module$1.config.reverseGeocodingElement).off('click').on('click', function (evt) {
      evt.preventDefault();
      if ('geolocation' in navigator) {
        var geoOptions = {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0
        };

        navigator.geolocation.getCurrentPosition(function (position) {
          module$1.getReverseGeoInfo(position.coords.latitude, position.coords.longitude);
        }, function (err) {
          if (typeof module$1.config.reverseGeocodingErrorCallback === 'function') {
            module$1.config.reverseGeocodingErrorCallback('Failed to determine current location: ' + err.toString());
          }
        }, geoOptions);
      }
    });
  }
};

module$1.formatGeoInfo = function (place) {
  var geoInfo = {
    administrative_area_level_1: '',
    country: '',
    formatted_address: '',
    lat: '',
    lng: '',
    vicinity: ''
  };

  var addressComponent = {
    administrative_area_level_1: 'short_name',
    country: 'long_name',
    locality: 'long_name'
  };
  for (var i = 0; i < place.address_components.length; i++) {
    var addressType = place.address_components[i].types[0];
    if (addressComponent[addressType]) {
      geoInfo[addressType] = place.address_components[i][addressComponent[addressType]];
    }
  }
  geoInfo.formatted_address = place.formatted_address;
  geoInfo.lat = place.geometry.location.lat();
  geoInfo.lng = place.geometry.location.lng();
  geoInfo.vicinity = place.vicinity || geoInfo.locality || geoInfo.administrative_area_level_1 || geoInfo.country || '';
  return geoInfo;
};

module$1.getSelectedAddressGeoInfo = function () {
  var place = autoComplete.getPlace();
  return module$1.formatGeoInfo(place);
};

module$1.getReverseGeoInfo = function (latitude, longitude) {
  var geocoder = new gmap.Geocoder();
  var latlng = new gmap.LatLng(latitude, longitude);

  geocoder.geocode({ latLng: latlng }, function (results, status) {
    if (status === gmap.GeocoderStatus.OK) {
      var geoInfo = module$1.formatGeoInfo(results[0]);
      jq('#' + module$1.config.autoCompleteElement).val(geoInfo.formatted_address);
      if (typeof module$1.config.reverseGeocodingSuccessCallback === 'function') {
        module$1.config.reverseGeocodingSuccessCallback(geoInfo);
      }
    } else if (typeof module$1.config.reverseGeocodingErrorCallback === 'function') {
      module$1.config.reverseGeocodingErrorCallback(status);
    }
  });
};

var geocoding = {
  init: module$1.init
};

var markers = [];
var infowindows = [];
var gmap$1 = void 0;
var map = void 0;

/*
  required params
  1. config.canvas - HTML ID
  2. config.center - center object contains lat and lon

  optional params
  1. mapTypeId
  2. zoom
  3. panControl
  4. zoomControl
  5. mapTypeControl
  6. scaleControl
  7. streetViewControl
  8. overviewMapControl
 */
var init$8 = function init(config) {
  gmapPromise.then(function (google) {
    gmap$1 = google.maps;
    map = undefined;
    var canvas = document.getElementById(config.canvas);
    var center = void 0;
    if (config.center) {
      center = new gmap$1.LatLng(config.center.lat, config.center.lon);
    } else {
      // default map center to Sydney
      center = new gmap$1.LatLng(-33.87, 151.21);
    }
    var options = {
      center: center,
      mapTypeId: config.mapTypeId ? config.mapTypeId : gmap$1.MapTypeId.ROADMAP,
      zoom: config.zoom ? config.zoom : 16,
      panControl: config.panControl ? config.panControl : true,
      zoomControl: config.zoomControl ? config.zoomControl : true,
      mapTypeControl: config.mapTypeControl ? config.mapTypeControl : false,
      scaleControl: config.scaleControl ? config.scaleControl : true,
      streetViewControl: config.streetViewControl ? config.streetViewControl : false,
      overviewMapControl: config.overviewMapControl ? config.overviewMapControl : true
    };
    map = new gmap$1.Map(canvas, options);
  });
};

/**
 * Determine the center of the map.
 * Now relying on promise to execute when the map is loaded
 */
var setCenter = function setCenter(center) {
  gmapPromise.then(function () {
    var newCenter = new gmap$1.LatLng(center.lat, center.lon);
    map.setOptions({
      center: newCenter
    });
  });
};

/**
 * Adjust the zoom according to markers positions.
 */
var autoAdjustZoom = function autoAdjustZoom() {
  gmapPromise.then(function () {
    var bounds = new gmap$1.LatLngBounds();
    for (var i = 0; i < markers.length; i++) {
      bounds.extend(markers[i].getPosition());
    }
    map.fitBounds(bounds);
  });
};

/*
  required params
  1. markerData.lat
  2. markerData.lon
  3. markerData.title
  4. markerData.icon

  optional params
  1. infowindowHTML
 */
var addMarker = function addMarker(markerData) {
  gmapPromise.then(function () {
    var location = new gmap$1.LatLng(markerData.lat, markerData.lon);
    var marker = new gmap$1.Marker({
      position: location,
      map: map,
      title: markerData.title,
      icon: markerData.icon
    });
    markers.push(marker);
    if (markerData.infowindowHTML) {
      (function () {
        var infowindow = new gmap$1.InfoWindow({
          content: markerData.infowindowHTML
        });
        infowindows.push(infowindow);
        gmap$1.event.addListener(marker, 'click', function () {
          // close all other opened infowindow
          jq.each(infowindows, function (i, infow) {
            infow.close();
          });
          infowindow.open(map, marker);
        });
      })();
    }
    if (typeof markerData.removeAdjustZoom === 'undefined' || markerData.removeAdjustZoom !== true) {
      autoAdjustZoom();
    }
  });
};

var clearMarkers = function clearMarkers() {
  markers = [];
  infowindows = [];
};

var gmap$2 = {
  init: init$8,
  setCenter: setCenter,
  addMarker: addMarker,
  clearMarkers: clearMarkers
};

var sponsorBoxTemplate = "<i class=\"sponsor_info icon-16-info right\"></i>\n<div class=\"large bold\"><%- T_('Promova-se aqui!') %></div>\n<div class=\"small margin-t5 margin-b5\">\n    <%- T_('Patrocine-se a si mesmo para suas habilidades principais:') %>\n</div>\n<%  for (var id in sponsorInfo) {  %>\n    <%  if (jq.inArray(id, selectedSkillIDs) >= 0) {  %>\n        <%  if (sponsorInfo[id]['is_sponsored']) {  %>\n            <div class=\"SponsorSkillEntry sponsor-skill-entry inline-block\" data-skill-id=\"<%-  id  %>\">\n                <span class=\"SponsorSkillEntry-name\"><%-  sponsorInfo[id]['skillDetail']['name']  %></span>\n                <span class=\"SponsorSkillEntry-time\"><%- T_('Você está patrocinado! Termina em <[- sponsorTimeLeft ]>', { sponsorTimeLeft: sponsorInfo[id]['sponsor_time_left'] }) %></span>\n            </div>\n        <%  } else if (sponsorInfo[id]['can_sponsor']) {  %>\n            <div class=\"SponsorSkillEntry sponsor-skill-entry inline-block\" data-skill-id=\"<%-  id  %>\">\n                <span class=\"SponsorSkillEntry-action\"><button class=\"btn btn-success btn-mini btn-sponsor-list\" data-skill-id=\"<%-  id  %>\"><%- T_('Patrocinador') %></button><img class=\"margin-5\" src=\"<%=  cdn_url('/img/throbber_horizontal.gif')  %>\" style=\"display: none;\" /></span>\n                <span class=\"SponsorSkillEntry-name\"><%-  sponsorInfo[id]['skillDetail']['name']  %></span>\n                <span class=\"SponsorSkillEntry-price sponsor-price\"><%- T_('Patrocinador por <[= currencySign ]><[- sponsorPrice ]> <[- currencyCode ]>', { sponsorPrice: sponsorInfo[id]['sponsor_price'], currencySign: currency.sign, currencyCode: currency.code }) %></span>\n            </div>\n        <%  }  %>\n    <%  }  %>\n<%  }  %>\n<em class=\"SponsorSkillEntry-note small\" id=\"select-another-skill\"><%- T_('Ou selecione outra habilidade no diretório para ser patrocinado por essa habilidade') %></em>\n";

var freelancerInfowindowTemplate = "<div class=\"popover-content is-hireme\">\n    <div class=\"userprofile-overview\">\n        <div class=\"userprofile-overview--image\">\n            <img src=\"<%=  profile_logo %>\" alt=\"<%-  username  %>\" title=\"<%-  username  %>\">\n        </div>\n        <div class=\"userprofile-overview--summary\">\n            <span class=\"userprofile-overview--name\"><%-  username  %></span>\n            <span class=\"userprofile-overview--online\">\n                <%  if (is_online) {  %>\n                <span class=\"online-status\" data-size=\"medium\" data-status=\"online\"></span>\n                <%  } else {  %>\n                <span class=\"online-status\" data-size=\"medium\" data-status=\"offline\"></span>\n                <%  }  %>\n            </span>\n            <img class=\"location-flag\" src=\"/<%=  flag_icon  %>\" alt=\"<%-  flag_name  %>\" title=\"<%-  flag_name  %>\">\n            <span class=\"Rating Rating--labeled\"\n                  data-star_rating=\"<%-  rating_stars_count  %>\">\n                <span class=\"Rating-total\">\n                    <span class=\"Rating-progress\"></span>\n                </span>\n                <span class=\"Rating-review\">\n                    <%- review.reviews == 1 ? T_('1 comentário') : T_('<[-count]> comentários', { count: review.reviews }) %>\n                </span>\n            </span>\n        </div>\n    </div>\n\n    <div class=\"popover--freelancer-details\">\n        <span class=\"popover--freelancer-price\">\n            <span class=\"popover--freelancer-value\">$<%-  hourlyrate  %></span>\n            <%- T_(\"por hora\") %>\n        </span>\n    </div>\n    <div class=\"popover--freelancer-action\">\n        <a href=\"/u/<%-  username  %>\" class=\"btn btn-small\"><%- T_('Perfil') %></a>\n        <button class=\"btn btn-small hireme-btn\" data-userid=\"<%-  user_id  %>\"><span class=\"fl-icon-bird\"></span><%- T_('Me Contratar') %></button>\n    </div>\n</div>\n";

var _templateObject$13 = _taggedTemplateLiteral(['<div class="PageFreelancersDirectory-superCategories-item">\n    <a href="/freelancers<%- url %>/1/"><%- name %> Freelancers</a>\n    </div>'], ['<div class="PageFreelancersDirectory-superCategories-item">\n    <a href="/freelancers<%- url %>/1/"><%- name %> Freelancers</a>\n    </div>']),
    _templateObject2$6 = _taggedTemplateLiteral(['<div class="PageFreelancersDirectory-superCategories-item">\n    <a href="/freelancers/r/<%- continent.link %>">\n      Freelancers in <%- continent.name %>\n    </a>\n  </div>'], ['<div class="PageFreelancersDirectory-superCategories-item">\n    <a href="/freelancers/r/<%- continent.link %>">\n      Freelancers in <%- continent.name %>\n    </a>\n  </div>']),
    _templateObject3$3 = _taggedTemplateLiteral(['Freelancers Para Contratar'], ['Freelancers Para Contratar']);

var freeSearchString = void 0;
var seoURL$1 = seoURL;

var freelancerlistItem = _.template(jq('#freelancer-item').html());
var skillBubbleTmpl = _.template(jq('#selected_job_bubble').html());
var locationBubbleTmpl = _.template(jq('#selected_location_bubble').html());
var countryBubbleTmpl = _.template(jq('#selected_country_bubble').html());
var examBubbleTmpl = _.template(jq('#selected_exam_bubble').html());
var rateBubbleTmpl = _.template(jq('#selected_rate_bubble').html());
var starBubbleTmpl = _.template(jq('#selected_star_bubble').html());
var onlineBubbleTmpl = _.template(jq('#online_bubble').html());
var freeSearchBubbleTmpl = _.template(jq('#selected_freeSearch_bubble').html());

var starRating = void 0;
var paymentModalData = void 0;
var currencyDetails = void 0;
var filterVars = {
  countries: [],
  exams: [],
  jobs: [],
  job_names: [],
  location: undefined,
  hourly_rate_min: undefined,
  hourly_rate_max: undefined,
  history_range: undefined,
  online_only: undefined };

var countryTemplate = _.template('<li data-value="<%- country.name %>"' + '<% if (is_disabled) { %>class="disabled"<% } %> <%- is_disabled %>' + ' data-code=<%- country.code %> style="cursor:pointer;" ' + 'id="country_<%-country.code %>"><a class="pad" style="color:#333;">' + '<%- country.name %> </a></li>');

var examTemplate = _.template('<li data-value="<%- exam.name %>"' + '<% if (is_disabled) { %>class="disabled"<% } %> <%- is_disabled %>' + ' data-id=<%- exam.id %> style="cursor:pointer;" ' + 'id="exam_<%-exam.id %>"><a class="pad" style="color:#333;">' + '<%- exam.name %> </a></li>');

var seoSkillTemplate = _.template(oneLineTrim(_templateObject$13));

var seoContinentTemplate = _.template(oneLineTrim(_templateObject2$6));

var getSponsorInfoAjaxRequest = void 0;
var abortedRequestUncheckedSkillIDs = [];
var sponsorInfo = {};
var resultsCount = 0;
var searchSource = 'page load';
var xhr = void 0;
var resultsPerPage = 10;
// Extended search searches for offline users if online
// users found is less that a page-full
var enableExtendedSearch = !!getCookie(cookieBase + '_USER_ID');
var userLanguage = getCookie(cookieBase + '_LANGUAGE');

function getSeoLinkByJob(jobIdArray) {
  var jobSeoArray = [];
  if (jobIdArray.length === 0) {
    // job placeholder should be 'all'
    jobSeoArray = ['all'];
  } else {
    _.each(mapped_jobs, function (e) {
      if (jobIdArray.indexOf(e.id) > -1) {
        jobSeoArray.push(e.seo_url);
      }
    });
  }
  return jobSeoArray.join('-');
}

function updateContinentLink(jobIdArray) {
  var jobSeoLink = getSeoLinkByJob(jobIdArray);
  jq('#seo_continent').html('');
  if (continents) {
    Object.keys(continents).forEach(function (i) {
      continents[i].link = continents[i].continent_url + '/' + jobSeoLink + '/';
      jq('#seo_continent').append(seoContinentTemplate({
        continent: continents[i] }));
    });
  }
}

function getSeoLink(jobIdArray, countryNameArray) {
  var jobSeoLink = getSeoLinkByJob(jobIdArray);
  // Shallow clone the countries to not alter the source
  var countries$$1 = countryNameArray.slice();
  if (countries$$1.length === 0) {
    // country placeholder is 'skills'
    countries$$1 = ['skills'];
  } else {
    for (var i = 0; i < countries$$1.length; i++) {
      if (countries$$1.hasOwnProperty(i)) {
        countries$$1[i] = countries$$1[i].replace(/[(),'.]/g, '');
        countries$$1[i] = countries$$1[i].replace(/\s/g, '_');
      }
    }
  }

  var countrySeoLink = countries$$1.join('-');
  return '/' + countrySeoLink + '/' + jobSeoLink;
}

function appendLocalSearchItem() {
  jq('#selected_location_div').empty().append(locationBubbleTmpl({
    default_type: false,
    name: jq('#input-location').val(),
    T_: translate }));
}

function appendCountryItem(country) {
  var isDisabled = false;
  if (jq('#selected_country_' + country.code).length === 1) {
    isDisabled = true;
  }
  jq('#country_select').append(countryTemplate({
    country: country,
    is_disabled: isDisabled }));
}

function getAllCountriesHTML() {
  var countryItems = '';
  var lcountries = countries;
  var isDisabled = false;
  // Add 'All countries' option
  var allCountry = {};
  allCountry.name = 'All countries';
  allCountry.code = 'ALL_COUNTRIES';
  countryItems += countryTemplate({
    country: allCountry,
    is_disabled: false });

  if (lcountries) {
    Object.keys(lcountries).forEach(function (i) {
      isDisabled = false;
      if (jq('#selected_country_' + countries[i].code).length === 1) {
        isDisabled = true;
      }
      countryItems += countryTemplate({
        country: countries[i],
        is_disabled: isDisabled });
    });
  }
  return countryItems;
}

function appendAllCountries() {
  document.getElementById('country_select').innerHTML = getAllCountriesHTML();
}

function getAllExamsHTML() {
  var lexams = exams;
  var examItems = '';
  var isDisabled = false;
  if (lexams) {
    Object.keys(lexams).forEach(function (i) {
      isDisabled = false;
      if (jq('#selected_exam_' + exams[i].id).length === 1) {
        isDisabled = true;
      }
      examItems += examTemplate({ exam: exams[i], is_disabled: isDisabled });
    });
  }
  return examItems;
}

function appendExamItem(exam) {
  jq('#exam_select').append(examTemplate({ exam: exam, is_disabled: false }));
  if (jq('#selected_exam_' + exam.id).length === 1) {
    jq('#exam_' + exam.id).addClass('disabled');
  }
}

function appendAllExams() {
  document.getElementById('exam_select').innerHTML = '';
  document.getElementById('exam_select').innerHTML = getAllExamsHTML();
}

function getFilterVars(filterVars) {
  // set default value according to profile hourly rate change
  filterVars.history_range = jq('#history_range').val();
  if (jq('#hourly_rate').val() == 'customized') {
    if (isNumeric(jq('#hourly_rate_min').val())) {
      filterVars.hourly_rate_min = jq('#hourly_rate_min').val();
    }
    if (isNumeric(jq('#hourly_rate_max').val())) {
      filterVars.hourly_rate_max = jq('#hourly_rate_max').val();
    }
  } else if (jq('#hourly_rate').val() == '10') {
    filterVars.hourly_rate_max = 9; // < 10
  } else if (jq('#hourly_rate').val() == '10-20') {
    filterVars.hourly_rate_min = 10;
    filterVars.hourly_rate_max = 20;
  } else if (jq('#hourly_rate').val() == '20-30') {
    filterVars.hourly_rate_min = 20;
    filterVars.hourly_rate_max = 30;
  } else if (jq('#hourly_rate').val() == '30-40') {
    filterVars.hourly_rate_min = 30;
    filterVars.hourly_rate_max = 40;
  } else if (jq('#hourly_rate').val() == '40') {
    filterVars.hourly_rate_min = 41; // > 40
  }
  jq('.selected_skill').each(function () {
    filterVars.job_names.push(jq(this).children(':first-child').html());

    filterVars.jobs.push(jq(this).attr('value'));
  });

  jq('.selected_country').each(function (index, value) {
    filterVars.countries.push(value.getAttribute('value'));
  });
  jq('.selected_exam').each(function (index, value) {
    filterVars.exams.push(value.getAttribute('value'));
  });
  if (jq('#online_only').is(':checked')) {
    filterVars.online_only = true;
  }
  var latitude = jq('#input-location-lat').val();
  var longitude = jq('#input-location-lng').val();
  filterVars.latlon = [];
  if (latitude && longitude) {
    filterVars.latlon = [latitude, longitude];
    filterVars.location = latitude + ',' + longitude;
  }
  if (freeSearchString) {
    filterVars.freeSearch = freeSearchString;
  }
}

function clearEntries() {
  jq('#freelancer_list').addClass('hide').html('');
  jq('.extended-freelancer-list').addClass('hide');
  jq('ul.extended-freelancer-list').html('');
}
/**
   * New function to add dependencies that used to be global
   */
function addDependencies(item) {
  item.getUserIdfromCookie = getUserIdfromCookie;
  item.cdn_url = cdn_url;
  item.T_ = translate;
}
function addEntry(item) {
  addDependencies(item);
  jq('#freelancer_list').removeClass('hide').append(freelancerlistItem(item));
}

function addEntryExtended(item) {
  addDependencies(item);
  jq('#extended_freelancer_list').append(freelancerlistItem(item));
}

function showNoEntry() {
  var noEntryText = '<div class="alert alert-info"><h4>' + (translate('Desculpe, não pudemos encontrar quaisquer Freelancers correspondentes.') + '</h4>');
  if (jq('#online_only').is(':checked')) {
    noEntryText += translate('Você pode <a id="remove_online_filter">ampliar a sua busca on-line</a> não restringindo a Freelancers on-line.');
  } else {
    noEntryText += translate('Por favor, modifique sua pesquisa e tente novamente.') + '</div>';
  }
  jq('#freelancer_list').removeClass('hide').html(noEntryText);
  jq('#freelancer_list').parent().find('p').hide();
}

function clearSponsorEntries() {
  jq('#sponsor_header').hide();
  jq('#sponsor_list').html('');
  jq('#sponsor_list').hide();
}

function addSponsorEntry(item) {
  addDependencies(item);
  jq('#sponsor_list').append(freelancerlistItem(item));
}

function pageSelectCallback(pageIndex) {
  filterVars = {
    countries: [],
    exams: [],
    jobs: [],
    job_names: [],
    hourly_rate_min: undefined,
    hourly_rate_max: undefined,
    history_range: undefined,
    online_only: undefined,
    freeSearch: undefined };

  getFilterVars(filterVars);
  var offset = pageIndex * 10;

  if (typeof xhr === 'object') {
    xhr.abort();
  }

  xhr = jq.ajax({
    type: 'get',
    url: '/ajax/directory/getFreelancer.php',
    data: {
      jobs: filterVars.jobs,
      countries: filterVars.countries,
      exams: filterVars.exams,
      hourly_rate_min: filterVars.hourly_rate_min,
      hourly_rate_max: filterVars.hourly_rate_max,
      star_rating: starRating,
      history_range: filterVars.history_range,
      offset: offset,
      online_only: filterVars.online_only,
      freeSearch: filterVars.freeSearch,
      location: filterVars.location },

    dataType: 'json',
    beforeSend: function beforeSend() {
      var listHeight = jq('#freelancer_list').height();
      jq('#processing_div').css('padding-top', listHeight * 0.2 + 'px').height(listHeight * 0.8 + 'px').show();
      jq('#freelancer_list').addClass('processing');

      updatePageTitleAndHeader(filterVars, pageIndex + 1);
    },
    success: function success(msg) {
      if (seoURL$1 && window.history && typeof window.history.pushState === 'function') {
        window.history.pushState('object or dafd', 'Title', '/freelancers' + seoURL$1 + '/' + (pageIndex + 1) + window.location.search);
      }
      if (msg != null && msg.status == 'success') {
        clearEntries();
        _.each(msg.users, function (item) {
          item.is_admin = is_admin;
          addEntry(item);
          if (item.is_online) {
            onlineoffline.set_status(item.user_id, online_status_code);
          } else {
            onlineoffline.set_status(item.user_id, offline_status_code);
          }
        });
        drawMap(msg.users, filterVars.latlon);
        initEarningTooltips();
        // onlineoffline register
        onlineoffline.sub(msg.user_ids);

        highlightSearchKeyword(msg.BOLD_TAG_LEFT, msg.BOLD_TAG_RIGHT);
        searchSource = 'page selection';
      } else {
        clearEntries();
        drawMap([]);
        showNoEntry();
        jq('.ns_pagination').hide();
      }

      trackSearch(filterVars.freeSearch);
    },
    error: function error(jqXHR, status) {
      if (status === 'abort') {
        return;
      }
      clearEntries();
      drawMap([]);
      showNoEntry();
      jq('.ns_pagination').hide();
    },
    complete: function complete() {
      jq('#processing_div').hide();
      jq('#freelancer_list').removeClass('processing');
      jq('body').animate({ scrollTop: 0 });
      initialSeeMore('freelancerList');
    } });

  return false;
}

function getFacets() {
  var filterVars = {
    countries: [],
    exams: [],
    jobs: [],
    job_names: [],
    hourly_rate_min: undefined,
    hourly_rate_max: undefined,
    history_range: undefined };

  getFilterVars(filterVars);
  updateContinentLink(filterVars.jobs);
  jq.ajax({
    type: 'GET',
    url: '/ajax/directory/getFacets.php',
    data: {
      jobs: filterVars.jobs,
      countries: filterVars.countries,
      exams: filterVars.exams,
      hourly_rate_min: filterVars.hourly_rate_min,
      hourly_rate_max: filterVars.hourly_rate_max,
      star_rating: starRating },

    dataType: 'json',
    success: function success(result) {
      if (result.status == 'success') {
        (function () {
          var skills = result.facets;
          if (skills != null) {
            (function () {
              jq('#seo_skill').html('');

              var id = void 0;
              var name = void 0;

              // Lint: Don't make functions within a loop
              var runEach = function runEach(e) {
                if (e.id == id) {
                  name = e.name;
                  return {};
                }
              };

              if (skills) {
                Object.keys(skills).forEach(function (i) {
                  var jobArray = filterVars.jobs.slice(0);
                  id = skills[i].id;
                  if (jobArray.indexOf(id) < 0) {
                    jobArray.push(id);
                    var url = getSeoLink(jobArray, filterVars.countries);
                    name = '';

                    _.each(mapped_jobs, runEach);

                    jq('#seo_skill').append(seoSkillTemplate({ url: url, name: name }));
                  }
                });
              }
            })();
          }
        })();
      }
    } });
}

function isNumeric(n) {
  return !Number.isNaN(parseFloat(n)) && Number.isFinite(n);
}

function getSponsoredHilightInfo(skillIDs, selfSponsoredRecentlySkillID) {
  // get country
  var countries$$1 = [];
  var selfSponsorUncheckedSkillIDs = [];
  jq('.selected_country').each(function (index, value) {
    countries$$1.push(value.getAttribute('value'));
  });
  if (typeof getSponsorInfoAjaxRequest !== 'undefined') {
    getSponsorInfoAjaxRequest.abort();
  }
  for (var i = 0; i < abortedRequestUncheckedSkillIDs.length; i++) {
    selfSponsorUncheckedSkillIDs.push(abortedRequestUncheckedSkillIDs[i]);
  }
  for (var _i = 0; _i < skillIDs.length; _i++) {
    if (typeof sponsorInfo[skillIDs[_i]] === 'undefined') {
      selfSponsorUncheckedSkillIDs.push(skillIDs[_i]);
      abortedRequestUncheckedSkillIDs.push(skillIDs[_i]);
    }
  }
  if (typeof selfSponsoredRecentlySkillID !== 'undefined') {
    selfSponsorUncheckedSkillIDs.push(selfSponsoredRecentlySkillID);
    abortedRequestUncheckedSkillIDs.push(selfSponsoredRecentlySkillID);
  }

  selfSponsorUncheckedSkillIDs = _.uniq(selfSponsorUncheckedSkillIDs);
  abortedRequestUncheckedSkillIDs = _.uniq(abortedRequestUncheckedSkillIDs);
  getSponsorInfoAjaxRequest = jq.ajax({
    type: 'GET',
    url: '/ajax/directory/sponsoredHilightInfo.php',
    cache: false,
    data: {
      skillIDs: skillIDs,
      selfSponsorUncheckedSkillIDs: selfSponsorUncheckedSkillIDs },

    dataType: 'json',
    beforeSend: function beforeSend() {},
    success: function success(msg) {
      var showSponsor = false;
      if (msg.status == 'success') {
        abortedRequestUncheckedSkillIDs.length = 0;
        if (msg.count > 0) {
          _.each(msg.users, function (item) {
            item.is_admin = is_admin;
            addSponsorEntry(item);
            onlineoffline.sub(item.user_id);
            showSponsor = true;
          });
          if (showSponsor) {
            jq('#sponsor_header').show();
            jq('#sponsor_list').show();
          } else {
            jq('#sponsor_header').hide();
            jq('#sponsor_list').hide();
          }
        } else {
          jq('#sponsor_header').hide();
          jq('#sponsor_list').hide();
        }
        jq('.curr_sign').html(msg.currency.sign);
        jq('.curr_code').html(msg.currency.code);
        for (var _i2 = 0; _i2 < msg.selfSponsorInfo.length; _i2++) {
          sponsorInfo[msg.selfSponsorInfo[_i2].id] = msg.selfSponsorInfo[_i2];
        }
        var showSponsorBox = false;
        var sponsorBox = jq('#sponsor-hilight-box');
        var template = sponsorBoxTemplate;

        // SponsorBox maybe null if disabled by feature flag `sponsoredUpgrade`
        // in which case we do not bother trying to render it.
        if (sponsorBox && Object.keys(sponsorInfo).length) {
          currencyDetails = {
            id: msg.currency.id,
            code: msg.currency.code,
            sign: msg.currency.sign };

          var sponsorBoxHTML = _.template(template)({
            sponsorInfo: sponsorInfo,
            selectedSkillIDs: skillIDs,
            currency: msg.currency,
            abtestRestrictedSkills: ['3', '69', '38'],
            T_: translate,
            jq: jq,
            cdn_url: cdn_url });

          sponsorBox.html(sponsorBoxHTML);

          var sponsorExists = sponsorBox.find('.sponsor-skill-entry').length;
          if (sponsorExists) {
            sponsorBox.show();
            var newTop = sponsorBox.height() / 3 * 2 + sponsorBox.offset().top - jq('#freelancer-content').offset().top;
            jq('#sponsor_menu_arrow').css('top', newTop + 'px').show();
            initTooltipForSponsoredListing();
            showSponsorBox = true;
          }
          var selectAnotherSkill = jq('#select-another-skill');
          if (jq('.selected_skill').length > 0) {
            selectAnotherSkill.hide();
          } else {
            selectAnotherSkill.show();
          }
        }
        if (!showSponsorBox) {
          sponsorBox.html('').hide();
          jq('#sponsor_menu_arrow').hide();
        }
      }
    },
    complete: function complete() {
      initialSeeMore('sponsorList');
    } });
}

function initTooltipForSponsoredListing() {
  var sponsorInfo = jq('.sponsor_info');

  sponsorInfo.popover({
    delay: { show: 200, hide: 1 },
    trigger: 'hover',
    placement: 'top',
    title: translate('Listagem  patrocinada'),
    content: jq('#sponsor_tooltip').html(),
    html: true });
}

function drawMap(users, latlon) {
  var canvas = 'freelancers-map-canvas';
  var $mapEl = jq('#' + canvas);
  gmap$2.clearMarkers();
  if (users.length === 0 || latlon.length === 0) {
    $mapEl.hide();
  } else {
    var mapConfig = {};
    mapConfig.canvas = canvas;
    mapConfig.center = { lat: latlon[0], lon: latlon[1] };
    gmap$2.init(mapConfig);
    jq.each(users, function (i, user) {
      user.T_ = translate;
      var marker = {};
      marker.lat = user.location.lat;
      marker.lon = user.location.lon;
      marker.title = user.username;
      marker.icon = '/static/css/images/FreelancerPin24x24px.png';
      marker.infowindowHTML = _.template(freelancerInfowindowTemplate)(user);
      gmap$2.addMarker(marker);
    });
    $mapEl.show();
  }
}

function getFreelancers(getSponsorHilight) {
  filterVars = {
    countries: [],
    exams: [],
    jobs: [],
    job_names: [],
    hourly_rate_min: undefined,
    hourly_rate_max: undefined,
    history_range: undefined,
    online_only: undefined,
    freeSearch: undefined,
    location: undefined };

  getFilterVars(filterVars);
  if (getSponsorHilight == true) {
    (function () {
      var skillIDs = [];
      jq('.selected_skill').each(function () {
        var skillID = jq(this).attr('value');
        if (skillID) {
          skillIDs.push(skillID);
        }
      });
      if (skillIDs.length > 0) {
        getSponsoredHilightInfo(skillIDs);
      } else {
        jq('#sponsor-hilight-box').html('').hide();
        jq('#sponsor_menu_arrow').hide();
      }
    })();
  }

  clearSponsorEntries();

  if (typeof xhr === 'object') {
    xhr.abort();
  }

  // Keep the profile description under the maximum size.
  var truncateProfileDescription = function truncateProfileDescription(item, maxSize) {
    item.about = item.profile;
    if (item.about.length > maxSize) {
      item.about = item.about.substring(0, maxSize - 3);
      item.about += '...';
    }
  };

  xhr = jq.ajax({
    type: 'get',
    url: '/ajax/directory/getFreelancer.php',
    data: {
      jobs: filterVars.jobs,
      countries: filterVars.countries,
      exams: filterVars.exams,
      hourly_rate_min: filterVars.hourly_rate_min,
      hourly_rate_max: filterVars.hourly_rate_max,
      star_rating: starRating,
      history_range: filterVars.history_range,
      online_only: filterVars.online_only,
      freeSearch: filterVars.freeSearch,
      location: filterVars.location },

    dataType: 'json',
    beforeSend: function beforeSend() {
      var listHeight = jq('#freelancer_list').height();
      jq('#processing_div').css('padding-top', listHeight * 0.2 + 'px').height(listHeight * 0.8 + 'px').show();
      jq('#freelancer_list').addClass('processing');
      jq('#filter_div').css('opacity', 0.6);

      updatePageTitleAndHeader(filterVars, 1);

      seoURL$1 = getSeoLink(filterVars.jobs, filterVars.countries);

      // for pagination
      if (seoURL$1 && window.history && typeof window.history.pushState === 'function') {
        window.history.pushState('object or dafd', 'Title', '/freelancers' + seoURL$1 + window.location.search);
      }

      freelancerSearchQTS('/freelancers' + seoURL$1);
    },
    success: function success(msg) {
      resultsCount = msg.count;
      if (msg != null && msg.status == 'success') {
        // set number of search results
        updateResultCount(msg.count);
        if (msg.count > 0) {
          // has freelancers, getfacets and update seo div
          getFacets();
        }
        clearEntries();
        _.each(msg.users, function (item) {
          // T77128 - Replace snippet of description with the truncated profile description.
          // TODO: T85296 - Improvement needed for better display of highlighted result.
          truncateProfileDescription(item, msg.max_truncated_description_size);

          item.is_admin = is_admin;
          addEntry(item);
          if (item.is_online) {
            onlineoffline.set_status(item.user_id, online_status_code);
          } else {
            onlineoffline.set_status(item.user_id, offline_status_code);
          }
        });

        // Include offline freelancers if less than 1 page of online-only
        // freelancers are found
        if (enableExtendedSearch && filterVars.online_only && msg.users.length < resultsPerPage) {
          getFreelancersExtended(msg.users);
        } else {
          drawMap(msg.users, filterVars.latlon);
          initEarningTooltips();

          // onlineoffline register
          onlineoffline.sub(msg.user_ids);
        }

        var numEntries = msg.count;
        jq('#freelancer-display-num').html(numEntries);
        jq('#freelancer-display-num').parent().show();
        jq('.ns_pagination').pagination(numEntries, {
          callback: pageSelectCallback,
          items_per_page: 10 });

        jq('.ns_pagination').show();
        highlightSearchKeyword(msg.BOLD_TAG_LEFT, msg.BOLD_TAG_RIGHT);
      } else {
        updateResultCount(false);
        clearEntries();
        // Include offline freelancers if less than 1 page of online-only
        // freelancers are found
        if (enableExtendedSearch && filterVars.online_only && typeof msg === 'object' && msg.msg === 'No users found') {
          getFreelancersExtended([]);
        } else {
          drawMap([]);
          showNoEntry();
        }
        jq('.ns_pagination').hide();
      }
      trackSearch(filterVars.freeSearch);
    },
    error: function error(jqXHR, status) {
      if (status === 'abort') {
        return;
      }
      updateResultCount(false);
      clearEntries();
      drawMap([]);
      showNoEntry();
      jq('.ns_pagination').hide();
    },
    complete: function complete() {
      jq('#filter_div').css('opacity', 1);
      jq('#processing_div').hide();
      jq('#freelancer_list').removeClass('processing');
      if (filterVars.job_names.length > 0) {
        jq('#job_name').html(filterVars.job_names.toString());
      } else {
        jq('#job_name').html(' all skills');
      }
      if (filterVars.countries.length !== 0) {
        jq('#area_name').html(' over ' + filterVars.countries.toString());
      } else {
        jq('#area_name').html('');
      }
      initialSeeMore('freelancerList');
    } });
}

// Search for offline-only freelancers
function getFreelancersExtended(users) {
  filterVars = {
    countries: [],
    exams: [],
    jobs: [],
    job_names: [],
    hourly_rate_min: undefined,
    hourly_rate_max: undefined,
    history_range: undefined,
    offline_only: true,
    freeSearch: undefined,
    location: undefined };

  getFilterVars(filterVars);

  var keyword = jq('#freeSearchInput').val().trim();

  if (typeof xhr === 'object') {
    xhr.abort();
  }

  xhr = jq.ajax({
    type: 'get',
    url: '/ajax/directory/getFreelancer.php',
    data: {
      jobs: filterVars.jobs,
      countries: filterVars.countries,
      exams: filterVars.exams,
      hourly_rate_min: filterVars.hourly_rate_min,
      hourly_rate_max: filterVars.hourly_rate_max,
      star_rating: starRating,
      history_range: filterVars.history_range,
      offline_only: filterVars.offline_only,
      freeSearch: filterVars.freeSearch,
      location: filterVars.location,
      limit: resultsPerPage - users.length },

    dataType: 'json',
    success: function success(msg) {
      if (msg === null || typeof msg === 'object' && msg.status !== 'success' || msg.count <= 0) {
        if (!users.length) {
          clearEntries();
          updateResultCount(false);
          drawMap([]);
          showNoEntry();
        }
        return;
      }

      jq('.extended-freelancer-list-keywords').text(keyword);

      var onlineOfflineStatusCode = void 0;
      _.each(msg.users, function (item) {
        item.is_admin = is_admin;
        addEntryExtended(item);
        onlineOfflineStatusCode = item.is_online ? online_status_code : offline_status_code;
        onlineoffline.set_status(item.user_id, onlineOfflineStatusCode);
      });

      var extendedListId = ['ul.extended-freelancer-list', filterVars.freeSearch ? 'h4.extended-freelancer-list.list-with-keywords' : 'h4.extended-freelancer-list.list-without-keywords'];

      jq(extendedListId.join(',')).removeClass('hide');

      drawMap(users.concat(msg.users), filterVars.latlon);
      initEarningTooltips();

      // onlineoffline register
      onlineoffline.sub(msg.user_ids);

      highlightSearchKeyword(msg.BOLD_TAG_LEFT, msg.BOLD_TAG_RIGHT);
    },
    complete: function complete() {
      initialSeeMore('extendedFreelancerList');
    } });
}

function freelancerSearchQTS(pagePushStateLocation) {
  // qts for directory/hireme
  var freeSearchParams = {
    label: 'search',
    section: 'freelancer_listing',
    action: 'filter',
    page: pagePushStateLocation,
    name: searchSource.replace(/ /g, '_'),
    location: window.location.host + pagePushStateLocation };

  switch (freeSearchParams.name) {
    case 'skills_filter':
    case 'remove_skill_filter':
      {
        var _ret4 = function () {
          var skillName = [];

          if (filterVars.jobs) {
            Object.keys(filterVars.jobs).forEach(function (scount) {
              var jobId = filterVars.jobs[scount];
              var thisJob = mapped_jobs[jobId];
              skillName.push(thisJob.name);
            });
          }

          freeSearchParams.skill_category = jq('#skill_category').val();
          freeSearchParams.skill_subcategory = jq('#skill_subcategory').val();

          freeSearchParams.value = skillName.toString();
          return 'break';
        }();

        if (_ret4 === 'break') break;
      }
    case 'exam_filter':
    case 'remove_exam_filter':
      freeSearchParams.value = filterVars.exams;
      break;
    case 'keyword':
      freeSearchParams.value = filterVars.freeSearch;
      break;
    case 'online_users_filter':
      freeSearchParams.value = filterVars.online_only ? 'online_on' : 'online_off';
      break;
    case 'rating_filter':
      freeSearchParams.value = starRating;
      break;
    case 'country_filter':
      freeSearchParams.value = filterVars.countries;
      break;
    case 'hourly_rate_filter':
      freeSearchParams.value = jq('#hourly_rate option:selected').text();
      break;
    case 'remove_country_filter':
    case 'remove_location_filter':
    case 'remove_rating_filter':
    case 'remove_hourly_rate_filter':
      break;
    default:
    // do nothing
  }

  _t.push(['user_action', freeSearchParams]);
}

function highlightSearchKeyword(BOLD_TAG_LEFT, BOLD_TAG_RIGHT) {
  var truncProfileTexts = jq('ul.ns_freelancer-list > li > .freelancer-details ' + '> .bio.truncProfile > .profile_text');

  for (var i = 0; i < truncProfileTexts.length; i++) {
    var truncProfile = jq(truncProfileTexts[i]);
    truncProfile.html(truncProfile.html().replace(new RegExp(BOLD_TAG_LEFT, 'g'), '<strong>').replace(new RegExp(BOLD_TAG_RIGHT, 'g'), '</strong>'));
  }
}

function initialSeeMore(list) {
  var selector = '.ns_freelancer-list';
  if (typeof list !== 'undefined') {
    switch (list) {
      case 'sponsorList':
        selector = '#sponsor_list';
        break;
      case 'freelancerList':
        selector = '#freelancer_list';
        break;
      case 'extendedFreelancerList':
        selector = '#extended_freelancer_list';
        break;
      default:
      // do nothing
    }
  }

  var profiles = jq('ul' + selector + ' > li');
  for (var i = 0; i < profiles.length; i++) {
    var profile = jq(profiles[i]);
    var truncProfile = profile.find(' bio.truncProfile > span.profile_text');
    var cleanProfile = profile.find(' bio.cleanProfile > span.profile_text');
    var truncProfileText = truncProfile.text().trim();
    var cleanProfileText = cleanProfile.text().trim();

    if (truncProfileText.length < cleanProfileText.length) {
      // add ... in the front
      if (cleanProfileText.substr(0, 5) != truncProfileText.substr(0, 5)) {
        truncProfile.html('... ' + truncProfile.html());
      }
      // add ... in the end
      // if clearnText != truncProfile at the end
      if (cleanProfileText.substr(cleanProfileText.length - 5, 5) !== truncProfileText.substr(truncProfileText.length - 5, 5)) {
        // if trunText last 4 chars is not ' ...'
        if (truncProfileText.substr(truncProfileText.length - 4, 4) !== ' ...') {
          truncProfile.html(truncProfile.html() + ' ...');
        }
      }
      truncProfile.siblings('a.seeMore').show();
    }
  }
}

function init$9() {
  appendAllCountries(countries);
  appendAllExams(exams);
  DirKeyControl.bindSelected();
  initialSeeMore();
}

function initEarningTooltips() {
  jq('.Earnings').tooltip();
}

function getSkillsFromSelectorCallback(paramObj) {
  jq('#selected_skills_div').html('');
  for (var i = 0; i < paramObj.selectedSkills.length; ++i) {
    jq('#selected_skills_div').append(skillBubbleTmpl({
      id: paramObj.selectedSkills[i].id,
      name: paramObj.selectedSkills[i].name,
      default_type: false,
      T_: translate }));
  }
  jq('#job_select_div').trigger('mouseleave');
  toggleNoSkillSponsorUpsell();
  searchSource = 'skills filter';
  getFreelancers(true);
}

function toggleNoSkillSponsorUpsell() {
  if (typeof sponsoredUpsellSkillIds !== 'undefined' && sponsoredUpsellSkillIds !== null && sponsoredUpsellSkillIds.length > 0 && jq('.selected_skill').length < 1) {
    getSponsoredHilightInfo(sponsoredUpsellSkillIds);
  }
}

function toggleOnlineBubble() {
  if (jq('#online_only').is(':checked')) {
    jq('#online_only_div').html(onlineBubbleTmpl({ T_: translate }));
  } else {
    jq('#online_only_div').html('');
  }
}

function freeSearch(searchString) {
  if (typeof searchString === 'undefined' || searchString === null) {
    freeSearchString = jq('#freeSearchInput').val().trim();
  } else {
    freeSearchString = searchString;
  }
  jq('#selected_freeSearch_div').html(freeSearchString == '' ? '' : freeSearchBubbleTmpl({ value: freeSearchString, T_: translate }));

  searchSource = 'keyword';
  getFreelancers(true);
}

function trackSearch(keyword) {
  keyword = keyword || '';
  var criteriaObj = {};
  jq('.selected-criteria a').each(function () {
    var criteria = jq(this).closest('ul').attr('id');
    criteria = criteria.replace('_div', '');
    var criteriaValue = jq(this).attr('value');

    if (criteria == 'selected_skills' || criteria == 'selected_exams' || criteria == 'selected_country') {
      if (!criteriaObj[criteria]) {
        criteriaObj[criteria] = [];
      }
      criteriaObj[criteria].push(criteriaValue);
    } else if (jq(this).attr('value')) {
      criteriaObj[criteria] = criteriaValue;
    } else {
      criteriaObj[criteria] = true;
    }
  });

  var filters = JSON.stringify(criteriaObj);
  var itemsDisplayed = jq('#freelancer_list li.ns_result').length;
  var itemsCount = resultsCount || total_freelancers;
  var itemsPage = jq('#freelancer-content .pagination a.current:nth(1)').text() ? jq('#freelancer-content .pagination a.current:nth(1)').text() : 1;

  _lt.push({
    event: 'Directory Page Search',
    source: searchSource,
    keyword: keyword,
    filters: filters,
    items_displayed: itemsDisplayed,
    items_count: itemsCount,
    items_page: itemsPage });
}

function trackSearchAction(index, ref, refId, label) {
  var criteriaObj = {};
  jq('.selected-criteria a').each(function () {
    var criteria = jq(this).closest('ul').attr('id');
    criteria = criteria.replace('_div', '');
    var criteriaValue = jq(this).attr('value');

    if (criteria == 'selected_skills' || criteria == 'selected_exams' || criteria == 'selected_country') {
      if (!criteriaObj[criteria]) {
        criteriaObj[criteria] = [];
      }
      criteriaObj[criteria].push(criteriaValue);
    } else if (jq(this).attr('value')) {
      criteriaObj[criteria] = criteriaValue;
    } else {
      criteriaObj[criteria] = true;
    }
  });

  var filters = JSON.stringify(criteriaObj);
  var itemsDisplayed = jq('#freelancer_list li.ns_result').length;
  var itemsCount = resultsCount || total_freelancers;
  var currentPage = jq('#freelancer-content .pagination a.current:nth(1)').text();
  var itemsPage = currentPage || 1;
  var keyword = freeSearchString || '';

  var freeSearchParams = {
    keyword: keyword,
    section: 'Directory',
    subsection: index,
    filters: filters,
    items_displayed: itemsDisplayed,
    items_page: itemsPage,
    items_count: itemsCount,
    label: label,
    reference: ref,
    reference_id: refId };

  _t.push(['search_action', freeSearchParams]);
}

var allowHireMeTracking = true;
function ttrefTracking(trackEvent) {
  if (allowHireMeTracking) {
    allowHireMeTracking = false;
    window._ttref.push(['_clearEntrypoint', 'ProjectHireMe']);
    window._ttref.push(['_setCookie', 'ProjectHireMe_DirectoryPage']);
    window._ttref.push(['_trackEvent', 'ProjectHireMe', trackEvent]);
    setTimeout(function () {
      allowHireMeTracking = true;
    }, 100);
  }
}

function getCurrentItemIndex(el) {
  var currentItem = el.closest('.ns_result');
  var currentItemIndex = parseInt(jq('#freelancer_list .ns_result').index(currentItem), 10) + 1;
  return currentItemIndex;
}

/**
   * Build a list phrase from an array of string.
   *
   * @param    {array}   list            List of strings
   * @param    {string}  connector       String connecting the list, eg, comma ", "
   * @param    {string}  finalConnector  String connecting the last element of a list, eg, " and "
   * @returns  {string}  Phrase list of jobs
   */
function buildListPhrase(list) {
  var connector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ', ';
  var finalConnector = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ' and ';

  var arr = list.slice(); // Shallow copy to avoid modifying the source
  var last = arr.pop();
  return [arr.join(connector), last].filter(function (str) {
    return !!str;
  }).join(finalConnector);
}

/**
   * Update the HTML title and directory header based on the skills and countries
   * filters, and page. Calls either updatePageTitleAndHeaderEnglish() or
   * updatePageTitleAndHeaderNonEnglish() depending on user language.
   *
   * @param    {array}   filterVars  Filters passed
   * @param    {number}  page        Page number
   */
function updatePageTitleAndHeader(filterVars, page) {
  if (userLanguage == 'en') {
    updatePageTitleAndHeaderEnglish(filterVars, page);
  } else {
    updatePageTitleAndHeaderNonEnglish(filterVars);
  }
}

/**
   * Update the HTML title and directory header based on the skills and countries
   * filters, and page. This is only for users that set their language to English.
   * There should be no translations involved due to certain limitations /
   * restrictions.
   *
   * @param    {array}   filterVars  filters passed
   * @param    {number}  page        Page number
   */
function updatePageTitleAndHeaderEnglish(filterVars, page) {
  var htmlTitle = [];
  var directoryTitle = [];

  if (!filterVars.jobs.length) {
    htmlTitle.push('Freelancers');
    directoryTitle.push('Freelancers');
  } else {
    var jobs = getJobNames(filterVars.jobs);
    htmlTitle.push(jobs.join(' '));

    jobs = getJobNames(filterVars.jobs, 'plural_phrase_worker');
    jobs = buildListPhrase(jobs);
    directoryTitle.push(jobs);
  }

  if (!filterVars.countries.length) {
    directoryTitle.push('For Hire');
  } else {
    var _countries = buildListPhrase(filterVars.countries);
    htmlTitle.push('in ' + _countries);
    directoryTitle.push('for hire in ' + _countries);
  }

  htmlTitle.push('For Hire | Freelancer');
  htmlTitle.push(page > 1 ? '- Page ' + page : '');
  htmlTitle.filter(function (str) {
    return !!str;
  });
  // jq(title) doesn't work in IE8.
  document.title = htmlTitle.join(' ');

  directoryTitle.push(page > 1 ? '- Page ' + page : '');
  directoryTitle.filter(function (str) {
    return !!str;
  });
  jq('#directory_title').html(directoryTitle.join(' '));
}

/**
   * Update the HTML title and directory header based on the skills and countries
   * filters, and page.
   *
   * @param    {array}  filterVars  Filters passed
   */
function updatePageTitleAndHeaderNonEnglish(filterVars) {
  var htmlTitle = [];

  if (filterVars.jobs.length) {
    var jobs = getJobNames(filterVars.jobs, undefined, 'seoworker1');
    htmlTitle.push(jobs.join(' '));
  }

  if (!htmlTitle.length) {
    htmlTitle.push('Freelancers');
  }

  htmlTitle.push('For Hire');

  if (filterVars.countries.length) {
    var _countries2 = filterVars.countries.join(' ');
    htmlTitle.push('in ' + _countries2);
  }

  htmlTitle.push('| Freelancer');
  htmlTitle.filter(function (str) {
    return !!str;
  });
  // jq(title) doesn't work in IE8.
  document.title = htmlTitle.join(' ');

  jq('#directory_title').html(translate(_templateObject3$3));
}

/**
   * Primarily used in updatePageTitleAndHeader*() functions, this retrieves the
   * names of the jobs that will be used to build the list phrase. The name source
   * is looked-up in mapped_jobs[id].
   *
   * @param    {array}   jobs  List of job ids
   * @param    {string}  key   Key name
   * @returns  {array}   List of job names
   */
function getJobNames(jobIds) {
  var jobNameKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'name';
  var lastJobNameKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'plural_phrase_worker';

  // Shallow copy to avoid modifying the source
  var jobs = jobIds.slice();
  var job = jobs.pop();
  jobs.forEach(function (jobId, key) {
    jobs[key] = mapped_jobs[jobId][jobNameKey];
  });
  job = mapped_jobs[job][lastJobNameKey];
  jobs.push(job);
  return jobs;
}

/**
   * Update the result count displayed.
   *
   * If the count is falsy, the result count display is hidden.
   *
   * @param   {number|mixed}  count  number of results, or falsy value to hide
   * @return  {void}
   */
function updateResultCount(count) {
  var jqResultAmount = jq('.result-amount');
  if (!count) {
    jqResultAmount.text('').hide();
    return;
  }

  var countTxt = count == 1 ? translate('Showing <%- num %> result', { num: count }) : translate('Showing <%- num %> results', { num: count });
  jqResultAmount.text(countTxt).show();
}

jq(document).ready(function () {
  if (selected_users_info != null && selected_users_info.length !== 0) {
    // manually set the status
    _.each(selected_users_info, function (item) {
      if (item.is_online == true) {
        onlineoffline.set_status(item.user_id, online_status_code);
      } else {
        onlineoffline.set_status(item.user_id, offline_status_code);
      }
    });
  }

  if (total_freelancers == 0) {
    showNoEntry();
  }

  toggleOnlineBubble();
  toggleNoSkillSponsorUpsell();

  // Initialize skill selector form
  skillSelectorForm.createSelector({
    parent: jq('#skill_selector_div'),
    template: 'directory',
    skillCategoryBundle: categoriesBundle,
    skillDropdownList: mapped_jobs,
    skillCategoryMap: category_job_map,
    onSkillSelectedCallback: getSkillsFromSelectorCallback,
    onAllSkillsSelectedCallback: function onAllSkillsSelectedCallback() {
      jq('#selected_skills_div').html('');
    } });

  jq('.star-rating').rating({
    callback: function callback(value) {
      if (value) {
        jq('.star-rating').data('rating').required = false;
      } else {
        jq('.star-rating').data('rating').required = true;
      }
      var name = void 0;
      if (value == 1) {
        name = translate('1 estrela');
      } else {
        name = translate('<%- num %> estrelas', { num: value });
      }
      if (value > 0) {
        jq('#selected_star_div').html(starBubbleTmpl({ value: value, name: name, T_: translate }));
      } else {
        jq('#selected_star_div').html('');
      }
      starRating = value;
      searchSource = 'rating filter';
      getFreelancers(true);
    },
    cancel: translate('Redefinir') });

  jq('.rating-cancel').hide();
  jq('#country_select_div').slimScroll({
    height: '200px' });

  jq('#exam_select_div').slimScroll({
    height: '200px' });

  init$9();
  jq('.ns_pagination').pagination(total_freelancers, {
    callback: pageSelectCallback,
    items_per_page: 10,
    current_page: cur_page - 1 });

  initEarningTooltips();
  var ftl = {
    countries: [],
    exams: [],
    jobs: [],
    job_names: [],
    hourly_rate_min: undefined,
    hourly_rate_max: undefined,
    history_range: undefined };

  getFilterVars(ftl);
  if (ftl.jobs.length) {
    getSponsoredHilightInfo(ftl.jobs);
  }

  initTooltipForSponsoredListing();

  var clearLocationInfo = function clearLocationInfo() {
    jq('#input-location').val('');
    jq('#input-location-lat').val('');
    jq('#input-location-lng').val('');
  };

  var updateLatLngFromGeoInfo = function updateLatLngFromGeoInfo(geoInfo) {
    jq('#input-location-lat').val(geoInfo.lat);
    jq('#input-location-lng').val(geoInfo.lng);
    appendLocalSearchItem();
    getFreelancers(true);
  };

  geocoding.init({
    autoCompleteElement: 'input-location',
    autoCompleteCallback: updateLatLngFromGeoInfo,
    reverseGeocodingElement: 'location_select_reset',
    reverseGeocodingSuccessCallback: updateLatLngFromGeoInfo });

  // Register 'Countries' event listeners
  // running anonymous function to become foldable on most editors
  (function () {
    jq('#input-country').on('focusin', function () {
      jq('#country_select_wrap').show();
      DirKeyControl.setFirstSelected('country');
    }).on('keyup', function (e) {
      var _this = this;

      if (!DirKeyControl.KEY.isFunctionKey(e)) {
        (function () {
          var input = jq(_this).val().toLowerCase();
          jq('#country_select').html('');
          if (input == '') {
            appendAllCountries(countries);
          } else if (countries) {
            Object.keys(countries).forEach(function (i) {
              if (countries[i].name.toLowerCase().indexOf(input) !== -1) {
                appendCountryItem(countries[i]);
              }
            });
          }
          DirKeyControl.setFirstSelected('country');
        })();
      }
    }).on('keydown', function (e) {
      if (DirKeyControl.KEY.isFunctionKey(e)) {
        DirKeyControl.navigation(e.which, 'country');
      }
    }).bind('clickoutside', function () {
      if (jq('#input-country').val() == '') {
        // nothing selected, list all jobs
        appendAllCountries(countries);
      }
      jq('#country_select_wrap').hide();
    });

    jq('#country_select').on('click', 'li:not(.disabled)', function () {
      jq('#country_select_wrap').hide();
      var name = jq(this).data('value');
      var code = jq(this).data('code');
      var defaultType = false;

      if (name == 'All countries') {
        // select 'All countries'
        // make all the countries selectable
        jq('#country_select .disabled').each(function () {
          jq(this).removeClass('disabled');
        });
        jq('#selected_country_div').html('');
        defaultType = true;
      } else {
        // enable all country in drop list
        jq('#country_ALL_COUNTRIES').removeClass('disabled');
        if (jq('#selected_country_ALL_COUNTRIES').length === 1) {
          jq('#selected_country_ALL_COUNTRIES').parent().remove();
        }

        // if country not selected, append
        if (jq('#selected_country_' + code).length === 1) {
          // the skill has been selected
          jq('#selected_country_' + code).parent().remove();
        }
        jq('#selected_country_div').append(countryBubbleTmpl({ name: name, code: code, default_type: defaultType, T_: translate }));
      }
      jq('#country_select_div').trigger('mouseleave');
      jq(this).addClass('disabled');
      searchSource = 'country filter';
      getFreelancers(true);
    });
  })();

  // Register 'Exams' event listeners
  (function () {
    jq('#input-exam').on('focusin', function () {
      jq('#exam_select_wrap').show();
      DirKeyControl.setFirstSelected('exam');
    }).on('keyup', function (e) {
      if (!DirKeyControl.KEY.isFunctionKey(e)) {
        var input = jq(this).val().toLowerCase();
        jq('#exam_select').html('');
        if (input == '') {
          appendAllExams(exams);
        } else {
          for (var i = 0; i < exams.length; i++) {
            if (exams[i].name.toLowerCase().indexOf(input) !== -1) {
              appendExamItem(exams[i]);
            }
          }
        }
        DirKeyControl.setFirstSelected('exam');
      }
    }).on('keydown', function (e) {
      if (DirKeyControl.KEY.isFunctionKey(e)) {
        DirKeyControl.navigation(e.which, 'exam');
      }
    }).bind('clickoutside', function () {
      if (jq('#input-exam').val() == '') {
        // nothing selected, list all exams
        appendAllExams(exams);
      }
      jq('#exam_select_wrap').hide('fast');
    });

    jq('#exam_select').on('click', 'li:not(.disabled)', function () {
      var name = jq(this).data('value');
      var id = jq(this).data('id');
      var defaultType = false;

      // if exam not selected, append
      if (jq('#selected_exams_' + id).length === 1) {
        // the skill has been selected
        jq('#selected_exams_' + id).parent().remove();
      }
      jq('#selected_exams_div').append(examBubbleTmpl({ name: name, id: id, default_type: defaultType, T_: translate }));

      jq('#exam_select_div').trigger('mouseleave');
      jq(this).addClass('disabled');
      searchSource = 'exam filter';
      getFreelancers(true);
    });
  })();

  // click search to update the freelancers
  jq('#apply').click(function () {
    getFreelancers(true);
  });

  // if click hourly_rate to be customized
  jq('#hourly_rate').change(function () {
    if (jq(this).val() == 'customized') {
      jq('#customized_hourly_rate_div').show();
    } else {
      jq('#customized_hourly_rate_div').hide();
    }
    var val = jq(this).val();
    var name = jq(this).find('option:selected').html();
    name = name.replace('&lt;', '<');
    name = name.replace('&gt;', '>');
    if (val != 0) {
      jq('#selected_rate_div').html(rateBubbleTmpl({
        val: val,
        name: name,
        T_: translate }));
    } else {
      jq('#selected_rate_div').html('');
    }
    searchSource = 'hourly rate filter';
    getFreelancers(true);
  });

  // Bubble event listeners
  (function () {
    // click bubble to delete skill
    jq(document).on('click', '.selected_skill:not(.default_type)', function () {
      var id = parseInt(jq(this).attr('value'), 10);
      // remove the bubble
      jq(this).parent().remove();
      skillSelectorForm.removeSelectedSkill(id);
      searchSource = 'remove skill filter';
      getFreelancers(true); // refresh
      toggleNoSkillSponsorUpsell();
    });

    // click bubble to delete local search
    jq('#selected_location_div').on('click', '.selected_location:not(.default_type)', function () {
      jq(this).parent().remove();
      clearLocationInfo();
      searchSource = 'remove location filter';
      getFreelancers(true); // refresh
    });

    // click bubble to delete country
    jq('#selected_country_div').on('click', '.selected_country:not(.default_type)', function () {
      jq(this).parent().remove();
      searchSource = 'remove country filter';
      getFreelancers(true); // refresh
      var code = jq(this).attr('id').replace('selected_country_', '');
      jq('#country_' + code).removeClass('disabled');
    });

    // click bubble to delete exam
    jq('#selected_exams_div').on('click', '.selected_exam:not(.default_type)', function () {
      jq(this).parent().remove();
      searchSource = 'remove exam filter';
      getFreelancers(true); // refresh
      var id = jq(this).attr('id').replace('selected_exam_', '');
      jq('#exam_' + id).removeClass('disabled');
    });

    // click bubble to delete star filter
    jq('#selected_star_div').on('click', '.selected_star:not(.default_type)', function () {
      jq(this).parent().remove();
      searchSource = 'remove rating filter';
      getFreelancers(true); // refresh
      jq('.rating-cancel').trigger('click');
      jq('.rating-cancel').hide();
    });

    // click bubble to remove hourly rate filter
    jq('#selected_rate_div').on('click', '.selected_rate:not(.default_type)', function () {
      jq(this).parent().remove();
      jq('#hourly_rate').val(jq('#dafault_hourly_rate').val());
      searchSource = 'remove hourly rate filter';
      getFreelancers(true); // refresh
    });
  })();

  // Online checkbox filter handler
  jq('#online_only').on('click', function () {
    searchSource = 'online users filter';
    getFreelancers(true);
    toggleOnlineBubble();
    toggleNoSkillSponsorUpsell();
    // Disable extended search if user explicitly enabled online-only
    if (this.checked) {
      enableExtendedSearch = false;
    }
  });

  jq(document).on('click', '#remove_online_filter', function () {
    jq('#selected-online').click();
  });

  jq('#freeSearchForm').on('submit', function () {
    freeSearch();
    return false;
  });

  jq(document).on('click', '.selected_freeSearch', function () {
    jq('#freeSearchInput').val('');
    searchSource = 'keyword';
    freeSearch('');
  });

  jq('#history_range').change(function () {
    getFreelancers(true);
  });

  jq('#sponsor-hilight-box').on('click', '.btn-sponsor-list', function () {
    var sponsorButton = jq(this);
    var weekSelection = sponsorButton.prev('.listing-promotion-select');
    var headersData = {
      'X-XSRF-TOKEN': getCSRFToken() };

    var sponsorData = {
      job_id: sponsorButton.data('skill-id'),
      path: window.location.pathname };

    var amount = sponsorInfo[sponsorData.job_id].sponsor_price;

    paymentModalData = {
      currencyDetails: currencyDetails,
      amount: amount };

    fixedAmountPaymentModalModule.initModal(paymentModalData, function () {
      jq.ajax({
        type: 'GET',
        url: '/ajax/directory/purchaseSponsor.php',
        cache: false,
        headers: headersData,
        data: sponsorData,
        dataType: 'json',
        beforeSend: function beforeSend() {
          sponsorButton.hide();
          weekSelection.hide();
          sponsorButton.next().show();
          jq('#listing-promotion-error').hide();
        },
        success: function success(msg) {
          if (msg.status == 'success') {
            (function () {
              var skillIDs = [];
              var $selectedSkills = jq('.selected_skill');

              if ($selectedSkills.length > 0) {
                $selectedSkills.each(function () {
                  var skillID = jq(this).attr('value');
                  if (skillID) {
                    skillIDs.push(skillID);
                  }
                });
              } else if (typeof sponsoredUpsellSkillIds !== 'undefined' && sponsoredUpsellSkillIds.length > 0 && $selectedSkills.length < 1) {
                skillIDs = sponsoredUpsellSkillIds;
              }

              sponsorButton.closest('.sponsor-skill-entry').find('.sponsor-price').html(translate('Recuperando informação...'));
              clearSponsorEntries();
              getSponsoredHilightInfo(skillIDs, sponsorData.job_id);
            })();
          } else if (msg.status == 'insuffunds') {
            window.location.href = msg.redirectUrl;
          } else {
            alert(msg.msg);
          }
        },
        error: function error() {
          sponsorButton.show();
        },
        complete: function complete() {
          sponsorButton.next().hide();
        } });
    }, {
      sponsorButton: sponsorButton,
      sponsorSkillID: sponsorData.job_id });
  });

  jq('#display_div').on('mouseover', '.ns_result', function () {
    jq(this).children('.ns_hover').show();
  });
  jq('#display_div').on('mouseleave', '.ns_result', function () {
    jq(this).children('.ns_hover').hide();
  });

  jq('#display_div').on('click', '.hireme_btn', hiremeCallback);
  jq('#display_div').on('click', '.prehire_btn', prehireCallback);
  jq('#display_div').on('click', '#freelancers-map-canvas .hireme-btn', function (e) {
    var userid = jq(e.target).data('userid');
    jq('.directory-hireme[data-user_id=\'' + userid + '\']').trigger('click');
  });

  function prehireCallback() {
    var _this2 = this;

    ABTestApi.testSubjectActivate('FOT-2704-prehire_one_button', 'test');

    var userId = jq(this).data('user_id');
    var startPrehireChat = function startPrehireChat(prehire) {
      window.liveChat.startChat([prehire.freelancer_id], 'private_chat', 'directory-prehire-chat', {
        type: 'prehire',
        id: prehire.id });
    };

    jq.ajax({
      url: '/api/messages/0.1/prehire/',
      type: 'post',
      dataType: 'json',
      data: {
        freelancer_id: userId },

      // TODO: This is a hack to let the AB test run
      // till we sort out whatever the API issue is
      retryLimit: 3,
      headers: getAuthHeader(),
      error: function error() {
        _this2.retryLimit--;
        if (_this2.retryLimit > 0) {
          jq.ajax(_this2);
        }
      },
      success: function success(response) {
        startPrehireChat(response.result);
      } });
  }

  function hiremeCallback() {
    ABTestApi.testSubjectActivate('FOT-2704-prehire_one_button', 'control');

    var userId = jq(this).data('user_id');
    var currentItemIndex = getCurrentItemIndex(jq(this));
    var username = jq(this).closest('.ns_result').find('.find-freelancer-username').html();
    var hourlyrate = jq(this).closest('.ns_result').find('.freelancer-hourlyrate').data('hourlyrate');
    var isOnline = jq(this).closest('.ns_result').find('.online-status').data('is_online');
    trackSearchAction(currentItemIndex, 'user_id', userId, 'HireMe');
    var params = {
      currencyId: currencyId,
      username: username,
      userID: userId,
      hourlyrate: hourlyrate,
      is_online: isOnline,
      sourceType: 'DirectoryPage' };

    ttrefTracking('ShowModal');

    params.abTestPrehire = false;

    moduleQuickHire.initForm(params);
  }

  /**
     * Initialises a negotiated project between the currently logged in user
     * and the selected freelancer. It creates a project, puts in in the
     * freelancer pending state which awaits the freelancer to make an offer
     * to the employer.
     */
  jq(document).on('click', '.negotiated-project-btn', function () {
    var $button = jq(this);
    var $negotiatedLoadingContainer = jq('.quick-hire-form-container');
    moduleNegotiatedProject.init($negotiatedLoadingContainer, $button);
  });

  jq(document).on('click', '.find-freelancer-username', function () {
    var now = new Date();
    var time = now.getTime() + 60 * 60 * 1000;
    now.setTime(time);
    document.cookie = 'HIREME_SOURCE_HREF=FindFreelancers; ' + ('expires=' + now.toGMTString() + '; ') + 'path=/; secure';
    var userId = jq(this).parents('.ns_result').find('.hireme-wrapper').find('.hireme_btn').data('user_id');
    var currentItemIndex = getCurrentItemIndex(jq(this));
    trackSearchAction(currentItemIndex, 'user_id', userId, 'Profile-name');
  });

  jq('#skill_selector_div').on('click', '.filter-slider-folding', function () {
    var iTag = jq(this).find('i');
    if (iTag.hasClass('icon-plus-sign')) {
      jq('.filter-slider-folding i').removeClass('icon-minus-sign').addClass('icon-plus-sign');
      iTag.removeClass('icon-plus-sign').addClass('icon-minus-sign');
    } else {
      iTag.removeClass('icon-minus-sign').addClass('icon-plus-sign');
    }
  });

  jq('.sponsor-upsell-skill').on('click', function () {
    var thisSkill = jq(this);
    var skillID = thisSkill.data('skill-id');
    jq('.selected_skill').trigger('click');
    jq('#input_skill_' + skillID).trigger('click');
    jq('#sponsor-upsell').hide();
  });

  jq(document).on('click', '.freelancer-statistic a', function () {
    var userId = jq(this).parents('.ns_result').find('.hireme-wrapper').find('.hireme_btn').data('user_id');
    var currentItemIndex = getCurrentItemIndex(jq(this));
    trackSearchAction(currentItemIndex, 'user_id', userId, 'Review-link');
  });

  jq(document).on('mousedown', '.freelancer-profile-wrapper, .find-freelancer-username', function () {
    ttrefTracking('ProfileRedirect');
  });

  jq(document).on('click', '.freelancer-profile-image', function () {
    var userId = jq(this).parents('.ns_result').find('.hireme-wrapper').find('.hireme_btn').data('user_id');
    var currentItemIndex = getCurrentItemIndex(jq(this));
    trackSearchAction(currentItemIndex, 'user_id', userId, 'Profile-picture');
  });

  jq(document).on('click', '.Rating a', function () {
    var userId = jq(this).parents('.ns_result').find('.hireme-wrapper').find('.hireme_btn').data('user_id');
    var currentItemIndex = getCurrentItemIndex(jq(this));
    trackSearchAction(currentItemIndex, 'user_id', userId, 'Profile-review');
  });

  jq(document).on('click', 'p.bio > .seeMore', function () {
    var action = jq(this).data('action');
    var item = jq(this).parents('.ns_result');
    switch (action) {
      case 'more':
        {
          var userId = jq(this).parents('.ns_result').find('.hireme-wrapper').find('.hireme_btn').data('user_id');
          var currentItemIndex = getCurrentItemIndex(jq(this));
          trackSearchAction(currentItemIndex, 'user_id', userId, 'more');
          item.find('.bio.cleanProfile').show();
          item.find('.bio.truncProfile').hide();
          break;
        }
      case 'less':
        item.find('.bio.cleanProfile').hide();
        item.find('.bio.truncProfile').show();
        break;
      default:
      // do nothing
    }
  });

  jq('#online_only_div').on('click', '#selected-online', function () {
    jq('#online_only').trigger('click');
  });
  if (freeSearchOnLoad != '') {
    freeSearch(freeSearchOnLoad);
  } else {
    trackSearch('');
  }
});

/**
     * Filters more/less functionality
     */
var filtersMoreToggle = document.getElementById('filters-more-toggle');
var filtersMoreContent = document.getElementById('filters-more-content');

if (filtersMoreToggle && filtersMoreContent) {
  (function () {
    var filtersMoreToggleLessText = filtersMoreToggle.getAttribute('data-less');
    var filtersMoreToggleMoreText = filtersMoreToggle.getAttribute('data-more');
    // Set a "More/Less" button to toggle the extra filters on mobile view.
    filtersMoreToggle.addEventListener('click', function () {
      if (filtersMoreContent.classList.contains('is-active')) {
        filtersMoreToggle.textContent = filtersMoreToggleMoreText;
      } else {
        filtersMoreToggle.textContent = filtersMoreToggleLessText;
      }

      filtersMoreContent.classList.toggle('is-active');
    });
  })();
}
